var Opal = require('./opal').default; /* Generated by Opal 0.11.99.dev */
Opal.modules["diceBot/DiceBot"] = function(Opal) {
  function $rb_minus(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs - rhs : lhs['$-'](rhs);
  }
  function $rb_divide(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs / rhs : lhs['$/'](rhs);
  }
  function $rb_plus(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs + rhs : lhs['$+'](rhs);
  }
  function $rb_times(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs * rhs : lhs['$*'](rhs);
  }
  function $rb_ge(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs >= rhs : lhs['$>='](rhs);
  }
  var self = Opal.top, $nesting = [], nil = Opal.nil, $$$ = Opal.const_get_qualified, $$ = Opal.const_get_relative, $breaker = Opal.breaker, $slice = Opal.slice, $klass = Opal.klass, $send = Opal.send, $truthy = Opal.truthy, $gvars = Opal.gvars, $hash2 = Opal.hash2;

  Opal.add_stubs(['$freeze', '$map', '$to_proc', '$join', '$clearPrefixes', '$!', '$empty?', '$prefixs', '$prefixes', '$class', '$puts', '$gameType', '$setPrefixes', '$attr_accessor', '$attr_reader', '$gameName', '$getHelpMessage', '$rand', '$check_suc', '$roll', '$marshalSignOfInequality', '$unlimitedRollDiceType', '$getD66Value', '$rollDiceAddingUp', '$parren_killer', '$debug', '$isGetOriginalMessage', '$getOriginalMessage', '$=~', '$prefixesPattern', '$removeDiceCommandMessage', '$rollDiceCommandCatched', '$nil?', '$!=', '$sub', '$rollDiceCommand', '$to_s', '$get_table_by_nD6', '$get_table_by_nDx', '$getTableValue', '$[]', '$-', '$/', '$getD66', '$bcdice', '$get_table_by_number', '$+', '$*', '$getDiceListFromDiceText', '$collect', '$split', '$to_i', '$each', '$>=', '$kind_of?', '$call', '$select', '$public_methods', '$===', '$send', '$upcase', '$==', '$getTableInfoFromExtraTableText', '$get_table_by_nDx_extratable', '$get_table_by_d66', '$%', '$get_table_by_d66_swap', '$raise', '$gsub', '$rollTableMessageDiceText', '$size', '$inspect']);
  return (function($base, $super, $parent_nesting) {
    var self = $klass($base, $super, 'DiceBot');

    var $nesting = [self].concat($parent_nesting), $DiceBot_prefixes$1, $DiceBot_prefixesPattern$2, $DiceBot_setPrefixes$3, $DiceBot_clearPrefixes$4, $DiceBot_inherited$5, $DiceBot_initialize$6, $DiceBot_postSet$7, $DiceBot_info$8, $DiceBot_gameName$9, $DiceBot_prefixes$10, $DiceBot_gameType$11, $DiceBot_setGameType$12, $DiceBot_setSendMode$13, $DiceBot_upplerRollThreshold$eq$14, $DiceBot_bcdice$eq$15, $DiceBot_bcdice$16, $DiceBot_rand$17, $DiceBot_check_suc$18, $DiceBot_roll$19, $DiceBot_marshalSignOfInequality$20, $DiceBot_unlimitedRollDiceType$21, $DiceBot_sortType$22, $DiceBot_setSortType$23, $DiceBot_d66$24, $DiceBot_rollDiceAddingUp$25, $DiceBot_getHelpMessage$26, $DiceBot_parren_killer$27, $DiceBot_changeText$28, $DiceBot_dice_command$29, $DiceBot_isGetOriginalMessage$30, $DiceBot_removeDiceCommandMessage$31, $DiceBot_rollDiceCommandCatched$32, $DiceBot_rollDiceCommand$33, $DiceBot_setDiceText$34, $DiceBot_setDiffText$35, $DiceBot_dice_command_xRn$36, $DiceBot_check_2D6$37, $DiceBot_check_nD6$38, $DiceBot_check_nD10$39, $DiceBot_check_1D100$40, $DiceBot_check_1D20$41, $DiceBot_get_table_by_2d6$42, $DiceBot_get_table_by_1d6$43, $DiceBot_get_table_by_nD6$44, $DiceBot_get_table_by_nDx$45, $DiceBot_get_table_by_1d3$46, $DiceBot_getD66$47, $DiceBot_get_table_by_d66_swap$48, $DiceBot_get_table_by_d66$49, $DiceBot_getDiceRolledAdditionalText$50, $DiceBot_getDiceRevision$51, $DiceBot_changeDiceValueByDiceText$52, $DiceBot_setRatingTable$53, $DiceBot_getJackUpValueOnAddRoll$54, $DiceBot_isD9$55, $DiceBot_getGrichText$56, $DiceBot_check2dCritical$57, $DiceBot_is2dCritical$58, $DiceBot_getDiceList$59, $DiceBot_getDiceListFromDiceText$60, $DiceBot_get_table_by_number$62, $DiceBot_getTableValue$64, $DiceBot_analyzeDiceCommandResultMethod$65, $DiceBot_get_table_by_nDx_extratable$68, $DiceBot_getTableCommandResult$69, $DiceBot_getTableInfoFromExtraTableText$70;

    self.$$prototype.gameType = self.$$prototype.bcdice = self.$$prototype.sortType = self.$$prototype.diceText = self.$$prototype.d66Type = nil;
    
    Opal.const_set($nesting[0], 'EMPTY_PREFIXES_PATTERN', /(^|\s)(S)?()(\s|$)/i.$freeze());
    Opal.defs(self, '$prefixes', $DiceBot_prefixes$1 = function $$prefixes() {
      var self = this;
      if (self.prefixes == null) self.prefixes = nil;

      return self.prefixes
    }, $DiceBot_prefixes$1.$$arity = 0);
    Opal.defs(self, '$prefixesPattern', $DiceBot_prefixesPattern$2 = function $$prefixesPattern() {
      var self = this;
      if (self.prefixesPattern == null) self.prefixesPattern = nil;

      return self.prefixesPattern
    }, $DiceBot_prefixesPattern$2.$$arity = 0);
    Opal.defs(self, '$setPrefixes', $DiceBot_setPrefixes$3 = function $$setPrefixes(prefixes) {
      var self = this;

      
      self.prefixes = $send(prefixes, 'map', [], "freeze".$to_proc()).$freeze();
      self.prefixesPattern = new RegExp("" + "(^|\\s)(S)?(" + (prefixes.$join("|")) + ")(\\s|$)", 'i').$freeze();
      return self;
    }, $DiceBot_setPrefixes$3.$$arity = 1);
    Opal.defs(self, '$clearPrefixes', $DiceBot_clearPrefixes$4 = function $$clearPrefixes() {
      var self = this;

      
      self.prefixes = [].$freeze();
      self.prefixesPattern = $$($nesting, 'EMPTY_PREFIXES_PATTERN');
      return self;
    }, $DiceBot_clearPrefixes$4.$$arity = 0);
    Opal.defs(self, '$inherited', $DiceBot_inherited$5 = function $$inherited(subclass) {
      var self = this;

      return subclass.$clearPrefixes()
    }, $DiceBot_inherited$5.$$arity = 1);
    self.$clearPrefixes();
    self.bcdice = nil;
    (Opal.class_variable_set($nesting[0], '@@DEFAULT_SEND_MODE', 2));
    
    Opal.def(self, '$initialize', $DiceBot_initialize$6 = function $$initialize() {
      var $a, self = this;
      if ($gvars.stderr == null) $gvars.stderr = nil;

      
      self.sendMode = (($a = $nesting[0].$$cvars['@@DEFAULT_SEND_MODE']) == null ? nil : $a);
      self.sortType = 0;
      self.sameDiceRerollCount = 0;
      self.sameDiceRerollType = 0;
      self.d66Type = 1;
      self.isPrintMaxDice = false;
      self.upplerRollThreshold = 0;
      self.unlimitedRollDiceType = 0;
      self.rerollNumber = 0;
      self.defaultSuccessTarget = "";
      self.rerollLimitCount = 10000;
      self.fractionType = "omit";
      self.gameType = "DiceBot";
      if ($truthy(($truthy($a = self.$prefixs()['$empty?']()['$!']()) ? self.$class().$prefixes()['$empty?']() : $a))) {
        
        $gvars.stderr.$puts("" + (self.$gameType()) + ": #prefixs is deprecated. Please use .setPrefixes.");
        return self.$class().$setPrefixes(self.$prefixs());
      } else {
        return nil
      };
    }, $DiceBot_initialize$6.$$arity = 0);
    self.$attr_accessor("rerollLimitCount");
    self.$attr_reader("sendMode", "sameDiceRerollCount", "sameDiceRerollType", "d66Type");
    self.$attr_reader("isPrintMaxDice", "upplerRollThreshold", "unlimitedRollDiceType");
    self.$attr_reader("defaultSuccessTarget", "rerollNumber", "fractionType");
    
    Opal.def(self, '$postSet', $DiceBot_postSet$7 = function $$postSet() {
      var self = this;

      return nil
    }, $DiceBot_postSet$7.$$arity = 0);
    
    Opal.def(self, '$info', $DiceBot_info$8 = function $$info() {
      var self = this;

      return $hash2(["name", "gameType", "prefixs", "info"], {"name": self.$gameName(), "gameType": self.$gameType(), "prefixs": self.$class().$prefixes(), "info": self.$getHelpMessage()})
    }, $DiceBot_info$8.$$arity = 0);
    
    Opal.def(self, '$gameName', $DiceBot_gameName$9 = function $$gameName() {
      var self = this;

      return self.$gameType()
    }, $DiceBot_gameName$9.$$arity = 0);
    
    Opal.def(self, '$prefixes', $DiceBot_prefixes$10 = function $$prefixes() {
      var self = this;

      return self.$class().$prefixes()
    }, $DiceBot_prefixes$10.$$arity = 0);
    Opal.alias(self, "prefixs", "prefixes");
    
    Opal.def(self, '$gameType', $DiceBot_gameType$11 = function $$gameType() {
      var self = this;

      return self.gameType
    }, $DiceBot_gameType$11.$$arity = 0);
    
    Opal.def(self, '$setGameType', $DiceBot_setGameType$12 = function $$setGameType(type) {
      var self = this;

      return (self.gameType = type)
    }, $DiceBot_setGameType$12.$$arity = 1);
    
    Opal.def(self, '$setSendMode', $DiceBot_setSendMode$13 = function $$setSendMode(m) {
      var self = this;

      return (self.sendMode = m)
    }, $DiceBot_setSendMode$13.$$arity = 1);
    
    Opal.def(self, '$upplerRollThreshold=', $DiceBot_upplerRollThreshold$eq$14 = function(v) {
      var self = this;

      return (self.upplerRollThreshold = v)
    }, $DiceBot_upplerRollThreshold$eq$14.$$arity = 1);
    
    Opal.def(self, '$bcdice=', $DiceBot_bcdice$eq$15 = function(b) {
      var self = this;

      return (self.bcdice = b)
    }, $DiceBot_bcdice$eq$15.$$arity = 1);
    
    Opal.def(self, '$bcdice', $DiceBot_bcdice$16 = function $$bcdice() {
      var self = this;

      return self.bcdice
    }, $DiceBot_bcdice$16.$$arity = 0);
    
    Opal.def(self, '$rand', $DiceBot_rand$17 = function $$rand(max) {
      var self = this;

      return self.bcdice.$rand(max)
    }, $DiceBot_rand$17.$$arity = 1);
    
    Opal.def(self, '$check_suc', $DiceBot_check_suc$18 = function $$check_suc($a) {
      var $post_args, params, self = this;

      
      
      $post_args = Opal.slice.call(arguments, 0, arguments.length);
      
      params = $post_args;;
      return $send(self.bcdice, 'check_suc', Opal.to_a(params));
    }, $DiceBot_check_suc$18.$$arity = -1);
    
    Opal.def(self, '$roll', $DiceBot_roll$19 = function $$roll($a) {
      var $post_args, args, self = this;

      
      
      $post_args = Opal.slice.call(arguments, 0, arguments.length);
      
      args = $post_args;;
      return $send(self.bcdice, 'roll', Opal.to_a(args));
    }, $DiceBot_roll$19.$$arity = -1);
    
    Opal.def(self, '$marshalSignOfInequality', $DiceBot_marshalSignOfInequality$20 = function $$marshalSignOfInequality($a) {
      var $post_args, args, self = this;

      
      
      $post_args = Opal.slice.call(arguments, 0, arguments.length);
      
      args = $post_args;;
      return $send(self.bcdice, 'marshalSignOfInequality', Opal.to_a(args));
    }, $DiceBot_marshalSignOfInequality$20.$$arity = -1);
    
    Opal.def(self, '$unlimitedRollDiceType', $DiceBot_unlimitedRollDiceType$21 = function $$unlimitedRollDiceType() {
      var self = this;

      return self.bcdice.$unlimitedRollDiceType()
    }, $DiceBot_unlimitedRollDiceType$21.$$arity = 0);
    
    Opal.def(self, '$sortType', $DiceBot_sortType$22 = function $$sortType() {
      var self = this;

      return self.sortType
    }, $DiceBot_sortType$22.$$arity = 0);
    
    Opal.def(self, '$setSortType', $DiceBot_setSortType$23 = function $$setSortType(s) {
      var self = this;

      return (self.sortType = s)
    }, $DiceBot_setSortType$23.$$arity = 1);
    
    Opal.def(self, '$d66', $DiceBot_d66$24 = function $$d66($a) {
      var $post_args, args, self = this;

      
      
      $post_args = Opal.slice.call(arguments, 0, arguments.length);
      
      args = $post_args;;
      return $send(self.bcdice, 'getD66Value', Opal.to_a(args));
    }, $DiceBot_d66$24.$$arity = -1);
    
    Opal.def(self, '$rollDiceAddingUp', $DiceBot_rollDiceAddingUp$25 = function $$rollDiceAddingUp($a) {
      var $post_args, arg, self = this;

      
      
      $post_args = Opal.slice.call(arguments, 0, arguments.length);
      
      arg = $post_args;;
      return $send(self.bcdice, 'rollDiceAddingUp', Opal.to_a(arg));
    }, $DiceBot_rollDiceAddingUp$25.$$arity = -1);
    
    Opal.def(self, '$getHelpMessage', $DiceBot_getHelpMessage$26 = function $$getHelpMessage() {
      var self = this;

      return ""
    }, $DiceBot_getHelpMessage$26.$$arity = 0);
    
    Opal.def(self, '$parren_killer', $DiceBot_parren_killer$27 = function $$parren_killer(string) {
      var self = this;

      return self.bcdice.$parren_killer(string)
    }, $DiceBot_parren_killer$27.$$arity = 1);
    
    Opal.def(self, '$changeText', $DiceBot_changeText$28 = function $$changeText(string) {
      var self = this;

      
      self.$debug("DiceBot.parren_killer_add called");
      return string;
    }, $DiceBot_changeText$28.$$arity = 1);
    
    Opal.def(self, '$dice_command', $DiceBot_dice_command$29 = function $$dice_command(string, nick_e) {
      var $a, $b, self = this, secret_flg = nil, __last__match__1 = nil, __last__match__2 = nil, __last__match__3 = nil, __last__match__4 = nil, __last__match__5 = nil, __last__match__6 = nil, __last__match__7 = nil, __last__match__8 = nil, __last__match__9 = nil, __last__match__10 = nil, __last__match__11 = nil, __last__match__12 = nil, __last__match__13 = nil, __last__match__14 = nil, __last__match__15 = nil, __last__match__16 = nil, __last__match__17 = nil, __last__match__18 = nil, __last__match__19 = nil, __last__match__20 = nil, secretMarker = nil, command = nil, output_msg = nil;

      
      if ($truthy(self.$isGetOriginalMessage())) {
        string = self.bcdice.$getOriginalMessage()};
      self.$debug("dice_command Begin string", string);
      secret_flg = false;
      if ($truthy(self.$class().$prefixesPattern()['$=~'](string))) {
      } else {
        
        __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
        __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
        __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
        __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
        __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
        __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
        __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
        __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
        __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
        __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
        __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
        __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
        __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
        __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
        __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
        __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
        __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
        __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
        __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
        __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
        self.$debug("not match in prefixes");
        return ["1", secret_flg];
      };
      __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
      __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
      __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
      __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
      __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
      __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
      __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
      __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
      __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
      __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
      __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
      __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
      __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
      __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
      __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
      __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
      __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
      __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
      __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
      __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
      secretMarker = __last__match__2;
      command = __last__match__3;
      command = self.$removeDiceCommandMessage(command);
      self.$debug("dicebot after command", command);
      self.$debug("match");
      $b = self.$rollDiceCommandCatched(command), $a = Opal.to_ary($b), (output_msg = ($a[0] == null ? nil : $a[0])), (secret_flg = ($a[1] == null ? nil : $a[1])), $b;
      if ($truthy(($truthy($a = output_msg['$nil?']()) ? $a : output_msg['$empty?']()))) {
        output_msg = "1"};
      secret_flg = ($truthy($a = secret_flg) ? $a : false);
      if ($truthy(output_msg['$!=']("1"))) {
        output_msg = "" + (nick_e) + ": " + (output_msg)};
      if ($truthy(secretMarker)) {
        if ($truthy(output_msg['$!=']("1"))) {
          secret_flg = true}};
      return [output_msg, secret_flg];
    }, $DiceBot_dice_command$29.$$arity = 2);
    
    Opal.def(self, '$isGetOriginalMessage', $DiceBot_isGetOriginalMessage$30 = function $$isGetOriginalMessage() {
      var self = this;

      return false
    }, $DiceBot_isGetOriginalMessage$30.$$arity = 0);
    
    Opal.def(self, '$removeDiceCommandMessage', $DiceBot_removeDiceCommandMessage$31 = function $$removeDiceCommandMessage(command) {
      var self = this;

      return command.$sub(/[\s　].+/, "")
    }, $DiceBot_removeDiceCommandMessage$31.$$arity = 1);
    
    Opal.def(self, '$rollDiceCommandCatched', $DiceBot_rollDiceCommandCatched$32 = function $$rollDiceCommandCatched(command) {
      var $a, $b, self = this, result = nil, secret_flg = nil, e = nil;

      
      result = nil;
      
      try {
        
        self.$debug("call rollDiceCommand command", command);
        $b = self.$rollDiceCommand(command), $a = Opal.to_ary($b), (result = ($a[0] == null ? nil : $a[0])), (secret_flg = ($a[1] == null ? nil : $a[1])), $b;
      } catch ($err) {
        if (Opal.rescue($err, [$$($nesting, 'StandardError')])) {e = $err;
          try {
            self.$debug("executeCommand exception", e.$to_s(), [].$join("\n"))
          } finally { Opal.pop_exception() }
        } else { throw $err; }
      };;
      self.$debug("rollDiceCommand result", result);
      return [result, secret_flg];
    }, $DiceBot_rollDiceCommandCatched$32.$$arity = 1);
    
    Opal.def(self, '$rollDiceCommand', $DiceBot_rollDiceCommand$33 = function $$rollDiceCommand(command) {
      var self = this;

      return nil
    }, $DiceBot_rollDiceCommand$33.$$arity = 1);
    
    Opal.def(self, '$setDiceText', $DiceBot_setDiceText$34 = function $$setDiceText(diceText) {
      var self = this;

      
      self.$debug("setDiceText diceText", diceText);
      return (self.diceText = diceText);
    }, $DiceBot_setDiceText$34.$$arity = 1);
    
    Opal.def(self, '$setDiffText', $DiceBot_setDiffText$35 = function $$setDiffText(diffText) {
      var self = this;

      return (self.diffText = diffText)
    }, $DiceBot_setDiffText$35.$$arity = 1);
    
    Opal.def(self, '$dice_command_xRn', $DiceBot_dice_command_xRn$36 = function $$dice_command_xRn(string, nick_e) {
      var self = this;

      return ""
    }, $DiceBot_dice_command_xRn$36.$$arity = 2);
    
    Opal.def(self, '$check_2D6', $DiceBot_check_2D6$37 = function $$check_2D6(total_n, dice_n, signOfInequality, diff, dice_cnt, dice_max, n1, n_max) {
      var self = this;

      return ""
    }, $DiceBot_check_2D6$37.$$arity = 8);
    
    Opal.def(self, '$check_nD6', $DiceBot_check_nD6$38 = function $$check_nD6(total_n, dice_n, signOfInequality, diff, dice_cnt, dice_max, n1, n_max) {
      var self = this;

      return ""
    }, $DiceBot_check_nD6$38.$$arity = 8);
    
    Opal.def(self, '$check_nD10', $DiceBot_check_nD10$39 = function $$check_nD10(total_n, dice_n, signOfInequality, diff, dice_cnt, dice_max, n1, n_max) {
      var self = this;

      return ""
    }, $DiceBot_check_nD10$39.$$arity = 8);
    
    Opal.def(self, '$check_1D100', $DiceBot_check_1D100$40 = function $$check_1D100(total_n, dice_n, signOfInequality, diff, dice_cnt, dice_max, n1, n_max) {
      var self = this;

      return ""
    }, $DiceBot_check_1D100$40.$$arity = 8);
    
    Opal.def(self, '$check_1D20', $DiceBot_check_1D20$41 = function $$check_1D20(total_n, dice_n, signOfInequality, diff, dice_cnt, dice_max, n1, n_max) {
      var self = this;

      return ""
    }, $DiceBot_check_1D20$41.$$arity = 8);
    
    Opal.def(self, '$get_table_by_2d6', $DiceBot_get_table_by_2d6$42 = function $$get_table_by_2d6(table) {
      var self = this;

      return self.$get_table_by_nD6(table, 2)
    }, $DiceBot_get_table_by_2d6$42.$$arity = 1);
    
    Opal.def(self, '$get_table_by_1d6', $DiceBot_get_table_by_1d6$43 = function $$get_table_by_1d6(table) {
      var self = this;

      return self.$get_table_by_nD6(table, 1)
    }, $DiceBot_get_table_by_1d6$43.$$arity = 1);
    
    Opal.def(self, '$get_table_by_nD6', $DiceBot_get_table_by_nD6$44 = function $$get_table_by_nD6(table, count) {
      var self = this;

      return self.$get_table_by_nDx(table, count, 6)
    }, $DiceBot_get_table_by_nD6$44.$$arity = 2);
    
    Opal.def(self, '$get_table_by_nDx', $DiceBot_get_table_by_nDx$45 = function $$get_table_by_nDx(table, count, diceType) {
      var $a, $b, self = this, num = nil, text = nil;

      
      $b = self.$roll(count, diceType), $a = Opal.to_ary($b), (num = ($a[0] == null ? nil : $a[0])), $b;
      text = self.$getTableValue(table['$[]']($rb_minus(num, count)));
      if ($truthy(text['$nil?']())) {
        return ["1", 0]};
      return [text, num];
    }, $DiceBot_get_table_by_nDx$45.$$arity = 3);
    
    Opal.def(self, '$get_table_by_1d3', $DiceBot_get_table_by_1d3$46 = function $$get_table_by_1d3(table) {
      var $a, $b, self = this, count = nil, num = nil, index = nil, text = nil;

      
      self.$debug("get_table_by_1d3");
      count = 1;
      $b = self.$roll(count, 6), $a = Opal.to_ary($b), (num = ($a[0] == null ? nil : $a[0])), $b;
      self.$debug("num", num);
      index = $rb_divide($rb_minus(num, 1), 2);
      self.$debug("index", index);
      text = table['$[]'](index);
      if ($truthy(text['$nil?']())) {
        return ["1", 0]};
      return [text, num];
    }, $DiceBot_get_table_by_1d3$46.$$arity = 1);
    
    Opal.def(self, '$getD66', $DiceBot_getD66$47 = function $$getD66(isSwap) {
      var self = this, number = nil;

      return (number = self.$bcdice().$getD66(isSwap))
    }, $DiceBot_getD66$47.$$arity = 1);
    
    Opal.def(self, '$get_table_by_d66_swap', $DiceBot_get_table_by_d66_swap$48 = function $$get_table_by_d66_swap(table) {
      var self = this, isSwap = nil, number = nil;

      
      isSwap = true;
      number = self.$bcdice().$getD66(isSwap);
      return [self.$get_table_by_number(number, table), number];
    }, $DiceBot_get_table_by_d66_swap$48.$$arity = 1);
    
    Opal.def(self, '$get_table_by_d66', $DiceBot_get_table_by_d66$49 = function $$get_table_by_d66(table) {
      var $a, $b, self = this, dice1 = nil, dummy = nil, dice2 = nil, num = nil, text = nil, indexText = nil;

      
      $b = self.$roll(1, 6), $a = Opal.to_ary($b), (dice1 = ($a[0] == null ? nil : $a[0])), (dummy = ($a[1] == null ? nil : $a[1])), $b;
      $b = self.$roll(1, 6), $a = Opal.to_ary($b), (dice2 = ($a[0] == null ? nil : $a[0])), (dummy = ($a[1] == null ? nil : $a[1])), $b;
      num = $rb_plus($rb_times($rb_minus(dice1, 1), 6), $rb_minus(dice2, 1));
      text = table['$[]'](num);
      indexText = "" + (dice1) + (dice2);
      if ($truthy(text['$nil?']())) {
        return ["1", indexText]};
      return [text, indexText];
    }, $DiceBot_get_table_by_d66$49.$$arity = 1);
    
    Opal.def(self, '$getDiceRolledAdditionalText', $DiceBot_getDiceRolledAdditionalText$50 = function $$getDiceRolledAdditionalText(n1, n_max, dice_max) {
      var self = this;

      return ""
    }, $DiceBot_getDiceRolledAdditionalText$50.$$arity = 3);
    
    Opal.def(self, '$getDiceRevision', $DiceBot_getDiceRevision$51 = function $$getDiceRevision(n_max, dice_max, total_n) {
      var self = this;

      return ["", 0]
    }, $DiceBot_getDiceRevision$51.$$arity = 3);
    
    Opal.def(self, '$changeDiceValueByDiceText', $DiceBot_changeDiceValueByDiceText$52 = function $$changeDiceValueByDiceText(dice_now, dice_str, isCheckSuccess, dice_max) {
      var self = this;

      return dice_now
    }, $DiceBot_changeDiceValueByDiceText$52.$$arity = 4);
    
    Opal.def(self, '$setRatingTable', $DiceBot_setRatingTable$53 = function $$setRatingTable(nick_e, tnick, channel_to_list) {
      var self = this;

      return "1"
    }, $DiceBot_setRatingTable$53.$$arity = 3);
    
    Opal.def(self, '$getJackUpValueOnAddRoll', $DiceBot_getJackUpValueOnAddRoll$54 = function $$getJackUpValueOnAddRoll(dice_n) {
      var self = this;

      return 0
    }, $DiceBot_getJackUpValueOnAddRoll$54.$$arity = 1);
    
    Opal.def(self, '$isD9', $DiceBot_isD9$55 = function $$isD9() {
      var self = this;

      return false
    }, $DiceBot_isD9$55.$$arity = 0);
    
    Opal.def(self, '$getGrichText', $DiceBot_getGrichText$56 = function $$getGrichText(numberSpot1, dice_cnt_total, suc) {
      var self = this;

      return ""
    }, $DiceBot_getGrichText$56.$$arity = 3);
    
    Opal.def(self, '$check2dCritical', $DiceBot_check2dCritical$57 = function $$check2dCritical(critical, dice_new, dice_arry, loop_count) {
      var self = this;

      return nil
    }, $DiceBot_check2dCritical$57.$$arity = 4);
    
    Opal.def(self, '$is2dCritical', $DiceBot_is2dCritical$58 = function $$is2dCritical() {
      var self = this;

      return false
    }, $DiceBot_is2dCritical$58.$$arity = 0);
    
    Opal.def(self, '$getDiceList', $DiceBot_getDiceList$59 = function $$getDiceList() {
      var self = this;

      return self.$getDiceListFromDiceText(self.diceText)
    }, $DiceBot_getDiceList$59.$$arity = 0);
    
    Opal.def(self, '$getDiceListFromDiceText', $DiceBot_getDiceListFromDiceText$60 = function $$getDiceListFromDiceText(diceText) {
      var $a, $$61, self = this, diceList = nil, __last__match__1 = nil, __last__match__2 = nil, __last__match__3 = nil, __last__match__4 = nil, __last__match__5 = nil, __last__match__6 = nil, __last__match__7 = nil, __last__match__8 = nil, __last__match__9 = nil, __last__match__10 = nil, __last__match__11 = nil, __last__match__12 = nil, __last__match__13 = nil, __last__match__14 = nil, __last__match__15 = nil, __last__match__16 = nil, __last__match__17 = nil, __last__match__18 = nil, __last__match__19 = nil, __last__match__20 = nil, diceString = nil;

      
      self.$debug("getDiceList diceText", diceText);
      diceList = [];
      if ($truthy(/\[([\d,]+)\]/['$=~'](diceText))) {
        
        __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
        __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
        __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
        __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
        __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
        __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
        __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
        __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
        __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
        __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
        __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
        __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
        __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
        __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
        __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
        __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
        __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
        __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
        __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
        __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
        diceText = __last__match__1;};
      if ($truthy(/([\d,]+)/['$=~'](diceText))) {
      } else {
        return diceList
      };
      __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
      __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
      __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
      __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
      __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
      __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
      __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
      __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
      __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
      __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
      __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
      __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
      __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
      __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
      __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
      __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
      __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
      __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
      __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
      __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
      diceString = __last__match__1;
      diceList = $send(diceString.$split(/,/), 'collect', [], ($$61 = function(i){var self = $$61.$$s || this;

      
        
        if (i == null) {
          i = nil;
        };
        return i.$to_i();}, $$61.$$s = self, $$61.$$arity = 1, $$61));
      self.$debug("diceList", diceList);
      return diceList;
    }, $DiceBot_getDiceListFromDiceText$60.$$arity = 1);
    
    Opal.def(self, '$get_table_by_number', $DiceBot_get_table_by_number$62 = function $$get_table_by_number(index, table, default$) {try {

      var $$63, self = this;

      
      
      if (default$ == null) {
        default$ = "1";
      };
      $send(table, 'each', [], ($$63 = function(item){var self = $$63.$$s || this, number = nil;

      
        
        if (item == null) {
          item = nil;
        };
        number = item['$[]'](0);
        if ($truthy($rb_ge(number, index))) {
          Opal.ret(self.$getTableValue(item['$[]'](1)))
        } else {
          return nil
        };}, $$63.$$s = self, $$63.$$arity = 1, $$63));
      return self.$getTableValue(default$);
      } catch ($returner) { if ($returner === Opal.returner) { return $returner.$v } throw $returner; }
    }, $DiceBot_get_table_by_number$62.$$arity = -3);
    
    Opal.def(self, '$getTableValue', $DiceBot_getTableValue$64 = function $$getTableValue(data) {
      var self = this;

      
      if ($truthy(data['$kind_of?']($$($nesting, 'Proc')))) {
        return data.$call()};
      return data;
    }, $DiceBot_getTableValue$64.$$arity = 1);
    
    Opal.def(self, '$analyzeDiceCommandResultMethod', $DiceBot_analyzeDiceCommandResultMethod$65 = function $$analyzeDiceCommandResultMethod(command) {try {

      var $$66, $$67, self = this, methodList = nil;

      
      methodList = $send(self.$public_methods(false), 'select', [], ($$66 = function(method){var self = $$66.$$s || this;

      
        
        if (method == null) {
          method = nil;
        };
        return /^get.+DiceCommandResult$/['$==='](method.$to_s());}, $$66.$$s = self, $$66.$$arity = 1, $$66));
      $send(methodList, 'each', [], ($$67 = function(method){var self = $$67.$$s || this, result = nil;

      
        
        if (method == null) {
          method = nil;
        };
        result = self.$send(method, command);
        if ($truthy(result['$nil?']())) {
          return nil
        } else {
          Opal.ret(result)
        };}, $$67.$$s = self, $$67.$$arity = 1, $$67));
      return nil;
      } catch ($returner) { if ($returner === Opal.returner) { return $returner.$v } throw $returner; }
    }, $DiceBot_analyzeDiceCommandResultMethod$65.$$arity = 1);
    
    Opal.def(self, '$get_table_by_nDx_extratable', $DiceBot_get_table_by_nDx_extratable$68 = function $$get_table_by_nDx_extratable(table, count, diceType) {
      var $a, $b, self = this, number = nil, diceText = nil, text = nil;

      
      $b = self.$roll(count, diceType), $a = Opal.to_ary($b), (number = ($a[0] == null ? nil : $a[0])), (diceText = ($a[1] == null ? nil : $a[1])), $b;
      text = self.$getTableValue(table['$[]']($rb_minus(number, count)));
      return [text, number, diceText];
    }, $DiceBot_get_table_by_nDx_extratable$68.$$arity = 3);
    
    Opal.def(self, '$getTableCommandResult', $DiceBot_getTableCommandResult$69 = function $$getTableCommandResult(command, tables, isPrintDiceText) {
      var $a, $b, $c, $d, self = this, info = nil, name = nil, type = nil, table = nil, $case = nil, __last__match__1 = nil, __last__match__2 = nil, __last__match__3 = nil, __last__match__4 = nil, __last__match__5 = nil, __last__match__6 = nil, __last__match__7 = nil, __last__match__8 = nil, __last__match__9 = nil, __last__match__10 = nil, __last__match__11 = nil, __last__match__12 = nil, __last__match__13 = nil, __last__match__14 = nil, __last__match__15 = nil, __last__match__16 = nil, __last__match__17 = nil, __last__match__18 = nil, __last__match__19 = nil, __last__match__20 = nil, count = nil, diceType = nil, limit = nil, item = nil, value = nil, output = nil, diceText = nil, text = nil, number = nil;

      
      
      if (isPrintDiceText == null) {
        isPrintDiceText = true;
      };
      info = tables['$[]'](command);
      if ($truthy(info['$nil?']())) {
        return nil};
      name = info['$[]']("name");
      type = info['$[]']("type").$upcase();
      table = info['$[]']("table");
      if ($truthy((($a = type['$==']("D66")) ? self.d66Type['$=='](2) : type['$==']("D66")))) {
        type = "D66S"};
      $b = (function() {$case = type;
      if (/(\d+)D(\d+)/['$===']($case)) {
      __last__match__1 = (($c = $gvars['~']) === nil ? nil : $c['$[]'](1));
      __last__match__2 = (($c = $gvars['~']) === nil ? nil : $c['$[]'](2));
      __last__match__3 = (($c = $gvars['~']) === nil ? nil : $c['$[]'](3));
      __last__match__4 = (($c = $gvars['~']) === nil ? nil : $c['$[]'](4));
      __last__match__5 = (($c = $gvars['~']) === nil ? nil : $c['$[]'](5));
      __last__match__6 = (($c = $gvars['~']) === nil ? nil : $c['$[]'](6));
      __last__match__7 = (($c = $gvars['~']) === nil ? nil : $c['$[]'](7));
      __last__match__8 = (($c = $gvars['~']) === nil ? nil : $c['$[]'](8));
      __last__match__9 = (($c = $gvars['~']) === nil ? nil : $c['$[]'](9));
      __last__match__10 = (($c = $gvars['~']) === nil ? nil : $c['$[]'](10));
      __last__match__11 = (($c = $gvars['~']) === nil ? nil : $c['$[]'](11));
      __last__match__12 = (($c = $gvars['~']) === nil ? nil : $c['$[]'](12));
      __last__match__13 = (($c = $gvars['~']) === nil ? nil : $c['$[]'](13));
      __last__match__14 = (($c = $gvars['~']) === nil ? nil : $c['$[]'](14));
      __last__match__15 = (($c = $gvars['~']) === nil ? nil : $c['$[]'](15));
      __last__match__16 = (($c = $gvars['~']) === nil ? nil : $c['$[]'](16));
      __last__match__17 = (($c = $gvars['~']) === nil ? nil : $c['$[]'](17));
      __last__match__18 = (($c = $gvars['~']) === nil ? nil : $c['$[]'](18));
      __last__match__19 = (($c = $gvars['~']) === nil ? nil : $c['$[]'](19));
      __last__match__20 = (($c = $gvars['~']) === nil ? nil : $c['$[]'](20));
      count = __last__match__1.$to_i();
      diceType = __last__match__2.$to_i();
      limit = $rb_minus($rb_times(diceType, count), $rb_minus(count, 1));
      table = self.$getTableInfoFromExtraTableText(table, limit);
      return self.$get_table_by_nDx_extratable(table, count, diceType);}
      else if ("D66"['$===']($case) || "D66N"['$===']($case)) {
      table = self.$getTableInfoFromExtraTableText(table, 36);
      $d = self.$get_table_by_d66(table), $c = Opal.to_ary($d), (item = ($c[0] == null ? nil : $c[0])), (value = ($c[1] == null ? nil : $c[1])), $d;
      value = value.$to_i();
      output = item['$[]'](1);
      diceText = $rb_plus($rb_plus($rb_divide(value, 10).$to_s(), ","), value['$%'](10).$to_s());
      return [output, value, diceText];}
      else if ("D66S"['$===']($case)) {
      table = self.$getTableInfoFromExtraTableText(table, 21);
      $d = self.$get_table_by_d66_swap(table), $c = Opal.to_ary($d), (output = ($c[0] == null ? nil : $c[0])), (value = ($c[1] == null ? nil : $c[1])), $d;
      value = value.$to_i();
      diceText = $rb_plus($rb_plus($rb_divide(value, 10).$to_s(), ","), value['$%'](10).$to_s());
      return [output, value, diceText];}
      else {return self.$raise("" + "invalid dice Type " + (command))}})(), $a = Opal.to_ary($b), (text = ($a[0] == null ? nil : $a[0])), (number = ($a[1] == null ? nil : $a[1])), (diceText = ($a[2] == null ? nil : $a[2])), $b;
      text = text.$gsub("\\n", "\n");
      text = self.bcdice.$rollTableMessageDiceText(text);
      if ($truthy(text['$nil?']())) {
        return nil};
      if ($truthy(($truthy($a = isPrintDiceText) ? diceText['$nil?']()['$!']() : $a))) {
        return "" + (name) + "(" + (number) + "[" + (diceText) + "]) ＞ " + (text)};
      return "" + (name) + "(" + (number) + ") ＞ " + (text);
    }, $DiceBot_getTableCommandResult$69.$$arity = -3);
    return (Opal.def(self, '$getTableInfoFromExtraTableText', $DiceBot_getTableInfoFromExtraTableText$70 = function $$getTableInfoFromExtraTableText(text, count) {
      var $$71, self = this, newTable = nil;

      
      
      if (count == null) {
        count = nil;
      };
      if ($truthy(text['$kind_of?']($$($nesting, 'String')))) {
        text = text.$split(/\n/)};
      newTable = $send(text, 'map', [], ($$71 = function(item){var self = $$71.$$s || this, $a, __last__match__1 = nil, __last__match__2 = nil, __last__match__3 = nil, __last__match__4 = nil, __last__match__5 = nil, __last__match__6 = nil, __last__match__7 = nil, __last__match__8 = nil, __last__match__9 = nil, __last__match__10 = nil, __last__match__11 = nil, __last__match__12 = nil, __last__match__13 = nil, __last__match__14 = nil, __last__match__15 = nil, __last__match__16 = nil, __last__match__17 = nil, __last__match__18 = nil, __last__match__19 = nil, __last__match__20 = nil;

      
        
        if (item == null) {
          item = nil;
        };
        if ($truthy(($truthy($a = item['$kind_of?']($$($nesting, 'String'))) ? /^(\d+):(.*)/['$==='](item) : $a))) {
          
          __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
          __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
          __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
          __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
          __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
          __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
          __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
          __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
          __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
          __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
          __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
          __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
          __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
          __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
          __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
          __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
          __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
          __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
          __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
          __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
          return [__last__match__1.$to_i(), __last__match__2];
        } else {
          return item
        };}, $$71.$$s = self, $$71.$$arity = 1, $$71));
      if ($truthy(count['$nil?']())) {
      } else if ($truthy(newTable.$size()['$!='](count))) {
        self.$raise("" + "invalid table size:" + (newTable.$size()) + "\n" + (newTable.$inspect()))};
      return newTable;
    }, $DiceBot_getTableInfoFromExtraTableText$70.$$arity = -2), nil) && 'getTableInfoFromExtraTableText';
  })($nesting[0], null, $nesting)
};

/* Generated by Opal 0.11.99.dev */
Opal.modules["StaticDiceBotLoaderList"] = function(Opal) {
  var self = Opal.top, $nesting = [], nil = Opal.nil, $$$ = Opal.const_get_qualified, $$ = Opal.const_get_relative, $breaker = Opal.breaker, $slice = Opal.slice, $klass = Opal.klass;

  return (function($base, $super, $parent_nesting) {
    var self = $klass($base, $super, 'StaticDiceBotLoaderList');

    var $nesting = [self].concat($parent_nesting), $StaticDiceBotLoaderList_getBotNames$1;

    
    Opal.const_set($nesting[0], 'BOT_NAMES', [["CardRanker", "CardRanker", "カードランカー"], ["MeikyuDays", "MeikyuDays", "迷宮デイズ"], ["GeishaGirlwithKatana", "GeishaGirlwithKatana", "ゲイシャ・ガール・ウィズ・カタナ"], ["WorldOfDarkness", "WorldOfDarkness", "ワールドオブダークネス"], ["FullMetalPanic", "FullMetalPanic", "フルメタル・パニック！"], ["Utakaze", "Utakaze", "ウタカゼ"], ["YankeeYogSothoth", "YankeeYogSothoth", "ヤンキー＆ヨグ＝ソトース"], ["TunnelsAndTrolls", "Tunnels & Trolls", "トンネルズ＆トロールズ"], ["TherapieSein", "TherapieSein", "青春疾患セラフィザイン"], ["SevenFortressMobius", "SevenFortressMobius", "セブン＝フォートレス メビウス"], ["BattleTech", "BattleTech", "バトルテック"], ["Elysion", "Elysion", "エリュシオン"], ["NightWizard", "NightWizard", "ナイトウィザード2版"], ["ShinobiGami", "ShinobiGami", "シノビガミ"], ["CodeLayerd", "CodeLayerd", "コード：レイヤード"], ["SRS", "SRS", "Standard RPG System"], ["DetatokoSaga", "DetatokoSaga", "でたとこサーガ"], ["DarkSouls", "DarkSouls", "ダークソウルTRPG"], ["BloodCrusade", "BloodCrusade", "ブラッド・クルセイド"], ["BadLife", "BadLife", "犯罪活劇RPGバッドライフ"], ["LogHorizon_Korean", "LogHorizon:Korean", "로그 호라이즌"], ["Strave", "Strave", "碧空のストレイヴ"], ["Elric", "Elric!", "エルリック！"], ["IthaWenUa", "IthaWenUa", "イサー・ウェン＝アー"], ["ShadowRun4", "ShadowRun4", "シャドウラン第４版"], ["ChaosFlare", "Chaos Flare", "カオスフレア"], ["BeginningIdol", "BeginningIdol", "ビギニングアイドル"], ["CthulhuTech", "CthulhuTech", "クトゥルフテック"], ["Kamigakari", "Kamigakari", "神我狩"], ["GundogZero", "GundogZero", "ガンドッグ・ゼロ"], ["Gundog", "Gundog", "ガンドッグ"], ["DarkBlaze", "DarkBlaze", "ダークブレイズ"], ["DemonParasite", "DemonParasite", "デモンパラサイト"], ["Cthulhu_ChineseTraditional", "Cthulhu:ChineseTraditional", "克蘇魯神話"], ["LostRoyal", "LostRoyal", "ロストロイヤル"], ["Dracurouge_Korean", "Dracurouge:Korean", "드라크루주"], ["BladeOfArcana", "BladeOfArcana", "ブレイド・オブ・アルカナ"], ["InfiniteFantasia", "InfiniteFantasia", "無限のファンタジア"], ["Cthulhu", "Cthulhu", "クトゥルフ"], ["Cthulhu7th", "Cthulhu7th", "クトゥルフ第7版"], ["KurayamiCrying", "KurayamiCrying", "クラヤミクライン"], ["Alshard", "Alshard", "アルシャード"], ["KillDeathBusiness_Korean", "KillDeathBusiness:Korean", "Kill Death Business (한국어)"], ["Torg", "TORG", "トーグ"], ["Chill3", "Chill3", "Chill 3"], ["EmbryoMachine", "EmbryoMachine", "エムブリオマシン"], ["GardenOrder", "GardenOrder", "ガーデンオーダー"], ["TokumeiTenkousei", "TokumeiTenkousei", "特命転攻生"], ["NightWizard3rd", "NightWizard3rd", "ナイトウィザード3版"], ["RokumonSekai2", "RokumonSekai2", "六門世界2nd"], ["NightmareHunterDeep", "NightmareHunterDeep", "ナイトメアハンター=ディープ"], ["ShinMegamiTenseiKakuseihen", "SMTKakuseihen", "真・女神転生TRPG　覚醒編"], ["RuneQuest", "RuneQuest", "ルーンクエスト"], ["ShoujoTenrankai", "ShoujoTenrankai", "少女展爛会"], ["Chill", "Chill", "Chill"], ["Postman", "Postman", "壊れた世界のポストマン"], ["Amadeus_Korean", "Amadeus:Korean", "아마데우스"], ["Hieizan", "Hieizan", "比叡山炎上"], ["KillDeathBusiness", "KillDeathBusiness", "キルデスビジネス"], ["ColossalHunter", "ColossalHunter", "コロッサルハンター"], ["CrashWorld", "CrashWorld", "墜落世界"], ["SwordWorld2_0", "SwordWorld2.0", "ソードワールド2.0"], ["EarthDawn", "EarthDawn", "アースドーン"], ["Oukahoushin3rd", "Oukahoushin3rd", "央華封神RPG第三版"], ["Cthulhu7th_ChineseTraditional", "Cthulhu7th:ChineseTraditional", "克蘇魯神話第7版"], ["Nechronica_Korean", "Nechronica:Korean", "네크로니카"], ["ShadowRun", "ShadowRun", "シャドウラン"], ["Cthulhu7th_Korean", "Cthulhu7th:Korean", "크툴루의 부름 7판"], ["KanColle", "KanColle", "艦これRPG"], ["Pathfinder", "Pathfinder", "Pathfinder"], ["Insane", "Insane", "インセイン"], ["EndBreaker", "EndBreaker", "エンドブレイカー"], ["BeginningIdol_Korean", "BeginningIdol:Korean", "비기닝 아이돌"], ["Torg1_5", "TORG1.5", "トーグ1.5版"], ["ShinkuuGakuen", "ShinkuuGakuen", "真空学園"], ["DeadlineHeroes", "DeadlineHeroes", "デッドラインヒーローズ"], ["ZettaiReido", "ZettaiReido", "絶対隷奴"], ["Cthulhu_Korean", "Cthulhu:Korean", "크툴루"], ["Raisondetre", "Raisondetre", "叛逆レゾンデートル"], ["HarnMaster", "HarnMaster", "ハーンマスター"], ["Arianrhod", "Arianrhod", "アリアンロッド"], ["Alter_raise", "Alter_raise", "心衝想機TRPGアルトレイズ"], ["HouraiGakuen", "HouraiGakuen", "蓬莱学園の冒険!!"], ["Satasupe", "Satasupe", "サタスペ"], ["StellarKnights", "StellarKnights", "銀剣のステラナイツ"], ["NjslyrBattle", "NJSLYRBATTLE", "NJSLYRBATTLE"], ["BloodMoon", "BloodMoon", "ブラッド・ムーン"], ["MeikyuKingdom", "MeikyuKingdom", "迷宮キングダム"], ["EclipsePhase", "EclipsePhase", "エクリプス・フェイズ"], ["TwilightGunsmoke", "TwilightGunsmoke", "トワイライト・ガンスモーク"], ["SwordWorld2_5", "SwordWorld2.5", "ソードワールド2.5"], ["Kamigakari_Korean", "Kamigakari:Korean", "카미가카리"], ["OrgaRain", "OrgaRain", "在りて遍くオルガレイン"], ["MetalHeadExtream", "MetalHeadExtream", "メタルヘッドエクストリーム"], ["EarthDawn3", "EarthDawn3", "アースドーン3版"], ["TokyoNova", "TokyoNova", "トーキョーＮ◎ＶＡ"], ["ParasiteBlood", "ParasiteBlood", "パラサイトブラッド"], ["OneWayHeroics", "OneWayHeroics", "片道勇者"], ["Gorilla", "Gorilla", "ゴリラTRPG"], ["GurpsFW", "GurpsFW", "ガープスフィルトウィズ"], ["HuntersMoon", "HuntersMoon", "ハンターズムーン"], ["BarnaKronika", "BarnaKronika", "バルナ・クロニカ"], ["AceKillerGene", "AceKillerGene", "エースキラージーン"], ["Dracurouge", "Dracurouge", "ドラクルージュ"], ["LogHorizon", "LogHorizon", "ログ・ホライズン"], ["Pendragon", "Pendragon", "ペンドラゴン"], ["Illusio", "Illusio", "晃天のイルージオ"], ["Garako", "Garako", "ガラコと破界の塔"], ["RecordOfSteam", "RecordOfSteam", "Record of Steam"], ["Avandner", "Avandner", "黒絢のアヴァンドナー"], ["MetallicGuadian", "MetallicGuadian", "メタリックガーディアン"], ["MetalHead", "MetalHead", "メタルヘッド"], ["RoleMaster", "RoleMaster", "ロールマスター"], ["BeastBindTrinity", "BeastBindTrinity", "ビーストバインド トリニティ"], ["Skynauts", "Skynauts", "歯車の塔の探空士"], ["Gurps", "GURPS", "ガープス"], ["Nuekagami", "Nuekagami", "鵺鏡"], ["WaresBlade", "WaresBlade", "ワースブレイド"], ["MonotoneMusium", "MonotoneMusium", "モノトーン・ミュージアム"], ["Warhammer", "Warhammer", "ウォーハンマー"], ["Ryutama", "Ryutama", "りゅうたま"], ["FilledWith", "FilledWith", "フィルトウィズ"], ["WitchQuest", "WitchQuest", "ウィッチクエスト"], ["MagicaLogia", "MagicaLogia", "マギカロギア"], ["GoldenSkyStories", "GoldenSkyStories", "ゆうやけこやけ"], ["DungeonsAndDoragons", "DungeonsAndDoragons", "ダンジョンズ＆ドラゴンズ"], ["Airgetlamh", "Airgetlamh", "朱の孤塔のエアゲトラム"], ["JamesBond", "JamesBond", "ジェームズ・ボンド007"], ["SwordWorld", "SwordWorld", "ソードワールド"], ["MonotoneMusium_Korean", "MonotoneMusium:Korean", "모노톤 뮤지엄"], ["EtrianOdysseySRS", "EtrianOdysseySRS", "世界樹の迷宮SRS"], ["EarthDawn4", "EarthDawn4", "アースドーン4版"], ["DoubleCross", "DoubleCross", "ダブルクロス2nd,3rd"], ["GehennaAn", "GehennaAn", "ゲヘナ・アナスタシス"], ["GranCrest", "GranCrest", "グランクレスト"], ["DetatokoSaga_Korean", "DetatokoSaga:Korean", "데타토코 사가"], ["SharedFantasia", "SharedFantasia", "Shared†Fantasia"], ["StrangerOfSwordCity", "StrangerOfSwordCity", "剣の街の異邦人TRPG"], ["WARPS", "WARPS", "ワープス"], ["HatsuneMiku", "HatsuneMiku", "初音ミクTRPG ココロダンジョン"], ["PhantasmAdventure", "PhantasmAdventure", "ファンタズムアドベンチャー"], ["Peekaboo", "Peekaboo", "ピーカーブー"], ["Nechronica", "Nechronica", "ネクロニカ"], ["GundogRevised", "GundogRevised", "ガンドッグ・リヴァイズド"], ["ArsMagica", "ArsMagica", "アルスマギカ"], ["DiceOfTheDead", "DiceOfTheDead", "ダイス・オブ・ザ・デッド"], ["Amadeus", "Amadeus", "アマデウス"], ["BlindMythos", "BlindMythos", "ブラインド・ミトス"], ["LiveraDoll", "LiveraDoll", "紫縞のリヴラドール"], ["Paranoia", "Paranoia", "パラノイア"], ["DarkDaysDrive", "DarkDaysDrive", "ダークデイズドライブ"], ["Insane_Korean", "Insane:Korean", "인세인"], ["Alsetto", "Alsetto", "詩片のアルセット"]]);
    return (Opal.defs(self, '$getBotNames', $StaticDiceBotLoaderList_getBotNames$1 = function $$getBotNames() {
      var self = this;

      return $$($nesting, 'BOT_NAMES')
    }, $StaticDiceBotLoaderList_getBotNames$1.$$arity = 0), nil) && 'getBotNames';
  })($nesting[0], null, $nesting)
};

/* Generated by Opal 0.11.99.dev */
Opal.modules["StaticTableFileData"] = function(Opal) {
  var self = Opal.top, $nesting = [], nil = Opal.nil, $$$ = Opal.const_get_qualified, $$ = Opal.const_get_relative, $breaker = Opal.breaker, $slice = Opal.slice, $klass = Opal.klass;

  Opal.add_stubs(['$new']);
  return (function($base, $super, $parent_nesting) {
    var self = $klass($base, $super, 'StaticTableFileData');

    var $nesting = [self].concat($parent_nesting), $StaticTableFileData_getTableData$1, $StaticTableFileData_getFileData$2;

    
    Opal.defs(self, '$getTableData', $StaticTableFileData_getTableData$1 = function $$getTableData() {
      var self = this, tableData = nil;

      
      tableData = $$($nesting, 'Hash').$new();
      return tableData;
    }, $StaticTableFileData_getTableData$1.$$arity = 0);
    return (Opal.defs(self, '$getFileData', $StaticTableFileData_getFileData$2 = function $$getFileData() {
      var self = this, fileData = nil;

      
      fileData = $$($nesting, 'Hash').$new();
      return fileData;
    }, $StaticTableFileData_getFileData$2.$$arity = 0), nil) && 'getFileData';
  })($nesting[0], null, $nesting)
};

/* Generated by Opal 0.11.99.dev */
Opal.modules["log"] = function(Opal) {
  var $debugPrint$1, $debugPuts$2, $debug$3, self = Opal.top, $nesting = [], nil = Opal.nil, $$$ = Opal.const_get_qualified, $$ = Opal.const_get_relative, $breaker = Opal.breaker, $slice = Opal.slice, $truthy = Opal.truthy, $gvars = Opal.gvars, $send = Opal.send;

  Opal.add_stubs(['$print', '$tosjis', '$puts', '$kind_of?', '$inspect', '$empty?', '$debugPuts', '$map', '$join']);
  
  
  Opal.def(self, '$debugPrint', $debugPrint$1 = function $$debugPrint(text) {
    var self = this;
    if ($gvars.RUBY18_WIN == null) $gvars.RUBY18_WIN = nil;

    return self.$print((function() {if ($truthy($gvars.RUBY18_WIN)) {
      return text.$tosjis()
    } else {
      return text
    }; return nil; })())
  }, $debugPrint$1.$$arity = 1);
  
  Opal.def(self, '$debugPuts', $debugPuts$2 = function $$debugPuts(text) {
    var self = this, line = nil;
    if ($gvars.RUBY18_WIN == null) $gvars.RUBY18_WIN = nil;

    
    line = "" + (text) + "\n";
    return self.$puts((function() {if ($truthy($gvars.RUBY18_WIN)) {
      return line.$tosjis()
    } else {
      return line
    }; return nil; })());
  }, $debugPuts$2.$$arity = 1);
  return (Opal.def(self, '$debug', $debug$3 = function $$debug(target, $a) {
    var $post_args, values, $$4, self = this, targetStr = nil, valueStrs = nil;
    if ($gvars.isDebug == null) $gvars.isDebug = nil;

    
    
    $post_args = Opal.slice.call(arguments, 1, arguments.length);
    
    values = $post_args;;
    if ($truthy($gvars.isDebug)) {
    } else {
      return nil
    };
    targetStr = (function() {if ($truthy(target['$kind_of?']($$($nesting, 'String')))) {
      return target
    } else {
      return target.$inspect()
    }; return nil; })();
    if ($truthy(values['$empty?']())) {
      return self.$debugPuts(targetStr)
    } else {
      
      valueStrs = $send(values, 'map', [], ($$4 = function(value){var self = $$4.$$s || this;

      
        
        if (value == null) {
          value = nil;
        };
        if ($truthy(value['$kind_of?']($$($nesting, 'String')))) {
          return "" + "\"" + (value) + "\""
        } else {
          return value.$inspect()
        };}, $$4.$$s = self, $$4.$$arity = 1, $$4));
      return self.$debugPuts("" + (targetStr) + ": " + (valueStrs.$join(", ")));
    };
  }, $debug$3.$$arity = -2), nil) && 'debug';
};

/* Generated by Opal 0.11.99.dev */
Opal.modules["kconv"] = function(Opal) {
  var self = Opal.top, $nesting = [], nil = Opal.nil, $$$ = Opal.const_get_qualified, $$ = Opal.const_get_relative, $breaker = Opal.breaker, $slice = Opal.slice, $klass = Opal.klass;

  return (function($base, $super, $parent_nesting) {
    var self = $klass($base, $super, 'Kconv');

    var $nesting = [self].concat($parent_nesting);

    
    Opal.const_set($nesting[0], 'JIS', "JIS");
    Opal.const_set($nesting[0], 'EUC', "EUC");
    Opal.const_set($nesting[0], 'SJIS', "SJIS");
    Opal.const_set($nesting[0], 'BINARY', "BINARY");
    Opal.const_set($nesting[0], 'ASCII', "ASCII");
    Opal.const_set($nesting[0], 'UTF8', "UTF8");
    return Opal.const_set($nesting[0], 'UTF16', "UTF16");
  })($nesting[0], null, $nesting)
};

/* Generated by Opal 0.11.99.dev */
Opal.modules["configBcDiceForSystem"] = function(Opal) {
  var self = Opal.top, $nesting = [], nil = Opal.nil, $$$ = Opal.const_get_qualified, $$ = Opal.const_get_relative, $breaker = Opal.breaker, $slice = Opal.slice, $gvars = Opal.gvars;

  
  $gvars.okResult = "_OK_";
  $gvars.ngResult = "_NG_";
  return ($gvars.ircNickMaxLength = 9);
};

/* Generated by Opal 0.11.99.dev */
Opal.modules["configBcDice"] = function(Opal) {
  function $rb_plus(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs + rhs : lhs['$+'](rhs);
  }
  var self = Opal.top, $nesting = [], nil = Opal.nil, $$$ = Opal.const_get_qualified, $$ = Opal.const_get_relative, $breaker = Opal.breaker, $slice = Opal.slice, $gvars = Opal.gvars;
  if ($gvars.bcDiceVersion == null) $gvars.bcDiceVersion = nil;

  Opal.add_stubs(['$require', '$+']);
  
  self.$require("kconv");
  self.$require("configBcDiceForSystem");
  $gvars.isDebug = false;
  $gvars.bcDiceVersion = "2.02.29";
  $gvars.SEND_STR_MAX = 405;
  $gvars.isRollVoidDiceAtAnyRecive = true;
  $gvars.DICE_MAXCNT = 200;
  $gvars.DICE_MAXNUM = 1000;
  $gvars.ircCode = $$$($$($nesting, 'Kconv'), 'UTF8');
  $gvars.isHandSort = true;
  $gvars.quitCommand = "お疲れ様";
  $gvars.quitMessage = "さようなら";
  $gvars.OPEN_DICE = "Open Dice!";
  $gvars.OPEN_PLOT = "Open Plot!";
  $gvars.ADD_PLOT = "PLOT";
  $gvars.READY_CMD = "#HERE";
  $gvars.server = "irc.trpg.net";
  $gvars.port = 6667;
  $gvars.defaultLoginChannelsText = "#Dice_Test";
  $gvars.nick = "bcDICE";
  $gvars.userName = $rb_plus("v", $gvars.bcDiceVersion);
  $gvars.ircName = "rubydice";
  $gvars.defaultGameType = "";
  $gvars.extraCardFileName = "";
  $gvars.iniFileName = "bcdice.ini";
  return ($gvars.allGameTypes = ["AceKillerGene", "Airgetlamh", "Alsetto", "Alshard", "Alter_raise", "Amadeus", "Amadeus:Korean", "Arianrhod", "ArsMagica", "Avandner", "BadLife", "BarnaKronika", "BattleTech", "BeastBindTrinity", "BeginningIdol", "BeginningIdol:Korean", "BladeOfArcana", "BlindMythos", "BloodCrusade", "BloodMoon", "CardRanker", "Chaos_Flare", "Chill", "Chill3", "CodeLayerd", "ColossalHunter", "CrashWorld", "Cthulhu", "Cthulhu7th", "Cthulhu7th:ChineseTraditional", "Cthulhu7th:Korean", "Cthulhu:ChineseTraditional", "Cthulhu:Korean", "CthulhuTech", "DarkBlaze", "DarkDaysDrive", "DarkSouls", "DeadlineHeroes", "DemonParasite", "DetatokoSaga", "DetatokoSaga:Korean", "DiceOfTheDead", "DoubleCross", "Dracurouge", "Dracurouge:Korean", "DungeonsAndDoragons", "EarthDawn", "EarthDawn3", "EarthDawn4", "EclipsePhase", "Elric!", "Elysion", "EmbryoMachine", "EndBreaker", "EtrianOdysseySRS", "FilledWith", "FullMetalPanic", "GURPS", "Garako", "GardenOrder", "GehennaAn", "GeishaGirlwithKatana", "GoldenSkyStories", "Gorilla", "GranCrest", "Gundog", "GundogRevised", "GundogZero", "GurpsFW", "HarnMaster", "HatsuneMiku", "Hieizan", "HouraiGakuen", "HuntersMoon", "Illusio", "InfiniteFantasia", "Insane", "Insane:Korean", "IthaWenUa", "JamesBond", "Kamigakari", "Kamigakari:Korean", "KanColle", "KillDeathBusiness", "KillDeathBusiness:Korean", "KurayamiCrying", "LiveraDoll", "LogHorizon", "LogHorizon:Korean", "LostRoyal", "MagicaLogia", "MeikyuDays", "MeikyuKingdom", "MetalHead", "MetalHeadExtream", "MetallicGuadian", "MonotoneMusium", "MonotoneMusium:Korean", "NJSLYRBATTLE", "Nechronica", "Nechronica:Korean", "NightWizard", "NightWizard3rd", "NightmareHunterDeep", "Nuekagami", "OneWayHeroics", "OrgaRain", "Oukahoushin3rd", "Paranoia", "ParasiteBlood", "Pathfinder", "Peekaboo", "Pendragon", "PhantasmAdventure", "Postman", "Raisondetre", "RecordOfSteam", "RokumonSekai2", "RoleMaster", "RuneQuest", "Ryutama", "SMTKakuseihen", "SRS", "Satasupe", "SevenFortressMobius", "ShadowRun", "ShadowRun4", "SharedFantasia", "ShinkuuGakuen", "ShinobiGami", "ShoujoTenrankai", "Skynauts", "StellarKnights", "StrangerOfSwordCity", "Strave", "SwordWorld", "SwordWorld2.0", "SwordWorld2.5", "TORG", "TORG1.5", "TherapieSein", "TokumeiTenkousei", "TokyoNova", "Tunnels_&_Trolls", "TwilightGunsmoke", "Utakaze", "WARPS", "WaresBlade", "Warhammer", "WitchQuest", "WorldOfDarkness", "YankeeYogSothoth", "ZettaiReido"]);
};

/* Generated by Opal 0.11.99.dev */
Opal.modules["CountHolder"] = function(Opal) {
  function $rb_minus(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs - rhs : lhs['$-'](rhs);
  }
  function $rb_plus(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs + rhs : lhs['$+'](rhs);
  }
  var self = Opal.top, $nesting = [], nil = Opal.nil, $$$ = Opal.const_get_qualified, $$ = Opal.const_get_relative, $breaker = Opal.breaker, $slice = Opal.slice, $klass = Opal.klass, $gvars = Opal.gvars, $truthy = Opal.truthy, $hash2 = Opal.hash2, $send = Opal.send;

  Opal.add_stubs(['$require', '$debug', '$getNick', '$==', '$===', '$get_point_list', '$delete_point_list', '$nil?', '$rename_point_counter', '$!=', '$=~', '$executeSetCommand', '$to_i', '$setCountHolderByParams', '$setCount', '$changeCount', '$[]', '$[]=', '$-', '$getCharacterInfoList', '$<<', '$downcase', '$parren_killer', '$getCharacterInfo', '$getValueText', '$+', '$getPointListAtSameNick', '$empty?', '$getPointListAtSameChannel', '$each', '$sort_point_hash', '$split', '$upcase', '$sort', '$keys', '$delete', '$setPointCounter', '$include?', '$sort_by', '$getPointHashCurrentAndMax', '$<=>', '$b_crr', '$a_crr']);
  
  self.$require("log");
  self.$require("configBcDice");
  return (function($base, $super, $parent_nesting) {
    var self = $klass($base, $super, 'CountHolder');

    var $nesting = [self].concat($parent_nesting), $CountHolder_initialize$1, $CountHolder_executeCommand$2, $CountHolder_executeSetCommand$3, $CountHolder_setCountHolderByParams$4, $CountHolder_setCount$5, $CountHolder_changeCount$6, $CountHolder_getValueText$7, $CountHolder_getCharacterInfoList$8, $CountHolder_getCharacterInfo$9, $CountHolder_get_point_list$10, $CountHolder_getPointListAtSameNick$11, $CountHolder_getPointListAtSameChannel$16, $CountHolder_rename_point_counter$19, $CountHolder_setPointCounters$20, $CountHolder_setPointCounter$21, $CountHolder_sort_point_hash$22, $CountHolder_getPointHashCurrentAndMax$24;

    self.$$prototype.bcdice = self.$$prototype.command = self.$$prototype.nick = self.$$prototype.channel = self.$$prototype.pointerMode = self.$$prototype.maxValue = self.$$prototype.characterName = self.$$prototype.tagName = self.$$prototype.currentValue = self.$$prototype.modifyText = self.$$prototype.countInfos = nil;
    
    
    Opal.def(self, '$initialize', $CountHolder_initialize$1 = function $$initialize(bcdice, countInfos) {
      var self = this;

      
      self.bcdice = bcdice;
      return (self.countInfos = countInfos);
    }, $CountHolder_initialize$1.$$arity = 2);
    
    Opal.def(self, '$executeCommand', $CountHolder_executeCommand$2 = function $$executeCommand(command, nick, channel, pointerMode) {
      var $a, self = this, output = nil, isSecret = nil, $case = nil, __last__match__1 = nil, __last__match__2 = nil, __last__match__3 = nil, __last__match__4 = nil, __last__match__5 = nil, __last__match__6 = nil, __last__match__7 = nil, __last__match__8 = nil, __last__match__9 = nil, __last__match__10 = nil, __last__match__11 = nil, __last__match__12 = nil, __last__match__13 = nil, __last__match__14 = nil, __last__match__15 = nil, __last__match__16 = nil, __last__match__17 = nil, __last__match__18 = nil, __last__match__19 = nil, __last__match__20 = nil;

      
      self.$debug("point_counter_command begin(command, nick, channel, pointerMode)", command, nick, channel, pointerMode);
      self.command = command;
      self.nick = self.bcdice.$getNick(nick);
      self.channel = channel;
      self.pointerMode = pointerMode;
      output = "1";
      isSecret = pointerMode['$==']("sameNick");
      $case = self.command;
      if (/^#OPEN!/i['$===']($case)) {
      __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
      __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
      __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
      __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
      __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
      __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
      __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
      __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
      __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
      __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
      __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
      __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
      __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
      __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
      __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
      __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
      __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
      __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
      __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
      __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
      output = self.$get_point_list();}
      else if (/^#(.*)DIED!/i['$===']($case)) {
      __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
      __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
      __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
      __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
      __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
      __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
      __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
      __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
      __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
      __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
      __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
      __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
      __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
      __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
      __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
      __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
      __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
      __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
      __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
      __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
      output = self.$delete_point_list();
      if ($truthy(output['$nil?']())) {
      } else {
        
        output = "" + (nick) + ": " + (output) + " のカウンタが削除されました";
        isSecret = true;
      };}
      else if (/^#RENAME!/i['$===']($case)) {
      __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
      __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
      __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
      __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
      __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
      __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
      __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
      __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
      __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
      __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
      __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
      __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
      __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
      __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
      __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
      __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
      __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
      __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
      __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
      __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
      output = self.$rename_point_counter();
      if ($truthy(output['$!=']("1"))) {
        
        output = "" + (nick) + ": " + (output);
        isSecret = false;};}
      else {if ($truthy(/^#/['$=~'](self.command))) {
        
        __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
        __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
        __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
        __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
        __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
        __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
        __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
        __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
        __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
        __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
        __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
        __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
        __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
        __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
        __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
        __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
        __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
        __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
        __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
        __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
        output = self.$executeSetCommand();
        if ($truthy(output['$!=']("1"))) {
          output = "" + (nick) + ": " + (output)};}};
      self.$debug("point_counter_command END output, isSecret", output, isSecret);
      return [output, isSecret];
    }, $CountHolder_executeCommand$2.$$arity = 4);
    
    Opal.def(self, '$executeSetCommand', $CountHolder_executeSetCommand$3 = function $$executeSetCommand() {
      var $a, self = this, output = nil, $case = nil, __last__match__1 = nil, __last__match__2 = nil, __last__match__3 = nil, __last__match__4 = nil, __last__match__5 = nil, __last__match__6 = nil, __last__match__7 = nil, __last__match__8 = nil, __last__match__9 = nil, __last__match__10 = nil, __last__match__11 = nil, __last__match__12 = nil, __last__match__13 = nil, __last__match__14 = nil, __last__match__15 = nil, __last__match__16 = nil, __last__match__17 = nil, __last__match__18 = nil, __last__match__19 = nil, __last__match__20 = nil;
      if ($gvars.point_counter == null) $gvars.point_counter = nil;

      
      self.$debug("setCountHolder nick, channel, pointerMode", self.nick, self.channel, self.pointerMode);
      self.characterName = self.nick;
      self.tagName = nil;
      self.currentValue = nil;
      self.maxValue = nil;
      self.modifyText = nil;
      self.$debug("$point_counter", $gvars.point_counter);
      output = "1";
      self.$debug("@command", self.command);
      $case = self.command;
      if (/^#([^:\uFF1A]+)(:|\uFF1A)(\w+?)\s*(\d+)(\/(\d+))?/['$===']($case)) {
      __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
      __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
      __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
      __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
      __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
      __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
      __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
      __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
      __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
      __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
      __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
      __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
      __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
      __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
      __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
      __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
      __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
      __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
      __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
      __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
      self.$debug(" #(識別名):(タグ)(現在値)/(最大値) で指定します。最大値がないものは省略できます。");
      self.characterName = __last__match__1;
      self.tagName = __last__match__3;
      self.currentValue = __last__match__4.$to_i();
      self.maxValue = __last__match__6;}
      else if (/^#([^:：]+)(:|：)(\w+?)\s*([\+\-]\d+)/['$===']($case)) {
      __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
      __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
      __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
      __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
      __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
      __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
      __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
      __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
      __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
      __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
      __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
      __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
      __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
      __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
      __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
      __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
      __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
      __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
      __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
      __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
      self.$debug(" #(識別名):(タグ)(変更量)");
      self.characterName = __last__match__1;
      self.tagName = __last__match__3;
      self.modifyText = __last__match__4;}
      else if (/^#(\w+?)\s*(\d+)\/(\d+)/['$===']($case)) {
      __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
      __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
      __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
      __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
      __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
      __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
      __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
      __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
      __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
      __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
      __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
      __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
      __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
      __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
      __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
      __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
      __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
      __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
      __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
      __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
      self.$debug(" #(タグ)(現在値)/(最大値) 現在値/最大値指定は半角のみ。");
      self.tagName = __last__match__1;
      self.currentValue = __last__match__2.$to_i();
      self.maxValue = __last__match__3;}
      else if (/^#(\w+?)\s*([\+\-]\d+)/['$===']($case)) {
      __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
      __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
      __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
      __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
      __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
      __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
      __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
      __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
      __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
      __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
      __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
      __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
      __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
      __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
      __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
      __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
      __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
      __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
      __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
      __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
      self.$debug(" #(タグ)(変更量)");
      self.tagName = __last__match__1;
      self.modifyText = __last__match__2;}
      else if (/^#(\w+?)\s*(\d+)/['$===']($case)) {
      __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
      __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
      __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
      __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
      __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
      __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
      __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
      __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
      __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
      __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
      __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
      __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
      __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
      __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
      __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
      __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
      __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
      __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
      __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
      __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
      self.$debug(" #(タグ)(現在値) で指定します。現在値は半角です。");
      self.tagName = __last__match__1;
      self.currentValue = __last__match__2.$to_i();}
      else if (/^#(\w+?)\s*([\+\-]\d+)/['$===']($case)) {
      __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
      __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
      __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
      __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
      __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
      __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
      __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
      __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
      __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
      __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
      __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
      __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
      __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
      __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
      __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
      __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
      __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
      __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
      __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
      __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
      self.$debug(" #(タグ)(変更量) ");
      self.tagName = __last__match__1;
      self.modifyText = __last__match__2;}
      else {
      self.$debug("not match command", self.command);
      return "";};
      if ($truthy(self.maxValue['$nil?']())) {
      } else {
        self.maxValue = self.maxValue.$to_i()
      };
      self.$debug("characterName", self.characterName);
      self.$debug("tagName", self.tagName);
      self.$debug("@currentValue", self.currentValue);
      self.$debug("@maxValue", self.maxValue);
      self.$debug("@modifyText", self.modifyText);
      return self.$setCountHolderByParams();
    }, $CountHolder_executeSetCommand$3.$$arity = 0);
    
    Opal.def(self, '$setCountHolderByParams', $CountHolder_setCountHolderByParams$4 = function $$setCountHolderByParams() {
      var self = this;

      
      self.$debug("@modifyText", self.modifyText);
      if ($truthy(self.modifyText['$nil?']())) {
        return self.$setCount()
      } else {
        return self.$changeCount()
      };
    }, $CountHolder_setCountHolderByParams$4.$$arity = 0);
    
    Opal.def(self, '$setCount', $CountHolder_setCount$5 = function $$setCount() {
      var $a, self = this, $writer = nil, characterInfoList = nil, characterInfo = nil, output = nil;

      
      ($truthy($a = self.countInfos['$[]'](self.channel)) ? $a : (($writer = [self.channel, $hash2([], {})]), $send(self.countInfos, '[]=', Opal.to_a($writer)), $writer[$rb_minus($writer["length"], 1)]));
      characterInfoList = self.$getCharacterInfoList();
      ($truthy($a = characterInfoList['$[]'](self.characterName)) ? $a : (($writer = [self.characterName, $hash2([], {})]), $send(characterInfoList, '[]=', Opal.to_a($writer)), $writer[$rb_minus($writer["length"], 1)]));
      characterInfo = characterInfoList['$[]'](self.characterName);
      
      $writer = [self.tagName, $hash2(["currentValue", "maxValue"], {"currentValue": self.currentValue, "maxValue": self.maxValue})];
      $send(characterInfo, '[]=', Opal.to_a($writer));
      $writer[$rb_minus($writer["length"], 1)];;
      self.$debug("setCount @nick, @characterName", self.nick, self.characterName);
      output = "";
      if ($truthy(self.nick['$!='](self.characterName))) {
        output['$<<']("" + (self.characterName.$downcase()))};
      output['$<<']("" + "(" + (self.tagName) + ") " + (self.currentValue));
      self.$debug("setCount @maxValue", self.maxValue);
      if ($truthy(self.maxValue['$nil?']())) {
      } else {
        output['$<<']("" + "/" + (self.maxValue))
      };
      return output;
    }, $CountHolder_setCount$5.$$arity = 0);
    
    Opal.def(self, '$changeCount', $CountHolder_changeCount$6 = function $$changeCount() {
      var self = this, modifyValue = nil, characterInfo = nil, info = nil, currentValue = nil, maxValue = nil, preText = nil, $writer = nil, nowText = nil, output = nil;

      
      self.$debug("changeCount begin");
      modifyValue = self.bcdice.$parren_killer("" + "(0" + (self.modifyText) + ")").$to_i();
      characterInfo = self.$getCharacterInfo(self.channel, self.characterName);
      info = characterInfo['$[]'](self.tagName);
      self.$debug("characterInfo", characterInfo);
      self.$debug("info", info);
      if ($truthy(info['$nil?']())) {
        return ""};
      currentValue = info['$[]']("currentValue");
      maxValue = info['$[]']("maxValue");
      preText = self.$getValueText(currentValue, maxValue);
      self.$debug("currentValue", currentValue);
      self.$debug("modifyValue", modifyValue);
      currentValue = $rb_plus(currentValue, modifyValue);
      
      $writer = ["currentValue", currentValue];
      $send(info, '[]=', Opal.to_a($writer));
      $writer[$rb_minus($writer["length"], 1)];;
      nowText = self.$getValueText(currentValue, maxValue);
      output = "";
      if ($truthy(self.nick['$!='](self.characterName))) {
        output['$<<']("" + (self.characterName.$downcase()))};
      output['$<<']("" + "(" + (self.tagName) + ") " + (preText) + " -> " + (nowText));
      self.$debug("changeCount end output", output);
      return output;
    }, $CountHolder_changeCount$6.$$arity = 0);
    
    Opal.def(self, '$getValueText', $CountHolder_getValueText$7 = function $$getValueText(currentValue, maxValue) {
      var self = this, text = nil;

      
      text = "" + (currentValue);
      if ($truthy(maxValue['$nil?']())) {
      } else {
        text = $rb_plus(text, "" + "/" + (maxValue))
      };
      return text;
    }, $CountHolder_getValueText$7.$$arity = 2);
    
    Opal.def(self, '$getCharacterInfoList', $CountHolder_getCharacterInfoList$8 = function $$getCharacterInfoList(channel) {
      var $a, self = this, $writer = nil, characterInfoList = nil;

      
      
      if (channel == null) {
        channel = nil;
      };
      channel = ($truthy($a = channel) ? $a : self.channel);
      ($truthy($a = self.countInfos['$[]'](channel)) ? $a : (($writer = [channel, $hash2([], {})]), $send(self.countInfos, '[]=', Opal.to_a($writer)), $writer[$rb_minus($writer["length"], 1)]));
      characterInfoList = self.countInfos['$[]'](channel);
      return characterInfoList;
    }, $CountHolder_getCharacterInfoList$8.$$arity = -1);
    
    Opal.def(self, '$getCharacterInfo', $CountHolder_getCharacterInfo$9 = function $$getCharacterInfo(channel, characterName) {
      var $a, self = this, characterInfoList = nil, $writer = nil, characterInfo = nil;

      
      characterName = ($truthy($a = characterName) ? $a : self.characterName);
      characterInfoList = self.$getCharacterInfoList(channel);
      ($truthy($a = characterInfoList['$[]'](characterName)) ? $a : (($writer = [characterName, $hash2([], {})]), $send(characterInfoList, '[]=', Opal.to_a($writer)), $writer[$rb_minus($writer["length"], 1)]));
      characterInfo = characterInfoList['$[]'](characterName);
      return characterInfo;
    }, $CountHolder_getCharacterInfo$9.$$arity = 2);
    
    Opal.def(self, '$get_point_list', $CountHolder_get_point_list$10 = function $$get_point_list() {
      var $a, self = this, output = nil, __last__match__1 = nil, __last__match__2 = nil, __last__match__3 = nil, __last__match__4 = nil, __last__match__5 = nil, __last__match__6 = nil, __last__match__7 = nil, __last__match__8 = nil, __last__match__9 = nil, __last__match__10 = nil, __last__match__11 = nil, __last__match__12 = nil, __last__match__13 = nil, __last__match__14 = nil, __last__match__15 = nil, __last__match__16 = nil, __last__match__17 = nil, __last__match__18 = nil, __last__match__19 = nil, __last__match__20 = nil, tag = nil, $case = nil, pc_out = nil;

      
      self.$debug("get_point_list(command, nick, channel, pointerMode)", self.command, self.nick, self.channel, self.pointerMode);
      output = "1";
      if ($truthy(/^#OPEN![\s]*(\w*)(\s|$)/['$=~'](self.command))) {
      } else {
        return output
      };
      __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
      __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
      __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
      __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
      __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
      __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
      __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
      __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
      __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
      __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
      __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
      __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
      __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
      __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
      __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
      __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
      __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
      __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
      __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
      __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
      tag = __last__match__1;
      $case = self.pointerMode;
      if ("sameNick"['$===']($case)) {
      self.$debug("same nick");
      pc_out = self.$getPointListAtSameNick(tag);
      if ($truthy(pc_out['$empty?']())) {
      } else {
        output = pc_out
      };}
      else if ("sameChannel"['$===']($case)) {if ($truthy(tag)) {
        
        self.$debug("same Channel");
        pc_out = self.$getPointListAtSameChannel(tag);
        if ($truthy(pc_out['$empty?']())) {
        } else {
          output = pc_out
        };}};
      return output;
    }, $CountHolder_get_point_list$10.$$arity = 0);
    
    Opal.def(self, '$getPointListAtSameNick', $CountHolder_getPointListAtSameNick$11 = function $$getPointListAtSameNick(command, nick, channel, pointerMode, tag) {
      var $$12, $$14, $$15, self = this, pc_list = nil, pc_out = nil, sort_pc = nil, out_pc = nil, pc_sorted = nil, tag_arr = nil, tag_out = nil;
      if ($gvars.point_counter == null) $gvars.point_counter = nil;

      
      self.$debug("getPointListAtSameNick(command, nick, channel, pointerMode, tag)", command, nick, channel, pointerMode, tag);
      self.$debug("同一Nick, 自キャラの一覧表示(パラメータ指定不要)");
      pc_list = $gvars.point_counter['$[]'](nick);
      pc_out = "";
      if ($truthy(pc_list)) {
        
        sort_pc = $hash2([], {});
        $send(pc_list, 'each', [], ($$12 = function(pc_o){var self = $$12.$$s || this, $$13, tag_out = nil, check_name = nil, $writer = nil, tag_arr = nil;
          if ($gvars.point_counter == null) $gvars.point_counter = nil;

        
          
          if (pc_o == null) {
            pc_o = nil;
          };
          if ($truthy($gvars.point_counter['$[]']("" + (nick) + "," + (pc_o)))) {
            
            tag_out = "";
            if ($truthy(tag)) {
              
              check_name = "" + (nick) + "," + (pc_o);
              if ($truthy($gvars.point_counter['$[]']("" + (check_name) + "," + (tag) + ",0"))) {
                
                $writer = [check_name, $gvars.point_counter['$[]']("" + (check_name) + "," + (tag) + ",0")];
                $send(sort_pc, '[]=', Opal.to_a($writer));
                $writer[$rb_minus($writer["length"], 1)];};
              if ($truthy($gvars.point_counter['$[]']("" + (check_name) + "," + (tag) + ",1"))) {
                
                $writer = [check_name, $gvars.point_counter['$[]']("" + (check_name) + "," + (tag) + ",1")];
                $send(sort_pc, '[]=', Opal.to_a($writer));
                $writer[$rb_minus($writer["length"], 1)];};
            } else {
              
              tag_arr = $gvars.point_counter['$[]']("" + (nick) + "," + (pc_o));
              $send(tag_arr, 'each', [], ($$13 = function(tag_o){var self = $$13.$$s || this;
                if ($gvars.point_counter == null) $gvars.point_counter = nil;

              
                
                if (tag_o == null) {
                  tag_o = nil;
                };
                check_name = "" + (nick) + "," + (pc_o) + "," + (tag_o);
                if ($truthy($gvars.point_counter['$[]']("" + (check_name) + ",0"))) {
                  tag_out = $rb_plus(tag_out, $rb_plus($rb_plus("$tag_o(", $gvars.point_counter['$[]']("" + (check_name) + ",0")), ") "))};
                if ($truthy($gvars.point_counter['$[]']("" + (check_name) + ",1"))) {
                  return (tag_out = $rb_plus(tag_out, $rb_plus($rb_plus("" + (tag_o) + "[", $gvars.point_counter['$[]']("" + (check_name) + ",1")), "] ")))
                } else {
                  return nil
                };}, $$13.$$s = self, $$13.$$arity = 1, $$13));
            };
            if ($truthy(tag_out)) {
              
              self.$debug("中身があるなら");
              if ($truthy(pc_out)) {
                pc_out = $rb_plus(pc_out, ", ")};
              return (pc_out = $rb_plus(pc_out, "" + (pc_o.$downcase()) + ":" + (tag_out)));
            } else {
              return nil
            };
          } else {
            return nil
          };}, $$12.$$s = self, $$12.$$arity = 1, $$12));
        if ($truthy(tag)) {
          
          out_pc = "";
          pc_sorted = self.$sort_point_hash(sort_pc);
          $send(pc_sorted, 'each', [], ($$14 = function(pc_o){var self = $$14.$$s || this, pc_name = nil;
            if ($gvars.pc_name == null) $gvars.pc_name = nil;
            if ($gvars.point_counter == null) $gvars.point_counter = nil;

          
            
            if (pc_o == null) {
              pc_o = nil;
            };
            pc_name = pc_o.$split(/,/);
            if ($truthy(out_pc)) {
              out_pc = $rb_plus(out_pc, ", ")};
            if ($truthy($gvars.pc_name['$[]'](1))) {
              
              if ($truthy($gvars.point_counter['$[]']("" + (pc_o) + "," + (tag) + ",0"))) {
                out_pc = $rb_plus(out_pc, $rb_plus($rb_plus("" + (pc_name['$[]'](1).$upcase()) + "(", $gvars.point_counter['$[]']("" + (pc_o) + "," + (tag) + ",0")), ")"))};
              if ($truthy($gvars.point_counter['$[]']("" + (pc_o) + "," + (tag) + ",1"))) {
                return (out_pc = $rb_plus(out_pc, $rb_plus($rb_plus("" + (pc_name['$[]'](1).$upcase()) + "[", $gvars.point_counter['$[]']("" + (pc_o) + "," + (tag) + ",1")), "]")))
              } else {
                return nil
              };
            } else {
              
              if ($truthy($gvars.point_counter['$[]']("" + (pc_o) + "," + (tag) + ",0"))) {
                out_pc = $rb_plus(out_pc, $rb_plus($rb_plus("" + (pc_name['$[]'](0).$upcase()) + "(", $gvars.point_counter['$[]']("" + (pc_o) + "," + (tag) + ",0")), ")"))};
              if ($truthy($gvars.point_counter['$[]']("" + (pc_o) + "," + (tag) + ",1"))) {
                return (out_pc = $rb_plus(out_pc, $rb_plus($rb_plus("" + (pc_name['$[]'](0).$upcase()) + "[", $gvars.point_counter['$[]']("" + (pc_o) + "," + (tag) + ",1")), "]")))
              } else {
                return nil
              };
            };}, $$14.$$s = self, $$14.$$arity = 1, $$14));
          if ($truthy(out_pc)) {
            pc_out = "" + (tag) + ": " + (out_pc)};};
      } else if ($truthy($gvars.point_counter['$[]']("$nick,"))) {
        
        tag_arr = $gvars.point_counter['$[]']("$nick,");
        tag_out = "";
        $send(tag_arr, 'each', [], ($$15 = function(tag_o){var self = $$15.$$s || this, check_name = nil;
          if ($gvars.point_counter == null) $gvars.point_counter = nil;

        
          
          if (tag_o == null) {
            tag_o = nil;
          };
          check_name = "" + (nick) + ",," + (tag_o);
          if ($truthy($gvars.point_counter['$[]']("" + (check_name) + ",0"))) {
            tag_out = $rb_plus(tag_out, $rb_plus($rb_plus("" + (tag_o) + "(", $gvars.point_counter['$[]']("" + (check_name) + ",0")), ") "))};
          if ($truthy($gvars.point_counter['$[]']("" + (check_name) + ",1"))) {
            return (tag_out = $rb_plus(tag_out, $rb_plus($rb_plus("" + (tag_o) + "[", $gvars.point_counter['$[]']("" + (check_name) + ",1")), "] ")))
          } else {
            return nil
          };}, $$15.$$s = self, $$15.$$arity = 1, $$15));
        if ($truthy(tag_out)) {
          
          self.$debug("中身があるなら");
          if ($truthy(pc_out)) {
            pc_out = $rb_plus(pc_out, ", ")};
          pc_out = $rb_plus(pc_out, "" + (tag_out));};};
      return pc_out;
    }, $CountHolder_getPointListAtSameNick$11.$$arity = 5);
    
    Opal.def(self, '$getPointListAtSameChannel', $CountHolder_getPointListAtSameChannel$16 = function $$getPointListAtSameChannel(tagName) {
      var $$17, self = this, output = nil, characterInfoList = nil;

      
      self.$debug("getPointListAtSameChannel(command, nick, channel, pointerMode, tagName)", self.command, self.nick, self.channel, self.pointerMode, tagName);
      self.$debug("同一チャンネル特定タグ(ポイント)の表示");
      output = "";
      if ($truthy(tagName['$empty?']())) {
      } else {
        output['$<<']("" + (tagName) + ":")
      };
      self.$debug("getPointListAtSameChannel @countInfos", self.countInfos);
      characterInfoList = self.$getCharacterInfoList();
      $send(characterInfoList.$keys().$sort(), 'each', [], ($$17 = function(characterName){var self = $$17.$$s || this, $$18, characterInfo = nil, tagText = nil;

      
        
        if (characterName == null) {
          characterName = nil;
        };
        characterInfo = characterInfoList['$[]'](characterName);
        tagText = "";
        $send(characterInfo.$keys().$sort(), 'each', [], ($$18 = function(currentTag){var self = $$18.$$s || this, info = nil, currentValue = nil, maxValue = nil;

        
          
          if (currentTag == null) {
            currentTag = nil;
          };
          if ($truthy(tagName['$empty?']())) {
          } else if ($truthy(tagName['$=='](currentTag))) {
          } else {
            return nil;
          };
          info = characterInfo['$[]'](currentTag);
          currentValue = info['$[]']("currentValue");
          maxValue = info['$[]']("maxValue");
          tagText['$<<']("" + (currentValue));
          if ($truthy(maxValue['$nil?']())) {
            return nil
          } else {
            return tagText['$<<']("" + "/" + (maxValue))
          };}, $$18.$$s = self, $$18.$$arity = 1, $$18));
        if ($truthy(tagText['$empty?']())) {
          return nil
        } else {
          
          if ($truthy(output['$empty?']())) {
          } else {
            output['$<<'](" ")
          };
          return output['$<<']("" + (characterName) + "(" + (tagText) + ")");
        };}, $$17.$$s = self, $$17.$$arity = 1, $$17));
      return output;
    }, $CountHolder_getPointListAtSameChannel$16.$$arity = 1);
    
    Opal.def(self, '$rename_point_counter', $CountHolder_rename_point_counter$19 = function $$rename_point_counter() {
      var $a, self = this, output = nil, __last__match__1 = nil, __last__match__2 = nil, __last__match__3 = nil, __last__match__4 = nil, __last__match__5 = nil, __last__match__6 = nil, __last__match__7 = nil, __last__match__8 = nil, __last__match__9 = nil, __last__match__10 = nil, __last__match__11 = nil, __last__match__12 = nil, __last__match__13 = nil, __last__match__14 = nil, __last__match__15 = nil, __last__match__16 = nil, __last__match__17 = nil, __last__match__18 = nil, __last__match__19 = nil, __last__match__20 = nil, oldName = nil, newName = nil, characterInfoList = nil, counterInfo = nil, $writer = nil;

      
      self.$debug("rename_point_counter @command, @nick", self.command, self.nick);
      output = "1";
      if ($truthy(/^#RENAME!\s*(.+?)\s*\-\>\s*(.+?)(\s|$)/['$=~'](self.command))) {
      } else {
        return output
      };
      __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
      __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
      __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
      __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
      __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
      __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
      __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
      __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
      __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
      __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
      __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
      __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
      __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
      __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
      __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
      __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
      __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
      __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
      __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
      __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
      oldName = __last__match__1;
      newName = __last__match__2;
      self.$debug("oldName, newName", oldName, newName);
      characterInfoList = self.$getCharacterInfoList(self.channel);
      counterInfo = characterInfoList.$delete(oldName);
      if ($truthy(counterInfo['$nil?']())) {
        return output};
      
      $writer = [newName, counterInfo];
      $send(characterInfoList, '[]=', Opal.to_a($writer));
      $writer[$rb_minus($writer["length"], 1)];;
      output = "" + (oldName) + "->" + (newName);
      return output;
    }, $CountHolder_rename_point_counter$19.$$arity = 0);
    
    Opal.def(self, '$setPointCounters', $CountHolder_setPointCounters$20 = function $$setPointCounters(nick, pc, target) {
      var self = this, key = nil;

      
      key = "" + (nick) + "," + (pc);
      self.$setPointCounter(key, pc);
      key = "" + (nick) + "," + (pc) + "," + (target);
      return self.$setPointCounter(key, target);
    }, $CountHolder_setPointCounters$20.$$arity = 3);
    
    Opal.def(self, '$setPointCounter', $CountHolder_setPointCounter$21 = function $$setPointCounter(key, data) {
      var self = this, $writer = nil, cnt_list = nil;
      if ($gvars.point_counter == null) $gvars.point_counter = nil;

      
      self.$debug("setPointCounter begin key, data", key, data);
      if ($truthy($gvars.point_counter['$include?'](key))) {
      } else {
        
        self.$debug("$point_counterにkeyが存在しないので新規作成");
        
        $writer = [key, data];
        $send($gvars.point_counter, '[]=', Opal.to_a($writer));
        $writer[$rb_minus($writer["length"], 1)];;
        return nil;
      };
      self.$debug("$point_counterにkeyが存在する場合");
      cnt_list = $gvars.point_counter['$[]'](key);
      if ($truthy(cnt_list['$include?'](data))) {
        return nil
      } else {
        return cnt_list['$<<'](data)
      };
    }, $CountHolder_setPointCounter$21.$$arity = 2);
    
    Opal.def(self, '$sort_point_hash', $CountHolder_sort_point_hash$22 = function $$sort_point_hash(base_hash) {
      var $$23, self = this, keys = nil, pc_sorted = nil;

      
      keys = base_hash.$keys();
      pc_sorted = $send(keys, 'sort_by', [], ($$23 = function(a, b){var self = $$23.$$s || this, $a, $b, a_current = nil, a_max = nil, b_current = nil, b_max = nil, compare = nil;

      
        
        if (a == null) {
          a = nil;
        };
        
        if (b == null) {
          b = nil;
        };
        $b = self.$getPointHashCurrentAndMax(a), $a = Opal.to_ary($b), (a_current = ($a[0] == null ? nil : $a[0])), (a_max = ($a[1] == null ? nil : $a[1])), $b;
        $b = self.$getPointHashCurrentAndMax(b), $a = Opal.to_ary($b), (b_current = ($a[0] == null ? nil : $a[0])), (b_max = ($a[1] == null ? nil : $a[1])), $b;
        compare = self.$b_crr()['$<=>'](self.$a_crr());
        if ($truthy(compare['$=='](0))) {
          
          compare = a_max['$<=>'](b_max);
          if ($truthy(compare['$=='](0))) {
            compare = a['$<=>'](b)};};
        return compare;}, $$23.$$s = self, $$23.$$arity = 2, $$23));
      return pc_sorted;
    }, $CountHolder_sort_point_hash$22.$$arity = 1);
    return (Opal.def(self, '$getPointHashCurrentAndMax', $CountHolder_getPointHashCurrentAndMax$24 = function $$getPointHashCurrentAndMax(key) {
      var $a, self = this, __last__match__1 = nil, __last__match__2 = nil, __last__match__3 = nil, __last__match__4 = nil, __last__match__5 = nil, __last__match__6 = nil, __last__match__7 = nil, __last__match__8 = nil, __last__match__9 = nil, __last__match__10 = nil, __last__match__11 = nil, __last__match__12 = nil, __last__match__13 = nil, __last__match__14 = nil, __last__match__15 = nil, __last__match__16 = nil, __last__match__17 = nil, __last__match__18 = nil, __last__match__19 = nil, __last__match__20 = nil, current = nil, max = nil;

      
      if ($truthy(/(\d+)[\/](\d+)/['$=~'](key))) {
        
        __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
        __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
        __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
        __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
        __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
        __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
        __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
        __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
        __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
        __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
        __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
        __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
        __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
        __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
        __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
        __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
        __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
        __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
        __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
        __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
        current = __last__match__1;
        max = __last__match__2;
        return [current, max];};
      return [0, 0];
    }, $CountHolder_getPointHashCurrentAndMax$24.$$arity = 1), nil) && 'getPointHashCurrentAndMax';
  })($nesting[0], null, $nesting);
};

/* Generated by Opal 0.11.99.dev */
Opal.modules["CardTrader"] = function(Opal) {
  function $rb_minus(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs - rhs : lhs['$-'](rhs);
  }
  function $rb_gt(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs > rhs : lhs['$>'](rhs);
  }
  function $rb_plus(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs + rhs : lhs['$+'](rhs);
  }
  function $rb_le(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs <= rhs : lhs['$<='](rhs);
  }
  function $rb_lt(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs < rhs : lhs['$<'](rhs);
  }
  function $rb_times(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs * rhs : lhs['$*'](rhs);
  }
  var self = Opal.top, $nesting = [], nil = Opal.nil, $$$ = Opal.const_get_qualified, $$ = Opal.const_get_relative, $breaker = Opal.breaker, $slice = Opal.slice, $gvars = Opal.gvars, $klass = Opal.klass, $hash2 = Opal.hash2, $send = Opal.send, $truthy = Opal.truthy;

  Opal.add_stubs(['$require', '$attr_accessor', '$attr_reader', '$initValues', '$set1Deck1Joker', '$card_place=', '$-', '$debug', '$clone', '$lambda', '$sendMessageToOnlySender', '$each', '$to_proc', '$sleep', '$=~', '$to_i', '$>', '$sendMessageToChannels', '$readExtraCard', '$to_s', '$sendMessage', '$nil?', '$empty?', '$readlines', '$__last__match__1', '$__last__match__2', '$push', '$[]=', '$raise', '$+', '$===', '$shuffleCards', '$drawCardByCommandText', '$drawCardOpen', '$getHandAndPlaceCardInfoText', '$playCardByCommandText', '$returnCards', '$clearAllPlaceAllPlayerCards', '$reviewCards', '$getAllCardLocation', '$transferCardsByCommandText', '$pickupCardCommandText', '$backCardCommandText', '$dealCard', '$lookAndDealCard', '$discardCardCommandText', '$sendCardToTargetNickPlaceCommandText', '$tapCardCommandText', '$printCardRestorationSpellResult', '$printMilStoneResult', '$drawCard', '$length', '$getCardsTextFromCards', '$[]', '$upcase', '$<=', '$times', '$ejectOneCardRandomFromCards', '$<<', '$pickupCard', '$!=', '$getCardsText', '$pickupCardByCardName', '$join', '$split', '$pickupCardByCards', '$pickupOneCard', '$==', '$delete_if', '$backCard', '$backCardByCommandSetAndPlace', '$backOneCard', '$getBurriedCard', '$transferOneCard', '$sendDealResult', '$discardCards', '$playCard', '$playCardByCardsBlockTextAndPlaceNo', '$playCardByCardsTextAndPlaceNo', '$playCardByCardAndPlaceNo', '$playOneCard', '$discardOneCard', '$discardCardsByCommandSetAndPlaceAndDestination', '$discardCardsByCardsAndPlace', '$getDestinationWhenPlaceIsNotHand', '$getCardsFromDealCards', '$reject!', '$!', '$transferCards', '$<', '$transferCardsByCommand', '$transferCardsByCards', '$transferTargetCard', '$transferTargetCardToNewMember', '$roll', '$delete_at', '$getSendCardToTargetNickPlace', '$printRegistCardResult', '$okCards', '$getSendCardToTargetNickPlaceByCardSetAndDestination', '$getSendCardToTargetNickPlaceByCards', '$tapCard', '$tapCardByCardsTextAndPlace', '$tapOneCardByCardAndPlace', '$*', '$getCardMilstone', '$clearAllPlayerCardsWhenPlayedPlace', '$clearAllPlayerCards', '$clear', '$shift', '$getCardLocationOnPlace', '$getCardLocationOnNumberdPlace', '$isTapCardPlace', '$getHandCardInfoText', '$getPlaceCardInfoText', '$getDealCardsText', '$compareCardByCardNumber', '$<=>', '$sort', '$compareCard', '$%', '$throwCardRestorationSpell', '$getNewSpellText', '$setNewSpellText', '$keys', '$getSpellWords', '$getDealCardIndex', '$getIndexWord', '$shrinkSpellWords', '$each_with_index', '$include?', '$gsub', '$pop', '$expandSpellWords', '$getCardsFromIndexWordAndSpellText']);
  
  self.$require("configBcDice");
  $gvars.ircNickRegExp = "[A-Za-z\\d\\-\\[\\]\\'^{}_]+";
  return (function($base, $super, $parent_nesting) {
    var self = $klass($base, $super, 'CardTrader');

    var $nesting = [self].concat($parent_nesting), $CardTrader_initialize$1, $CardTrader_initValues$2, $CardTrader_card_place$eq$3, $CardTrader_set1Deck1Joker$4, $CardTrader_set1Deck2Jokers$5, $CardTrader_set2Decks2Jokers$6, $CardTrader_setBcDice$7, $CardTrader_setNick$8, $CardTrader_setTnick$9, $CardTrader_printCardHelp$10, $CardTrader_setCardMode$13, $CardTrader_readCardSet$14, $CardTrader_sendMessage$15, $CardTrader_sendMessageToOnlySender$16, $CardTrader_sendMessageToChannels$17, $CardTrader_readExtraCard$18, $CardTrader_executeCard$20, $CardTrader_shuffleCards$21, $CardTrader_drawCardByCommandText$22, $CardTrader_drawCardOpen$23, $CardTrader_drawCard$24, $CardTrader_pickupCardCommandText$26, $CardTrader_pickupCard$27, $CardTrader_pickupCardByCardName$28, $CardTrader_pickupCardByCards$29, $CardTrader_pickupOneCard$31, $CardTrader_backCardCommandText$33, $CardTrader_backCard$34, $CardTrader_backCardByCommandSetAndPlace$35, $CardTrader_backOneCard$37, $CardTrader_dealCard$39, $CardTrader_sendDealResult$40, $CardTrader_lookAndDealCard$41, $CardTrader_discardCardCommandText$42, $CardTrader_playCardByCommandText$43, $CardTrader_playCard$44, $CardTrader_playCardByCardsBlockTextAndPlaceNo$45, $CardTrader_playCardByCardsTextAndPlaceNo$46, $CardTrader_playCardByCardAndPlaceNo$48, $CardTrader_playOneCard$49, $CardTrader_discardCards$50, $CardTrader_discardCardsByCommandSetAndPlaceAndDestination$51, $CardTrader_discardCardsByCardsAndPlace$52, $CardTrader_discardOneCard$54, $CardTrader_getDestinationWhenPlaceIsNotHand$56, $CardTrader_getCardsFromDealCards$57, $CardTrader_transferCardsByCommandText$58, $CardTrader_transferCards$59, $CardTrader_transferCardsByCommand$60, $CardTrader_transferCardsByCards$61, $CardTrader_transferOneCard$63, $CardTrader_ejectOneCardRandomFromCards$64, $CardTrader_transferTargetCard$65, $CardTrader_transferTargetCardToNewMember$67, $CardTrader_sendCardToTargetNickPlaceCommandText$68, $CardTrader_getSendCardToTargetNickPlace$69, $CardTrader_getSendCardToTargetNickPlaceByCardSetAndDestination$70, $CardTrader_getSendCardToTargetNickPlaceByCards$71, $CardTrader_printRegistCardResult$73, $CardTrader_tapCardCommandText$74, $CardTrader_tapCard$75, $CardTrader_tapCardByCardsTextAndPlace$76, $CardTrader_tapOneCardByCardAndPlace$78, $CardTrader_printMilStoneResult$79, $CardTrader_getCardMilstone$80, $CardTrader_clearAllPlaceAllPlayerCards$81, $CardTrader_clearAllPlayerCardsWhenPlayedPlace$83, $CardTrader_clearAllPlayerCards$84, $CardTrader_returnCards$85, $CardTrader_getBurriedCard$86, $CardTrader_reviewCards$87, $CardTrader_getAllCardLocation$88, $CardTrader_getCardLocationOnPlace$90, $CardTrader_getCardLocationOnNumberdPlace$91, $CardTrader_getHandAndPlaceCardInfoText$92, $CardTrader_getHandCardInfoText$93, $CardTrader_getDealCardsText$94, $CardTrader_compareCard$95, $CardTrader_compareCardByCardNumber$96, $CardTrader_getPlaceCardInfoText$97, $CardTrader_getCardsText$99, $CardTrader_getCardsTextFromCards$100, $CardTrader_isTapCardPlace$103, $CardTrader_printCardRestorationSpellResult$104, $CardTrader_throwCardRestorationSpell$105, $CardTrader_getNewSpellText$106, $CardTrader_getSpellWords$107, $CardTrader_getIndexWord$109, $CardTrader_getDealCardIndex$110, $CardTrader_shrinkSpellWords$112, $CardTrader_setNewSpellText$115, $CardTrader_expandSpellWords$117, $CardTrader_getCardsFromIndexWordAndSpellText$120;

    self.$$prototype.card_place = self.$$prototype.card_val = self.$$prototype.tnick = self.$$prototype.bcdice = self.$$prototype.channel = self.$$prototype.nick_e = self.$$prototype.cardRegExp = self.$$prototype.card_channels = self.$$prototype.cardRest = self.$$prototype.deal_cards = self.$$prototype.cardTitles = self.$$prototype.canTapCard = self.$$prototype.card_spell = nil;
    
    self.$attr_accessor("card_place");
    self.$attr_accessor("canTapCard");
    self.$attr_reader("numOfDecks");
    self.$attr_reader("numOfJokers");
    
    Opal.def(self, '$initialize', $CardTrader_initialize$1 = function $$initialize() {
      var self = this;

      
      self.$initValues();
      self.card_channels = $hash2([], {});
      return (self.card_spell = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z"]);
    }, $CardTrader_initialize$1.$$arity = 0);
    
    Opal.def(self, '$initValues', $CardTrader_initValues$2 = function $$initValues() {
      var self = this, $writer = nil;

      
      self.cardTitles = $hash2([], {});
      self.cardRegExp = "[DHSCJdhscj][\\d]+";
      self.deal_cards = $hash2(["card_played"], {"card_played": []});
      self.$set1Deck1Joker();
      
      $writer = [1];
      $send(self, 'card_place=', Opal.to_a($writer));
      $writer[$rb_minus($writer["length"], 1)];;
      return (self.canTapCard = true);
    }, $CardTrader_initValues$2.$$arity = 0);
    
    Opal.def(self, '$card_place=', $CardTrader_card_place$eq$3 = function(place) {
      var self = this;

      
      self.card_place = place;
      return self.$debug("setCardPlace @card_place", self.card_place);
    }, $CardTrader_card_place$eq$3.$$arity = 1);
    
    Opal.def(self, '$set1Deck1Joker', $CardTrader_set1Deck1Joker$4 = function $$set1Deck1Joker() {
      var self = this;

      
      self.card_val = ["S1", "S2", "S3", "S4", "S5", "S6", "S7", "S8", "S9", "S10", "S11", "S12", "S13", "H1", "H2", "H3", "H4", "H5", "H6", "H7", "H8", "H9", "H10", "H11", "H12", "H13", "D1", "D2", "D3", "D4", "D5", "D6", "D7", "D8", "D9", "D10", "D11", "D12", "D13", "C1", "C2", "C3", "C4", "C5", "C6", "C7", "C8", "C9", "C10", "C11", "C12", "C13", "J1"];
      self.cardRest = self.card_val.$clone();
      self.numOfDecks = 1;
      self.numOfJokers = 1;
      return self;
    }, $CardTrader_set1Deck1Joker$4.$$arity = 0);
    
    Opal.def(self, '$set1Deck2Jokers', $CardTrader_set1Deck2Jokers$5 = function $$set1Deck2Jokers() {
      var self = this;

      
      self.card_val = ["S1", "S2", "S3", "S4", "S5", "S6", "S7", "S8", "S9", "S10", "S11", "S12", "S13", "H1", "H2", "H3", "H4", "H5", "H6", "H7", "H8", "H9", "H10", "H11", "H12", "H13", "D1", "D2", "D3", "D4", "D5", "D6", "D7", "D8", "D9", "D10", "D11", "D12", "D13", "C1", "C2", "C3", "C4", "C5", "C6", "C7", "C8", "C9", "C10", "C11", "C12", "C13", "J1", "J0"];
      self.cardRest = self.card_val.$clone();
      self.numOfDecks = 1;
      self.numOfJokers = 2;
      return self;
    }, $CardTrader_set1Deck2Jokers$5.$$arity = 0);
    
    Opal.def(self, '$set2Decks2Jokers', $CardTrader_set2Decks2Jokers$6 = function $$set2Decks2Jokers() {
      var self = this;

      
      self.card_val = ["S1", "S2", "S3", "S4", "S5", "S6", "S7", "S8", "S9", "S10", "S11", "S12", "S13", "s1", "s2", "s3", "s4", "s5", "s6", "s7", "s8", "s9", "s10", "s11", "s12", "s13", "H1", "H2", "H3", "H4", "H5", "H6", "H7", "H8", "H9", "H10", "H11", "H12", "H13", "h1", "h2", "h3", "h4", "h5", "h6", "h7", "h8", "h9", "h10", "h11", "h12", "h13", "D1", "D2", "D3", "D4", "D5", "D6", "D7", "D8", "D9", "D10", "D11", "D12", "D13", "d1", "d2", "d3", "d4", "d5", "d6", "d7", "d8", "d9", "d10", "d11", "d12", "d13", "C1", "C2", "C3", "C4", "C5", "C6", "C7", "C8", "C9", "C10", "C11", "C12", "C13", "c1", "c2", "c3", "c4", "c5", "c6", "c7", "c8", "c9", "c10", "c11", "c12", "c13", "J1", "J2", "J3", "J4"];
      self.cardRest = self.card_val.$clone();
      self.numOfDecks = 2;
      self.numOfJokers = 2;
      return self;
    }, $CardTrader_set2Decks2Jokers$6.$$arity = 0);
    
    Opal.def(self, '$setBcDice', $CardTrader_setBcDice$7 = function $$setBcDice(bcDice) {
      var self = this;

      return (self.bcdice = bcDice)
    }, $CardTrader_setBcDice$7.$$arity = 1);
    
    Opal.def(self, '$setNick', $CardTrader_setNick$8 = function $$setNick(nick_e) {
      var self = this;

      return (self.nick_e = nick_e)
    }, $CardTrader_setNick$8.$$arity = 1);
    
    Opal.def(self, '$setTnick', $CardTrader_setTnick$9 = function $$setTnick(t) {
      var self = this;

      return (self.tnick = t)
    }, $CardTrader_setTnick$9.$$arity = 1);
    
    Opal.def(self, '$printCardHelp', $CardTrader_printCardHelp$10 = function $$printCardHelp() {
      var $$11, $$12, self = this, send_to_sender = nil;

      
      send_to_sender = $send(self, 'lambda', [], ($$11 = function(message){var self = $$11.$$s || this;

      
        
        if (message == null) {
          message = nil;
        };
        return self.$sendMessageToOnlySender(message);}, $$11.$$s = self, $$11.$$arity = 1, $$11));
      $send([["・カードを引く　　　　　　　(c-draw[n]) (nは枚数)", "・オープンでカードを引く　　(c-odraw[n])", "・カードを選んで引く　　　　(c-pick[c[,c]]) (cはカード。カンマで複数指定可)", "・捨てたカードを手札に戻す　(c-back[c[,c]])", "・置いたカードを手札に戻す　(c-back1[c[,c]])"], ["・手札と場札を見る　　　　　(c-hand) (Talk可)", "・カードを出す　　　　　　　(c-play[c[,c]]", "・カードを場に出す　　　　　(c-play1[c[,c]]", "・カードを捨てる　　　　　　(c-discard[c[,c]]) (Talk可)", "・場のカードを選んで捨てる　(c-discard1[c[,c]])", "・山札からめくって捨てる　  (c-milstone[n])"], ["・カードを相手に一枚渡す　　(c-pass[c]相手) (カード指定が無いときはランダム)", "・場のカードを相手に渡す　　(c-pass1[c]相手) (カード指定が無いときはランダム)", "・カードを相手の場に出す　　(c-place[c[,c]]相手)", "・場のカードを相手の場に出す(c-place1[c[,c]]相手)"], ["・場のカードをタップする　　(c-tap1[c[,c]]相手)", "・場のカードをアンタップする(c-untap1[c[,c]]相手)", "  ---"]], 'each', [], ($$12 = function(messages){var self = $$12.$$s || this;

      
        
        if (messages == null) {
          messages = nil;
        };
        $send(messages, 'each', [], send_to_sender.$to_proc());
        return self.$sleep(1);}, $$12.$$s = self, $$12.$$arity = 1, $$12));
      self.$sleep(1);
      $send(["・カードを配る　　　　　　　(c-deal[n]相手)", "・カードを見てから配る　　　(c-vdeal[n]相手)", "・カードのシャッフル　　　　(c-shuffle)", "・捨てカードを山に戻す　　　(c-rshuffle)", "・全員の場のカードを捨てる　(c-clean)"], 'each', [], send_to_sender.$to_proc());
      self.$sleep(1);
      $send(["・相手の手札と場札を見る　　(c-vhand) (Talk不可)", "・枚数配置を見る　　　　　　(c-check)", "・復活の呪文　　　　　　　　(c-spell[呪文]) (c-spellで呪文の表示)"], 'each', [], send_to_sender.$to_proc());
      return self.$sendMessageToOnlySender("  -- END ---");
    }, $CardTrader_printCardHelp$10.$$arity = 0);
    
    Opal.def(self, '$setCardMode', $CardTrader_setCardMode$13 = function $$setCardMode() {
      var $a, self = this, __last__match__1 = nil, __last__match__2 = nil, __last__match__3 = nil, __last__match__4 = nil, __last__match__5 = nil, __last__match__6 = nil, __last__match__7 = nil, __last__match__8 = nil, __last__match__9 = nil, __last__match__10 = nil, __last__match__11 = nil, __last__match__12 = nil, __last__match__13 = nil, __last__match__14 = nil, __last__match__15 = nil, __last__match__16 = nil, __last__match__17 = nil, __last__match__18 = nil, __last__match__19 = nil, __last__match__20 = nil;

      
      if ($truthy(/(\d+)/['$=~'](self.tnick))) {
      } else {
        return nil
      };
      __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
      __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
      __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
      __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
      __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
      __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
      __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
      __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
      __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
      __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
      __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
      __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
      __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
      __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
      __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
      __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
      __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
      __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
      __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
      __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
      self.card_place = __last__match__1.$to_i();
      if ($truthy($rb_gt(self.card_place, 0))) {
        return self.$sendMessageToChannels("カード置き場ありに変更しました")
      } else {
        return self.$sendMessageToChannels("カード置き場無しに変更しました")
      };
    }, $CardTrader_setCardMode$13.$$arity = 0);
    
    Opal.def(self, '$readCardSet', $CardTrader_readCardSet$14 = function $$readCardSet() {
      var self = this, e = nil;

      try {
        
        self.$readExtraCard(self.tnick);
        return self.$sendMessageToOnlySender("カードセットの読み込み成功しました");
      } catch ($err) {
        if (Opal.rescue($err, [$$($nesting, 'StandardError')])) {e = $err;
          try {
            return self.$sendMessageToOnlySender(e.$to_s())
          } finally { Opal.pop_exception() }
        } else { throw $err; }
      }
    }, $CardTrader_readCardSet$14.$$arity = 0);
    
    Opal.def(self, '$sendMessage', $CardTrader_sendMessage$15 = function $$sendMessage(to, message) {
      var self = this;

      return self.bcdice.$sendMessage(to, message)
    }, $CardTrader_sendMessage$15.$$arity = 2);
    
    Opal.def(self, '$sendMessageToOnlySender', $CardTrader_sendMessageToOnlySender$16 = function $$sendMessageToOnlySender(message) {
      var self = this;

      return self.bcdice.$sendMessageToOnlySender(message)
    }, $CardTrader_sendMessageToOnlySender$16.$$arity = 1);
    
    Opal.def(self, '$sendMessageToChannels', $CardTrader_sendMessageToChannels$17 = function $$sendMessageToChannels(message) {
      var self = this;

      return self.bcdice.$sendMessageToChannels(message)
    }, $CardTrader_sendMessageToChannels$17.$$arity = 1);
    
    Opal.def(self, '$readExtraCard', $CardTrader_readExtraCard$18 = function $$readExtraCard(cardFileName) {
      var $$19, self = this, lines = nil, e = nil;

      
      if ($truthy(cardFileName['$nil?']())) {
        return nil};
      if ($truthy(cardFileName['$empty?']())) {
        return nil};
      self.$debug("" + "Loading Cardset『" + (cardFileName) + "』...\n");
      self.card_val = [];
      
      try {
        
        lines = $$($nesting, 'File').$readlines(cardFileName);
        $send(lines, 'each', [], ($$19 = function(line){var self = $$19.$$s || this, cardNumber = nil, cardTitle = nil, $writer = nil;
          if (self.card_val == null) self.card_val = nil;
          if (self.cardTitles == null) self.cardTitles = nil;

        
          
          if (line == null) {
            line = nil;
          };
          if ($truthy(/^(\d+)->(.+)$/['$=~'](line))) {
          } else {
            return nil;
          };
          cardNumber = self.$__last__match__1().$to_i();
          cardTitle = self.$__last__match__2();
          self.card_val.$push(cardNumber);
          
          $writer = [cardNumber, cardTitle];
          $send(self.cardTitles, '[]=', Opal.to_a($writer));
          return $writer[$rb_minus($writer["length"], 1)];;}, $$19.$$s = self, $$19.$$arity = 1, $$19));
        self.cardRegExp = "[\\d]+";
        self.cardRest = self.card_val.$clone();
        self.deal_cards = $hash2(["card_played"], {"card_played": []});
        return self.$debug("Load Finished...\n");
      } catch ($err) {
        if (Opal.rescue($err, [$$($nesting, 'StandardError')])) {e = $err;
          try {
            return self.$raise($rb_plus("" + "カードデータを開けません :『" + (cardFileName) + "』", e.$to_s()))
          } finally { Opal.pop_exception() }
        } else { throw $err; }
      };;
    }, $CardTrader_readExtraCard$18.$$arity = 1);
    
    Opal.def(self, '$executeCard', $CardTrader_executeCard$20 = function $$executeCard(arg, channel) {
      var $a, $b, self = this, __last__match__1 = nil, __last__match__2 = nil, __last__match__3 = nil, __last__match__4 = nil, __last__match__5 = nil, __last__match__6 = nil, __last__match__7 = nil, __last__match__8 = nil, __last__match__9 = nil, __last__match__10 = nil, __last__match__11 = nil, __last__match__12 = nil, __last__match__13 = nil, __last__match__14 = nil, __last__match__15 = nil, __last__match__16 = nil, __last__match__17 = nil, __last__match__18 = nil, __last__match__19 = nil, __last__match__20 = nil, card_ok = nil, count = nil, $case = nil, output_msg = nil, value = nil, name = nil, messageText = nil, out_msg = nil, place_msg = nil, sendTo = nil, targetNick = nil, spellText = nil, commandText = nil;
      if ($gvars.ircNickRegExp == null) $gvars.ircNickRegExp = nil;

      
      self.channel = channel;
      self.$debug("executeCard arg", arg);
      if ($truthy(/(c-)/['$=~'](arg))) {
      } else {
        return nil
      };
      __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
      __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
      __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
      __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
      __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
      __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
      __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
      __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
      __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
      __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
      __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
      __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
      __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
      __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
      __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
      __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
      __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
      __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
      __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
      __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
      card_ok = 0;
      count = 0;
      return (function() {$case = arg;
      if (/(c-shuffle|c-sh)($|\s)/['$===']($case)) {
      __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
      __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
      __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
      __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
      __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
      __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
      __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
      __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
      __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
      __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
      __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
      __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
      __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
      __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
      __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
      __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
      __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
      __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
      __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
      __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
      output_msg = self.$shuffleCards();
      return self.$sendMessage(self.channel, output_msg);}
      else if (/c-draw(\[[\d]+\])?($|\s)/['$===']($case)) {
      __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
      __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
      __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
      __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
      __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
      __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
      __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
      __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
      __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
      __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
      __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
      __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
      __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
      __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
      __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
      __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
      __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
      __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
      __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
      __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
      return self.$drawCardByCommandText(arg);}
      else if (/(c-odraw|c-opend)(\[[\d]+\])?($|\s)/['$===']($case)) {
      __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
      __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
      __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
      __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
      __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
      __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
      __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
      __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
      __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
      __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
      __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
      __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
      __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
      __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
      __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
      __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
      __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
      __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
      __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
      __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
      value = __last__match__2;
      return self.$drawCardOpen(value);}
      else if (/c-hand($|\s)/['$===']($case)) {
      __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
      __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
      __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
      __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
      __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
      __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
      __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
      __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
      __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
      __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
      __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
      __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
      __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
      __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
      __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
      __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
      __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
      __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
      __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
      __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
      return self.$sendMessageToOnlySender(self.$getHandAndPlaceCardInfoText(arg, self.nick_e));}
      else if (new RegExp("" + "c-vhand\\s*(" + ($gvars.ircNickRegExp) + ")($|\\s)")['$===']($case)) {
      __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
      __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
      __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
      __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
      __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
      __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
      __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
      __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
      __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
      __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
      __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
      __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
      __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
      __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
      __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
      __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
      __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
      __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
      __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
      __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
      name = __last__match__1;
      self.$debug("c-vhand name", name);
      messageText = $rb_plus($rb_plus("" + (name) + " の手札は", self.$getHandAndPlaceCardInfoText("c-hand", name)), "です");
      return self.$sendMessageToOnlySender(messageText);}
      else if (new RegExp("" + "c-play(\\d*)\\[" + (self.cardRegExp) + "(," + (self.cardRegExp) + ")*\\]($|\\s)")['$===']($case)) {
      __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
      __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
      __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
      __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
      __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
      __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
      __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
      __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
      __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
      __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
      __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
      __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
      __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
      __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
      __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
      __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
      __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
      __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
      __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
      __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
      return self.$playCardByCommandText(arg);}
      else if (/(c-rshuffle|c-rsh)($|\s)/['$===']($case)) {
      __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
      __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
      __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
      __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
      __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
      __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
      __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
      __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
      __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
      __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
      __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
      __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
      __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
      __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
      __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
      __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
      __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
      __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
      __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
      __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
      output_msg = self.$returnCards();
      return self.$sendMessage(self.channel, output_msg);}
      else if (/c-clean($|\s)/['$===']($case)) {
      __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
      __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
      __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
      __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
      __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
      __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
      __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
      __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
      __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
      __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
      __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
      __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
      __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
      __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
      __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
      __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
      __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
      __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
      __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
      __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
      output_msg = self.$clearAllPlaceAllPlayerCards();
      return self.$sendMessage(self.channel, output_msg);}
      else if (/c-review($|\s)/['$===']($case)) {
      __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
      __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
      __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
      __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
      __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
      __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
      __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
      __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
      __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
      __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
      __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
      __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
      __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
      __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
      __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
      __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
      __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
      __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
      __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
      __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
      output_msg = self.$reviewCards();
      return self.$sendMessageToOnlySender(output_msg);}
      else if (/c-check($|\s)/['$===']($case)) {
      __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
      __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
      __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
      __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
      __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
      __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
      __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
      __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
      __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
      __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
      __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
      __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
      __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
      __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
      __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
      __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
      __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
      __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
      __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
      __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
      $b = self.$getAllCardLocation(), $a = Opal.to_ary($b), (out_msg = ($a[0] == null ? nil : $a[0])), (place_msg = ($a[1] == null ? nil : $a[1])), $b;
      self.$sendMessage(self.channel, out_msg);
      return self.$sendMessage(self.channel, place_msg);}
      else if (new RegExp("" + "c-pass(\\d)*(\\[" + (self.cardRegExp) + "(," + (self.cardRegExp) + ")*\\])?\\s*(" + ($gvars.ircNickRegExp) + ")($|\\s)")['$===']($case)) {
      __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
      __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
      __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
      __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
      __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
      __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
      __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
      __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
      __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
      __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
      __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
      __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
      __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
      __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
      __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
      __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
      __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
      __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
      __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
      __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
      sendTo = __last__match__4;
      return self.$transferCardsByCommandText(arg, sendTo);}
      else if (new RegExp("" + "c-pick\\[" + (self.cardRegExp) + "(," + (self.cardRegExp) + ")*\\]($|\\s)")['$===']($case)) {
      __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
      __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
      __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
      __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
      __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
      __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
      __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
      __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
      __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
      __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
      __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
      __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
      __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
      __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
      __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
      __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
      __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
      __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
      __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
      __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
      return self.$pickupCardCommandText(arg);}
      else if (new RegExp("" + "c-back(\\d)*\\[" + (self.cardRegExp) + "(," + (self.cardRegExp) + ")*\\]($|\\s)")['$===']($case)) {
      __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
      __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
      __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
      __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
      __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
      __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
      __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
      __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
      __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
      __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
      __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
      __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
      __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
      __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
      __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
      __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
      __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
      __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
      __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
      __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
      return self.$backCardCommandText(arg);}
      else if (new RegExp("" + "c-deal(\\[[\\d]+\\]|\\s)\\s*(" + ($gvars.ircNickRegExp) + ")($|\\s)")['$===']($case)) {
      __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
      __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
      __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
      __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
      __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
      __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
      __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
      __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
      __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
      __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
      __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
      __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
      __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
      __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
      __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
      __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
      __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
      __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
      __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
      __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
      count = __last__match__1;
      targetNick = __last__match__2;
      return self.$dealCard(count, targetNick);}
      else if (new RegExp("" + "c-vdeal(\\[[\\d]+\\]|\\s)\\s*(" + ($gvars.ircNickRegExp) + ")($|\\s)")['$===']($case)) {
      __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
      __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
      __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
      __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
      __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
      __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
      __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
      __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
      __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
      __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
      __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
      __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
      __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
      __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
      __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
      __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
      __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
      __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
      __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
      __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
      count = __last__match__1;
      targetNick = __last__match__2;
      return self.$lookAndDealCard(count, targetNick);}
      else if (new RegExp("" + "c-(dis|discard)(\\d)*\\[" + (self.cardRegExp) + "(," + (self.cardRegExp) + ")*\\]($|\\s)")['$===']($case)) {
      __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
      __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
      __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
      __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
      __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
      __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
      __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
      __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
      __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
      __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
      __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
      __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
      __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
      __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
      __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
      __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
      __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
      __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
      __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
      __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
      return self.$discardCardCommandText(arg);}
      else if (new RegExp("" + "c-place(\\d)*(\\[" + (self.cardRegExp) + "(," + (self.cardRegExp) + ")*\\])?\\s*(" + ($gvars.ircNickRegExp) + ")($|\\s)")['$===']($case)) {
      __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
      __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
      __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
      __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
      __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
      __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
      __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
      __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
      __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
      __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
      __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
      __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
      __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
      __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
      __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
      __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
      __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
      __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
      __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
      __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
      targetNick = __last__match__4;
      return self.$sendCardToTargetNickPlaceCommandText(arg, targetNick);}
      else if (new RegExp("" + "c-(un)?tap(\\d+)\\[" + (self.cardRegExp) + "(," + (self.cardRegExp) + ")*\\]($|\\s)")['$===']($case)) {
      __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
      __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
      __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
      __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
      __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
      __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
      __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
      __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
      __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
      __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
      __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
      __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
      __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
      __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
      __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
      __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
      __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
      __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
      __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
      __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
      return self.$tapCardCommandText(arg);}
      else if (new RegExp("" + "c-spell(\\[(" + ($gvars.ircNickRegExp) + "[^\\]]+?)\\])?($|\\s)")['$===']($case)) {
      __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
      __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
      __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
      __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
      __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
      __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
      __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
      __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
      __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
      __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
      __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
      __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
      __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
      __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
      __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
      __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
      __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
      __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
      __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
      __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
      spellText = __last__match__2;
      return self.$printCardRestorationSpellResult(spellText);}
      else if (/(c-mil(stone)?(\[[\d]+\])?)($|\s)/['$===']($case)) {
      __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
      __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
      __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
      __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
      __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
      __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
      __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
      __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
      __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
      __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
      __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
      __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
      __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
      __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
      __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
      __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
      __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
      __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
      __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
      __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
      commandText = __last__match__1;
      return self.$printMilStoneResult(commandText);}
      else { return nil }})();
    }, $CardTrader_executeCard$20.$$arity = 2);
    
    Opal.def(self, '$shuffleCards', $CardTrader_shuffleCards$21 = function $$shuffleCards() {
      var self = this;

      
      self.cardRest = self.card_val.$clone();
      self.deal_cards = $hash2(["card_played"], {"card_played": []});
      return "シャッフルしました";
    }, $CardTrader_shuffleCards$21.$$arity = 0);
    
    Opal.def(self, '$drawCardByCommandText', $CardTrader_drawCardByCommandText$22 = function $$drawCardByCommandText(arg) {
      var $a, self = this, cards = nil, $writer = nil;

      
      self.$debug("drawCardByCommandText arg", arg);
      cards = self.$drawCard(arg);
      self.$debug("drawCardByCommandText cards", cards);
      if ($truthy($rb_gt(cards.$length(), 0))) {
        
        self.$sendMessageToOnlySender(self.$getCardsTextFromCards(cards));
        self.$sendMessage(self.channel, "" + (self.nick_e) + ": " + (cards.$length()) + "枚引きました");
      } else {
        self.$sendMessage(self.channel, "カードが残っていません")
      };
      return ($truthy($a = self.card_channels['$[]'](self.nick_e)) ? $a : (($writer = [self.nick_e, self.channel]), $send(self.card_channels, '[]=', Opal.to_a($writer)), $writer[$rb_minus($writer["length"], 1)]));
    }, $CardTrader_drawCardByCommandText$22.$$arity = 1);
    
    Opal.def(self, '$drawCardOpen', $CardTrader_drawCardOpen$23 = function $$drawCardOpen(value) {
      var $a, self = this, cmd = nil, cards = nil, $writer = nil;

      
      cmd = "c-draw";
      if ($truthy(value['$nil?']())) {
      } else {
        cmd = $rb_plus(cmd, value)
      };
      cards = self.$drawCard(cmd);
      if ($truthy($rb_gt(cards.$length(), 0))) {
        self.$sendMessage(self.channel, $rb_plus($rb_plus("" + (self.nick_e) + ": ", self.$getCardsTextFromCards(cards)), "を引きました"))
      } else {
        self.$sendMessage(self.channel, "カードが残っていません")
      };
      return ($truthy($a = self.card_channels['$[]'](self.nick_e)) ? $a : (($writer = [self.nick_e, self.channel]), $send(self.card_channels, '[]=', Opal.to_a($writer)), $writer[$rb_minus($writer["length"], 1)]));
    }, $CardTrader_drawCardOpen$23.$$arity = 1);
    
    Opal.def(self, '$drawCard', $CardTrader_drawCard$24 = function $$drawCard(command, destination) {
      var $a, $$25, self = this, outputCards = nil, __last__match__1 = nil, __last__match__2 = nil, __last__match__3 = nil, __last__match__4 = nil, __last__match__5 = nil, __last__match__6 = nil, __last__match__7 = nil, __last__match__8 = nil, __last__match__9 = nil, __last__match__10 = nil, __last__match__11 = nil, __last__match__12 = nil, __last__match__13 = nil, __last__match__14 = nil, __last__match__15 = nil, __last__match__16 = nil, __last__match__17 = nil, __last__match__18 = nil, __last__match__19 = nil, __last__match__20 = nil, count = nil;

      
      
      if (destination == null) {
        destination = nil;
      };
      destination = ($truthy($a = destination) ? $a : self.nick_e);
      destination = destination.$upcase();
      self.$debug("drawCard command, destination", command, destination);
      outputCards = [];
      self.$debug("@cardRest.length", self.cardRest.$length());
      if ($truthy($rb_le(self.cardRest.$length(), 0))) {
        return outputCards};
      if ($truthy(/(c-draw(\[([\d]+)\])?)/['$=~'](command))) {
      } else {
        return outputCards
      };
      __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
      __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
      __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
      __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
      __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
      __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
      __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
      __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
      __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
      __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
      __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
      __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
      __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
      __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
      __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
      __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
      __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
      __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
      __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
      __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
      count = __last__match__3;
      count = ($truthy($a = count) ? $a : 1);
      count = count.$to_i();
      self.$debug("draw count", count);
      (function(){var $brk = Opal.new_brk(); try {return $send(count, 'times', [], ($$25 = function(i){var self = $$25.$$s || this, $b, card = nil, $writer = nil;
        if (self.cardRest == null) self.cardRest = nil;
        if (self.deal_cards == null) self.deal_cards = nil;

      
        
        if (i == null) {
          i = nil;
        };
        if ($truthy($rb_le(self.cardRest.$length(), 0))) {
          
          Opal.brk(nil, $brk)};
        card = self.$ejectOneCardRandomFromCards(self.cardRest);
        if ($truthy(card['$nil?']())) {
          
          Opal.brk(nil, $brk)};
        ($truthy($b = self.deal_cards['$[]'](destination)) ? $b : (($writer = [destination, []]), $send(self.deal_cards, '[]=', Opal.to_a($writer)), $writer[$rb_minus($writer["length"], 1)]));
        self.deal_cards['$[]'](destination)['$<<'](card);
        return outputCards['$<<'](card);}, $$25.$$s = self, $$25.$$brk = $brk, $$25.$$arity = 1, $$25))
      } catch (err) { if (err === $brk) { return err.$v } else { throw err } }})();
      return outputCards;
    }, $CardTrader_drawCard$24.$$arity = -2);
    
    Opal.def(self, '$pickupCardCommandText', $CardTrader_pickupCardCommandText$26 = function $$pickupCardCommandText(string) {
      var $a, $b, self = this, count = nil, output_msg = nil;

      
      self.$debug("pickupCardCommandText string", string);
      $b = self.$pickupCard(string), $a = Opal.to_ary($b), (count = ($a[0] == null ? nil : $a[0])), (output_msg = ($a[1] == null ? nil : $a[1])), $b;
      if ($truthy($rb_gt(count, 0))) {
        self.$sendMessage(self.channel, "" + (self.nick_e) + ": " + (count) + "枚選んで引きました")};
      if ($truthy(output_msg['$!='](""))) {
        self.$sendMessage(self.channel, $rb_plus($rb_plus("[", self.$getCardsText(output_msg)), "]がありません"))};
      return self.$sendMessageToOnlySender(self.$getHandAndPlaceCardInfoText("Auto"));
    }, $CardTrader_pickupCardCommandText$26.$$arity = 1);
    
    Opal.def(self, '$pickupCard', $CardTrader_pickupCard$27 = function $$pickupCard(string) {
      var $a, $b, self = this, okCount = nil, ngCardList = nil, __last__match__1 = nil, __last__match__2 = nil, __last__match__3 = nil, __last__match__4 = nil, __last__match__5 = nil, __last__match__6 = nil, __last__match__7 = nil, __last__match__8 = nil, __last__match__9 = nil, __last__match__10 = nil, __last__match__11 = nil, __last__match__12 = nil, __last__match__13 = nil, __last__match__14 = nil, __last__match__15 = nil, __last__match__16 = nil, __last__match__17 = nil, __last__match__18 = nil, __last__match__19 = nil, __last__match__20 = nil, cardName = nil, ngCardText = nil;

      
      okCount = 0;
      ngCardList = [];
      if ($truthy(new RegExp("" + "(c-pick\\[((,)?" + (self.cardRegExp) + ")+\\])")['$=~'](string))) {
        
        __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
        __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
        __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
        __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
        __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
        __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
        __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
        __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
        __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
        __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
        __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
        __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
        __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
        __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
        __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
        __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
        __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
        __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
        __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
        __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
        cardName = __last__match__1;
        $b = self.$pickupCardByCardName(cardName), $a = Opal.to_ary($b), (okCount = ($a[0] == null ? nil : $a[0])), (ngCardList = ($a[1] == null ? nil : $a[1])), $b;};
      ngCardText = ngCardList.$join(",");
      return [okCount, ngCardText];
    }, $CardTrader_pickupCard$27.$$arity = 1);
    
    Opal.def(self, '$pickupCardByCardName', $CardTrader_pickupCardByCardName$28 = function $$pickupCardByCardName(cardName) {
      var $a, $b, self = this, okCount = nil, ngCardList = nil, __last__match__1 = nil, __last__match__2 = nil, __last__match__3 = nil, __last__match__4 = nil, __last__match__5 = nil, __last__match__6 = nil, __last__match__7 = nil, __last__match__8 = nil, __last__match__9 = nil, __last__match__10 = nil, __last__match__11 = nil, __last__match__12 = nil, __last__match__13 = nil, __last__match__14 = nil, __last__match__15 = nil, __last__match__16 = nil, __last__match__17 = nil, __last__match__18 = nil, __last__match__19 = nil, __last__match__20 = nil, cards = nil;

      
      okCount = 0;
      ngCardList = [];
      if ($truthy(new RegExp("" + "\\[(" + (self.cardRegExp) + "(," + (self.cardRegExp) + ")*)\\]")['$=~'](cardName))) {
        
        __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
        __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
        __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
        __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
        __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
        __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
        __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
        __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
        __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
        __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
        __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
        __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
        __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
        __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
        __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
        __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
        __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
        __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
        __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
        __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
        cards = __last__match__1.$split(/,/);
        $b = self.$pickupCardByCards(cards), $a = Opal.to_ary($b), (okCount = ($a[0] == null ? nil : $a[0])), (ngCardList = ($a[1] == null ? nil : $a[1])), $b;};
      return [okCount, ngCardList];
    }, $CardTrader_pickupCardByCardName$28.$$arity = 1);
    
    Opal.def(self, '$pickupCardByCards', $CardTrader_pickupCardByCards$29 = function $$pickupCardByCards(cards) {
      var $$30, self = this, okCount = nil, ngCardList = nil;

      
      okCount = 0;
      ngCardList = [];
      $send(cards, 'each', [], ($$30 = function(card){var self = $$30.$$s || this, string = nil;
        if ($gvars.okResult == null) $gvars.okResult = nil;

      
        
        if (card == null) {
          card = nil;
        };
        string = self.$pickupOneCard(card);
        if ($truthy(string['$==']($gvars.okResult))) {
          return (okCount = $rb_plus(okCount, 1))
        } else {
          return ngCardList['$<<'](string)
        };}, $$30.$$s = self, $$30.$$arity = 1, $$30));
      return [okCount, ngCardList];
    }, $CardTrader_pickupCardByCards$29.$$arity = 1);
    
    Opal.def(self, '$pickupOneCard', $CardTrader_pickupOneCard$31 = function $$pickupOneCard(card) {
      var $$32, $a, self = this, targetCard = nil, destination = nil, isDelete = nil, $writer = nil;
      if ($gvars.okResult == null) $gvars.okResult = nil;

      
      if ($truthy($rb_le(self.cardRest.$length(), 0))) {
        return "山札"};
      targetCard = card.$upcase();
      destination = self.nick_e.$upcase();
      isDelete = $send(self.cardRest, 'delete_if', [], ($$32 = function(card){var self = $$32.$$s || this;

      
        
        if (card == null) {
          card = nil;
        };
        return card['$=='](targetCard);}, $$32.$$s = self, $$32.$$arity = 1, $$32));
      if ($truthy(isDelete)) {
        
        ($truthy($a = self.deal_cards['$[]'](destination)) ? $a : (($writer = [destination, []]), $send(self.deal_cards, '[]=', Opal.to_a($writer)), $writer[$rb_minus($writer["length"], 1)]));
        self.deal_cards['$[]'](destination)['$<<'](targetCard);
        return $gvars.okResult;
      } else {
        return targetCard
      };
    }, $CardTrader_pickupOneCard$31.$$arity = 1);
    
    Opal.def(self, '$backCardCommandText', $CardTrader_backCardCommandText$33 = function $$backCardCommandText(command) {
      var $a, $b, self = this, count = nil, output_msg = nil;

      
      $b = self.$backCard(command), $a = Opal.to_ary($b), (count = ($a[0] == null ? nil : $a[0])), (output_msg = ($a[1] == null ? nil : $a[1])), $b;
      if ($truthy($rb_gt(count, 0))) {
        self.$sendMessage(self.channel, "" + (self.nick_e) + ": " + (count) + "枚戻しました")};
      if ($truthy(output_msg['$!='](""))) {
        return self.$sendMessage(self.channel, "" + "[" + (self.$getCardsText(output_msg)) + "]がありません")
      } else {
        return self.$sendMessageToOnlySender(self.$getHandAndPlaceCardInfoText("Auto"))
      };
    }, $CardTrader_backCardCommandText$33.$$arity = 1);
    
    Opal.def(self, '$backCard', $CardTrader_backCard$34 = function $$backCard(command) {
      var $a, $b, self = this, okCount = nil, ngCards = nil, __last__match__1 = nil, __last__match__2 = nil, __last__match__3 = nil, __last__match__4 = nil, __last__match__5 = nil, __last__match__6 = nil, __last__match__7 = nil, __last__match__8 = nil, __last__match__9 = nil, __last__match__10 = nil, __last__match__11 = nil, __last__match__12 = nil, __last__match__13 = nil, __last__match__14 = nil, __last__match__15 = nil, __last__match__16 = nil, __last__match__17 = nil, __last__match__18 = nil, __last__match__19 = nil, __last__match__20 = nil, commandset = nil, place = nil;

      
      okCount = 0;
      ngCards = [];
      if ($truthy(new RegExp("" + "(c-back(\\d*)\\[((,)?" + (self.cardRegExp) + ")+\\])")['$=~'](command))) {
        
        __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
        __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
        __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
        __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
        __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
        __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
        __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
        __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
        __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
        __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
        __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
        __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
        __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
        __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
        __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
        __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
        __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
        __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
        __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
        __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
        commandset = __last__match__1;
        place = __last__match__2.$to_i();
        $b = self.$backCardByCommandSetAndPlace(commandset, place), $a = Opal.to_ary($b), (okCount = ($a[0] == null ? nil : $a[0])), (ngCards = ($a[1] == null ? nil : $a[1])), $b;};
      return [okCount, ngCards.$join(",")];
    }, $CardTrader_backCard$34.$$arity = 1);
    
    Opal.def(self, '$backCardByCommandSetAndPlace', $CardTrader_backCardByCommandSetAndPlace$35 = function $$backCardByCommandSetAndPlace(commandset, place) {
      var $a, $$36, self = this, okCount = nil, ngCards = nil, destination = nil, __last__match__1 = nil, __last__match__2 = nil, __last__match__3 = nil, __last__match__4 = nil, __last__match__5 = nil, __last__match__6 = nil, __last__match__7 = nil, __last__match__8 = nil, __last__match__9 = nil, __last__match__10 = nil, __last__match__11 = nil, __last__match__12 = nil, __last__match__13 = nil, __last__match__14 = nil, __last__match__15 = nil, __last__match__16 = nil, __last__match__17 = nil, __last__match__18 = nil, __last__match__19 = nil, __last__match__20 = nil, cards = nil;

      
      okCount = 0;
      ngCards = [];
      destination = self.nick_e.$upcase();
      if ($truthy(new RegExp("" + "\\[(" + (self.cardRegExp) + "(," + (self.cardRegExp) + ")*)\\]")['$=~'](commandset))) {
        
        __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
        __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
        __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
        __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
        __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
        __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
        __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
        __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
        __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
        __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
        __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
        __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
        __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
        __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
        __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
        __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
        __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
        __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
        __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
        __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
        cards = __last__match__1.$split(/,/);
        $send(cards, 'each', [], ($$36 = function(card){var self = $$36.$$s || this, string = nil;
          if ($gvars.okResult == null) $gvars.okResult = nil;

        
          
          if (card == null) {
            card = nil;
          };
          string = self.$backOneCard(card, destination, place);
          if ($truthy(string['$==']($gvars.okResult))) {
            return (okCount = $rb_plus(okCount, 1))
          } else {
            return ngCards['$<<'](string)
          };}, $$36.$$s = self, $$36.$$arity = 1, $$36));};
      return [okCount, ngCards];
    }, $CardTrader_backCardByCommandSetAndPlace$35.$$arity = 2);
    
    Opal.def(self, '$backOneCard', $CardTrader_backOneCard$37 = function $$backOneCard(targetCard, destination, place) {
      var $a, $$38, self = this, string = nil, $writer = nil, cards = nil, isDelete = nil;
      if ($gvars.okResult == null) $gvars.okResult = nil;

      
      if ($truthy($rb_le(self.$getBurriedCard(), 0))) {
        return "捨て札"};
      targetCard = targetCard.$upcase();
      if ($truthy($rb_gt(self.card_place, 0))) {
        
        string = self.$transferOneCard(targetCard, "" + (place) + (destination), destination);
        if ($truthy(string['$==']($gvars.okResult))) {
          return $gvars.okResult};};
      ($truthy($a = self.deal_cards['$[]']("card_played")) ? $a : (($writer = ["card_played", []]), $send(self.deal_cards, '[]=', Opal.to_a($writer)), $writer[$rb_minus($writer["length"], 1)]));
      cards = self.deal_cards['$[]']("card_played");
      isDelete = $send(cards, 'delete_if', [], ($$38 = function(i){var self = $$38.$$s || this;

      
        
        if (i == null) {
          i = nil;
        };
        return i['$=='](targetCard);}, $$38.$$s = self, $$38.$$arity = 1, $$38));
      if ($truthy(isDelete)) {
        
        self.deal_cards['$[]'](destination)['$<<'](targetCard);
        return $gvars.okResult;};
      return "${targetCard}";
    }, $CardTrader_backOneCard$37.$$arity = 3);
    
    Opal.def(self, '$dealCard', $CardTrader_dealCard$39 = function $$dealCard(count, targetNick, isLook) {
      var $a, self = this, cards = nil, $writer = nil;

      
      
      if (isLook == null) {
        isLook = false;
      };
      self.$debug("dealCard count, targetNick", count, targetNick);
      cards = self.$drawCard("" + "c-draw" + (count), targetNick);
      if ($truthy($rb_gt(cards.$length(), 0))) {
        self.$sendDealResult(targetNick, count, self.$getCardsTextFromCards(cards), isLook)
      } else {
        self.$sendMessage(self.channel, "カードが残っていません")
      };
      ($truthy($a = self.card_channels['$[]'](targetNick)) ? $a : (($writer = [targetNick, self.channel]), $send(self.card_channels, '[]=', Opal.to_a($writer)), $writer[$rb_minus($writer["length"], 1)]));
      return count;
    }, $CardTrader_dealCard$39.$$arity = -3);
    
    Opal.def(self, '$sendDealResult', $CardTrader_sendDealResult$40 = function $$sendDealResult(targetNick, count, output_msg, isLook) {
      var self = this;

      
      self.$sendMessage(targetNick, output_msg);
      if ($truthy(isLook)) {
        self.$sendMessage(self.nick_e, "" + (targetNick) + " に " + (output_msg) + " を配りました")};
      return self.$sendMessage(self.channel, "" + (self.nick_e) + ": " + (targetNick) + "に" + (count) + "枚配りました");
    }, $CardTrader_sendDealResult$40.$$arity = 4);
    
    Opal.def(self, '$lookAndDealCard', $CardTrader_lookAndDealCard$41 = function $$lookAndDealCard(count, targetNick) {
      var self = this, isLook = nil;

      
      isLook = true;
      return self.$dealCard(count, targetNick, isLook);
    }, $CardTrader_lookAndDealCard$41.$$arity = 2);
    
    Opal.def(self, '$discardCardCommandText', $CardTrader_discardCardCommandText$42 = function $$discardCardCommandText(commandText) {
      var $a, $b, self = this, count = nil, output_msg = nil, card_ok = nil, cardText = nil;
      if ($gvars.card_ok == null) $gvars.card_ok = nil;

      
      $b = self.$discardCards(commandText), $a = Opal.to_ary($b), (count = ($a[0] == null ? nil : $a[0])), (output_msg = ($a[1] == null ? nil : $a[1])), (card_ok = ($a[2] == null ? nil : $a[2])), $b;
      if ($truthy($rb_gt(count, 0))) {
        
        self.$sendMessage(self.channel, "" + (self.nick_e) + ": " + (count) + "枚捨てました");
        if ($truthy(self.cardTitles['$empty?']())) {
        } else {
          
          cardText = self.$getCardsText($gvars.card_ok);
          self.$sendMessage(self.channel, "" + "[" + (cardText) + "]");
        };};
      if ($truthy(output_msg['$!='](""))) {
        
        cardText = self.$getCardsText(output_msg);
        return self.$sendMessageToOnlySender("" + "[" + (cardText) + "]がありません");
      } else {
        return self.$sendMessageToOnlySender(self.$getHandAndPlaceCardInfoText("Auto"))
      };
    }, $CardTrader_discardCardCommandText$42.$$arity = 1);
    
    Opal.def(self, '$playCardByCommandText', $CardTrader_playCardByCommandText$43 = function $$playCardByCommandText(arg) {
      var $a, $b, self = this, count = nil, output_msg = nil, card_ok = nil;
      if ($gvars.card_ok == null) $gvars.card_ok = nil;

      
      self.$debug("c-play pattern", arg);
      $b = self.$playCard(arg), $a = Opal.to_ary($b), (count = ($a[0] == null ? nil : $a[0])), (output_msg = ($a[1] == null ? nil : $a[1])), (card_ok = ($a[2] == null ? nil : $a[2])), $b;
      if ($truthy($rb_gt(count, 0))) {
        
        self.$sendMessage(self.channel, "" + (self.nick_e) + ": " + (count) + "枚出しました");
        if ($truthy(self.cardTitles['$empty?']())) {
        } else {
          self.$sendMessage(self.channel, $rb_plus($rb_plus("[", self.$getCardsText($gvars.card_ok)), "]"))
        };};
      if ($truthy(output_msg['$!='](""))) {
        
        self.$debug("output_msg", output_msg);
        self.$sendMessage(self.channel, $rb_plus($rb_plus("[", self.$getCardsText(output_msg)), "]は持っていません"));};
      return self.$sendMessageToOnlySender(self.$getHandAndPlaceCardInfoText("Auto", self.nick_e));
    }, $CardTrader_playCardByCommandText$43.$$arity = 1);
    
    Opal.def(self, '$playCard', $CardTrader_playCard$44 = function $$playCard(cardPlayCommandText) {
      var $a, $b, self = this, okCardCount = nil, okCardList = nil, ngCardList = nil, __last__match__1 = nil, __last__match__2 = nil, __last__match__3 = nil, __last__match__4 = nil, __last__match__5 = nil, __last__match__6 = nil, __last__match__7 = nil, __last__match__8 = nil, __last__match__9 = nil, __last__match__10 = nil, __last__match__11 = nil, __last__match__12 = nil, __last__match__13 = nil, __last__match__14 = nil, __last__match__15 = nil, __last__match__16 = nil, __last__match__17 = nil, __last__match__18 = nil, __last__match__19 = nil, __last__match__20 = nil, cardsBlockText = nil, place = nil, okCardText = nil, ngCardText = nil;

      
      self.$debug("playCard cardPlayCommandText", cardPlayCommandText);
      okCardCount = 0;
      okCardList = [];
      ngCardList = [];
      if ($truthy(new RegExp("" + "(c-play(\\d*)\\[((,)?" + (self.cardRegExp) + ")+\\])")['$=~'](cardPlayCommandText))) {
        
        __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
        __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
        __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
        __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
        __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
        __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
        __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
        __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
        __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
        __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
        __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
        __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
        __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
        __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
        __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
        __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
        __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
        __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
        __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
        __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
        cardsBlockText = __last__match__1;
        place = __last__match__2.$to_i();
        self.$debug("cardsBlockText", cardsBlockText);
        self.$debug("place", place);
        $b = self.$playCardByCardsBlockTextAndPlaceNo(cardsBlockText, place), $a = Opal.to_ary($b), (okCardList = ($a[0] == null ? nil : $a[0])), (ngCardList = ($a[1] == null ? nil : $a[1])), $b;
        self.$debug("okCardList", okCardList);
        self.$debug("ngCardList", ngCardList);
        okCardCount = okCardList.$length();
        okCardText = okCardList.$join(",");
        ngCardText = ngCardList.$join(",");};
      return [okCardCount, ngCardText, okCardText];
    }, $CardTrader_playCard$44.$$arity = 1);
    
    Opal.def(self, '$playCardByCardsBlockTextAndPlaceNo', $CardTrader_playCardByCardsBlockTextAndPlaceNo$45 = function $$playCardByCardsBlockTextAndPlaceNo(cardsBlockText, place) {
      var $a, $b, self = this, okCardList = nil, ngCardList = nil, __last__match__1 = nil, __last__match__2 = nil, __last__match__3 = nil, __last__match__4 = nil, __last__match__5 = nil, __last__match__6 = nil, __last__match__7 = nil, __last__match__8 = nil, __last__match__9 = nil, __last__match__10 = nil, __last__match__11 = nil, __last__match__12 = nil, __last__match__13 = nil, __last__match__14 = nil, __last__match__15 = nil, __last__match__16 = nil, __last__match__17 = nil, __last__match__18 = nil, __last__match__19 = nil, __last__match__20 = nil, cardsText = nil;

      
      okCardList = [];
      ngCardList = [];
      if ($truthy(new RegExp("" + "\\[(" + (self.cardRegExp) + "(," + (self.cardRegExp) + ")*)\\]")['$=~'](cardsBlockText))) {
        
        __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
        __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
        __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
        __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
        __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
        __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
        __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
        __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
        __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
        __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
        __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
        __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
        __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
        __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
        __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
        __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
        __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
        __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
        __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
        __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
        cardsText = __last__match__1;
        $b = self.$playCardByCardsTextAndPlaceNo(cardsText, place), $a = Opal.to_ary($b), (okCardList = ($a[0] == null ? nil : $a[0])), (ngCardList = ($a[1] == null ? nil : $a[1])), $b;};
      return [okCardList, ngCardList];
    }, $CardTrader_playCardByCardsBlockTextAndPlaceNo$45.$$arity = 2);
    
    Opal.def(self, '$playCardByCardsTextAndPlaceNo', $CardTrader_playCardByCardsTextAndPlaceNo$46 = function $$playCardByCardsTextAndPlaceNo(cardsText, place) {
      var $$47, self = this, cards = nil, okCardList = nil, ngCardList = nil;

      
      cards = cardsText.$split(/,/);
      okCardList = [];
      ngCardList = [];
      $send(cards, 'each', [], ($$47 = function(card){var self = $$47.$$s || this, $a, $b, okList = nil, ngList = nil;

      
        
        if (card == null) {
          card = nil;
        };
        $b = self.$playCardByCardAndPlaceNo(card, place), $a = Opal.to_ary($b), (okList = ($a[0] == null ? nil : $a[0])), (ngList = ($a[1] == null ? nil : $a[1])), $b;
        okCardList = $rb_plus(okCardList, okList);
        return (ngCardList = $rb_plus(ngCardList, ngList));}, $$47.$$s = self, $$47.$$arity = 1, $$47));
      return [okCardList, ngCardList];
    }, $CardTrader_playCardByCardsTextAndPlaceNo$46.$$arity = 2);
    
    Opal.def(self, '$playCardByCardAndPlaceNo', $CardTrader_playCardByCardAndPlaceNo$48 = function $$playCardByCardAndPlaceNo(card, place) {
      var self = this, okList = nil, ngList = nil, result = nil;
      if ($gvars.okResult == null) $gvars.okResult = nil;

      
      self.$debug("playCardByCardAndPlaceNo card, place", card, place);
      okList = [];
      ngList = [];
      result = self.$playOneCard(card, place);
      self.$debug("playOneCard result", result);
      if ($truthy(result['$==']($gvars.okResult))) {
        okList['$<<'](card)
      } else {
        ngList['$<<'](result)
      };
      return [okList, ngList];
    }, $CardTrader_playCardByCardAndPlaceNo$48.$$arity = 2);
    
    Opal.def(self, '$playOneCard', $CardTrader_playOneCard$49 = function $$playOneCard(card, place) {
      var self = this, destination = nil, result = nil;
      if ($gvars.okResult == null) $gvars.okResult = nil;

      
      self.$debug("playOneCard card, place", card, place);
      destination = self.nick_e.$upcase();
      result = "";
      if ($truthy($rb_gt(place, 0))) {
        
        self.$debug("playOneCard place > 0");
        result = self.$transferOneCard(card, destination, "" + (place) + (destination));
      } else {
        
        self.$debug("playOneCard place <= 0");
        result = self.$discardOneCard(card, place, destination);
      };
      if ($truthy(result['$==']($gvars.okResult))) {
        return result
      } else {
        return card
      };
    }, $CardTrader_playOneCard$49.$$arity = 2);
    
    Opal.def(self, '$discardCards', $CardTrader_discardCards$50 = function $$discardCards(command, destination) {
      var $a, $b, self = this, okList = nil, ngList = nil, __last__match__1 = nil, __last__match__2 = nil, __last__match__3 = nil, __last__match__4 = nil, __last__match__5 = nil, __last__match__6 = nil, __last__match__7 = nil, __last__match__8 = nil, __last__match__9 = nil, __last__match__10 = nil, __last__match__11 = nil, __last__match__12 = nil, __last__match__13 = nil, __last__match__14 = nil, __last__match__15 = nil, __last__match__16 = nil, __last__match__17 = nil, __last__match__18 = nil, __last__match__19 = nil, __last__match__20 = nil, commandSet = nil, place = nil, ngText = nil, okText = nil;

      
      
      if (destination == null) {
        destination = nil;
      };
      self.$debug("discardCards command, destination", command, destination);
      if ($truthy(destination['$nil?']())) {
        destination = self.nick_e};
      destination = destination.$upcase();
      okList = [];
      ngList = [];
      if ($truthy(new RegExp("" + "(c-(dis|discard)(\\d*)\\[((,)?" + (self.cardRegExp) + ")+\\])")['$=~'](command))) {
        
        __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
        __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
        __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
        __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
        __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
        __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
        __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
        __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
        __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
        __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
        __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
        __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
        __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
        __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
        __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
        __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
        __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
        __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
        __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
        __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
        self.$debug("discardCards reg OK");
        commandSet = __last__match__1;
        place = __last__match__3.$to_i();
        $b = self.$discardCardsByCommandSetAndPlaceAndDestination(commandSet, place, destination), $a = Opal.to_ary($b), (okList = ($a[0] == null ? nil : $a[0])), (ngList = ($a[1] == null ? nil : $a[1])), $b;};
      ngText = ngList.$join(",");
      okText = okList.$join(",");
      return [okList.$length(), ngText, okText];
    }, $CardTrader_discardCards$50.$$arity = -2);
    
    Opal.def(self, '$discardCardsByCommandSetAndPlaceAndDestination', $CardTrader_discardCardsByCommandSetAndPlaceAndDestination$51 = function $$discardCardsByCommandSetAndPlaceAndDestination(commandSet, place, destination) {
      var $a, $b, self = this, okList = nil, ngList = nil, __last__match__1 = nil, __last__match__2 = nil, __last__match__3 = nil, __last__match__4 = nil, __last__match__5 = nil, __last__match__6 = nil, __last__match__7 = nil, __last__match__8 = nil, __last__match__9 = nil, __last__match__10 = nil, __last__match__11 = nil, __last__match__12 = nil, __last__match__13 = nil, __last__match__14 = nil, __last__match__15 = nil, __last__match__16 = nil, __last__match__17 = nil, __last__match__18 = nil, __last__match__19 = nil, __last__match__20 = nil, cards = nil;

      
      okList = [];
      ngList = [];
      if ($truthy(new RegExp("" + "\\[(" + (self.cardRegExp) + "(," + (self.cardRegExp) + ")*)\\]")['$=~'](commandSet))) {
        
        __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
        __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
        __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
        __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
        __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
        __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
        __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
        __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
        __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
        __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
        __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
        __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
        __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
        __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
        __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
        __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
        __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
        __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
        __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
        __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
        cards = __last__match__1.$split(/,/);
        $b = self.$discardCardsByCardsAndPlace(cards, place, destination), $a = Opal.to_ary($b), (okList = ($a[0] == null ? nil : $a[0])), (ngList = ($a[1] == null ? nil : $a[1])), $b;};
      return [okList, ngList];
    }, $CardTrader_discardCardsByCommandSetAndPlaceAndDestination$51.$$arity = 3);
    
    Opal.def(self, '$discardCardsByCardsAndPlace', $CardTrader_discardCardsByCardsAndPlace$52 = function $$discardCardsByCardsAndPlace(cards, place, destination) {
      var $$53, self = this, okList = nil, ngList = nil;

      
      okList = [];
      ngList = [];
      $send(cards, 'each', [], ($$53 = function(card){var self = $$53.$$s || this, result = nil;
        if ($gvars.okResult == null) $gvars.okResult = nil;

      
        
        if (card == null) {
          card = nil;
        };
        result = self.$discardOneCard(card, place, destination);
        if ($truthy(result['$==']($gvars.okResult))) {
          return okList['$<<'](card)
        } else {
          return ngList['$<<'](result)
        };}, $$53.$$s = self, $$53.$$arity = 1, $$53));
      return [okList, ngList];
    }, $CardTrader_discardCardsByCardsAndPlace$52.$$arity = 3);
    
    Opal.def(self, '$discardOneCard', $CardTrader_discardOneCard$54 = function $$discardOneCard(card, place, destination) {
      var $$55, $a, self = this, this_cards = nil, rest_cards = nil, temp_cards = nil, result = nil, isTargetCardInHand = nil, $writer = nil;
      if ($gvars.okResult == null) $gvars.okResult = nil;

      
      card = card.$upcase();
      destination = destination.$upcase();
      destination = self.$getDestinationWhenPlaceIsNotHand(place, destination);
      this_cards = [];
      rest_cards = [];
      temp_cards = self.$getCardsFromDealCards(destination);
      result = $send(temp_cards, 'reject!', [], ($$55 = function(i){var self = $$55.$$s || this;

      
        
        if (i == null) {
          i = nil;
        };
        return i['$=='](card);}, $$55.$$s = self, $$55.$$arity = 1, $$55));
      isTargetCardInHand = result['$nil?']()['$!']();
      if ($truthy(isTargetCardInHand)) {
        this_cards['$<<'](card)
      } else {
        rest_cards['$<<'](card)
      };
      self.$debug("isTargetCardInHand", isTargetCardInHand);
      if ($truthy(isTargetCardInHand)) {
        
        self.$debug("isTargetCardInHand OK, so set card info");
        ($truthy($a = self.deal_cards['$[]'](destination)) ? $a : (($writer = [destination, []]), $send(self.deal_cards, '[]=', Opal.to_a($writer)), $writer[$rb_minus($writer["length"], 1)]));
        
        $writer = [destination, $rb_plus(self.deal_cards['$[]'](destination), rest_cards)];
        $send(self.deal_cards, '[]=', Opal.to_a($writer));
        $writer[$rb_minus($writer["length"], 1)];;
        ($truthy($a = self.deal_cards['$[]']("card_played")) ? $a : (($writer = ["card_played", []]), $send(self.deal_cards, '[]=', Opal.to_a($writer)), $writer[$rb_minus($writer["length"], 1)]));
        
        $writer = ["card_played", $rb_plus(self.deal_cards['$[]']("card_played"), this_cards)];
        $send(self.deal_cards, '[]=', Opal.to_a($writer));
        $writer[$rb_minus($writer["length"], 1)];;
        self.$debug("@deal_cards", self.deal_cards);
        return $gvars.okResult;
      } else {
        return card
      };
    }, $CardTrader_discardOneCard$54.$$arity = 3);
    
    Opal.def(self, '$getDestinationWhenPlaceIsNotHand', $CardTrader_getDestinationWhenPlaceIsNotHand$56 = function $$getDestinationWhenPlaceIsNotHand(place, destination) {
      var self = this;

      
      if ($truthy($rb_gt(place, 0))) {
        
        destination = "" + (place) + (destination);
        return destination;};
      return destination;
    }, $CardTrader_getDestinationWhenPlaceIsNotHand$56.$$arity = 2);
    
    Opal.def(self, '$getCardsFromDealCards', $CardTrader_getCardsFromDealCards$57 = function $$getCardsFromDealCards(destination) {
      var self = this, cards = nil;

      
      self.$debug("getCardsFromDealCards destination", destination);
      self.$debug("@deal_cards", self.deal_cards);
      self.$debug("@deal_cards[destination]", self.deal_cards['$[]'](destination));
      if ($truthy(self.deal_cards['$[]'](destination)['$nil?']())) {
        
        self.$debug("getCardsFromDealCards empty");
        return [];};
      cards = self.deal_cards['$[]'](destination);
      self.$debug("getCardsFromDealCards cards", cards);
      return cards;
    }, $CardTrader_getCardsFromDealCards$57.$$arity = 1);
    
    Opal.def(self, '$transferCardsByCommandText', $CardTrader_transferCardsByCommandText$58 = function $$transferCardsByCommandText(commandText, sendTo) {
      var $a, $b, self = this, count = nil, output_msg = nil;

      
      self.$debug("transferCardsByCommandText commandText, sendTo", commandText, sendTo);
      $b = self.$transferCards(commandText), $a = Opal.to_ary($b), (count = ($a[0] == null ? nil : $a[0])), (output_msg = ($a[1] == null ? nil : $a[1])), $b;
      if ($truthy($rb_lt(count, 0))) {
        self.$sendMessage(self.channel, "" + (self.nick_e) + ": 相手が登録されていません")
      } else {
        
        if ($truthy(output_msg['$!='](""))) {
          self.$sendMessage(self.channel, $rb_plus($rb_plus("[", self.$getCardsText(output_msg)), "]がありません"))};
        if ($truthy($rb_gt(count, 0))) {
          
          self.$sendMessage(self.channel, "" + (self.nick_e) + ": " + (count) + "枚渡しました");
          self.$debug("transferCardsByCommandText sendTo", sendTo);
          self.$sendMessage(sendTo, self.$getHandAndPlaceCardInfoText("Auto", sendTo));};
      };
      return self.$sendMessageToOnlySender(self.$getHandAndPlaceCardInfoText("Auto"));
    }, $CardTrader_transferCardsByCommandText$58.$$arity = 2);
    
    Opal.def(self, '$transferCards', $CardTrader_transferCards$59 = function $$transferCards(command) {
      var $a, $b, self = this, okCount = nil, ngCardList = nil, __last__match__1 = nil, __last__match__2 = nil, __last__match__3 = nil, __last__match__4 = nil, __last__match__5 = nil, __last__match__6 = nil, __last__match__7 = nil, __last__match__8 = nil, __last__match__9 = nil, __last__match__10 = nil, __last__match__11 = nil, __last__match__12 = nil, __last__match__13 = nil, __last__match__14 = nil, __last__match__15 = nil, __last__match__16 = nil, __last__match__17 = nil, __last__match__18 = nil, __last__match__19 = nil, __last__match__20 = nil, destination = nil, commandset = nil, place = nil, ngCardText = nil;
      if ($gvars.ircNickRegExp == null) $gvars.ircNickRegExp = nil;

      
      self.$debug("transferCards command", command);
      okCount = 0;
      ngCardList = [];
      if ($truthy(new RegExp("" + "(c-pass(\\d*)(\\[(((,)?" + (self.cardRegExp) + ")*)\\])?)\\s*(" + ($gvars.ircNickRegExp) + ")")['$=~'](command))) {
        
        __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
        __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
        __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
        __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
        __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
        __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
        __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
        __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
        __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
        __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
        __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
        __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
        __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
        __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
        __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
        __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
        __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
        __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
        __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
        __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
        destination = __last__match__7.$upcase();
        commandset = __last__match__1;
        place = __last__match__2.$to_i();
        place = ($truthy($a = place) ? $a : 0);
        $b = self.$transferCardsByCommand(commandset, place, destination), $a = Opal.to_ary($b), (okCount = ($a[0] == null ? nil : $a[0])), (ngCardList = ($a[1] == null ? nil : $a[1])), $b;
        self.$debug("transferCardsByCommand resutl okCount, ngCardList", okCount, ngCardList);};
      ngCardText = ngCardList.$join(",");
      return [okCount, ngCardText];
    }, $CardTrader_transferCards$59.$$arity = 1);
    
    Opal.def(self, '$transferCardsByCommand', $CardTrader_transferCardsByCommand$60 = function $$transferCardsByCommand(commandset, place, destination) {
      var $a, $b, self = this, nick_e = nil, okCount = nil, ngCardList = nil, cards = nil, __last__match__1 = nil, __last__match__2 = nil, __last__match__3 = nil, __last__match__4 = nil, __last__match__5 = nil, __last__match__6 = nil, __last__match__7 = nil, __last__match__8 = nil, __last__match__9 = nil, __last__match__10 = nil, __last__match__11 = nil, __last__match__12 = nil, __last__match__13 = nil, __last__match__14 = nil, __last__match__15 = nil, __last__match__16 = nil, __last__match__17 = nil, __last__match__18 = nil, __last__match__19 = nil, __last__match__20 = nil;

      
      self.$debug("transferCardsByCommand commandset, place, destination", commandset, place, destination);
      nick_e = self.nick_e;
      if ($truthy($rb_gt(place, 0))) {
        nick_e = "" + (place) + (nick_e)};
      okCount = 0;
      ngCardList = [];
      self.$debug("LINE", 1567);
      cards = [""];
      if ($truthy(new RegExp("" + "\\[(" + (self.cardRegExp) + "(," + (self.cardRegExp) + ")*)\\]")['$=~'](commandset))) {
        
        __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
        __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
        __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
        __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
        __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
        __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
        __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
        __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
        __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
        __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
        __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
        __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
        __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
        __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
        __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
        __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
        __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
        __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
        __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
        __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
        cards = __last__match__1.$split(/,/);};
      self.$debug("transferCardsByCommand cards", cards);
      $b = self.$transferCardsByCards(cards, destination, nick_e), $a = Opal.to_ary($b), (okCount = ($a[0] == null ? nil : $a[0])), (ngCardList = ($a[1] == null ? nil : $a[1])), $b;
      self.$debug("LINE", 1598);
      return [okCount, ngCardList];
    }, $CardTrader_transferCardsByCommand$60.$$arity = 3);
    
    Opal.def(self, '$transferCardsByCards', $CardTrader_transferCardsByCards$61 = function $$transferCardsByCards(cards, destination, nick_e) {try {

      var $$62, self = this, okCount = nil, ngCardList = nil;

      
      okCount = 0;
      ngCardList = [];
      $send(cards, 'each', [], ($$62 = function(card){var self = $$62.$$s || this, result = nil, $case = nil;
        if ($gvars.ngResult == null) $gvars.ngResult = nil;
        if ($gvars.okResult == null) $gvars.okResult = nil;

      
        
        if (card == null) {
          card = nil;
        };
        self.$debug("transferCardsByCards card", card);
        result = self.$transferOneCard(card, nick_e, destination);
        self.$debug("transferOneCard result", result);
        return (function() {$case = result;
        if ($gvars.ngResult['$===']($case)) {Opal.ret([-1, ["渡す相手が登録されていません"]])}
        else if ($gvars.okResult['$===']($case)) {return (okCount = $rb_plus(okCount, 1))}
        else {return ngCardList['$<<'](result)}})();}, $$62.$$s = self, $$62.$$arity = 1, $$62));
      return [okCount, ngCardList];
      } catch ($returner) { if ($returner === Opal.returner) { return $returner.$v } throw $returner; }
    }, $CardTrader_transferCardsByCards$61.$$arity = 3);
    
    Opal.def(self, '$transferOneCard', $CardTrader_transferOneCard$63 = function $$transferOneCard(card, from, toSend) {
      var $a, $b, self = this, targetCard = nil, isTargetCardInHand = nil, restCards = nil, thisCard = nil, $writer = nil, cards = nil, isSuccess = nil;
      if ($gvars.ngResult == null) $gvars.ngResult = nil;
      if ($gvars.okResult == null) $gvars.okResult = nil;

      
      self.$debug("transferOneCard card, from, toSend", card, from, toSend);
      targetCard = card.$upcase();
      toSend = toSend.$upcase();
      from = from.$upcase();
      isTargetCardInHand = false;
      restCards = [];
      thisCard = "";
      ($truthy($a = self.deal_cards['$[]'](from)) ? $a : (($writer = [from, []]), $send(self.deal_cards, '[]=', Opal.to_a($writer)), $writer[$rb_minus($writer["length"], 1)]));
      cards = self.deal_cards['$[]'](from);
      self.$debug("from, cards, @deal_cards", from, cards, self.deal_cards);
      if ($truthy(targetCard['$=='](""))) {
        
        self.$debug("カード指定がないのでランダムで一枚渡す");
        thisCard = self.$ejectOneCardRandomFromCards(cards);
        isTargetCardInHand = true;
        restCards = self.deal_cards['$[]'](from);
      } else {
        
        self.$debug("カード指定あり targetCard", targetCard);
        $b = self.$transferTargetCard(targetCard, cards, toSend, from), $a = Opal.to_ary($b), (thisCard = ($a[0] == null ? nil : $a[0])), (restCards = ($a[1] == null ? nil : $a[1])), (isTargetCardInHand = ($a[2] == null ? nil : $a[2])), $b;
      };
      self.$debug("transferOneCard isTargetCardInHand", isTargetCardInHand);
      if ($truthy(isTargetCardInHand['$!']())) {
        return targetCard};
      self.$debug("transferOneCard @deal_cards", self.deal_cards);
      self.$debug("transferOneCard toSend", toSend);
      if ($truthy(self.deal_cards['$[]'](toSend))) {
        
        self.$debug("alreadyRegisted");
        self.deal_cards['$[]'](toSend)['$<<'](thisCard);
      } else {
        
        self.$debug("NOT registed");
        isSuccess = self.$transferTargetCardToNewMember(toSend, thisCard);
        self.$debug("isSuccess", isSuccess);
        if ($truthy(isSuccess)) {
        } else {
          return $gvars.ngResult
        };
      };
      
      $writer = [from, restCards];
      $send(self.deal_cards, '[]=', Opal.to_a($writer));
      $writer[$rb_minus($writer["length"], 1)];;
      self.$debug("transferOneCard @deal_cards", self.deal_cards);
      return $gvars.okResult;
    }, $CardTrader_transferOneCard$63.$$arity = 3);
    
    Opal.def(self, '$ejectOneCardRandomFromCards', $CardTrader_ejectOneCardRandomFromCards$64 = function $$ejectOneCardRandomFromCards(cards) {
      var $a, $b, self = this, cardNumber = nil, dummy = nil, card = nil;

      
      self.$debug("ejectOneCardRandomFromCards cards.length", cards.$length());
      if ($truthy(cards['$empty?']())) {
        return nil};
      $b = self.bcdice.$roll(1, cards.$length()), $a = Opal.to_ary($b), (cardNumber = ($a[0] == null ? nil : $a[0])), (dummy = ($a[1] == null ? nil : $a[1])), $b;
      cardNumber = $rb_minus(cardNumber, 1);
      self.$debug("cardNumber", cardNumber);
      card = cards.$delete_at(cardNumber);
      self.$debug("card", card);
      return card;
    }, $CardTrader_ejectOneCardRandomFromCards$64.$$arity = 1);
    
    Opal.def(self, '$transferTargetCard', $CardTrader_transferTargetCard$65 = function $$transferTargetCard(targetCard, cards, toSend, from) {
      var $$66, self = this, thisCard = nil, restCards = nil, isTargetCardInHand = nil;

      
      self.$debug("transferTargetCard(targetCard, cards, toSend, from)", targetCard, cards, toSend, from);
      thisCard = "";
      restCards = [];
      isTargetCardInHand = false;
      $send(cards, 'each', [], ($$66 = function(card){var self = $$66.$$s || this, $a;

      
        
        if (card == null) {
          card = nil;
        };
        if ($truthy(($truthy($a = isTargetCardInHand['$!']()) ? card['$=='](targetCard) : $a))) {
          
          isTargetCardInHand = true;
          return (thisCard = card);
        } else {
          return restCards['$<<'](card)
        };}, $$66.$$s = self, $$66.$$arity = 1, $$66));
      self.$debug("restCards", restCards);
      return [thisCard, restCards, isTargetCardInHand];
    }, $CardTrader_transferTargetCard$65.$$arity = 4);
    
    Opal.def(self, '$transferTargetCardToNewMember', $CardTrader_transferTargetCardToNewMember$67 = function $$transferTargetCardToNewMember(destination, thisCard) {
      var $a, self = this, isSuccess = nil, __last__match__1 = nil, __last__match__2 = nil, __last__match__3 = nil, __last__match__4 = nil, __last__match__5 = nil, __last__match__6 = nil, __last__match__7 = nil, __last__match__8 = nil, __last__match__9 = nil, __last__match__10 = nil, __last__match__11 = nil, __last__match__12 = nil, __last__match__13 = nil, __last__match__14 = nil, __last__match__15 = nil, __last__match__16 = nil, __last__match__17 = nil, __last__match__18 = nil, __last__match__19 = nil, __last__match__20 = nil, placeName = nil, $writer = nil;

      
      self.$debug("transferTargetCardToNewMember destination, thisCard", destination, thisCard);
      self.$debug("@card_place", self.card_place);
      isSuccess = false;
      if ($truthy($rb_gt(self.card_place, 0))) {
        if ($truthy(/^\d+(.+)/['$=~'](destination))) {
          
          __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
          __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
          __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
          __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
          __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
          __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
          __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
          __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
          __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
          __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
          __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
          __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
          __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
          __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
          __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
          __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
          __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
          __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
          __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
          __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
          placeName = __last__match__1;
          self.$debug("placeName", placeName);
          if ($truthy(self.deal_cards['$[]'](placeName))) {
            
            ($truthy($a = self.deal_cards['$[]'](destination)) ? $a : (($writer = [destination, []]), $send(self.deal_cards, '[]=', Opal.to_a($writer)), $writer[$rb_minus($writer["length"], 1)]));
            self.deal_cards['$[]'](destination)['$<<'](thisCard);
            isSuccess = true;};}};
      return isSuccess;
    }, $CardTrader_transferTargetCardToNewMember$67.$$arity = 2);
    
    Opal.def(self, '$sendCardToTargetNickPlaceCommandText', $CardTrader_sendCardToTargetNickPlaceCommandText$68 = function $$sendCardToTargetNickPlaceCommandText(commandText, targetNick) {
      var $a, $b, self = this, okCardList = nil, ngCardList = nil, ngCardText = nil;

      
      self.$debug("sendCardToTargetNickPlaceCommandText commandText, targetNick", commandText, targetNick);
      $b = self.$getSendCardToTargetNickPlace(commandText, targetNick), $a = Opal.to_ary($b), (okCardList = ($a[0] == null ? nil : $a[0])), (ngCardList = ($a[1] == null ? nil : $a[1])), $b;
      self.$debug("getSendCardToTargetNickPlace okCardList, ngCardList", okCardList, ngCardList);
      if ($truthy($rb_lt(okCardList.$length(), 0))) {
        
        self.$sendMessage(self.channel, "" + (self.nick_e) + ": 相手が登録されていません");
        return nil;};
      if ($truthy(ngCardList['$empty?']())) {
      } else {
        
        ngCardText = self.$getCardsTextFromCards(ngCardList);
        self.$sendMessage(self.channel, "" + "[" + (ngCardText) + "]がありません");
        return nil;
      };
      if ($truthy($rb_gt(okCardList.$length(), 0))) {
        self.$printRegistCardResult(targetNick, self.$okCards())};
      return self.$sendMessageToOnlySender(self.$getHandAndPlaceCardInfoText("Auto"));
    }, $CardTrader_sendCardToTargetNickPlaceCommandText$68.$$arity = 2);
    
    Opal.def(self, '$getSendCardToTargetNickPlace', $CardTrader_getSendCardToTargetNickPlace$69 = function $$getSendCardToTargetNickPlace(commandText, nick_e) {
      var $a, self = this, ngCardList = nil, okCardList = nil, __last__match__1 = nil, __last__match__2 = nil, __last__match__3 = nil, __last__match__4 = nil, __last__match__5 = nil, __last__match__6 = nil, __last__match__7 = nil, __last__match__8 = nil, __last__match__9 = nil, __last__match__10 = nil, __last__match__11 = nil, __last__match__12 = nil, __last__match__13 = nil, __last__match__14 = nil, __last__match__15 = nil, __last__match__16 = nil, __last__match__17 = nil, __last__match__18 = nil, __last__match__19 = nil, __last__match__20 = nil, cardset = nil, placeNumber = nil, destination = nil;
      if ($gvars.ircNickRegExp == null) $gvars.ircNickRegExp = nil;

      
      ngCardList = [];
      okCardList = [];
      self.$debug("commandText", commandText);
      if ($truthy(new RegExp("" + "(c-place(\\d*)(\\[(((,)?" + (self.cardRegExp) + ")*)\\])?)\\s*(" + ($gvars.ircNickRegExp) + ")")['$=~'](commandText))) {
        
        __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
        __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
        __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
        __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
        __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
        __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
        __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
        __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
        __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
        __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
        __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
        __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
        __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
        __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
        __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
        __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
        __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
        __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
        __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
        __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
        cardset = __last__match__1;
        placeNumber = __last__match__2.$to_i();
        destination = __last__match__7.$upcase();
        self.$getSendCardToTargetNickPlaceByCardSetAndDestination(cardset, placeNumber, destination);};
      return [okCardList, ngCardList];
    }, $CardTrader_getSendCardToTargetNickPlace$69.$$arity = 2);
    
    Opal.def(self, '$getSendCardToTargetNickPlaceByCardSetAndDestination', $CardTrader_getSendCardToTargetNickPlaceByCardSetAndDestination$70 = function $$getSendCardToTargetNickPlaceByCardSetAndDestination(cardset, placeNumber, destination) {
      var $a, $b, self = this, toSend = nil, from = nil, __last__match__1 = nil, __last__match__2 = nil, __last__match__3 = nil, __last__match__4 = nil, __last__match__5 = nil, __last__match__6 = nil, __last__match__7 = nil, __last__match__8 = nil, __last__match__9 = nil, __last__match__10 = nil, __last__match__11 = nil, __last__match__12 = nil, __last__match__13 = nil, __last__match__14 = nil, __last__match__15 = nil, __last__match__16 = nil, __last__match__17 = nil, __last__match__18 = nil, __last__match__19 = nil, __last__match__20 = nil, cards = nil, okCardList = nil, ngCardList = nil;

      
      self.$debug("getSendCardToTargetNickPlaceByCardSetAndDestination cardset, placeNumber, destination", cardset, placeNumber, destination);
      self.$debug("今のところ場が１つしかないので相手の場は決めうち");
      toSend = "" + "1" + (destination);
      self.$debug("toSend", toSend);
      from = self.nick_e;
      if ($truthy($rb_gt(placeNumber, 0))) {
        from = "" + (placeNumber) + (from)};
      self.$debug("from", from);
      if ($truthy(new RegExp("" + "\\[(" + (self.cardRegExp) + "(," + (self.cardRegExp) + ")*)\\]")['$=~'](cardset))) {
        
        __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
        __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
        __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
        __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
        __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
        __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
        __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
        __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
        __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
        __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
        __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
        __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
        __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
        __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
        __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
        __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
        __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
        __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
        __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
        __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
        cards = __last__match__1.$split(/,/);
        $b = self.$getSendCardToTargetNickPlaceByCards(cards, from, toSend), $a = Opal.to_ary($b), (okCardList = ($a[0] == null ? nil : $a[0])), (ngCardList = ($a[1] == null ? nil : $a[1])), $b;};
      return [okCardList, ngCardList];
    }, $CardTrader_getSendCardToTargetNickPlaceByCardSetAndDestination$70.$$arity = 3);
    
    Opal.def(self, '$getSendCardToTargetNickPlaceByCards', $CardTrader_getSendCardToTargetNickPlaceByCards$71 = function $$getSendCardToTargetNickPlaceByCards(cards, destination, toSend) {try {

      var $$72, self = this, okCardList = nil, ngCardList = nil;

      
      self.$debug("getSendCardToTargetNickPlaceByCards cards, destination, toSend", destination, toSend);
      okCardList = [];
      ngCardList = [];
      $send(cards, 'each', [], ($$72 = function(card){var self = $$72.$$s || this, result = nil, $case = nil;
        if ($gvars.ngResult == null) $gvars.ngResult = nil;
        if ($gvars.okResult == null) $gvars.okResult = nil;

      
        
        if (card == null) {
          card = nil;
        };
        result = self.$transferOneCard(card, destination, toSend);
        return (function() {$case = result;
        if ($gvars.ngResult['$===']($case)) {Opal.ret([-1, "渡す相手が登録されていません"])}
        else if ($gvars.okResult['$===']($case)) {return okCardList['$<<'](card)}
        else {return ngCardList['$<<'](result)}})();}, $$72.$$s = self, $$72.$$arity = 1, $$72));
      return [okCardList, ngCardList];
      } catch ($returner) { if ($returner === Opal.returner) { return $returner.$v } throw $returner; }
    }, $CardTrader_getSendCardToTargetNickPlaceByCards$71.$$arity = 3);
    
    Opal.def(self, '$printRegistCardResult', $CardTrader_printRegistCardResult$73 = function $$printRegistCardResult(targetNick, okCards) {
      var self = this, cardText = nil;

      
      self.$sendMessage(self.channel, "" + (self.nick_e) + ": " + (okCards.$length()) + "枚場に置きました");
      if ($truthy(self.cardTitles['$empty?']())) {
      } else {
        
        cardText = self.$getCardsTextFromCards(okCards);
        self.$sendMessage(self.channel, "" + "[" + (cardText) + "]");
      };
      return self.$sendMessage(targetNick, self.$getHandAndPlaceCardInfoText("Auto", targetNick));
    }, $CardTrader_printRegistCardResult$73.$$arity = 2);
    
    Opal.def(self, '$tapCardCommandText', $CardTrader_tapCardCommandText$74 = function $$tapCardCommandText(commandText) {
      var $a, $b, self = this, okList = nil, ngList = nil, isUntap = nil, tapTypeName = nil;

      
      self.$debug("tapCardCommandText commandText", commandText);
      $b = self.$tapCard(commandText), $a = Opal.to_ary($b), (okList = ($a[0] == null ? nil : $a[0])), (ngList = ($a[1] == null ? nil : $a[1])), (isUntap = ($a[2] == null ? nil : $a[2])), $b;
      if ($truthy($rb_gt(okList.$length(), 0))) {
        
        tapTypeName = (function() {if ($truthy(isUntap)) {
          return "アンタップ"
        } else {
          return "タップ"
        }; return nil; })();
        self.$sendMessage(self.channel, "" + (self.nick_e) + ": " + (okList.$length()) + "枚" + (tapTypeName) + "しました");
        if ($truthy(self.cardTitles['$empty?']())) {
        } else {
          self.$sendMessage(self.channel, "" + "[" + (self.$getCardsTextFromCards(okList)) + "]")
        };};
      if ($truthy($rb_gt(ngList.$length(), 0))) {
        self.$sendMessage(self.channel, "" + "[" + (self.$getCardsTextFromCards(ngList)) + "]は場にありません")};
      return self.$sendMessageToOnlySender(self.$getHandAndPlaceCardInfoText("Auto", self.nick_e));
    }, $CardTrader_tapCardCommandText$74.$$arity = 1);
    
    Opal.def(self, '$tapCard', $CardTrader_tapCard$75 = function $$tapCard(command) {
      var $a, $b, self = this, okCardList = nil, ngCardList = nil, __last__match__1 = nil, __last__match__2 = nil, __last__match__3 = nil, __last__match__4 = nil, __last__match__5 = nil, __last__match__6 = nil, __last__match__7 = nil, __last__match__8 = nil, __last__match__9 = nil, __last__match__10 = nil, __last__match__11 = nil, __last__match__12 = nil, __last__match__13 = nil, __last__match__14 = nil, __last__match__15 = nil, __last__match__16 = nil, __last__match__17 = nil, __last__match__18 = nil, __last__match__19 = nil, __last__match__20 = nil, place = nil, isUntap = nil, cardsText = nil;

      
      okCardList = [];
      ngCardList = [];
      if ($truthy(($truthy($a = self.canTapCard) ? self.card_place : $a))) {
      } else {
        return [okCardList, ngCardList]
      };
      if ($truthy(new RegExp("" + "(c-(un)?tap(\\d+)\\[((,)?" + (self.cardRegExp) + ")+\\])")['$=~'](command))) {
      } else {
        return [okCardList, ngCardList]
      };
      __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
      __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
      __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
      __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
      __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
      __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
      __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
      __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
      __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
      __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
      __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
      __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
      __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
      __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
      __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
      __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
      __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
      __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
      __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
      __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
      place = __last__match__3.$to_i();
      isUntap = __last__match__2;
      cardsText = __last__match__1;
      $b = self.$tapCardByCardsTextAndPlace(cardsText, place, isUntap), $a = Opal.to_ary($b), (okCardList = ($a[0] == null ? nil : $a[0])), (ngCardList = ($a[1] == null ? nil : $a[1])), $b;
      return [okCardList, ngCardList, isUntap];
    }, $CardTrader_tapCard$75.$$arity = 1);
    
    Opal.def(self, '$tapCardByCardsTextAndPlace', $CardTrader_tapCardByCardsTextAndPlace$76 = function $$tapCardByCardsTextAndPlace(cardsText, place, isUntap) {
      var $a, $$77, self = this, okCardList = nil, ngCardList = nil, __last__match__1 = nil, __last__match__2 = nil, __last__match__3 = nil, __last__match__4 = nil, __last__match__5 = nil, __last__match__6 = nil, __last__match__7 = nil, __last__match__8 = nil, __last__match__9 = nil, __last__match__10 = nil, __last__match__11 = nil, __last__match__12 = nil, __last__match__13 = nil, __last__match__14 = nil, __last__match__15 = nil, __last__match__16 = nil, __last__match__17 = nil, __last__match__18 = nil, __last__match__19 = nil, __last__match__20 = nil, cards = nil;

      
      okCardList = [];
      ngCardList = [];
      if ($truthy(new RegExp("" + "\\[(" + (self.cardRegExp) + "(," + (self.cardRegExp) + ")*)\\]")['$=~'](cardsText))) {
        
        __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
        __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
        __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
        __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
        __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
        __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
        __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
        __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
        __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
        __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
        __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
        __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
        __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
        __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
        __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
        __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
        __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
        __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
        __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
        __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
        cards = __last__match__1.$split(/,/);
        $send(cards, 'each', [], ($$77 = function(card){var self = $$77.$$s || this, $b, $c, okCard = nil, ngCard = nil;

        
          
          if (card == null) {
            card = nil;
          };
          $c = self.$tapOneCardByCardAndPlace(card, place, isUntap), $b = Opal.to_ary($c), (okCard = ($b[0] == null ? nil : $b[0])), (ngCard = ($b[1] == null ? nil : $b[1])), $c;
          if ($truthy(okCard['$nil?']())) {
          } else {
            okCardList['$<<'](okCard)
          };
          if ($truthy(ngCard['$nil?']())) {
            return nil
          } else {
            return ngCardList['$<<'](ngCard)
          };}, $$77.$$s = self, $$77.$$arity = 1, $$77));};
      return [okCardList, ngCardList];
    }, $CardTrader_tapCardByCardsTextAndPlace$76.$$arity = 3);
    
    Opal.def(self, '$tapOneCardByCardAndPlace', $CardTrader_tapOneCardByCardAndPlace$78 = function $$tapOneCardByCardAndPlace(card, place, isUntap) {
      var self = this, result = nil, nick_e_original = nil, nick_to = nil, destination = nil;
      if ($gvars.okResult == null) $gvars.okResult = nil;

      
      card = card.$upcase();
      result = "";
      nick_e_original = self.nick_e;
      self.nick_e = self.nick_e.$upcase();
      nick_to = "";
      if ($truthy(isUntap)) {
        
        destination = "" + ($rb_minus($rb_times(place, 2), 1)) + (self.nick_e);
        nick_to = "" + ($rb_times(place, 2)) + (self.nick_e);
      } else {
        
        destination = "" + ($rb_times(place, 2)) + (self.nick_e);
        nick_to = "" + ($rb_minus($rb_times(place, 2), 1)) + (self.nick_e);
      };
      result = self.$transferOneCard(card, nick_to, destination);
      self.nick_e = nick_e_original;
      if ($truthy(result['$==']($gvars.okResult))) {
        return [card, nil]
      } else {
        return [nil, card]
      };
    }, $CardTrader_tapOneCardByCardAndPlace$78.$$arity = 3);
    
    Opal.def(self, '$printMilStoneResult', $CardTrader_printMilStoneResult$79 = function $$printMilStoneResult(commandText) {
      var $a, $b, self = this, count = nil, output_msg = nil;

      
      $b = self.$getCardMilstone(commandText), $a = Opal.to_ary($b), (count = ($a[0] == null ? nil : $a[0])), (output_msg = ($a[1] == null ? nil : $a[1])), $b;
      if ($truthy($rb_gt(count, 0))) {
        return self.$sendMessage(self.channel, "" + (self.nick_e) + ": " + (self.$getCardsText(output_msg)) + "が出ました")
      } else {
        return self.$sendMessage(self.channel, "カードが残っていません")
      };
    }, $CardTrader_printMilStoneResult$79.$$arity = 1);
    
    Opal.def(self, '$getCardMilstone', $CardTrader_getCardMilstone$80 = function $$getCardMilstone(commandText) {
      var $a, $b, self = this, command = nil, count = nil, __last__match__1 = nil, __last__match__2 = nil, __last__match__3 = nil, __last__match__4 = nil, __last__match__5 = nil, __last__match__6 = nil, __last__match__7 = nil, __last__match__8 = nil, __last__match__9 = nil, __last__match__10 = nil, __last__match__11 = nil, __last__match__12 = nil, __last__match__13 = nil, __last__match__14 = nil, __last__match__15 = nil, __last__match__16 = nil, __last__match__17 = nil, __last__match__18 = nil, __last__match__19 = nil, __last__match__20 = nil, cards = nil, text = nil, cardInfo = nil, okCount = nil, ngCount = nil;

      
      command = "c-draw";
      count = 0;
      if ($truthy(/\[(\d+)\]/['$=~'](commandText))) {
        
        __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
        __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
        __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
        __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
        __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
        __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
        __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
        __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
        __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
        __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
        __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
        __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
        __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
        __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
        __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
        __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
        __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
        __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
        __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
        __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
        count = __last__match__1.$to_i();
        command = $rb_plus(command, "" + "[" + (count) + "]");};
      cards = self.$drawCard(command);
      self.$debug("cards", cards);
      text = "";
      if ($truthy($rb_gt(cards.$length(), 0))) {
        
        cardInfo = self.$getCardsTextFromCards(cards);
        $b = self.$discardCards("" + "c-discard[" + (cardInfo) + "]"), $a = Opal.to_ary($b), (okCount = ($a[0] == null ? nil : $a[0])), (ngCount = ($a[1] == null ? nil : $a[1])), (text = ($a[2] == null ? nil : $a[2])), $b;
        self.$debug("discardCards okCount, ngCount, text", okCount, ngCount, text);
        count = okCount;
      } else {
        count = 0
      };
      self.$debug("count", count);
      self.$debug("cardInfo", cardInfo);
      return [count, cardInfo];
    }, $CardTrader_getCardMilstone$80.$$arity = 1);
    
    Opal.def(self, '$clearAllPlaceAllPlayerCards', $CardTrader_clearAllPlaceAllPlayerCards$81 = function $$clearAllPlaceAllPlayerCards() {
      var $$82, self = this;

      
      $send(self.deal_cards, 'each', [], ($$82 = function(place, cards){var self = $$82.$$s || this;

      
        
        if (place == null) {
          place = nil;
        };
        
        if (cards == null) {
          cards = nil;
        };
        return self.$clearAllPlayerCardsWhenPlayedPlace(place, cards);}, $$82.$$s = self, $$82.$$arity = 2, $$82));
      return "場のカードを捨てました";
    }, $CardTrader_clearAllPlaceAllPlayerCards$81.$$arity = 0);
    
    Opal.def(self, '$clearAllPlayerCardsWhenPlayedPlace', $CardTrader_clearAllPlayerCardsWhenPlayedPlace$83 = function $$clearAllPlayerCardsWhenPlayedPlace(place, cards) {
      var $a, self = this, __last__match__1 = nil, __last__match__2 = nil, __last__match__3 = nil, __last__match__4 = nil, __last__match__5 = nil, __last__match__6 = nil, __last__match__7 = nil, __last__match__8 = nil, __last__match__9 = nil, __last__match__10 = nil, __last__match__11 = nil, __last__match__12 = nil, __last__match__13 = nil, __last__match__14 = nil, __last__match__15 = nil, __last__match__16 = nil, __last__match__17 = nil, __last__match__18 = nil, __last__match__19 = nil, __last__match__20 = nil;

      if ($truthy(place['$=~'](/^\d+/))) {
        
        __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
        __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
        __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
        __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
        __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
        __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
        __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
        __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
        __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
        __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
        __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
        __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
        __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
        __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
        __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
        __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
        __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
        __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
        __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
        __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
        return self.$clearAllPlayerCards(place, cards);
      } else {
        return nil
      }
    }, $CardTrader_clearAllPlayerCardsWhenPlayedPlace$83.$$arity = 2);
    
    Opal.def(self, '$clearAllPlayerCards', $CardTrader_clearAllPlayerCards$84 = function $$clearAllPlayerCards(place, cards) {
      var $a, self = this, cardset = nil, $writer = nil;

      
      cardset = cards.$join(",");
      self.$discardCards("" + "c-discard[" + (cardset) + "]", place);
      ($truthy($a = self.deal_cards['$[]'](place)) ? $a : (($writer = [place, []]), $send(self.deal_cards, '[]=', Opal.to_a($writer)), $writer[$rb_minus($writer["length"], 1)]));
      return self.deal_cards['$[]'](place).$clear();
    }, $CardTrader_clearAllPlayerCards$84.$$arity = 2);
    
    Opal.def(self, '$returnCards', $CardTrader_returnCards$85 = function $$returnCards() {
      var $a, self = this, $writer = nil, cards = nil;

      
      ($truthy($a = self.deal_cards['$[]']("card_played")) ? $a : (($writer = ["card_played", []]), $send(self.deal_cards, '[]=', Opal.to_a($writer)), $writer[$rb_minus($writer["length"], 1)]));
      cards = self.deal_cards['$[]']("card_played");
      while ($truthy($rb_gt(cards.$length(), 0))) {
        self.cardRest.$push(cards.$shift())
      };
      return "捨て札を山に戻しました";
    }, $CardTrader_returnCards$85.$$arity = 0);
    
    Opal.def(self, '$getBurriedCard', $CardTrader_getBurriedCard$86 = function $$getBurriedCard() {
      var $a, self = this, $writer = nil, cards = nil;

      
      ($truthy($a = self.deal_cards['$[]']("card_played")) ? $a : (($writer = ["card_played", []]), $send(self.deal_cards, '[]=', Opal.to_a($writer)), $writer[$rb_minus($writer["length"], 1)]));
      cards = self.deal_cards['$[]']("card_played");
      return cards.$length();
    }, $CardTrader_getBurriedCard$86.$$arity = 0);
    
    Opal.def(self, '$reviewCards', $CardTrader_reviewCards$87 = function $$reviewCards() {
      var self = this;

      return self.cardRest.$join(",")
    }, $CardTrader_reviewCards$87.$$arity = 0);
    
    Opal.def(self, '$getAllCardLocation', $CardTrader_getAllCardLocation$88 = function $$getAllCardLocation() {
      var $$89, self = this, allText = nil, allPlaceText = nil;

      
      allText = "" + "山札:" + (self.cardRest.$length()) + "枚 捨札:" + (self.$getBurriedCard()) + "枚";
      allPlaceText = "";
      $send(self.deal_cards, 'each', [], ($$89 = function(place, cards){var self = $$89.$$s || this, $a, $b, text = nil, placeText = nil;

      
        
        if (place == null) {
          place = nil;
        };
        
        if (cards == null) {
          cards = nil;
        };
        if ($truthy(place['$==']("card_played"))) {
          return nil;};
        $b = self.$getCardLocationOnPlace(place, cards), $a = Opal.to_ary($b), (text = ($a[0] == null ? nil : $a[0])), (placeText = ($a[1] == null ? nil : $a[1])), $b;
        allText = $rb_plus(allText, text);
        return (allPlaceText = $rb_plus(allPlaceText, placeText));}, $$89.$$s = self, $$89.$$arity = 2, $$89));
      return [allText, allPlaceText];
    }, $CardTrader_getAllCardLocation$88.$$arity = 0);
    
    Opal.def(self, '$getCardLocationOnPlace', $CardTrader_getCardLocationOnPlace$90 = function $$getCardLocationOnPlace(place, cards) {
      var $a, self = this, text = nil, placeText = nil, __last__match__1 = nil, __last__match__2 = nil, __last__match__3 = nil, __last__match__4 = nil, __last__match__5 = nil, __last__match__6 = nil, __last__match__7 = nil, __last__match__8 = nil, __last__match__9 = nil, __last__match__10 = nil, __last__match__11 = nil, __last__match__12 = nil, __last__match__13 = nil, __last__match__14 = nil, __last__match__15 = nil, __last__match__16 = nil, __last__match__17 = nil, __last__match__18 = nil, __last__match__19 = nil, __last__match__20 = nil, placeNumber = nil, cnick = nil;
      if ($gvars.ircNickRegExp == null) $gvars.ircNickRegExp = nil;

      
      text = "";
      placeText = "";
      if ($truthy(place['$=~'](new RegExp("" + "^(\\d+)(" + ($gvars.ircNickRegExp) + ")")))) {
        
        __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
        __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
        __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
        __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
        __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
        __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
        __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
        __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
        __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
        __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
        __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
        __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
        __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
        __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
        __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
        __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
        __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
        __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
        __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
        __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
        __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
        __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
        __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
        __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
        __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
        __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
        __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
        __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
        __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
        __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
        __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
        __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
        __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
        __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
        __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
        __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
        __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
        __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
        __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
        __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
        placeNumber = __last__match__1;
        cnick = __last__match__2;
        placeText = self.$getCardLocationOnNumberdPlace(cards, placeNumber, cnick);
      } else {
        text = "" + " " + (place) + ":" + (cards.$length()) + "枚"
      };
      return [text, placeText];
    }, $CardTrader_getCardLocationOnPlace$90.$$arity = 2);
    
    Opal.def(self, '$getCardLocationOnNumberdPlace', $CardTrader_getCardLocationOnNumberdPlace$91 = function $$getCardLocationOnNumberdPlace(cards, placeNumber, cnick) {
      var self = this, cardText = nil;

      
      cardText = self.$getCardsText(cards);
      if ($truthy(self.$isTapCardPlace(placeNumber))) {
        return "" + " " + (cnick) + "のタップした場札:" + (cardText)
      } else {
        return "" + " " + (cnick) + "の場札:" + (cardText)
      };
    }, $CardTrader_getCardLocationOnNumberdPlace$91.$$arity = 3);
    
    Opal.def(self, '$getHandAndPlaceCardInfoText', $CardTrader_getHandAndPlaceCardInfoText$92 = function $$getHandAndPlaceCardInfoText(str, destination) {
      var self = this, hand = nil, place = nil;

      
      
      if (destination == null) {
        destination = nil;
      };
      self.$debug("getHandAndPlaceCardInfoText(str, destination)", str, destination);
      if ($truthy(destination['$nil?']())) {
        destination = self.nick_e};
      destination = destination.$upcase();
      hand = self.$getHandCardInfoText(destination);
      self.$debug("hand", hand);
      place = self.$getPlaceCardInfoText(destination);
      self.$debug("place", place);
      return $rb_plus(hand, place);
    }, $CardTrader_getHandAndPlaceCardInfoText$92.$$arity = -2);
    
    Opal.def(self, '$getHandCardInfoText', $CardTrader_getHandCardInfoText$93 = function $$getHandCardInfoText(destination) {
      var self = this, out_msg = nil;

      
      destination = destination.$upcase();
      self.$debug("getHandCardInfoText destination", destination);
      out_msg = self.$getDealCardsText(destination);
      if ($truthy(out_msg['$empty?']())) {
        out_msg = "カードを持っていません"};
      return out_msg;
    }, $CardTrader_getHandCardInfoText$93.$$arity = 1);
    
    Opal.def(self, '$getDealCardsText', $CardTrader_getDealCardsText$94 = function $$getDealCardsText(destination) {
      var self = this, cards = nil, cardsText = nil;

      
      self.$debug("getDealCardsText destination", destination);
      cards = self.deal_cards['$[]'](destination);
      self.$debug("@deal_cards", self.deal_cards);
      self.$debug("getDealCardsText cards", cards);
      if ($truthy(cards['$nil?']())) {
        return ""};
      cardsText = self.$getCardsTextFromCards(cards);
      return "" + "[ " + (cardsText) + " ]";
    }, $CardTrader_getDealCardsText$94.$$arity = 1);
    
    Opal.def(self, '$compareCard', $CardTrader_compareCard$95 = function $$compareCard(a, b) {
      var $a, self = this, __last__match__1 = nil, __last__match__2 = nil, __last__match__3 = nil, __last__match__4 = nil, __last__match__5 = nil, __last__match__6 = nil, __last__match__7 = nil, __last__match__8 = nil, __last__match__9 = nil, __last__match__10 = nil, __last__match__11 = nil, __last__match__12 = nil, __last__match__13 = nil, __last__match__14 = nil, __last__match__15 = nil, __last__match__16 = nil, __last__match__17 = nil, __last__match__18 = nil, __last__match__19 = nil, __last__match__20 = nil;

      if ($truthy(a['$=~'](/[^\d]/))) {
        
        __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
        __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
        __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
        __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
        __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
        __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
        __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
        __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
        __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
        __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
        __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
        __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
        __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
        __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
        __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
        __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
        __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
        __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
        __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
        __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
        return self.$compareCardByCardNumber(a, b);
      } else {
        return a['$<=>'](b)
      }
    }, $CardTrader_compareCard$95.$$arity = 2);
    
    Opal.def(self, '$compareCardByCardNumber', $CardTrader_compareCardByCardNumber$96 = function $$compareCardByCardNumber(a, b) {
      var $a, self = this, __last__match__1 = nil, __last__match__2 = nil, __last__match__3 = nil, __last__match__4 = nil, __last__match__5 = nil, __last__match__6 = nil, __last__match__7 = nil, __last__match__8 = nil, __last__match__9 = nil, __last__match__10 = nil, __last__match__11 = nil, __last__match__12 = nil, __last__match__13 = nil, __last__match__14 = nil, __last__match__15 = nil, __last__match__16 = nil, __last__match__17 = nil, __last__match__18 = nil, __last__match__19 = nil, __last__match__20 = nil, a1 = nil, a2 = nil, b1 = nil, b2 = nil, result = nil;

      
      /([^\d]+)(\d+)/['$=~'](a);
      __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
      __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
      __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
      __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
      __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
      __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
      __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
      __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
      __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
      __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
      __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
      __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
      __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
      __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
      __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
      __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
      __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
      __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
      __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
      __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
      a1 = __last__match__1;
      a2 = __last__match__2;
      /([^\d]+)(\d+)/['$=~'](b);
      __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
      __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
      __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
      __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
      __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
      __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
      __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
      __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
      __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
      __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
      __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
      __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
      __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
      __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
      __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
      __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
      __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
      __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
      __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
      __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
      b1 = __last__match__1;
      b2 = __last__match__2;
      result = [a1, a2]['$<=>']([b1, b2]);
      return result;
    }, $CardTrader_compareCardByCardNumber$96.$$arity = 2);
    
    Opal.def(self, '$getPlaceCardInfoText', $CardTrader_getPlaceCardInfoText$97 = function $$getPlaceCardInfoText(destination) {
      var $$98, self = this, out_msg = nil, place_max = nil;

      
      destination = destination.$upcase();
      out_msg = "";
      if ($truthy($rb_gt(self.card_place, 0))) {
      } else {
        return out_msg
      };
      place_max = self.card_place;
      if ($truthy(self.canTapCard)) {
        place_max = $rb_times(place_max, 2)};
      self.$debug("place_max", place_max);
      $send(place_max, 'times', [], ($$98 = function(i){var self = $$98.$$s || this, $a, index = nil, dealCardsKey = nil, cards = nil, cardsText = nil;
        if (self.deal_cards == null) self.deal_cards = nil;

      
        
        if (i == null) {
          i = nil;
        };
        index = $rb_plus(i, 1);
        dealCardsKey = "" + (index) + (destination);
        self.$debug("dealCardsKey", dealCardsKey);
        cards = self.deal_cards['$[]'](dealCardsKey);
        cards = ($truthy($a = cards) ? $a : []);
        cardsText = self.$getCardsTextFromCards(cards);
        if ($truthy(self.$isTapCardPlace(index))) {
          return (out_msg = $rb_plus(out_msg, "" + " タップした場札:[ " + (cardsText) + " ]"))
        } else {
          return (out_msg = $rb_plus(out_msg, "" + " 場札:[ " + (cardsText) + " ]"))
        };}, $$98.$$s = self, $$98.$$arity = 1, $$98));
      return out_msg;
    }, $CardTrader_getPlaceCardInfoText$97.$$arity = 1);
    
    Opal.def(self, '$getCardsText', $CardTrader_getCardsText$99 = function $$getCardsText(cardsText) {
      var self = this, cards = nil;

      
      cards = cardsText.$split(/,/);
      return self.$getCardsTextFromCards(cards);
    }, $CardTrader_getCardsText$99.$$arity = 1);
    
    Opal.def(self, '$getCardsTextFromCards', $CardTrader_getCardsTextFromCards$100 = function $$getCardsTextFromCards(cards) {
      var $$101, $$102, self = this, out_msg = nil;
      if ($gvars.isHandSort == null) $gvars.isHandSort = nil;

      
      if ($truthy($gvars.isHandSort)) {
        cards = $send(cards, 'sort', [], ($$101 = function(a, b){var self = $$101.$$s || this;

        
          
          if (a == null) {
            a = nil;
          };
          
          if (b == null) {
            b = nil;
          };
          return self.$compareCard(a, b);}, $$101.$$s = self, $$101.$$arity = 2, $$101))};
      if ($truthy(self.cardTitles['$empty?']())) {
        return cards.$join(",")};
      out_msg = "";
      $send(cards, 'each', [], ($$102 = function(cardNumber){var self = $$102.$$s || this, title = nil;
        if (self.cardTitles == null) self.cardTitles = nil;

      
        
        if (cardNumber == null) {
          cardNumber = nil;
        };
        if ($truthy(out_msg['$!='](""))) {
          out_msg = $rb_plus(out_msg, ",")};
        title = self.cardTitles['$[]'](cardNumber);
        return (out_msg = $rb_plus(out_msg, "" + (cardNumber) + "-" + (title)));}, $$102.$$s = self, $$102.$$arity = 1, $$102));
      if ($truthy(out_msg['$=='](""))) {
        out_msg = "無し"};
      return out_msg;
    }, $CardTrader_getCardsTextFromCards$100.$$arity = 1);
    
    Opal.def(self, '$isTapCardPlace', $CardTrader_isTapCardPlace$103 = function $$isTapCardPlace(index) {
      var self = this;

      
      if ($truthy(self.canTapCard)) {
      } else {
        return false
      };
      return index['$%'](2)['$=='](0);
    }, $CardTrader_isTapCardPlace$103.$$arity = 1);
    
    Opal.def(self, '$printCardRestorationSpellResult', $CardTrader_printCardRestorationSpellResult$104 = function $$printCardRestorationSpellResult(spellText) {
      var self = this, output_msg = nil;

      
      output_msg = self.$throwCardRestorationSpell(spellText);
      if ($truthy(output_msg['$==']("readSpell"))) {
        return self.$sendMessage(self.channel, "" + (self.nick_e) + ": カード配置を復活しました")
      } else {
        return self.$sendMessage(self.channel, output_msg)
      };
    }, $CardTrader_printCardRestorationSpellResult$104.$$arity = 1);
    
    Opal.def(self, '$throwCardRestorationSpell', $CardTrader_throwCardRestorationSpell$105 = function $$throwCardRestorationSpell(spellText) {
      var self = this, output = nil;

      
      output = "0";
      self.$debug("spellText", spellText);
      if ($truthy(spellText['$nil?']())) {
        
        self.$debug("getNewSpellText");
        spellText = self.$getNewSpellText();
        output = "" + "復活の呪文 ＞ [" + (spellText) + "]";
      } else {
        
        self.$debug("setNewSpellText");
        output = self.$setNewSpellText(spellText);
      };
      self.$debug("throwCardRestorationSpell output", output);
      return output;
    }, $CardTrader_throwCardRestorationSpell$105.$$arity = 1);
    
    Opal.def(self, '$getNewSpellText', $CardTrader_getNewSpellText$106 = function $$getNewSpellText() {
      var self = this, textList = nil, placeNames = nil, spellWords = nil;

      
      self.$debug("getNewSpellText begin");
      textList = [];
      placeNames = self.deal_cards.$keys().$sort();
      textList['$<<'](placeNames);
      spellWords = self.$getSpellWords();
      textList['$<<'](spellWords);
      return textList.$join(",");
    }, $CardTrader_getNewSpellText$106.$$arity = 0);
    
    Opal.def(self, '$getSpellWords', $CardTrader_getSpellWords$107 = function $$getSpellWords() {
      var $$108, self = this, spellWords = nil;

      
      spellWords = "";
      $send(self.card_val, 'each', [], ($$108 = function(card){var self = $$108.$$s || this, index = nil, indexWord = nil;

      
        
        if (card == null) {
          card = nil;
        };
        index = self.$getDealCardIndex(card);
        indexWord = self.$getIndexWord(index);
        return spellWords['$<<'](indexWord);}, $$108.$$s = self, $$108.$$arity = 1, $$108));
      spellWords = self.$shrinkSpellWords(spellWords);
      return spellWords;
    }, $CardTrader_getSpellWords$107.$$arity = 0);
    
    Opal.def(self, '$getIndexWord', $CardTrader_getIndexWord$109 = function $$getIndexWord(index) {
      var self = this;

      return self.card_spell['$[]']($rb_plus(index, 1))
    }, $CardTrader_getIndexWord$109.$$arity = 1);
    
    Opal.def(self, '$getDealCardIndex', $CardTrader_getDealCardIndex$110 = function $$getDealCardIndex(card) {try {

      var $$111, self = this;

      
      $send(self.deal_cards.$keys().$sort(), 'each_with_index', [], ($$111 = function(place, index){var self = $$111.$$s || this, cards = nil;
        if (self.deal_cards == null) self.deal_cards = nil;

      
        
        if (place == null) {
          place = nil;
        };
        
        if (index == null) {
          index = nil;
        };
        cards = self.deal_cards['$[]'](place);
        if ($truthy(cards['$include?'](card))) {
          Opal.ret(index)
        } else {
          return nil
        };}, $$111.$$s = self, $$111.$$arity = 2, $$111));
      return -1;
      } catch ($returner) { if ($returner === Opal.returner) { return $returner.$v } throw $returner; }
    }, $CardTrader_getDealCardIndex$110.$$arity = 1);
    
    Opal.def(self, '$shrinkSpellWords', $CardTrader_shrinkSpellWords$112 = function $$shrinkSpellWords(spellWords) {
      var $$113, self = this;

      
      $send(self.card_spell, 'each', [], ($$113 = function(word){var self = $$113.$$s || this, $$114;

      
        
        if (word == null) {
          word = nil;
        };
        return (spellWords = $send(spellWords, 'gsub', [new RegExp("" + (word) + "(" + (word) + "+)")], ($$114 = function(){var self = $$114.$$s || this, $a, __last__match__1 = nil, __last__match__2 = nil, __last__match__3 = nil, __last__match__4 = nil, __last__match__5 = nil, __last__match__6 = nil, __last__match__7 = nil, __last__match__8 = nil, __last__match__9 = nil, __last__match__10 = nil, __last__match__11 = nil, __last__match__12 = nil, __last__match__13 = nil, __last__match__14 = nil, __last__match__15 = nil, __last__match__16 = nil, __last__match__17 = nil, __last__match__18 = nil, __last__match__19 = nil, __last__match__20 = nil;

        
          __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
          __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
          __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
          __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
          __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
          __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
          __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
          __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
          __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
          __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
          __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
          __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
          __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
          __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
          __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
          __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
          __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
          __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
          __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
          __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
          return $rb_plus(word, $rb_plus(__last__match__1.$length(), 1).$to_s());}, $$114.$$s = self, $$114.$$arity = 0, $$114)));}, $$113.$$s = self, $$113.$$arity = 1, $$113));
      return spellWords;
    }, $CardTrader_shrinkSpellWords$112.$$arity = 1);
    
    Opal.def(self, '$setNewSpellText', $CardTrader_setNewSpellText$115 = function $$setNewSpellText(spellText) {
      var $$116, self = this, textList = nil, spellWords = nil, placeNames = nil;

      
      self.$shuffleCards();
      textList = spellText.$split(",");
      spellWords = textList.$pop();
      placeNames = textList;
      self.$debug("placeNames", placeNames);
      self.$debug("spellWords", spellWords);
      spellWords = self.$expandSpellWords(spellWords);
      self.$debug("expanded spellWords", spellWords);
      $send(placeNames, 'each_with_index', [], ($$116 = function(place, index){var self = $$116.$$s || this, indexWord = nil, cards = nil, $writer = nil;
        if (self.deal_cards == null) self.deal_cards = nil;

      
        
        if (place == null) {
          place = nil;
        };
        
        if (index == null) {
          index = nil;
        };
        indexWord = self.$getIndexWord(index);
        cards = self.$getCardsFromIndexWordAndSpellText(indexWord, spellWords);
        
        $writer = [place, cards];
        $send(self.deal_cards, '[]=', Opal.to_a($writer));
        return $writer[$rb_minus($writer["length"], 1)];;}, $$116.$$s = self, $$116.$$arity = 2, $$116));
      self.$debug("setNewSpellText @deal_cards", self.deal_cards);
      return "readSpell";
    }, $CardTrader_setNewSpellText$115.$$arity = 1);
    
    Opal.def(self, '$expandSpellWords', $CardTrader_expandSpellWords$117 = function $$expandSpellWords(spellWords) {
      var $$118, self = this;

      
      $send(self.card_spell, 'each', [], ($$118 = function(word){var self = $$118.$$s || this, $$119;

      
        
        if (word == null) {
          word = nil;
        };
        return (spellWords = $send(spellWords, 'gsub', [new RegExp("" + (word) + "(\\d+)")], ($$119 = function(){var self = $$119.$$s || this, $a, __last__match__1 = nil, __last__match__2 = nil, __last__match__3 = nil, __last__match__4 = nil, __last__match__5 = nil, __last__match__6 = nil, __last__match__7 = nil, __last__match__8 = nil, __last__match__9 = nil, __last__match__10 = nil, __last__match__11 = nil, __last__match__12 = nil, __last__match__13 = nil, __last__match__14 = nil, __last__match__15 = nil, __last__match__16 = nil, __last__match__17 = nil, __last__match__18 = nil, __last__match__19 = nil, __last__match__20 = nil;

        
          __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
          __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
          __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
          __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
          __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
          __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
          __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
          __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
          __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
          __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
          __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
          __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
          __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
          __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
          __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
          __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
          __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
          __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
          __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
          __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
          return $rb_times(word, __last__match__1.$to_i());}, $$119.$$s = self, $$119.$$arity = 0, $$119)));}, $$118.$$s = self, $$118.$$arity = 1, $$118));
      return spellWords;
    }, $CardTrader_expandSpellWords$117.$$arity = 1);
    return (Opal.def(self, '$getCardsFromIndexWordAndSpellText', $CardTrader_getCardsFromIndexWordAndSpellText$120 = function $$getCardsFromIndexWordAndSpellText(indexWord, spellText) {
      var $$121, self = this, cards = nil;

      
      cards = [];
      $send(spellText.$split(/(?:)/), 'each_with_index', [], ($$121 = function(word, index){var self = $$121.$$s || this, $$122, card = nil, isDelete = nil;
        if (self.card_val == null) self.card_val = nil;
        if (self.cardRest == null) self.cardRest = nil;

      
        
        if (word == null) {
          word = nil;
        };
        
        if (index == null) {
          index = nil;
        };
        if ($truthy(indexWord['$=='](word))) {
        } else {
          return nil;
        };
        card = self.card_val['$[]'](index);
        isDelete = $send(self.cardRest, 'delete_if', [], ($$122 = function(i){var self = $$122.$$s || this;

        
          
          if (i == null) {
            i = nil;
          };
          return i['$=='](card);}, $$122.$$s = self, $$122.$$arity = 1, $$122));
        if ($truthy(isDelete)) {
        } else {
          return nil;
        };
        return cards['$<<'](card);}, $$121.$$s = self, $$121.$$arity = 2, $$121));
      return cards;
    }, $CardTrader_getCardsFromIndexWordAndSpellText$120.$$arity = 2), nil) && 'getCardsFromIndexWordAndSpellText';
  })($nesting[0], null, $nesting);
};

/* Generated by Opal 0.11.99.dev */
Opal.modules["fileutils"] = function(Opal) {
  var self = Opal.top, $nesting = [], nil = Opal.nil, $$$ = Opal.const_get_qualified, $$ = Opal.const_get_relative, $breaker = Opal.breaker, $slice = Opal.slice;

  return nil
};

/* Generated by Opal 0.11.99.dev */
Opal.modules["TableFileData"] = function(Opal) {
  function $rb_minus(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs - rhs : lhs['$-'](rhs);
  }
  function $rb_plus(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs + rhs : lhs['$+'](rhs);
  }
  var self = Opal.top, $nesting = [], nil = Opal.nil, $$$ = Opal.const_get_qualified, $$ = Opal.const_get_relative, $breaker = Opal.breaker, $slice = Opal.slice, $klass = Opal.klass, $truthy = Opal.truthy, $send = Opal.send, $hash2 = Opal.hash2, $gvars = Opal.gvars;

  Opal.add_stubs(['$require', '$new', '$directory?', '$searchTableFileDefine', '$include?', '$<<', '$merge!', '$nil?', '$!', '$exist?', '$glob', '$each', '$untaint', '$readGameCommandInfo', '$[]', '$empty?', '$[]=', '$-', '$basename', '$===', '$+', '$readOneTableData', '$map', '$lines', '$toutf8', '$read', '$to_proc', '$shift', '$getDiceAndTitle', '$getLineKeyValue', '$to_i', '$class', '$chomp', '$keys', '$__last__match__1', '$isTargetGameType', '$changeEnterCode', '$gsub', '$==', '$getTableDataFromFile', '$instance', '$getTableFileName', '$checkFile', '$getTableText', '$createFile', '$checkFileNotExist', '$raise', '$initCommand', '$checkCommand', '$gsub!', '$kind_of?', '$getFormatedTableText', '$each_with_index', '$tr', '$checkTableKey', '$open', '$write', '$checkFileWhenFileNameNotChanged', '$checkFileWhenFileNameChanged', '$checkFileExist', '$mv']);
  
  self.$require("kconv");
  self.$require("fileutils");
  self.$require("configBcDice");
  (function($base, $super, $parent_nesting) {
    var self = $klass($base, $super, 'TableFileData');

    var $nesting = [self].concat($parent_nesting), $TableFileData_initialize$1, $TableFileData_setDir$2, $TableFileData_searchTableFileDefine$3, $TableFileData_readGameCommandInfo$5, $TableFileData_getAllTableInfo$6, $TableFileData_getGameCommandInfos$8, $TableFileData_getTableDataFromFile$10, $TableFileData_getLineKeyValue$12, $TableFileData_getLineKeyValue$13, $TableFileData_getDiceAndTitle$14, $TableFileData_getTableData$15, $TableFileData_changeEnterCode$17, $TableFileData_isTargetGameType$19, $TableFileData_readOneTableData$20;

    self.$$prototype.dir = self.$$prototype.dirs = self.$$prototype.tableData = nil;
    
    
    Opal.def(self, '$initialize', $TableFileData_initialize$1 = function $$initialize(isLoadCommonTable) {
      var self = this;

      
      
      if (isLoadCommonTable == null) {
        isLoadCommonTable = true;
      };
      self.dirs = [];
      self.tableData = $$($nesting, 'Hash').$new();
      if ($truthy(isLoadCommonTable)) {
      } else {
        return nil
      };
      self.dir = (function() {if ($truthy($$($nesting, 'FileTest')['$directory?']("./extratables"))) {
        return "./extratables"
      } else {
        return "../extratables"
      }; return nil; })();
      return (self.tableData = self.$searchTableFileDefine(self.dir));
    }, $TableFileData_initialize$1.$$arity = -1);
    
    Opal.def(self, '$setDir', $TableFileData_setDir$2 = function $$setDir(dir, prefix) {
      var self = this, tableData = nil;

      
      
      if (prefix == null) {
        prefix = "";
      };
      if ($truthy(self.dirs['$include?'](dir))) {
        return nil};
      self.dirs['$<<'](dir);
      tableData = self.$searchTableFileDefine(dir, prefix);
      return self.tableData['$merge!'](tableData);
    }, $TableFileData_setDir$2.$$arity = -2);
    
    Opal.def(self, '$searchTableFileDefine', $TableFileData_searchTableFileDefine$3 = function $$searchTableFileDefine(dir, prefix) {
      var $$4, self = this, tableData = nil, fileNames = nil;

      
      
      if (prefix == null) {
        prefix = "";
      };
      tableData = $$($nesting, 'Hash').$new();
      if ($truthy(dir['$nil?']())) {
        return tableData};
      if ($truthy($$($nesting, 'File')['$exist?'](dir)['$!']())) {
        return tableData};
      if ($truthy($$($nesting, 'File')['$directory?'](dir)['$!']())) {
        return tableData};
      fileNames = $$($nesting, 'Dir').$glob("" + (dir) + "/" + (prefix) + "*.txt");
      $send(fileNames, 'each', [], ($$4 = function(fileName){var self = $$4.$$s || this, $a, info = nil, gameType = nil, command = nil, $writer = nil;

      
        
        if (fileName == null) {
          fileName = nil;
        };
        fileName = fileName.$untaint();
        info = self.$readGameCommandInfo(fileName, prefix);
        gameType = info['$[]']("gameType");
        gameType = ($truthy($a = gameType) ? $a : "");
        command = info['$[]']("command");
        if ($truthy(command['$empty?']())) {
          return nil;};
        
        $writer = ["" + (gameType) + "_" + (command), info];
        $send(tableData, '[]=', Opal.to_a($writer));
        return $writer[$rb_minus($writer["length"], 1)];;}, $$4.$$s = self, $$4.$$arity = 1, $$4));
      return tableData;
    }, $TableFileData_searchTableFileDefine$3.$$arity = -2);
    
    Opal.def(self, '$readGameCommandInfo', $TableFileData_readGameCommandInfo$5 = function $$readGameCommandInfo(fileName, prefix) {
      var $a, self = this, info = nil, baseName = nil, $case = nil, __last__match__1 = nil, __last__match__2 = nil, __last__match__3 = nil, __last__match__4 = nil, __last__match__5 = nil, __last__match__6 = nil, __last__match__7 = nil, __last__match__8 = nil, __last__match__9 = nil, __last__match__10 = nil, __last__match__11 = nil, __last__match__12 = nil, __last__match__13 = nil, __last__match__14 = nil, __last__match__15 = nil, __last__match__16 = nil, __last__match__17 = nil, __last__match__18 = nil, __last__match__19 = nil, __last__match__20 = nil, $writer = nil;

      
      info = $hash2(["fileName", "gameType", "command"], {"fileName": fileName, "gameType": "", "command": ""});
      baseName = $$($nesting, 'File').$basename(fileName, ".txt");
      $case = baseName;
      if (new RegExp("" + "^" + (prefix) + "(.+)_(.+)_(.+)$")['$===']($case)) {
      __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
      __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
      __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
      __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
      __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
      __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
      __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
      __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
      __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
      __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
      __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
      __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
      __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
      __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
      __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
      __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
      __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
      __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
      __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
      __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
      
      $writer = ["command", __last__match__3];
      $send(info, '[]=', Opal.to_a($writer));
      $writer[$rb_minus($writer["length"], 1)];;
      
      $writer = ["gameType", $rb_plus($rb_plus(__last__match__1, ":"), __last__match__2)];
      $send(info, '[]=', Opal.to_a($writer));
      $writer[$rb_minus($writer["length"], 1)];;}
      else if (new RegExp("" + "^" + (prefix) + "(.+)_(.+)$")['$===']($case)) {
      __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
      __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
      __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
      __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
      __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
      __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
      __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
      __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
      __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
      __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
      __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
      __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
      __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
      __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
      __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
      __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
      __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
      __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
      __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
      __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
      
      $writer = ["command", __last__match__2];
      $send(info, '[]=', Opal.to_a($writer));
      $writer[$rb_minus($writer["length"], 1)];;
      
      $writer = ["gameType", __last__match__1];
      $send(info, '[]=', Opal.to_a($writer));
      $writer[$rb_minus($writer["length"], 1)];;}
      else if (new RegExp("" + "^" + (prefix) + "(.+)$")['$===']($case)) {
      __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
      __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
      __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
      __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
      __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
      __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
      __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
      __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
      __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
      __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
      __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
      __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
      __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
      __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
      __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
      __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
      __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
      __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
      __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
      __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
      
      $writer = ["command", __last__match__1];
      $send(info, '[]=', Opal.to_a($writer));
      $writer[$rb_minus($writer["length"], 1)];;
      
      $writer = ["gameType", ""];
      $send(info, '[]=', Opal.to_a($writer));
      $writer[$rb_minus($writer["length"], 1)];;};
      return info;
    }, $TableFileData_readGameCommandInfo$5.$$arity = 2);
    
    Opal.def(self, '$getAllTableInfo', $TableFileData_getAllTableInfo$6 = function $$getAllTableInfo() {
      var $$7, self = this, result = nil;

      
      result = [];
      $send(self.tableData, 'each', [], ($$7 = function(key, oneTableData){var self = $$7.$$s || this, tableData = nil;

      
        
        if (key == null) {
          key = nil;
        };
        
        if (oneTableData == null) {
          oneTableData = nil;
        };
        tableData = self.$readOneTableData(oneTableData);
        return result['$<<'](tableData);}, $$7.$$s = self, $$7.$$arity = 2, $$7));
      return result;
    }, $TableFileData_getAllTableInfo$6.$$arity = 0);
    
    Opal.def(self, '$getGameCommandInfos', $TableFileData_getGameCommandInfos$8 = function $$getGameCommandInfos() {
      var $$9, self = this, commandInfos = nil;

      
      commandInfos = [];
      $send(self.tableData, 'each', [], ($$9 = function(command, info){var self = $$9.$$s || this, commandInfo = nil;

      
        
        if (command == null) {
          command = nil;
        };
        
        if (info == null) {
          info = nil;
        };
        commandInfo = $hash2(["gameType", "command"], {"gameType": info['$[]']("gameType"), "command": info['$[]']("command")});
        return commandInfos['$<<'](commandInfo);}, $$9.$$s = self, $$9.$$arity = 2, $$9));
      return commandInfos;
    }, $TableFileData_getGameCommandInfos$8.$$arity = 0);
    
    Opal.def(self, '$getTableDataFromFile', $TableFileData_getTableDataFromFile$10 = function $$getTableDataFromFile(fileName) {
      var $a, $b, $$11, self = this, table = nil, lines = nil, defineLine = nil, dice = nil, title = nil;

      
      table = [];
      lines = $send($$($nesting, 'File').$read(fileName).$toutf8().$lines(), 'map', [], "chomp".$to_proc());
      defineLine = lines.$shift();
      $b = self.$getDiceAndTitle(defineLine), $a = Opal.to_ary($b), (dice = ($a[0] == null ? nil : $a[0])), (title = ($a[1] == null ? nil : $a[1])), $b;
      $send(lines, 'each', [], ($$11 = function(line){var self = $$11.$$s || this, $c, $d, key = nil, value = nil;

      
        
        if (line == null) {
          line = nil;
        };
        $d = self.$getLineKeyValue(line), $c = Opal.to_ary($d), (key = ($c[0] == null ? nil : $c[0])), (value = ($c[1] == null ? nil : $c[1])), $d;
        if ($truthy(key['$empty?']())) {
          return nil;};
        key = key.$to_i();
        return table['$<<']([key, value]);}, $$11.$$s = self, $$11.$$arity = 1, $$11));
      return [dice, title, table];
    }, $TableFileData_getTableDataFromFile$10.$$arity = 1);
    
    Opal.def(self, '$getLineKeyValue', $TableFileData_getLineKeyValue$12 = function $$getLineKeyValue(line) {
      var self = this;

      return self.$class().$getLineKeyValue(line)
    }, $TableFileData_getLineKeyValue$12.$$arity = 1);
    Opal.defs(self, '$getLineKeyValue', $TableFileData_getLineKeyValue$13 = function $$getLineKeyValue(line) {
      var $a, self = this, __last__match__1 = nil, __last__match__2 = nil, __last__match__3 = nil, __last__match__4 = nil, __last__match__5 = nil, __last__match__6 = nil, __last__match__7 = nil, __last__match__8 = nil, __last__match__9 = nil, __last__match__10 = nil, __last__match__11 = nil, __last__match__12 = nil, __last__match__13 = nil, __last__match__14 = nil, __last__match__15 = nil, __last__match__16 = nil, __last__match__17 = nil, __last__match__18 = nil, __last__match__19 = nil, __last__match__20 = nil, key = nil, value = nil;

      
      line = line.$toutf8().$chomp();
      if ($truthy(/^[\s　]*([^:：]+)[\s　]*[:：][\s　]*(.+)/['$==='](line))) {
      } else {
        return ["", ""]
      };
      __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
      __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
      __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
      __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
      __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
      __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
      __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
      __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
      __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
      __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
      __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
      __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
      __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
      __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
      __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
      __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
      __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
      __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
      __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
      __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
      key = __last__match__1;
      value = __last__match__2;
      return [key, value];
    }, $TableFileData_getLineKeyValue$13.$$arity = 1);
    
    Opal.def(self, '$getDiceAndTitle', $TableFileData_getDiceAndTitle$14 = function $$getDiceAndTitle(line) {
      var $a, $b, self = this, dice = nil, title = nil;

      
      $b = self.$getLineKeyValue(line), $a = Opal.to_ary($b), (dice = ($a[0] == null ? nil : $a[0])), (title = ($a[1] == null ? nil : $a[1])), $b;
      return [dice, title];
    }, $TableFileData_getDiceAndTitle$14.$$arity = 1);
    
    Opal.def(self, '$getTableData', $TableFileData_getTableData$15 = function $$getTableData(arg, targetGameType) {
      var $$16, self = this, oneTableData = nil, isSecret = nil, dice = nil, title = nil, table = nil;

      
      oneTableData = $$($nesting, 'Hash').$new();
      isSecret = false;
      (function(){var $brk = Opal.new_brk(); try {return $send(self.tableData.$keys(), 'each', [], ($$16 = function(fileName){var self = $$16.$$s || this, key = nil, data = nil, gameType = nil;
        if (self.tableData == null) self.tableData = nil;

      
        
        if (fileName == null) {
          fileName = nil;
        };
        if ($truthy(/.*_(.+)/['$==='](fileName))) {
        } else {
          return nil;
        };
        key = self.$__last__match__1();
        if ($truthy(new RegExp("" + "^(s|S)?" + (key) + "(\\s|$)", 'i')['$==='](arg))) {
        } else {
          return nil;
        };
        data = self.tableData['$[]'](fileName);
        gameType = data['$[]']("gameType");
        if ($truthy(self.$isTargetGameType(gameType, targetGameType))) {
        } else {
          return nil;
        };
        oneTableData = data;
        isSecret = self.$__last__match__1()['$nil?']()['$!']();
        
        Opal.brk(nil, $brk);}, $$16.$$s = self, $$16.$$brk = $brk, $$16.$$arity = 1, $$16))
      } catch (err) { if (err === $brk) { return err.$v } else { throw err } }})();
      self.$readOneTableData(oneTableData);
      dice = oneTableData['$[]']("dice");
      title = oneTableData['$[]']("title");
      table = oneTableData['$[]']("table");
      table = self.$changeEnterCode(table);
      return [dice, title, table, isSecret];
    }, $TableFileData_getTableData$15.$$arity = 2);
    
    Opal.def(self, '$changeEnterCode', $TableFileData_changeEnterCode$17 = function $$changeEnterCode(table) {
      var $$18, self = this, newTable = nil;

      
      newTable = $hash2([], {});
      if ($truthy(table['$nil?']())) {
        return newTable};
      $send(table, 'each', [], ($$18 = function(key, value){var self = $$18.$$s || this, $writer = nil;

      
        
        if (key == null) {
          key = nil;
        };
        
        if (value == null) {
          value = nil;
        };
        value = value.$gsub(/\\n/, "\n");
        value = value.$gsub(/\\\n/, "\\n");
        
        $writer = [key, value];
        $send(newTable, '[]=', Opal.to_a($writer));
        return $writer[$rb_minus($writer["length"], 1)];;}, $$18.$$s = self, $$18.$$arity = 2, $$18));
      return newTable;
    }, $TableFileData_changeEnterCode$17.$$arity = 1);
    
    Opal.def(self, '$isTargetGameType', $TableFileData_isTargetGameType$19 = function $$isTargetGameType(gameType, targetGameType) {
      var self = this;

      
      if ($truthy(gameType['$empty?']())) {
        return true};
      return gameType['$=='](targetGameType);
    }, $TableFileData_isTargetGameType$19.$$arity = 2);
    return (Opal.def(self, '$readOneTableData', $TableFileData_readOneTableData$20 = function $$readOneTableData(oneTableData) {
      var $a, $b, self = this, command = nil, gameType = nil, fileName = nil, dice = nil, title = nil, table = nil, $writer = nil;

      
      if ($truthy(oneTableData['$nil?']())) {
        return nil};
      if ($truthy(oneTableData['$[]']("table")['$nil?']())) {
      } else {
        return nil
      };
      command = oneTableData['$[]']("command");
      gameType = oneTableData['$[]']("gameType");
      fileName = oneTableData['$[]']("fileName");
      if ($truthy(command['$nil?']())) {
        return nil};
      if ($truthy($$($nesting, 'File')['$exist?'](fileName)['$!']())) {
        return nil};
      $b = self.$getTableDataFromFile(fileName), $a = Opal.to_ary($b), (dice = ($a[0] == null ? nil : $a[0])), (title = ($a[1] == null ? nil : $a[1])), (table = ($a[2] == null ? nil : $a[2])), $b;
      
      $writer = ["dice", dice];
      $send(oneTableData, '[]=', Opal.to_a($writer));
      $writer[$rb_minus($writer["length"], 1)];;
      
      $writer = ["title", title];
      $send(oneTableData, '[]=', Opal.to_a($writer));
      $writer[$rb_minus($writer["length"], 1)];;
      
      $writer = ["table", table];
      $send(oneTableData, '[]=', Opal.to_a($writer));
      $writer[$rb_minus($writer["length"], 1)];;
      return oneTableData;
    }, $TableFileData_readOneTableData$20.$$arity = 1), nil) && 'readOneTableData';
  })($nesting[0], null, $nesting);
  (function($base, $super, $parent_nesting) {
    var self = $klass($base, $super, 'TableFileCreator');

    var $nesting = [self].concat($parent_nesting), $TableFileCreator_initialize$21, $TableFileCreator_execute$22, $TableFileCreator_checkFile$23, $TableFileCreator_checkFileNotExist$24, $TableFileCreator_checkFileExist$25, $TableFileCreator_getTableFileName$26, $TableFileCreator_initCommand$27, $TableFileCreator_checkCommand$28, $TableFileCreator_getTableText$29, $TableFileCreator_getFormatedTableText$30, $TableFileCreator_checkTableKey$32, $TableFileCreator_createFile$33;

    self.$$prototype.params = self.$$prototype.command = self.$$prototype.dir = self.$$prototype.prefix = nil;
    
    
    Opal.def(self, '$initialize', $TableFileCreator_initialize$21 = function $$initialize(dir, prefix, params) {
      var self = this;

      
      self.dir = dir;
      self.prefix = prefix;
      self.params = params;
      return (self.logger = $$$($$($nesting, 'DodontoF'), 'Logger').$instance());
    }, $TableFileCreator_initialize$21.$$arity = 3);
    
    Opal.def(self, '$execute', $TableFileCreator_execute$22 = function $$execute() {
      var self = this, fileName = nil, text = nil;

      
      fileName = self.$getTableFileName();
      self.$checkFile(fileName);
      text = self.$getTableText();
      return self.$createFile(fileName, text);
    }, $TableFileCreator_execute$22.$$arity = 0);
    
    Opal.def(self, '$checkFile', $TableFileCreator_checkFile$23 = function $$checkFile(fileName) {
      var self = this;

      return self.$checkFileNotExist(fileName)
    }, $TableFileCreator_checkFile$23.$$arity = 1);
    
    Opal.def(self, '$checkFileNotExist', $TableFileCreator_checkFileNotExist$24 = function $$checkFileNotExist(fileName) {
      var self = this;

      if ($truthy($$($nesting, 'File')['$exist?'](fileName))) {
        return self.$raise("commandNameAlreadyExist")
      } else {
        return nil
      }
    }, $TableFileCreator_checkFileNotExist$24.$$arity = 1);
    
    Opal.def(self, '$checkFileExist', $TableFileCreator_checkFileExist$25 = function $$checkFileExist(fileName) {
      var self = this;

      if ($truthy($$($nesting, 'File')['$exist?'](fileName))) {
        return nil
      } else {
        return self.$raise("commandNameIsNotExist")
      }
    }, $TableFileCreator_checkFileExist$25.$$arity = 1);
    
    Opal.def(self, '$getTableFileName', $TableFileCreator_getTableFileName$26 = function $$getTableFileName(command, gameType) {
      var $a, self = this, prefix2 = nil, fileName = nil;

      
      
      if (command == null) {
        command = nil;
      };
      
      if (gameType == null) {
        gameType = nil;
      };
      if ($truthy(gameType['$nil?']())) {
        gameType = self.params['$[]']("gameType")};
      gameType = ($truthy($a = gameType) ? $a : "");
      gameType = gameType.$gsub(":", "_");
      if ($truthy(command['$nil?']())) {
        
        self.$initCommand();
        command = self.command;};
      self.$checkCommand(command);
      prefix2 = "";
      if ($truthy(gameType['$empty?']())) {
      } else {
        prefix2 = "" + (gameType) + "_"
      };
      fileName = "" + (self.dir) + "/" + (self.prefix) + (prefix2) + (command) + ".txt";
      fileName.$untaint();
      return fileName;
    }, $TableFileCreator_getTableFileName$26.$$arity = -1);
    
    Opal.def(self, '$initCommand', $TableFileCreator_initCommand$27 = function $$initCommand() {
      var $a, self = this;

      
      self.command = self.params['$[]']("command");
      self.command = ($truthy($a = self.command) ? $a : "");
      self.command['$gsub!'](/\./, "_");
      return self.command.$untaint();
    }, $TableFileCreator_initCommand$27.$$arity = 0);
    
    Opal.def(self, '$checkCommand', $TableFileCreator_checkCommand$28 = function $$checkCommand(command) {
      var $a, self = this, __last__match__1 = nil, __last__match__2 = nil, __last__match__3 = nil, __last__match__4 = nil, __last__match__5 = nil, __last__match__6 = nil, __last__match__7 = nil, __last__match__8 = nil, __last__match__9 = nil, __last__match__10 = nil, __last__match__11 = nil, __last__match__12 = nil, __last__match__13 = nil, __last__match__14 = nil, __last__match__15 = nil, __last__match__16 = nil, __last__match__17 = nil, __last__match__18 = nil, __last__match__19 = nil, __last__match__20 = nil;

      
      if ($truthy(command['$empty?']())) {
        self.$raise("commandNameIsEmpty")};
      if ($truthy(/^[a-zA-Z\d]+$/['$==='](command))) {
      } else {
        self.$raise("commandNameCanUseOnlyAlphabetAndNumber")
      };
      __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
      __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
      __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
      __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
      __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
      __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
      __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
      __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
      __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
      __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
      __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
      __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
      __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
      __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
      __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
      __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
      __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
      __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
      __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
      return (__last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20)));
    }, $TableFileCreator_checkCommand$28.$$arity = 1);
    
    Opal.def(self, '$getTableText', $TableFileCreator_getTableText$29 = function $$getTableText() {
      var self = this, dice = nil, title = nil, table = nil, text = nil;

      
      dice = self.params['$[]']("dice");
      title = self.params['$[]']("title");
      table = self.params['$[]']("table");
      text = "";
      text['$<<']("" + (dice) + ":" + (title) + "\n");
      if ($truthy(table['$kind_of?']($$($nesting, 'String'))['$!']())) {
        table = self.$getFormatedTableText(table)};
      return text['$<<'](table);
    }, $TableFileCreator_getTableText$29.$$arity = 0);
    
    Opal.def(self, '$getFormatedTableText', $TableFileCreator_getFormatedTableText$30 = function $$getFormatedTableText(table) {
      var $$31, self = this, result = nil;

      
      result = "";
      $send(table, 'each_with_index', [], ($$31 = function(line, index){var self = $$31.$$s || this, $a, $b, key = nil, value = nil;

      
        
        if (line == null) {
          line = nil;
        };
        
        if (index == null) {
          index = nil;
        };
        $b = $$($nesting, 'TableFileData').$getLineKeyValue(line), $a = Opal.to_ary($b), (key = ($a[0] == null ? nil : $a[0])), (value = ($a[1] == null ? nil : $a[1])), $b;
        key = key.$tr("　", "");
        key = key.$tr(" ", "");
        key = key.$tr("０-９", "0-9");
        key = self.$checkTableKey(key, index);
        return result['$<<']((((("" + (key)) + ":") + (value)) + "\n").$toutf8());}, $$31.$$s = self, $$31.$$arity = 2, $$31));
      return result;
    }, $TableFileCreator_getFormatedTableText$30.$$arity = 1);
    
    Opal.def(self, '$checkTableKey', $TableFileCreator_checkTableKey$32 = function $$checkTableKey(key, index) {
      var self = this, keyValue = nil;

      
      if ($truthy(key['$==']("0"))) {
        return nil};
      keyValue = key.$to_i();
      if ($truthy(keyValue['$=='](0))) {
        self.$raise("" + "tableFormatIsInvalid\t" + ($rb_plus(index, 1)) + "\t" + (key))};
      return keyValue;
    }, $TableFileCreator_checkTableKey$32.$$arity = 2);
    return (Opal.def(self, '$createFile', $TableFileCreator_createFile$33 = function $$createFile(fileName, text) {
      var $$34, self = this;

      return $send(self, 'open', [fileName, "w+"], ($$34 = function(file){var self = $$34.$$s || this;

      
        
        if (file == null) {
          file = nil;
        };
        return file.$write(text);}, $$34.$$s = self, $$34.$$arity = 1, $$34))
    }, $TableFileCreator_createFile$33.$$arity = 2), nil) && 'createFile';
  })($nesting[0], null, $nesting);
  return (function($base, $super, $parent_nesting) {
    var self = $klass($base, $super, 'TableFileEditer');

    var $nesting = [self].concat($parent_nesting), $TableFileEditer_checkFile$35, $TableFileEditer_checkFileWhenFileNameNotChanged$36, $TableFileEditer_checkFileWhenFileNameChanged$37;

    self.$$prototype.params = self.$$prototype.originalCommand = self.$$prototype.command = self.$$prototype.originalGameType = self.$$prototype.gameType = nil;
    
    
    Opal.def(self, '$checkFile', $TableFileEditer_checkFile$35 = function $$checkFile(fileName) {
      var $a, self = this;

      
      self.originalCommand = self.params['$[]']("originalCommand");
      self.gameType = self.params['$[]']("gameType");
      self.originalGameType = self.params['$[]']("originalGameType");
      if ($truthy(($truthy($a = self.originalCommand['$=='](self.command)) ? self.originalGameType['$=='](self.gameType) : $a))) {
        return self.$checkFileWhenFileNameNotChanged(fileName)
      } else {
        return self.$checkFileWhenFileNameChanged(fileName)
      };
    }, $TableFileEditer_checkFile$35.$$arity = 1);
    
    Opal.def(self, '$checkFileWhenFileNameNotChanged', $TableFileEditer_checkFileWhenFileNameNotChanged$36 = function $$checkFileWhenFileNameNotChanged(fileName) {
      var self = this;

      return self.$checkFileExist(fileName)
    }, $TableFileEditer_checkFileWhenFileNameNotChanged$36.$$arity = 1);
    return (Opal.def(self, '$checkFileWhenFileNameChanged', $TableFileEditer_checkFileWhenFileNameChanged$37 = function $$checkFileWhenFileNameChanged(fileName) {
      var $a, self = this, originalCommand = nil, originalGameType = nil, originalFileName = nil, e = nil;

      
      originalCommand = self.originalCommand;
      originalCommand = ($truthy($a = originalCommand) ? $a : self.command);
      originalGameType = self.originalGameType;
      originalGameType = ($truthy($a = originalGameType) ? $a : self.gameType);
      originalFileName = self.$getTableFileName(originalCommand, originalGameType);
      self.$checkFileExist(originalFileName);
      self.$checkFileNotExist(fileName);
      
      try {
        return $$($nesting, 'FileUtils').$mv(originalFileName, fileName)
      } catch ($err) {
        if (Opal.rescue($err, [$$($nesting, 'StandardError')])) {e = $err;
          try {
            return self.$raise("changeCommandNameFaild")
          } finally { Opal.pop_exception() }
        } else { throw $err; }
      };;
    }, $TableFileEditer_checkFileWhenFileNameChanged$37.$$arity = 1), nil) && 'checkFileWhenFileNameChanged';
  })($nesting[0], $$($nesting, 'TableFileCreator'), $nesting);
};

/* Generated by Opal 0.11.99.dev */
Opal.modules["diceBot"] = function(Opal) {
  var self = Opal.top, $nesting = [], nil = Opal.nil, $$$ = Opal.const_get_qualified, $$ = Opal.const_get_relative, $breaker = Opal.breaker, $slice = Opal.slice;

  return nil
};

/* Generated by Opal 0.11.99.dev */
Opal.modules["diceBot/DiceBotLoader"] = function(Opal) {
  function $rb_minus(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs - rhs : lhs['$-'](rhs);
  }
  var self = Opal.top, $nesting = [], nil = Opal.nil, $$$ = Opal.const_get_qualified, $$ = Opal.const_get_relative, $breaker = Opal.breaker, $slice = Opal.slice, $klass = Opal.klass, $truthy = Opal.truthy, $send = Opal.send, $hash2 = Opal.hash2;

  Opal.add_stubs(['$===', '$!', '$include?', '$debug', '$validGameType?', '$expand_path', '$dirname', '$exist?', '$require', '$new', '$const_get', '$to_s', '$glob', '$map', '$untaint', '$basename', '$select', '$-', '$downcase', '$to_proc', '$[]', '$raise', '$first', '$each']);
  return (function($base, $super, $parent_nesting) {
    var self = $klass($base, $super, 'DiceBotLoader');

    var $nesting = [self].concat($parent_nesting), $DiceBotLoader_validGameType$ques$1, $DiceBotLoader_loadUnknownGame$2, $DiceBotLoader_collectDiceBots$3, $DiceBotLoader_initialize$7, $DiceBotLoader_match$ques$8, $DiceBotLoader_loadDiceBot$9;

    self.$$prototype.filenames = self.$$prototype.gameTitlePattern = self.$$prototype.diceBotClass = nil;
    
    Opal.const_set($nesting[0], 'BOT_NAME_PATTERN', /^[A-Z]\w*$/);
    Opal.const_set($nesting[0], 'BOT_NAMES_TO_IGNORE', ["DiceBot", "DiceBotLoader", "DiceBotLoaderList"]);
    Opal.defs(self, '$validGameType?', $DiceBotLoader_validGameType$ques$1 = function(gameType) {
      var $a, self = this;

      return ($truthy($a = $$($nesting, 'BOT_NAME_PATTERN')['$==='](gameType)) ? $$($nesting, 'BOT_NAMES_TO_IGNORE')['$include?'](gameType)['$!']() : $a)
    }, $DiceBotLoader_validGameType$ques$1.$$arity = 1);
    Opal.defs(self, '$loadUnknownGame', $DiceBotLoader_loadUnknownGame$2 = function $$loadUnknownGame(gameType) {
      var self = this, fileName = nil, e = nil;

      
      self.$debug("DiceBotLoader.loadUnknownGame gameType", gameType);
      if ($truthy(self['$validGameType?'](gameType))) {
      } else {
        
        self.$debug("DiceBotLoader.loadUnknownGame: 無効なゲームタイプ", gameType);
        return nil;
      };
      fileName = $$($nesting, 'File').$expand_path("" + (gameType) + ".rb", $$($nesting, 'File').$dirname("diceBot/DiceBotLoader.rb"));
      if ($truthy($$($nesting, 'File')['$exist?'](fileName))) {
      } else {
        
        self.$debug("DiceBotLoader.loadUnknownGame: ダイスボットファイルが存在しません", gameType);
        return nil;
      };
      
      try {
        
        self.$require(fileName);
        return $$($nesting, 'Object').$const_get(gameType).$new();
      } catch ($err) {
        if (Opal.rescue($err, [$$($nesting, 'LoadError'), $$($nesting, 'StandardError')])) {e = $err;
          try {
            
            self.$debug("DiceBotLoader.loadUnknownGame: ダイスボットの読み込みに失敗しました", e.$to_s());
            return nil;
          } finally { Opal.pop_exception() }
        } else { throw $err; }
      };;
    }, $DiceBotLoader_loadUnknownGame$2.$$arity = 1);
    Opal.defs(self, '$collectDiceBots', $DiceBotLoader_collectDiceBots$3 = function $$collectDiceBots() {
      var $$4, $$5, $$6, self = this, diceBotDir = nil, botFiles = nil, botNames = nil, validBotNames = nil;

      
      diceBotDir = $$($nesting, 'File').$expand_path($$($nesting, 'File').$dirname("diceBot/DiceBotLoader.rb"));
      self.$require("" + (diceBotDir) + "/DiceBot");
      botFiles = $$($nesting, 'Dir').$glob("" + (diceBotDir) + "/*.rb");
      botNames = $send(botFiles, 'map', [], ($$4 = function(botFile){var self = $$4.$$s || this;

      
        
        if (botFile == null) {
          botFile = nil;
        };
        return $$($nesting, 'File').$basename(botFile, ".rb").$untaint();}, $$4.$$s = self, $$4.$$arity = 1, $$4));
      validBotNames = $send($rb_minus(botNames, $$($nesting, 'BOT_NAMES_TO_IGNORE')), 'select', [], ($$5 = function(botName){var self = $$5.$$s || this;

      
        
        if (botName == null) {
          botName = nil;
        };
        return $$($nesting, 'BOT_NAME_PATTERN')['$==='](botName);}, $$5.$$s = self, $$5.$$arity = 1, $$5));
      return $send(validBotNames, 'map', [], ($$6 = function(botName){var self = $$6.$$s || this;

      
        
        if (botName == null) {
          botName = nil;
        };
        self.$require("" + (diceBotDir) + "/" + (botName));
        return $$($nesting, 'Object').$const_get(botName).$new();}, $$6.$$s = self, $$6.$$arity = 1, $$6));
    }, $DiceBotLoader_collectDiceBots$3.$$arity = 0);
    
    Opal.def(self, '$initialize', $DiceBotLoader_initialize$7 = function $$initialize(gameTitlePattern, options) {
      var $a, self = this, $case = nil, defaultFilenames = nil;

      
      
      if (options == null) {
        options = $hash2([], {});
      };
      $case = gameTitlePattern;
      if ($$($nesting, 'String')['$===']($case)) {self.gameTitlePattern = [gameTitlePattern.$downcase()]}
      else if ($$($nesting, 'Array')['$===']($case)) {self.gameTitlePattern = $send(gameTitlePattern, 'map', [], "downcase".$to_proc())}
      else if ($$($nesting, 'Regexp')['$===']($case)) {
      if ($truthy(options['$[]']("filenames"))) {
      } else {
        self.$raise($$($nesting, 'ArgumentError'), "options[:filenames] is required when gameTitlePattern is a Regexp")
      };
      self.gameTitlePattern = gameTitlePattern;}
      else {self.$raise($$($nesting, 'TypeError'), "gameTitlePattern must be a String or an Array<String> or a Regexp")};
      defaultFilenames = (function() {$case = gameTitlePattern;
      if ($$($nesting, 'String')['$===']($case)) {return [gameTitlePattern]}
      else if ($$($nesting, 'Array')['$===']($case)) {return [gameTitlePattern.$first()]}
      else if ($$($nesting, 'Regexp')['$===']($case)) {return []}
      else { return nil }})();
      self.filenames = ($truthy($a = options['$[]']("filenames")) ? $a : defaultFilenames);
      return (self.diceBotClass = ($truthy($a = options['$[]']("class")) ? $a : self.filenames.$first()));
    }, $DiceBotLoader_initialize$7.$$arity = -2);
    
    Opal.def(self, '$match?', $DiceBotLoader_match$ques$8 = function(gameTitle) {
      var self = this, $case = nil;

      return (function() {$case = self.gameTitlePattern;
      if ($$($nesting, 'Array')['$===']($case)) {return self.gameTitlePattern['$include?'](gameTitle.$downcase())}
      else if ($$($nesting, 'Regexp')['$===']($case)) {return self.gameTitlePattern['$==='](gameTitle)}
      else { return nil }})()
    }, $DiceBotLoader_match$ques$8.$$arity = 1);
    return (Opal.def(self, '$loadDiceBot', $DiceBotLoader_loadDiceBot$9 = function $$loadDiceBot() {
      var $$10, self = this;

      
      $send(self.filenames, 'each', [], ($$10 = function(filename){var self = $$10.$$s || this;

      
        
        if (filename == null) {
          filename = nil;
        };
        return self.$require($$($nesting, 'File').$expand_path(filename, $$($nesting, 'File').$dirname("diceBot/DiceBotLoader.rb")));}, $$10.$$s = self, $$10.$$arity = 1, $$10));
      return $$($nesting, 'Object').$const_get(self.diceBotClass).$new();
    }, $DiceBotLoader_loadDiceBot$9.$$arity = 0), nil) && 'loadDiceBot';
  })($nesting[0], null, $nesting)
};

/* Generated by Opal 0.11.99.dev */
Opal.modules["diceBot/DiceBotLoaderList"] = function(Opal) {
  var self = Opal.top, $nesting = [], nil = Opal.nil, $$$ = Opal.const_get_qualified, $$ = Opal.const_get_relative, $breaker = Opal.breaker, $slice = Opal.slice, $klass = Opal.klass, $truthy = Opal.truthy, $send = Opal.send, $hash2 = Opal.hash2;

  Opal.add_stubs(['$require', '$strip', '$empty?', '$find', '$match?', '$new']);
  
  self.$require("diceBot/DiceBotLoader");
  return (function($base, $super, $parent_nesting) {
    var self = $klass($base, $super, 'DiceBotLoaderList');

    var $nesting = [self].concat($parent_nesting), $DiceBotLoaderList_find$1;

    
    Opal.defs(self, '$find', $DiceBotLoaderList_find$1 = function $$find(gameTitle) {
      var $$2, self = this, strippedTitle = nil;
      if (self.loaders == null) self.loaders = nil;

      
      strippedTitle = gameTitle.$strip();
      if ($truthy(strippedTitle['$empty?']())) {
        return nil};
      return $send(self.loaders, 'find', [], ($$2 = function(loader){var self = $$2.$$s || this;

      
        
        if (loader == null) {
          loader = nil;
        };
        return loader['$match?'](strippedTitle);}, $$2.$$s = self, $$2.$$arity = 1, $$2));
    }, $DiceBotLoaderList_find$1.$$arity = 1);
    return (self.loaders = [$$($nesting, 'DiceBotLoader').$new(["Cthulhu", "COC"]), $$($nesting, 'DiceBotLoader').$new(["Hieizan", "COCH"]), $$($nesting, 'DiceBotLoader').$new(["Elric!", "EL"], $hash2(["filenames"], {"filenames": ["Elric"]})), $$($nesting, 'DiceBotLoader').$new(["RuneQuest", "RQ"]), $$($nesting, 'DiceBotLoader').$new(["Chill", "CH"]), $$($nesting, 'DiceBotLoader').$new(["RoleMaster", "RM"]), $$($nesting, 'DiceBotLoader').$new(["ShadowRun", "SR"]), $$($nesting, 'DiceBotLoader').$new(["ShadowRun4", "SR4"]), $$($nesting, 'DiceBotLoader').$new(["Pendragon", "PD"]), $$($nesting, 'DiceBotLoader').$new(/^(?:SwordWorld|SW)\s*2\.0$/i, $hash2(["filenames", "class"], {"filenames": ["SwordWorld", "SwordWorld2_0"], "class": "SwordWorld2_0"})), $$($nesting, 'DiceBotLoader').$new(/^(?:SwordWorld|SW)\s*2\.5$/i, $hash2(["filenames", "class"], {"filenames": ["SwordWorld", "SwordWorld2_5"], "class": "SwordWorld2_5"})), $$($nesting, 'DiceBotLoader').$new(["SwordWorld", "SW"]), $$($nesting, 'DiceBotLoader').$new(["Arianrhod", "AR"]), $$($nesting, 'DiceBotLoader').$new(/^(?:Infinite\s*Fantasia|IF)$/i, $hash2(["filenames"], {"filenames": ["InfiniteFantasia"]})), $$($nesting, 'DiceBotLoader').$new("WARPS"), $$($nesting, 'DiceBotLoader').$new(/^(?:Demon\s*Parasite|DP)$/i, $hash2(["filenames"], {"filenames": ["DemonParasite"]})), $$($nesting, 'DiceBotLoader').$new(/^(?:Parasite\s*Blood|PB)$/i, $hash2(["filenames", "class"], {"filenames": ["DemonParasite", "ParasiteBlood"], "class": "ParasiteBlood"})), $$($nesting, 'DiceBotLoader').$new(/^(?:Gun\s*Dog|GD)$/i, $hash2(["filenames"], {"filenames": ["Gundog"]})), $$($nesting, 'DiceBotLoader').$new(/^(?:Gun\s*Dog\s*Zero|GDZ)$/i, $hash2(["filenames", "class"], {"filenames": ["Gundog", "GundogZero"], "class": "GundogZero"})), $$($nesting, 'DiceBotLoader').$new(/^(?:Tunnels\s*&\s*Trolls|TuT)$/i, $hash2(["filenames"], {"filenames": ["TunnelsAndTrolls"]})), $$($nesting, 'DiceBotLoader').$new(/^(?:Nightmare\s*Hunter[=\s]*Deep|NHD)$/i, $hash2(["filenames"], {"filenames": ["NightmareHunterDeep"]})), $$($nesting, 'DiceBotLoader').$new(/^(?:War\s*Hammer(FRP)?|WH)$/i, $hash2(["filenames"], {"filenames": ["Warhammer"]})), $$($nesting, 'DiceBotLoader').$new(/^(?:Phantasm\s*Adventure|PA)$/i, $hash2(["filenames"], {"filenames": ["PhantasmAdventure"]})), $$($nesting, 'DiceBotLoader').$new(/^(?:Chaos\s*Flare|CF)$/i, $hash2(["filenames"], {"filenames": ["ChaosFlare"]})), $$($nesting, 'DiceBotLoader').$new(/^(?:Cthulhu\s*Tech|CT)$/i, $hash2(["filenames"], {"filenames": ["CthulhuTech"]})), $$($nesting, 'DiceBotLoader').$new(/^(?:Tokumei\s*Tenkousei|ToT)$/i, $hash2(["filenames"], {"filenames": ["TokumeiTenkousei"]})), $$($nesting, 'DiceBotLoader').$new(/^(?:Shinobi\s*Gami|SG)$/i, $hash2(["filenames"], {"filenames": ["ShinobiGami"]})), $$($nesting, 'DiceBotLoader').$new(/^(?:Double\s*Cross|DX)$/i, $hash2(["filenames"], {"filenames": ["DoubleCross"]})), $$($nesting, 'DiceBotLoader').$new(/^(?:Sata\s*Supe|SS)$/i, $hash2(["filenames"], {"filenames": ["Satasupe"]})), $$($nesting, 'DiceBotLoader').$new(/^(?:Ars\s*Magica|AM)$/i, $hash2(["filenames"], {"filenames": ["ArsMagica"]})), $$($nesting, 'DiceBotLoader').$new(/^(?:Dark\s*Blaze|DB)$/i, $hash2(["filenames"], {"filenames": ["DarkBlaze"]})), $$($nesting, 'DiceBotLoader').$new(/^(?:Night\s*Wizard|NW)$/i, $hash2(["filenames"], {"filenames": ["NightWizard"]})), $$($nesting, 'DiceBotLoader').$new("TORG", $hash2(["filenames"], {"filenames": ["Torg"]})), $$($nesting, 'DiceBotLoader').$new(/^TORG1.5$/i, $hash2(["filenames", "class"], {"filenames": ["Torg", "Torg1_5"], "class": "Torg1_5"})), $$($nesting, 'DiceBotLoader').$new(/^(?:hunters\s*moon|HM)$/i, $hash2(["filenames"], {"filenames": ["HuntersMoon"]})), $$($nesting, 'DiceBotLoader').$new(/^(?:Blood\s*Crusade|BC)$/i, $hash2(["filenames"], {"filenames": ["BloodCrusade"]})), $$($nesting, 'DiceBotLoader').$new(/^(?:Meikyu\s*Kingdom|MK)$/i, $hash2(["filenames"], {"filenames": ["MeikyuKingdom"]})), $$($nesting, 'DiceBotLoader').$new(/^(?:Earth\s*Dawn|ED)$/i, $hash2(["filenames"], {"filenames": ["EarthDawn"]})), $$($nesting, 'DiceBotLoader').$new(/^(?:(?:Earth\s*Dawn|ED)3)$/i, $hash2(["filenames", "class"], {"filenames": ["EarthDawn", "EarthDawn3"], "class": "EarthDawn3"})), $$($nesting, 'DiceBotLoader').$new(/^(?:(?:Earth\s*Dawn|ED)4)$/i, $hash2(["filenames", "class"], {"filenames": ["EarthDawn", "EarthDawn4"], "class": "EarthDawn4"})), $$($nesting, 'DiceBotLoader').$new(/^(?:Embryo\s*Machine|EM)$/i, $hash2(["filenames"], {"filenames": ["EmbryoMachine"]})), $$($nesting, 'DiceBotLoader').$new(/^(?:Gehenna\s*An|GA)$/i, $hash2(["filenames"], {"filenames": ["GehennaAn"]})), $$($nesting, 'DiceBotLoader').$new(/^(?:Magica\s*Logia|ML)$/i, $hash2(["filenames"], {"filenames": ["MagicaLogia"]})), $$($nesting, 'DiceBotLoader').$new(["Nechronica", "NC"]), $$($nesting, 'DiceBotLoader').$new(/^(?:Meikyu\s*Days|MD)$/i, $hash2(["filenames"], {"filenames": ["MeikyuDays"]})), $$($nesting, 'DiceBotLoader').$new(["Peekaboo", "PK"]), $$($nesting, 'DiceBotLoader').$new(/^(?:Barna\s*Kronika|BK)$/i, $hash2(["filenames"], {"filenames": ["BarnaKronika"]})), $$($nesting, 'DiceBotLoader').$new(["RokumonSekai2", "RS2"]), $$($nesting, 'DiceBotLoader').$new(/^(?:Monotone\s*Musium|MM)$/i, $hash2(["filenames"], {"filenames": ["MonotoneMusium"]})), $$($nesting, 'DiceBotLoader').$new(/^Zettai\s*Reido$/i, $hash2(["filenames"], {"filenames": ["ZettaiReido"]})), $$($nesting, 'DiceBotLoader').$new(/^Eclipse\s*Phase$/i, $hash2(["filenames"], {"filenames": ["EclipsePhase"]})), $$($nesting, 'DiceBotLoader').$new("NJSLYRBATTLE", $hash2(["filenames"], {"filenames": ["NjslyrBattle"]})), $$($nesting, 'DiceBotLoader').$new(["ShinMegamiTenseiKakuseihen", "SMTKakuseihen"]), $$($nesting, 'DiceBotLoader').$new("Ryutama"), $$($nesting, 'DiceBotLoader').$new("CardRanker"), $$($nesting, 'DiceBotLoader').$new("ShinkuuGakuen"), $$($nesting, 'DiceBotLoader').$new("CrashWorld"), $$($nesting, 'DiceBotLoader').$new("WitchQuest"), $$($nesting, 'DiceBotLoader').$new("BattleTech"), $$($nesting, 'DiceBotLoader').$new("Elysion"), $$($nesting, 'DiceBotLoader').$new("GeishaGirlwithKatana"), $$($nesting, 'DiceBotLoader').$new("GURPS", $hash2(["filenames"], {"filenames": ["Gurps"]})), $$($nesting, 'DiceBotLoader').$new("GurpsFW"), $$($nesting, 'DiceBotLoader').$new("FilledWith"), $$($nesting, 'DiceBotLoader').$new("HarnMaster"), $$($nesting, 'DiceBotLoader').$new("Insane"), $$($nesting, 'DiceBotLoader').$new("KillDeathBusiness"), $$($nesting, 'DiceBotLoader').$new("Kamigakari"), $$($nesting, 'DiceBotLoader').$new("RecordOfSteam"), $$($nesting, 'DiceBotLoader').$new("Oukahoushin3rd"), $$($nesting, 'DiceBotLoader').$new("BeastBindTrinity"), $$($nesting, 'DiceBotLoader').$new("BloodMoon"), $$($nesting, 'DiceBotLoader').$new("Utakaze"), $$($nesting, 'DiceBotLoader').$new("EndBreaker"), $$($nesting, 'DiceBotLoader').$new("KanColle"), $$($nesting, 'DiceBotLoader').$new("GranCrest"), $$($nesting, 'DiceBotLoader').$new("HouraiGakuen"), $$($nesting, 'DiceBotLoader').$new("TwilightGunsmoke"), $$($nesting, 'DiceBotLoader').$new("Garako"), $$($nesting, 'DiceBotLoader').$new("ShoujoTenrankai"), $$($nesting, 'DiceBotLoader').$new("GardenOrder"), $$($nesting, 'DiceBotLoader').$new("DarkSouls"), $$($nesting, 'DiceBotLoader').$new("None", $hash2(["filenames", "class"], {"filenames": [], "class": "DiceBot"}))]);
  })($nesting[0], null, $nesting);
};

/* Generated by Opal 0.11.99.dev */
Opal.modules["dice/AddDice"] = function(Opal) {
  function $rb_plus(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs + rhs : lhs['$+'](rhs);
  }
  function $rb_times(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs * rhs : lhs['$*'](rhs);
  }
  function $rb_gt(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs > rhs : lhs['$>'](rhs);
  }
  function $rb_le(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs <= rhs : lhs['$<='](rhs);
  }
  function $rb_lt(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs < rhs : lhs['$<'](rhs);
  }
  function $rb_ge(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs >= rhs : lhs['$>='](rhs);
  }
  function $rb_minus(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs - rhs : lhs['$-'](rhs);
  }
  function $rb_divide(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs / rhs : lhs['$/'](rhs);
  }
  var self = Opal.top, $nesting = [], nil = Opal.nil, $$$ = Opal.const_get_qualified, $$ = Opal.const_get_relative, $breaker = Opal.breaker, $slice = Opal.slice, $klass = Opal.klass, $truthy = Opal.truthy, $gvars = Opal.gvars, $send = Opal.send;

  Opal.add_stubs(['$nick_e', '$debug', '$=~', '$marshalSignOfInequality', '$split', '$each', '$each_with_index', '$empty?', '$rollDiceAddingUp', '$==', '$+', '$*', '$>', '$sendMode', '$getOperatorText', '$!=', '$setDiceText', '$setDiffText', '$getDiceRevision', '$check_suc', '$getDiceRolledAdditionalText', '$sameDiceRerollCount', '$<=', '$sameDiceRerollType', '$!', '$parren_killer', '$to_i', '$is2dCritical', '$rollDiceAddingUpCommand', '$<', '$push', '$shift', '$&', '$sortType', '$rollLocal', '$[]', '$getSlashedDice', '$>=', '$addDiceArrayByAddDiceCount', '$check2dCritical', '$changeDiceValueByDiceText', '$collect', '$times', '$-', '$[]=', '$===', '$/', '$ceil', '$round', '$floor', '$rollD66', '$roll', '$<<', '$getD66Value', '$inject', '$join', '$length']);
  return (function($base, $super, $parent_nesting) {
    var self = $klass($base, $super, 'AddDice');

    var $nesting = [self].concat($parent_nesting), $AddDice_initialize$1, $AddDice_rollDice$2, $AddDice_rollDiceAddingUp$5, $AddDice_rollDiceAddingUpCommand$7, $AddDice_addDiceArrayByAddDiceCount$8, $AddDice_getSlashedDice$13, $AddDice_rollLocal$14, $AddDice_rollD66$15, $AddDice_marshalSignOfInequality$20, $AddDice_getOperatorText$21, $AddDice_parren_killer$22;

    self.$$prototype.bcdice = self.$$prototype.diceBot = self.$$prototype.nick_e = nil;
    
    
    Opal.def(self, '$initialize', $AddDice_initialize$1 = function $$initialize(bcdice, diceBot) {
      var self = this;

      
      self.bcdice = bcdice;
      self.diceBot = diceBot;
      return (self.nick_e = self.bcdice.$nick_e());
    }, $AddDice_initialize$1.$$arity = 2);
    
    Opal.def(self, '$rollDice', $AddDice_rollDice$2 = function $$rollDice(string) {
      var $a, $$3, $b, self = this, __last__match__1 = nil, __last__match__2 = nil, __last__match__3 = nil, __last__match__4 = nil, __last__match__5 = nil, __last__match__6 = nil, __last__match__7 = nil, __last__match__8 = nil, __last__match__9 = nil, __last__match__10 = nil, __last__match__11 = nil, __last__match__12 = nil, __last__match__13 = nil, __last__match__14 = nil, __last__match__15 = nil, __last__match__16 = nil, __last__match__17 = nil, __last__match__18 = nil, __last__match__19 = nil, __last__match__20 = nil, judgeText = nil, judgeOperator = nil, diffText = nil, signOfInequality = nil, isCheckSuccess = nil, dice_cnt = nil, dice_max = nil, total_n = nil, dice_n = nil, output = nil, n1 = nil, n_max = nil, addUpTextList = nil, addText = nil, revision = nil, successText = nil;

      
      self.$debug("AddDice.rollDice() begin string", string);
      if ($truthy(/(^|\s)S?(([\d\+\*\-]*[\d]+D[\d\/UR@]*[\d\+\*\-D\/UR]*)(([<>=]+)([?\-\d]+))?)($|\s)/i['$=~'](string))) {
      } else {
        return "1"
      };
      __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
      __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
      __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
      __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
      __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
      __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
      __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
      __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
      __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
      __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
      __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
      __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
      __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
      __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
      __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
      __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
      __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
      __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
      __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
      __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
      string = __last__match__2;
      judgeText = __last__match__4;
      judgeOperator = __last__match__5;
      diffText = __last__match__6;
      signOfInequality = "";
      isCheckSuccess = false;
      if ($truthy(judgeText)) {
        
        isCheckSuccess = true;
        signOfInequality = self.bcdice.$marshalSignOfInequality(judgeOperator);
        string = __last__match__3;};
      dice_cnt = 0;
      dice_max = 0;
      total_n = 0;
      dice_n = 0;
      output = "";
      n1 = 0;
      n_max = 0;
      addUpTextList = string.$split(/\+/);
      $send(addUpTextList, 'each', [], ($$3 = function(addUpText){var self = $$3.$$s || this, $$4, subtractTextList = nil;

      
        
        if (addUpText == null) {
          addUpText = nil;
        };
        subtractTextList = addUpText.$split(/-/);
        return $send(subtractTextList, 'each_with_index', [], ($$4 = function(subtractText, index){var self = $$4.$$s || this, $b, $c, dice_now = nil, dice_n_wk = nil, dice_str = nil, n1_wk = nil, n_max_wk = nil, cnt_wk = nil, max_wk = nil, rate = nil, operatorText = nil;
          if (self.diceBot == null) self.diceBot = nil;

        
          
          if (subtractText == null) {
            subtractText = nil;
          };
          
          if (index == null) {
            index = nil;
          };
          if ($truthy(subtractText['$empty?']())) {
            return nil;};
          self.$debug("begin rollDiceAddingUp(subtractText, isCheckSuccess)", subtractText, isCheckSuccess);
          $c = self.$rollDiceAddingUp(subtractText, isCheckSuccess), $b = Opal.to_ary($c), (dice_now = ($b[0] == null ? nil : $b[0])), (dice_n_wk = ($b[1] == null ? nil : $b[1])), (dice_str = ($b[2] == null ? nil : $b[2])), (n1_wk = ($b[3] == null ? nil : $b[3])), (n_max_wk = ($b[4] == null ? nil : $b[4])), (cnt_wk = ($b[5] == null ? nil : $b[5])), (max_wk = ($b[6] == null ? nil : $b[6])), $c;
          self.$debug("end rollDiceAddingUp(subtractText, isCheckSuccess) -> dice_now", dice_now);
          rate = (function() {if (index['$=='](0)) {
            return 1
          } else {
            return -1
          }; return nil; })();
          total_n = $rb_plus(total_n, $rb_times(dice_now, rate));
          dice_n = $rb_plus(dice_n, $rb_times(dice_n_wk, rate));
          n1 = $rb_plus(n1, n1_wk);
          n_max = $rb_plus(n_max, n_max_wk);
          dice_cnt = $rb_plus(dice_cnt, cnt_wk);
          if ($truthy($rb_gt(max_wk, dice_max))) {
            dice_max = max_wk};
          if ($truthy(self.diceBot.$sendMode()['$=='](0))) {
            return nil;};
          operatorText = self.$getOperatorText(rate, output);
          return (output = $rb_plus(output, "" + (operatorText) + (dice_str)));}, $$4.$$s = self, $$4.$$arity = 2, $$4));}, $$3.$$s = self, $$3.$$arity = 1, $$3));
      if ($truthy(signOfInequality['$!='](""))) {
        string = $rb_plus(string, "" + (signOfInequality) + (diffText))};
      self.diceBot.$setDiceText(output);
      self.diceBot.$setDiffText(diffText);
      $b = self.diceBot.$getDiceRevision(n_max, dice_max, total_n), $a = Opal.to_ary($b), (addText = ($a[0] == null ? nil : $a[0])), (revision = ($a[1] == null ? nil : $a[1])), $b;
      self.$debug("addText, revision", addText, revision);
      self.$debug("@nick_e", self.nick_e);
      if ($truthy($rb_gt(self.diceBot.$sendMode(), 0))) {
        if ($truthy(output['$=~'](/[^\d\[\]]+/))) {
          
          __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
          __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
          __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
          __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
          __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
          __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
          __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
          __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
          __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
          __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
          __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
          __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
          __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
          __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
          __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
          __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
          __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
          __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
          __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
          __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
          output = "" + (self.nick_e) + ": (" + (string) + ") ＞ " + (output) + " ＞ " + (total_n) + (addText);
        } else {
          output = "" + (self.nick_e) + ": (" + (string) + ") ＞ " + (total_n) + (addText)
        }
      } else {
        output = "" + (self.nick_e) + ": (" + (string) + ") ＞ " + (total_n) + (addText)
      };
      total_n = $rb_plus(total_n, revision);
      if ($truthy(signOfInequality['$!='](""))) {
        
        successText = self.bcdice.$check_suc(total_n, dice_n, signOfInequality, diffText, dice_cnt, dice_max, n1, n_max);
        self.$debug("check_suc successText", successText);
        output = $rb_plus(output, successText);};
      output = $rb_plus(output, self.diceBot.$getDiceRolledAdditionalText(n1, n_max, dice_max));
      if ($truthy(($truthy($a = dice_cnt['$=='](0)) ? $a : dice_max['$=='](0)))) {
        output = "1"};
      self.$debug("AddDice.rollDice() end output", output);
      return output;
    }, $AddDice_rollDice$2.$$arity = 1);
    
    Opal.def(self, '$rollDiceAddingUp', $AddDice_rollDiceAddingUp$5 = function $$rollDiceAddingUp(string, isCheckSuccess) {try {

      var $a, $b, $$6, self = this, dice_max = nil, dice_total = nil, dice_n = nil, output = nil, n1 = nil, n_max = nil, dice_cnt_total = nil, double_check = nil, __last__match__1 = nil, __last__match__2 = nil, __last__match__3 = nil, __last__match__4 = nil, __last__match__5 = nil, __last__match__6 = nil, __last__match__7 = nil, __last__match__8 = nil, __last__match__9 = nil, __last__match__10 = nil, __last__match__11 = nil, __last__match__12 = nil, __last__match__13 = nil, __last__match__14 = nil, __last__match__15 = nil, __last__match__16 = nil, __last__match__17 = nil, __last__match__18 = nil, __last__match__19 = nil, __last__match__20 = nil, emptyResult = nil, mul_cmd = nil;

      
      
      if (isCheckSuccess == null) {
        isCheckSuccess = false;
      };
      self.$debug("rollDiceAddingUp() begin string", string);
      dice_max = 0;
      dice_total = 1;
      dice_n = 0;
      output = "";
      n1 = 0;
      n_max = 0;
      dice_cnt_total = 0;
      double_check = false;
      if ($truthy(self.diceBot.$sameDiceRerollCount()['$!='](0))) {
        if ($truthy($rb_le(self.diceBot.$sameDiceRerollType(), 0))) {
          
          self.$debug("判定のみ振り足し");
          if ($truthy(isCheckSuccess)) {
            double_check = true};
        } else if ($truthy($rb_le(self.diceBot.$sameDiceRerollType(), 1))) {
          
          self.$debug("ダメージのみ振り足し");
          if ($truthy(isCheckSuccess['$!']())) {
            double_check = true};
        } else {
          double_check = true
        }};
      self.$debug("double_check", double_check);
      while ($truthy(/(^([\d]+\*[\d]+)\*(.+)|(.+)\*([\d]+\*[\d]+)$|(.+)\*([\d]+\*[\d]+)\*(.+))/['$=~'](string))) {
        
        __last__match__1 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](1));
        __last__match__2 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](2));
        __last__match__3 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](3));
        __last__match__4 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](4));
        __last__match__5 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](5));
        __last__match__6 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](6));
        __last__match__7 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](7));
        __last__match__8 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](8));
        __last__match__9 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](9));
        __last__match__10 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](10));
        __last__match__11 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](11));
        __last__match__12 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](12));
        __last__match__13 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](13));
        __last__match__14 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](14));
        __last__match__15 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](15));
        __last__match__16 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](16));
        __last__match__17 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](17));
        __last__match__18 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](18));
        __last__match__19 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](19));
        __last__match__20 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](20));
        if ($truthy(__last__match__2)) {
          string = $rb_plus($rb_plus(self.$parren_killer($rb_plus($rb_plus("(", __last__match__2), ")")), "*"), __last__match__3)
        } else if ($truthy(__last__match__5)) {
          string = $rb_plus($rb_plus(__last__match__4, "*"), self.$parren_killer($rb_plus($rb_plus("(", __last__match__5), ")")))
        } else if ($truthy(__last__match__7)) {
          string = $rb_plus($rb_plus($rb_plus($rb_plus(__last__match__6, "*"), self.$parren_killer($rb_plus($rb_plus("(", __last__match__7), ")"))), "*"), __last__match__8)};
      };
      self.$debug("string", string);
      emptyResult = [dice_total, dice_n, output, n1, n_max, dice_cnt_total, dice_max];
      mul_cmd = string.$split(/\*/);
      $send(mul_cmd, 'each', [], ($$6 = function(mul_line){var self = $$6.$$s || this, $c, $d, dice_count = nil, critical = nil, slashMark = nil, dice_now = nil, output_tmp = nil, n1_count = nil, max_number_tmp = nil, result_dice_count = nil;
        if (self.diceBot == null) self.diceBot = nil;
        if ($gvars.DICE_MAXNUM == null) $gvars.DICE_MAXNUM = nil;

      
        
        if (mul_line == null) {
          mul_line = nil;
        };
        if ($truthy(/([\d]+)D([\d]+)(@(\d+))?(\/\d+[UR]?)?/i['$=~'](mul_line))) {
          
          __last__match__1 = (($c = $gvars['~']) === nil ? nil : $c['$[]'](1));
          __last__match__2 = (($c = $gvars['~']) === nil ? nil : $c['$[]'](2));
          __last__match__3 = (($c = $gvars['~']) === nil ? nil : $c['$[]'](3));
          __last__match__4 = (($c = $gvars['~']) === nil ? nil : $c['$[]'](4));
          __last__match__5 = (($c = $gvars['~']) === nil ? nil : $c['$[]'](5));
          __last__match__6 = (($c = $gvars['~']) === nil ? nil : $c['$[]'](6));
          __last__match__7 = (($c = $gvars['~']) === nil ? nil : $c['$[]'](7));
          __last__match__8 = (($c = $gvars['~']) === nil ? nil : $c['$[]'](8));
          __last__match__9 = (($c = $gvars['~']) === nil ? nil : $c['$[]'](9));
          __last__match__10 = (($c = $gvars['~']) === nil ? nil : $c['$[]'](10));
          __last__match__11 = (($c = $gvars['~']) === nil ? nil : $c['$[]'](11));
          __last__match__12 = (($c = $gvars['~']) === nil ? nil : $c['$[]'](12));
          __last__match__13 = (($c = $gvars['~']) === nil ? nil : $c['$[]'](13));
          __last__match__14 = (($c = $gvars['~']) === nil ? nil : $c['$[]'](14));
          __last__match__15 = (($c = $gvars['~']) === nil ? nil : $c['$[]'](15));
          __last__match__16 = (($c = $gvars['~']) === nil ? nil : $c['$[]'](16));
          __last__match__17 = (($c = $gvars['~']) === nil ? nil : $c['$[]'](17));
          __last__match__18 = (($c = $gvars['~']) === nil ? nil : $c['$[]'](18));
          __last__match__19 = (($c = $gvars['~']) === nil ? nil : $c['$[]'](19));
          __last__match__20 = (($c = $gvars['~']) === nil ? nil : $c['$[]'](20));
          dice_count = __last__match__1.$to_i();
          dice_max = __last__match__2.$to_i();
          critical = __last__match__4.$to_i();
          slashMark = __last__match__5;
          if ($truthy(($truthy($c = critical['$!='](0)) ? self.diceBot.$is2dCritical()['$!']() : $c))) {
            Opal.ret(emptyResult)};
          if ($truthy($rb_gt(dice_max, $gvars.DICE_MAXNUM))) {
            Opal.ret(emptyResult)};
          $d = self.$rollDiceAddingUpCommand(dice_count, dice_max, slashMark, double_check, isCheckSuccess, critical), $c = Opal.to_ary($d), (dice_max = ($c[0] == null ? nil : $c[0])), (dice_now = ($c[1] == null ? nil : $c[1])), (output_tmp = ($c[2] == null ? nil : $c[2])), (n1_count = ($c[3] == null ? nil : $c[3])), (max_number_tmp = ($c[4] == null ? nil : $c[4])), (result_dice_count = ($c[5] == null ? nil : $c[5])), $d;
          if ($truthy(output['$!='](""))) {
            output = $rb_plus(output, "*")};
          output = $rb_plus(output, output_tmp);
          dice_total = $rb_times(dice_total, dice_now);
          dice_n = $rb_plus(dice_n, dice_now);
          dice_cnt_total = $rb_plus(dice_cnt_total, result_dice_count);
          n1 = $rb_plus(n1, n1_count);
          return (n_max = $rb_plus(n_max, max_number_tmp));
        } else {
          
          mul_line = mul_line.$to_i();
          self.$debug("dice_total", dice_total);
          self.$debug("mul_line", mul_line);
          dice_total = $rb_times(dice_total, mul_line);
          if ($truthy(output['$empty?']())) {
          } else {
            output = $rb_plus(output, "*")
          };
          if ($truthy($rb_lt(mul_line, 0))) {
            return (output = $rb_plus(output, "" + "(" + (mul_line) + ")"))
          } else {
            return (output = $rb_plus(output, "" + (mul_line)))
          };
        };}, $$6.$$s = self, $$6.$$arity = 1, $$6));
      self.$debug("rollDiceAddingUp() end output", dice_total, dice_n, output, n1, n_max, dice_cnt_total, dice_max);
      return [dice_total, dice_n, output, n1, n_max, dice_cnt_total, dice_max];
      } catch ($returner) { if ($returner === Opal.returner) { return $returner.$v } throw $returner; }
    }, $AddDice_rollDiceAddingUp$5.$$arity = -2);
    
    Opal.def(self, '$rollDiceAddingUpCommand', $AddDice_rollDiceAddingUpCommand$7 = function $$rollDiceAddingUpCommand(dice_count, dice_max, slashMark, double_check, isCheckSuccess, critical) {
      var $a, $b, self = this, result_dice_count = nil, dice_now = nil, n1_count = nil, max_number = nil, dice_str = nil, dice_arry = nil, loop_count = nil, dice_wk = nil, dice_dat = nil, dice_new = nil, output = nil;

      
      result_dice_count = 0;
      dice_now = 0;
      n1_count = 0;
      max_number = 0;
      dice_str = "";
      dice_arry = [];
      dice_arry.$push(dice_count);
      loop_count = 0;
      self.$debug("before while dice_arry", dice_arry);
      while ($truthy(dice_arry['$empty?']()['$!']())) {
        
        self.$debug("IN while dice_arry", dice_arry);
        dice_wk = dice_arry.$shift();
        result_dice_count = $rb_plus(result_dice_count, dice_wk);
        self.$debug("dice_wk", dice_wk);
        self.$debug("dice_max", dice_max);
        self.$debug("(sortType & 1)", self.diceBot.$sortType()['$&'](1));
        dice_dat = self.$rollLocal(dice_wk, dice_max, self.diceBot.$sortType()['$&'](1));
        self.$debug("dice_dat", dice_dat);
        dice_new = dice_dat['$[]'](0);
        dice_now = $rb_plus(dice_now, dice_new);
        self.$debug("slashMark", slashMark);
        dice_now = self.$getSlashedDice(slashMark, dice_now);
        if ($truthy(dice_str['$!='](""))) {
          dice_str = $rb_plus(dice_str, "][")};
        self.$debug("dice_str", dice_str);
        dice_str = $rb_plus(dice_str, dice_dat['$[]'](1));
        n1_count = $rb_plus(n1_count, dice_dat['$[]'](2));
        max_number = $rb_plus(max_number, dice_dat['$[]'](3));
        if ($truthy(($truthy($b = double_check) ? $rb_ge(dice_wk, 2) : $b))) {
          self.$addDiceArrayByAddDiceCount(dice_dat, dice_max, dice_arry, dice_wk)};
        self.diceBot.$check2dCritical(critical, dice_new, dice_arry, loop_count);
        loop_count = $rb_plus(loop_count, 1);
      };
      dice_now = self.diceBot.$changeDiceValueByDiceText(dice_now, dice_str, isCheckSuccess, dice_max);
      output = "";
      if ($truthy($rb_gt(self.diceBot.$sendMode(), 1))) {
        output = $rb_plus(output, "" + (dice_now) + "[" + (dice_str) + "]")
      } else if ($truthy($rb_gt(self.diceBot.$sendMode(), 0))) {
        output = $rb_plus(output, "" + (dice_now))};
      return [dice_max, dice_now, output, n1_count, max_number, result_dice_count];
    }, $AddDice_rollDiceAddingUpCommand$7.$$arity = 6);
    
    Opal.def(self, '$addDiceArrayByAddDiceCount', $AddDice_addDiceArrayByAddDiceCount$8 = function $$addDiceArrayByAddDiceCount(dice_dat, dice_max, dice_arry, dice_wk) {
      var $$9, $$10, $$11, $$12, self = this, dice_num = nil, dice_face = nil;

      
      dice_num = $send(dice_dat['$[]'](1).$split(/,/), 'collect', [], ($$9 = function(s){var self = $$9.$$s || this;

      
        
        if (s == null) {
          s = nil;
        };
        return s.$to_i();}, $$9.$$s = self, $$9.$$arity = 1, $$9));
      dice_face = [];
      $send(dice_max, 'times', [], ($$10 = function(i){var self = $$10.$$s || this;

      
        
        if (i == null) {
          i = nil;
        };
        return dice_face.$push(0);}, $$10.$$s = self, $$10.$$arity = 1, $$10));
      $send(dice_num, 'each', [], ($$11 = function(dice_o){var self = $$11.$$s || this, $writer = nil;

      
        
        if (dice_o == null) {
          dice_o = nil;
        };
        $writer = [$rb_minus(dice_o, 1), $rb_plus(dice_face['$[]']($rb_minus(dice_o, 1)), 1)];
        $send(dice_face, '[]=', Opal.to_a($writer));
        return $writer[$rb_minus($writer["length"], 1)];}, $$11.$$s = self, $$11.$$arity = 1, $$11));
      return $send(dice_face, 'each', [], ($$12 = function(dice_o){var self = $$12.$$s || this;
        if (self.diceBot == null) self.diceBot = nil;

      
        
        if (dice_o == null) {
          dice_o = nil;
        };
        if ($truthy(self.diceBot.$sameDiceRerollCount()['$=='](1))) {
          if ($truthy(dice_o['$=='](dice_wk))) {
            return dice_arry.$push(dice_o)
          } else {
            return nil
          }
        } else if ($truthy($rb_ge(dice_o, self.diceBot.$sameDiceRerollCount()))) {
          return dice_arry.$push(dice_o)
        } else {
          return nil
        };}, $$12.$$s = self, $$12.$$arity = 1, $$12));
    }, $AddDice_addDiceArrayByAddDiceCount$8.$$arity = 4);
    
    Opal.def(self, '$getSlashedDice', $AddDice_getSlashedDice$13 = function $$getSlashedDice(slashMark, dice) {
      var $a, self = this, __last__match__1 = nil, __last__match__2 = nil, __last__match__3 = nil, __last__match__4 = nil, __last__match__5 = nil, __last__match__6 = nil, __last__match__7 = nil, __last__match__8 = nil, __last__match__9 = nil, __last__match__10 = nil, __last__match__11 = nil, __last__match__12 = nil, __last__match__13 = nil, __last__match__14 = nil, __last__match__15 = nil, __last__match__16 = nil, __last__match__17 = nil, __last__match__18 = nil, __last__match__19 = nil, __last__match__20 = nil, rate = nil, mark = nil, value = nil, $case = nil;

      
      if ($truthy(/^\/(\d+)(.)?$/i['$==='](slashMark))) {
      } else {
        return dice
      };
      __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
      __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
      __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
      __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
      __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
      __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
      __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
      __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
      __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
      __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
      __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
      __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
      __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
      __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
      __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
      __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
      __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
      __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
      __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
      __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
      rate = __last__match__1.$to_i();
      mark = __last__match__2;
      if ($truthy(rate['$=='](0))) {
        return dice};
      value = $rb_divide($rb_times(1.0, dice), rate);
      $case = mark;
      if ("U"['$===']($case)) {dice = value.$ceil()}
      else if ("R"['$===']($case)) {dice = value.$round()}
      else {dice = value.$floor()};
      return dice;
    }, $AddDice_getSlashedDice$13.$$arity = 2);
    
    Opal.def(self, '$rollLocal', $AddDice_rollLocal$14 = function $$rollLocal(dice_wk, dice_max, sortType) {
      var self = this;

      
      if ($truthy(dice_max['$=='](66))) {
        return self.$rollD66(dice_wk)};
      return self.bcdice.$roll(dice_wk, dice_max, sortType);
    }, $AddDice_rollLocal$14.$$arity = 3);
    
    Opal.def(self, '$rollD66', $AddDice_rollD66$15 = function $$rollD66(count) {
      var $$16, $$17, $$18, $$19, self = this, d66List = nil, total = nil, text = nil, n1Count = nil, nMaxCount = nil, result = nil;

      
      d66List = [];
      $send(count, 'times', [], ($$16 = function(i){var self = $$16.$$s || this;
        if (self.bcdice == null) self.bcdice = nil;

      
        
        if (i == null) {
          i = nil;
        };
        return d66List['$<<'](self.bcdice.$getD66Value());}, $$16.$$s = self, $$16.$$arity = 1, $$16));
      total = $send(d66List, 'inject', [], ($$17 = function(sum, i){var self = $$17.$$s || this;

      
        
        if (sum == null) {
          sum = nil;
        };
        
        if (i == null) {
          i = nil;
        };
        return $rb_plus(sum, i);}, $$17.$$s = self, $$17.$$arity = 2, $$17));
      text = d66List.$join(",");
      n1Count = $send(d66List, 'collect', [], ($$18 = function(i){var self = $$18.$$s || this;

      
        
        if (i == null) {
          i = nil;
        };
        return i['$=='](1);}, $$18.$$s = self, $$18.$$arity = 1, $$18)).$length();
      nMaxCount = $send(d66List, 'collect', [], ($$19 = function(i){var self = $$19.$$s || this;

      
        
        if (i == null) {
          i = nil;
        };
        return i['$=='](66);}, $$19.$$s = self, $$19.$$arity = 1, $$19)).$length();
      return (result = [total, text, n1Count, nMaxCount, 0, 0, 0]);
    }, $AddDice_rollD66$15.$$arity = 1);
    
    Opal.def(self, '$marshalSignOfInequality', $AddDice_marshalSignOfInequality$20 = function $$marshalSignOfInequality($a) {
      var $post_args, arg, self = this;

      
      
      $post_args = Opal.slice.call(arguments, 0, arguments.length);
      
      arg = $post_args;;
      return $send(self.bcdice, 'marshalSignOfInequality', Opal.to_a(arg));
    }, $AddDice_marshalSignOfInequality$20.$$arity = -1);
    
    Opal.def(self, '$getOperatorText', $AddDice_getOperatorText$21 = function $$getOperatorText(rate, output) {
      var self = this;

      
      if ($truthy($rb_lt(rate, 0))) {
        return "-"};
      if ($truthy(output['$empty?']())) {
        return ""};
      return "+";
    }, $AddDice_getOperatorText$21.$$arity = 2);
    return (Opal.def(self, '$parren_killer', $AddDice_parren_killer$22 = function $$parren_killer($a) {
      var $post_args, args, self = this;

      
      
      $post_args = Opal.slice.call(arguments, 0, arguments.length);
      
      args = $post_args;;
      return $send(self.bcdice, 'parren_killer', Opal.to_a(args));
    }, $AddDice_parren_killer$22.$$arity = -1), nil) && 'parren_killer';
  })($nesting[0], null, $nesting)
};

/* Generated by Opal 0.11.99.dev */
Opal.modules["dice/UpperDice"] = function(Opal) {
  function $rb_le(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs <= rhs : lhs['$<='](rhs);
  }
  function $rb_plus(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs + rhs : lhs['$+'](rhs);
  }
  function $rb_minus(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs - rhs : lhs['$-'](rhs);
  }
  function $rb_gt(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs > rhs : lhs['$>'](rhs);
  }
  function $rb_lt(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs < rhs : lhs['$<'](rhs);
  }
  var self = Opal.top, $nesting = [], nil = Opal.nil, $$$ = Opal.const_get_qualified, $$ = Opal.const_get_relative, $breaker = Opal.breaker, $slice = Opal.slice, $klass = Opal.klass, $truthy = Opal.truthy, $gvars = Opal.gvars, $send = Opal.send;

  Opal.add_stubs(['$nick_e', '$debug', '$gsub', '$=~', '$to_i', '$getMarshaledSignOfInequality', '$getAddRollUpperTarget', '$<=', '$split', '$+', '$each', '$push', '$getBonusValue', '$-', '$getUpperDiceCommandResult', '$>', '$<', '$isPrintMaxDice', '$!=', '$getMaxAndTotalValueResultStirng', '$length', '$==', '$upplerRollThreshold', '$empty?', '$join', '$parren_killer', '$collect', '$roll', '$&', '$sortType', '$<<']);
  return (function($base, $super, $parent_nesting) {
    var self = $klass($base, $super, 'UpperDice');

    var $nesting = [self].concat($parent_nesting), $UpperDice_initialize$1, $UpperDice_rollDice$2, $UpperDice_getMaxAndTotalValueResultStirng$4, $UpperDice_getAddRollUpperTarget$5, $UpperDice_getBonusValue$6, $UpperDice_getUpperDiceCommandResult$7;

    self.$$prototype.bcdice = self.$$prototype.upper = self.$$prototype.nick_e = self.$$prototype.diceBot = self.$$prototype.signOfInequality = nil;
    
    
    Opal.def(self, '$initialize', $UpperDice_initialize$1 = function $$initialize(bcdice, diceBot) {
      var self = this;

      
      self.bcdice = bcdice;
      self.diceBot = diceBot;
      return (self.nick_e = self.bcdice.$nick_e());
    }, $UpperDice_initialize$1.$$arity = 2);
    
    Opal.def(self, '$rollDice', $UpperDice_rollDice$2 = function $$rollDice(string) {
      var $a, $$3, $b, self = this, output = nil, __last__match__1 = nil, __last__match__2 = nil, __last__match__3 = nil, __last__match__4 = nil, __last__match__5 = nil, __last__match__6 = nil, __last__match__7 = nil, __last__match__8 = nil, __last__match__9 = nil, __last__match__10 = nil, __last__match__11 = nil, __last__match__12 = nil, __last__match__13 = nil, __last__match__14 = nil, __last__match__15 = nil, __last__match__16 = nil, __last__match__17 = nil, __last__match__18 = nil, __last__match__19 = nil, __last__match__20 = nil, command = nil, signOfInequalityText = nil, diff = nil, upperTarget1 = nil, upperTarget2 = nil, modify = nil, dice_a = nil, diceCommands = nil, bonusValues = nil, bonus = nil, diceDiff = nil, totalDiceString = nil, totalSuccessCount = nil, totalDiceCount = nil, maxDiceValue = nil, totalValue = nil, maxValue = nil;
      if ($gvars.SEND_STR_MAX == null) $gvars.SEND_STR_MAX = nil;

      
      self.$debug("udice begin string", string);
      output = "1";
      string = string.$gsub(/-[sS]?[\d]+[uU][\d]+/, "");
      if ($truthy(/(^|\s)[sS]?(\d+[uU][\d\+\-uU]+)(\[(\d+)\])?([\+\-\d]*)(([<>=]+)(\d+))?(\@(\d+))?($|\s)/['$=~'](string))) {
      } else {
        return output
      };
      __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
      __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
      __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
      __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
      __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
      __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
      __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
      __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
      __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
      __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
      __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
      __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
      __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
      __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
      __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
      __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
      __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
      __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
      __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
      __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
      command = __last__match__2;
      signOfInequalityText = __last__match__7;
      diff = __last__match__8.$to_i();
      upperTarget1 = __last__match__4;
      upperTarget2 = __last__match__10;
      modify = __last__match__5;
      self.$debug("modify", modify);
      modify = ($truthy($a = modify) ? $a : "");
      self.$debug("p $...", [__last__match__1, __last__match__2, __last__match__3, __last__match__4, __last__match__5, __last__match__6, __last__match__7, __last__match__8, __last__match__9, __last__match__10]);
      string = command;
      self.signOfInequality = self.bcdice.$getMarshaledSignOfInequality(signOfInequalityText);
      self.upper = self.$getAddRollUpperTarget(upperTarget1, upperTarget2);
      if ($truthy($rb_le(self.upper, 1))) {
        
        output = "" + (self.nick_e) + ": (" + (string) + "[" + (self.upper) + "]" + (modify) + ") ＞ 無限ロールの条件がまちがっています";
        return output;};
      dice_a = $rb_plus(string, modify).$split(/\+/);
      self.$debug("dice_a", dice_a);
      diceCommands = [];
      bonusValues = [];
      $send(dice_a, 'each', [], ($$3 = function(dice_o){var self = $$3.$$s || this, $b;

      
        
        if (dice_o == null) {
          dice_o = nil;
        };
        if ($truthy(/[Uu]/['$=~'](dice_o))) {
          
          __last__match__1 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](1));
          __last__match__2 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](2));
          __last__match__3 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](3));
          __last__match__4 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](4));
          __last__match__5 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](5));
          __last__match__6 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](6));
          __last__match__7 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](7));
          __last__match__8 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](8));
          __last__match__9 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](9));
          __last__match__10 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](10));
          __last__match__11 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](11));
          __last__match__12 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](12));
          __last__match__13 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](13));
          __last__match__14 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](14));
          __last__match__15 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](15));
          __last__match__16 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](16));
          __last__match__17 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](17));
          __last__match__18 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](18));
          __last__match__19 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](19));
          __last__match__20 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](20));
          return diceCommands.$push(dice_o);
        } else {
          return bonusValues.$push(dice_o)
        };}, $$3.$$s = self, $$3.$$arity = 1, $$3));
      bonus = self.$getBonusValue(bonusValues);
      self.$debug("bonus", bonus);
      diceDiff = $rb_minus(diff, bonus);
      $b = self.$getUpperDiceCommandResult(diceCommands, diceDiff), $a = Opal.to_ary($b), (totalDiceString = ($a[0] == null ? nil : $a[0])), (totalSuccessCount = ($a[1] == null ? nil : $a[1])), (totalDiceCount = ($a[2] == null ? nil : $a[2])), (maxDiceValue = ($a[3] == null ? nil : $a[3])), (totalValue = ($a[4] == null ? nil : $a[4])), $b;
      output = totalDiceString;
      if ($truthy($rb_gt(bonus, 0))) {
        output = $rb_plus(output, "" + "+" + (bonus))
      } else if ($truthy($rb_lt(bonus, 0))) {
        output = $rb_plus(output, "" + (bonus))};
      maxValue = $rb_plus(maxDiceValue, bonus);
      totalValue = $rb_plus(totalValue, bonus);
      string = $rb_plus(string, $rb_plus("" + "[" + (self.upper) + "]", modify));
      if ($truthy(($truthy($a = self.diceBot.$isPrintMaxDice()) ? $rb_gt(totalDiceCount, 1) : $a))) {
        output = "" + (output) + " ＞ " + (totalValue)};
      if ($truthy(self.signOfInequality['$!='](""))) {
        
        output = "" + (output) + " ＞ 成功数" + (totalSuccessCount);
        string = $rb_plus(string, "" + (self.signOfInequality) + (diff));
      } else {
        output = $rb_plus(output, self.$getMaxAndTotalValueResultStirng(maxValue, totalValue, totalDiceCount))
      };
      output = "" + (self.nick_e) + ": (" + (string) + ") ＞ " + (output);
      if ($truthy($rb_gt(output.$length(), $gvars.SEND_STR_MAX))) {
        
        output = "" + (self.nick_e) + ": (" + (string) + ") ＞ ... ＞ " + (totalValue);
        if ($truthy(self.signOfInequality['$=='](""))) {
          output = $rb_plus(output, self.$getMaxAndTotalValueResultStirng(maxValue, totalValue, totalDiceCount))};};
      return output;
    }, $UpperDice_rollDice$2.$$arity = 1);
    
    Opal.def(self, '$getMaxAndTotalValueResultStirng', $UpperDice_getMaxAndTotalValueResultStirng$4 = function $$getMaxAndTotalValueResultStirng(maxValue, totalValue, totalDiceCount) {
      var self = this;

      return "" + " ＞ " + (maxValue) + "/" + (totalValue) + "(最大/合計)"
    }, $UpperDice_getMaxAndTotalValueResultStirng$4.$$arity = 3);
    
    Opal.def(self, '$getAddRollUpperTarget', $UpperDice_getAddRollUpperTarget$5 = function $$getAddRollUpperTarget(target1, target2) {
      var self = this;

      
      if ($truthy(target1)) {
        return target1.$to_i()};
      if ($truthy(target2)) {
        return target2.$to_i()};
      if ($truthy(self.diceBot.$upplerRollThreshold()['$==']("Max"))) {
        return 2
      } else {
        return self.diceBot.$upplerRollThreshold()
      };
    }, $UpperDice_getAddRollUpperTarget$5.$$arity = 2);
    
    Opal.def(self, '$getBonusValue', $UpperDice_getBonusValue$6 = function $$getBonusValue(bonusValues) {
      var self = this, diceBonusText = nil, bonus = nil;

      
      if ($truthy(bonusValues['$empty?']())) {
        return 0};
      diceBonusText = bonusValues.$join("+");
      bonus = self.bcdice.$parren_killer($rb_plus($rb_plus("(", diceBonusText), ")")).$to_i();
      return bonus;
    }, $UpperDice_getBonusValue$6.$$arity = 1);
    return (Opal.def(self, '$getUpperDiceCommandResult', $UpperDice_getUpperDiceCommandResult$7 = function $$getUpperDiceCommandResult(diceCommands, diceDiff) {
      var $$8, self = this, diceStringList = nil, totalSuccessCount = nil, totalDiceCount = nil, maxDiceValue = nil, totalValue = nil, totalDiceString = nil;

      
      diceStringList = [];
      totalSuccessCount = 0;
      totalDiceCount = 0;
      maxDiceValue = 0;
      totalValue = 0;
      $send(diceCommands, 'each', [], ($$8 = function(diceCommand){var self = $$8.$$s || this, $a, $b, $$9, diceCount = nil, diceMax = nil, total = nil, diceString = nil, cnt1 = nil, cnt_max = nil, maxDiceResult = nil, successCount = nil, cnt_re = nil;
        if (self.diceBot == null) self.diceBot = nil;
        if (self.bcdice == null) self.bcdice = nil;
        if (self.upper == null) self.upper = nil;
        if (self.signOfInequality == null) self.signOfInequality = nil;

      
        
        if (diceCommand == null) {
          diceCommand = nil;
        };
        $b = $send(diceCommand.$split(/[uU]/), 'collect', [], ($$9 = function(s){var self = $$9.$$s || this;

        
          
          if (s == null) {
            s = nil;
          };
          return s.$to_i();}, $$9.$$s = self, $$9.$$arity = 1, $$9)), $a = Opal.to_ary($b), (diceCount = ($a[0] == null ? nil : $a[0])), (diceMax = ($a[1] == null ? nil : $a[1])), $b;
        if ($truthy(self.diceBot.$upplerRollThreshold()['$==']("Max"))) {
          self.upper = diceMax};
        $b = self.bcdice.$roll(diceCount, diceMax, self.diceBot.$sortType()['$&'](2), self.upper, self.signOfInequality, diceDiff), $a = Opal.to_ary($b), (total = ($a[0] == null ? nil : $a[0])), (diceString = ($a[1] == null ? nil : $a[1])), (cnt1 = ($a[2] == null ? nil : $a[2])), (cnt_max = ($a[3] == null ? nil : $a[3])), (maxDiceResult = ($a[4] == null ? nil : $a[4])), (successCount = ($a[5] == null ? nil : $a[5])), (cnt_re = ($a[6] == null ? nil : $a[6])), $b;
        diceStringList['$<<'](diceString);
        totalSuccessCount = $rb_plus(totalSuccessCount, successCount);
        if ($truthy($rb_gt(maxDiceResult, maxDiceValue))) {
          maxDiceValue = maxDiceResult};
        totalDiceCount = $rb_plus(totalDiceCount, diceCount);
        return (totalValue = $rb_plus(totalValue, total));}, $$8.$$s = self, $$8.$$arity = 1, $$8));
      totalDiceString = diceStringList.$join(",");
      return [totalDiceString, totalSuccessCount, totalDiceCount, maxDiceValue, totalValue];
    }, $UpperDice_getUpperDiceCommandResult$7.$$arity = 2), nil) && 'getUpperDiceCommandResult';
  })($nesting[0], null, $nesting)
};

/* Generated by Opal 0.11.99.dev */
Opal.modules["dice/RerollDice"] = function(Opal) {
  function $rb_plus(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs + rhs : lhs['$+'](rhs);
  }
  function $rb_gt(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs > rhs : lhs['$>'](rhs);
  }
  function $rb_le(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs <= rhs : lhs['$<='](rhs);
  }
  function $rb_ge(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs >= rhs : lhs['$>='](rhs);
  }
  function $rb_lt(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs < rhs : lhs['$<'](rhs);
  }
  var self = Opal.top, $nesting = [], nil = Opal.nil, $$$ = Opal.const_get_qualified, $$ = Opal.const_get_relative, $breaker = Opal.breaker, $slice = Opal.slice, $klass = Opal.klass, $truthy = Opal.truthy, $gvars = Opal.gvars, $send = Opal.send;

  Opal.add_stubs(['$nick_e', '$rollDiceCatched', '$+', '$to_s', '$debug', '$gsub', '$=~', '$to_i', '$marshalSignOfInequality', '$!=', '$defaultSuccessTarget', '$getRerollNumber', '$split', '$each', '$collect', '$checkReRollRule', '$roll', '$&', '$sortType', '$reRollNextDice', '$getGrichText', '$>', '$length', '$<=', '$loop', '$isReRollAgain', '$rerollNumber', '$!', '$nil?', '$raiseErroForJudgeRule', '$raise', '$===', '$>=', '$<']);
  return (function($base, $super, $parent_nesting) {
    var self = $klass($base, $super, 'RerollDice');

    var $nesting = [self].concat($parent_nesting), $RerollDice_initialize$1, $RerollDice_rollDice$2, $RerollDice_rollDiceCatched$3, $RerollDice_reRollNextDice$6, $RerollDice_getRerollNumber$8, $RerollDice_raiseErroForJudgeRule$9, $RerollDice_checkReRollRule$10;

    self.$$prototype.bcdice = self.$$prototype.nick_e = self.$$prototype.diceBot = nil;
    
    
    Opal.def(self, '$initialize', $RerollDice_initialize$1 = function $$initialize(bcdice, diceBot) {
      var self = this;

      
      self.bcdice = bcdice;
      self.diceBot = diceBot;
      return (self.nick_e = self.bcdice.$nick_e());
    }, $RerollDice_initialize$1.$$arity = 2);
    
    Opal.def(self, '$rollDice', $RerollDice_rollDice$2 = function $$rollDice(string) {
      var self = this, output = nil, e = nil;

      
      output = "";
      
      try {
        output = self.$rollDiceCatched(string)
      } catch ($err) {
        if (Opal.rescue($err, [$$($nesting, 'StandardError')])) {e = $err;
          try {
            output = $rb_plus("" + (string) + " ＞ ", e.$to_s())
          } finally { Opal.pop_exception() }
        } else { throw $err; }
      };;
      return "" + (self.nick_e) + ": " + (output);
    }, $RerollDice_rollDice$2.$$arity = 1);
    
    Opal.def(self, '$rollDiceCatched', $RerollDice_rollDiceCatched$3 = function $$rollDiceCatched(string) {
      var $a, $$4, $b, self = this, successCount = nil, signOfInequality = nil, output = nil, next_roll = nil, __last__match__1 = nil, __last__match__2 = nil, __last__match__3 = nil, __last__match__4 = nil, __last__match__5 = nil, __last__match__6 = nil, __last__match__7 = nil, __last__match__8 = nil, __last__match__9 = nil, __last__match__10 = nil, __last__match__11 = nil, __last__match__12 = nil, __last__match__13 = nil, __last__match__14 = nil, __last__match__15 = nil, __last__match__16 = nil, __last__match__17 = nil, __last__match__18 = nil, __last__match__19 = nil, __last__match__20 = nil, rerollNumber_1 = nil, rerollNumber_2 = nil, judgeText = nil, operator = nil, diff = nil, rerollNumber = nil, numberSpot1Total = nil, dice_cnt_total = nil, dice_max = nil, dice_a = nil, output2 = nil, round = nil, success = nil, dice_cnt = nil;
      if ($gvars.SEND_STR_MAX == null) $gvars.SEND_STR_MAX = nil;

      
      self.$debug("RerollDice.rollDice string", string);
      successCount = 0;
      signOfInequality = "";
      output = "";
      next_roll = 0;
      string = string.$gsub(/-[\d]+R[\d]+/, "");
      if ($truthy(/(^|\s)S?([\d]+R[\d\+R]+)(\[(\d+)\])?(([<>=]+)([\d]+))?(\@(\d+))?($|\s)/['$=~'](string))) {
      } else {
        
        self.$debug("is invaild rdice", string);
        return "1";
      };
      __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
      __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
      __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
      __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
      __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
      __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
      __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
      __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
      __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
      __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
      __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
      __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
      __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
      __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
      __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
      __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
      __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
      __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
      __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
      __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
      string = __last__match__2;
      rerollNumber_1 = __last__match__4;
      rerollNumber_2 = __last__match__9;
      judgeText = __last__match__5;
      operator = __last__match__6;
      diff = __last__match__7;
      if ($truthy(judgeText)) {
        
        diff = diff.$to_i();
        signOfInequality = self.bcdice.$marshalSignOfInequality(operator);
      } else if ($truthy(self.diceBot.$defaultSuccessTarget()['$!='](""))) {
        if ($truthy(self.diceBot.$defaultSuccessTarget()['$=~'](/([<>=]+)(\d+)/))) {
          
          __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
          __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
          __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
          __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
          __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
          __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
          __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
          __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
          __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
          __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
          __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
          __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
          __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
          __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
          __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
          __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
          __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
          __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
          __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
          __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
          __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
          __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
          __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
          __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
          __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
          __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
          __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
          __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
          __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
          __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
          __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
          __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
          __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
          __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
          __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
          __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
          __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
          __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
          __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
          __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
          operator = __last__match__1;
          diff = __last__match__2.$to_i();
          signOfInequality = self.bcdice.$marshalSignOfInequality(operator);}};
      rerollNumber = self.$getRerollNumber(rerollNumber_1, rerollNumber_2, judgeText, diff);
      self.$debug("rerollNumber", rerollNumber);
      self.$debug("diff", diff);
      numberSpot1Total = 0;
      dice_cnt_total = 0;
      dice_max = 0;
      dice_a = string.$split(/\+/);
      self.$debug("dice_a", dice_a);
      $send(dice_a, 'each', [], ($$4 = function(dice_o){var self = $$4.$$s || this, $b, $c, $$5, dice_cnt = nil, total = nil, dice_str = nil, numberSpot1 = nil, cnt_max = nil, n_max = nil, success = nil, rerollCount = nil;
        if (self.bcdice == null) self.bcdice = nil;
        if (self.diceBot == null) self.diceBot = nil;

      
        
        if (dice_o == null) {
          dice_o = nil;
        };
        self.$debug("dice_o", dice_o);
        $c = $send(dice_o.$split(/[rR]/), 'collect', [], ($$5 = function(s){var self = $$5.$$s || this;

        
          
          if (s == null) {
            s = nil;
          };
          return s.$to_i();}, $$5.$$s = self, $$5.$$arity = 1, $$5)), $b = Opal.to_ary($c), (dice_cnt = ($b[0] == null ? nil : $b[0])), (dice_max = ($b[1] == null ? nil : $b[1])), $c;
        self.$debug("dice_cnt", dice_cnt);
        self.$debug("dice_max", dice_max);
        self.$checkReRollRule(dice_max, signOfInequality, diff);
        $c = self.bcdice.$roll(dice_cnt, dice_max, self.diceBot.$sortType()['$&'](2), 0, signOfInequality, diff, rerollNumber), $b = Opal.to_ary($c), (total = ($b[0] == null ? nil : $b[0])), (dice_str = ($b[1] == null ? nil : $b[1])), (numberSpot1 = ($b[2] == null ? nil : $b[2])), (cnt_max = ($b[3] == null ? nil : $b[3])), (n_max = ($b[4] == null ? nil : $b[4])), (success = ($b[5] == null ? nil : $b[5])), (rerollCount = ($b[6] == null ? nil : $b[6])), $c;
        self.$debug("bcdice.roll : total, dice_str, numberSpot1, cnt_max, n_max, success, rerollCount", total, dice_str, numberSpot1, cnt_max, n_max, success, rerollCount);
        successCount = $rb_plus(successCount, success);
        if ($truthy(output['$!='](""))) {
          output = $rb_plus(output, ",")};
        output = $rb_plus(output, dice_str);
        next_roll = $rb_plus(next_roll, rerollCount);
        numberSpot1Total = $rb_plus(numberSpot1Total, numberSpot1);
        return (dice_cnt_total = $rb_plus(dice_cnt_total, dice_cnt));}, $$4.$$s = self, $$4.$$arity = 1, $$4));
      $b = self.$reRollNextDice(next_roll, dice_max, signOfInequality, diff, rerollNumber), $a = Opal.to_ary($b), (output2 = ($a[0] == null ? nil : $a[0])), (round = ($a[1] == null ? nil : $a[1])), (success = ($a[2] == null ? nil : $a[2])), (dice_cnt = ($a[3] == null ? nil : $a[3])), $b;
      successCount = $rb_plus(successCount, success);
      dice_cnt_total = $rb_plus(dice_cnt_total, dice_cnt);
      output = "" + (output) + (output2) + " ＞ 成功数" + (successCount);
      string = $rb_plus(string, "" + "[" + (rerollNumber) + "]" + (signOfInequality) + (diff));
      self.$debug("string", string);
      output = $rb_plus(output, self.diceBot.$getGrichText(numberSpot1Total, dice_cnt_total, successCount));
      output = "" + "(" + (string) + ") ＞ " + (output);
      if ($truthy($rb_gt(output.$length(), $gvars.SEND_STR_MAX))) {
        output = "" + "(" + (string) + ") ＞ ... ＞ 回転数" + (round) + " ＞ 成功数" + (successCount)};
      return output;
    }, $RerollDice_rollDiceCatched$3.$$arity = 1);
    
    Opal.def(self, '$reRollNextDice', $RerollDice_reRollNextDice$6 = function $$reRollNextDice(next_roll, dice_max, signOfInequality, diff, rerollNumber) {
      var $$7, self = this, dice_cnt = nil, output = nil, round = nil, successCount = nil, dice_cnt_total = nil;

      
      self.$debug("rerollNumber Begin");
      dice_cnt = next_roll;
      self.$debug("dice_cnt", dice_cnt);
      output = "";
      round = 0;
      successCount = 0;
      dice_cnt_total = 0;
      if ($truthy($rb_le(next_roll, 0))) {
        return [output, round, successCount, dice_cnt_total]};
      (function(){var $brk = Opal.new_brk(); try {return $send(self, 'loop', [], ($$7 = function(){var self = $$7.$$s || this, $a, $b, total = nil, dice_str = nil, numberSpot1 = nil, cnt_max = nil, n_max = nil, success = nil, rerollCount = nil;
        if (self.bcdice == null) self.bcdice = nil;
        if (self.diceBot == null) self.diceBot = nil;

      
        $b = self.bcdice.$roll(dice_cnt, dice_max, self.diceBot.$sortType()['$&'](2), 0, signOfInequality, diff, rerollNumber), $a = Opal.to_ary($b), (total = ($a[0] == null ? nil : $a[0])), (dice_str = ($a[1] == null ? nil : $a[1])), (numberSpot1 = ($a[2] == null ? nil : $a[2])), (cnt_max = ($a[3] == null ? nil : $a[3])), (n_max = ($a[4] == null ? nil : $a[4])), (success = ($a[5] == null ? nil : $a[5])), (rerollCount = ($a[6] == null ? nil : $a[6])), $b;
        self.$debug("total, dice_str, numberSpot1, cnt_max, n_max, success, rerollCount", total, dice_str, numberSpot1, cnt_max, n_max, success, rerollCount);
        successCount = $rb_plus(successCount, success);
        round = $rb_plus(round, 1);
        dice_cnt_total = $rb_plus(dice_cnt_total, dice_cnt);
        dice_cnt = rerollCount;
        self.$debug("dice_str", dice_str);
        output = $rb_plus(output, "" + " + " + (dice_str));
        if ($truthy(self.bcdice.$isReRollAgain(dice_cnt, round))) {
          return nil
        } else {
          
          Opal.brk(nil, $brk)
        };}, $$7.$$s = self, $$7.$$brk = $brk, $$7.$$arity = 0, $$7))
      } catch (err) { if (err === $brk) { return err.$v } else { throw err } }})();
      self.$debug("output", output);
      self.$debug("rerollNumber End");
      return [output, round, successCount, dice_cnt_total];
    }, $RerollDice_reRollNextDice$6.$$arity = 5);
    
    Opal.def(self, '$getRerollNumber', $RerollDice_getRerollNumber$8 = function $$getRerollNumber(rerollNumber_1, rerollNumber_2, judgeText, diff) {
      var self = this;

      if ($truthy(rerollNumber_1)) {
        return rerollNumber_1.$to_i()
      } else if ($truthy(rerollNumber_2)) {
        return rerollNumber_2.$to_i()
      } else if ($truthy(self.diceBot.$rerollNumber()['$!='](0))) {
        return self.diceBot.$rerollNumber()
      } else if ($truthy(diff['$nil?']()['$!']())) {
        return diff
      } else {
        return self.$raiseErroForJudgeRule()
      }
    }, $RerollDice_getRerollNumber$8.$$arity = 4);
    
    Opal.def(self, '$raiseErroForJudgeRule', $RerollDice_raiseErroForJudgeRule$9 = function $$raiseErroForJudgeRule() {
      var self = this;

      return self.$raise("条件が間違っています。2R6>=5 あるいは 2R6[5] のように振り足し目標値を指定してください。")
    }, $RerollDice_raiseErroForJudgeRule$9.$$arity = 0);
    return (Opal.def(self, '$checkReRollRule', $RerollDice_checkReRollRule$10 = function $$checkReRollRule(dice_max, signOfInequality, diff) {
      var $a, self = this, valid = nil, $case = nil;

      
      valid = true;
      $case = signOfInequality;
      if ("<="['$===']($case)) {if ($truthy($rb_ge(diff, dice_max))) {
        valid = false}}
      else if (">="['$===']($case)) {if ($truthy($rb_le(diff, 1))) {
        valid = false}}
      else if ("<>"['$===']($case)) {if ($truthy(($truthy($a = $rb_gt(diff, dice_max)) ? $a : $rb_lt(diff, 1)))) {
        valid = false}}
      else if ("<"['$===']($case)) {if ($truthy($rb_gt(diff, dice_max))) {
        valid = false}}
      else if (">"['$===']($case)) {if ($truthy($rb_lt(diff, 1))) {
        valid = false}};
      if ($truthy(valid)) {
        return nil
      } else {
        return self.$raiseErroForJudgeRule()
      };
    }, $RerollDice_checkReRollRule$10.$$arity = 3), nil) && 'checkReRollRule';
  })($nesting[0], null, $nesting)
};

/* Generated by Opal 0.11.99.dev */
Opal.modules["bcdiceCore"] = function(Opal) {
  function $rb_lt(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs < rhs : lhs['$<'](rhs);
  }
  function $rb_minus(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs - rhs : lhs['$-'](rhs);
  }
  function $rb_plus(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs + rhs : lhs['$+'](rhs);
  }
  function $rb_gt(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs > rhs : lhs['$>'](rhs);
  }
  function $rb_divide(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs / rhs : lhs['$/'](rhs);
  }
  function $rb_le(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs <= rhs : lhs['$<='](rhs);
  }
  function $rb_ge(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs >= rhs : lhs['$>='](rhs);
  }
  function $rb_times(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs * rhs : lhs['$*'](rhs);
  }
  var $decode$1, $encode$2, $a, self = Opal.top, $nesting = [], nil = Opal.nil, $$$ = Opal.const_get_qualified, $$ = Opal.const_get_relative, $breaker = Opal.breaker, $slice = Opal.slice, $gvars = Opal.gvars, $truthy = Opal.truthy, $hash2 = Opal.hash2, $klass = Opal.klass, $send = Opal.send;

  Opal.add_stubs(['$require', '$kconv', '$<', '$===', '$new', '$initValues', '$attr_accessor', '$attr_reader', '$setDiceBot', '$setBcDice', '$setDir', '$gameType', '$nil?', '$bcdice=', '$-', '$diceBot=', '$readExtraCard', '$first', '$split', '$debug', '$parren_killer', '$upcase', '$recieveMessageCatched', '$printErrorMessage', '$sendMessageToOnlySender', '$+', '$to_s', '$join', '$setTnick', '$match', '$setCommand', '$[]', '$executePointCounter', '$addPlot', '$clone', '$quit', '$checkMode', '$printHelp', '$printCardHelp', '$quitFunction', '$sleepForIrc', '$exit', '$call', '$quitFunction=', '$downcase', '$setMaster', '$setGame', '$setDisplayMode', '$setUpplerRollThreshold', '$setRerollLimit', '$setRatingTable', '$setSortMode', '$setCardMode', '$setSpellMode', '$setTapMode', '$readCardSet', '$!=', '$master', '$setMasterWhenMasterAlreadySet', '$setMasterWhenMasterYetSet', '$==', '$setMasterByCurrentMasterOwnself', '$master=', '$sendMessageToChannels', '$setGameByTitle', '$isMaster', '$=~', '$to_i', '$setSendMode', '$sendMode', '$upplerRollThreshold=', '$>', '$upplerRollThreshold', '$rerollLimitCount=', '$rerollLimitCount', '$setSortType', '$sortType', '$getPrintPlotChannel', '$empty?', '$executeCommand', '$countHolder', '$sendMessage', '$addToSecretDiceResult', '$getNick', '$lambda', '$each', '$to_proc', '$each_slice', '$lines', '$getHelpMessage', '$recievePublicMessageCatched', '$setChannelForPlotOrSecretDice', '$printPlot', '$printSecretRoll', '$executePointCounterPublic', '$executeDiceRoll', '$changeMessageOriginal', '$executeCard', '$openSecretRoll', '$setPrintPlotChannel', '$isTalkChannel', '$!', '$dice_command', '$broadmsg', '$setNick', '$rollD66', '$checkAddRoll', '$checkBDice', '$checkRnDice', '$checkUpperRoll', '$checkChoiceCommand', '$getTableDataResult', '$rollDice', '$bdice', '$dice_command_xRn', '$choice_random', '$getTableData', '$getTableIndexDiceValueAndDiceText', '$find', '$rollTableMessageDiceText', '$nick_e', '$roll', '$getD66Infos', '$getD66ValueByMarker', '$/', '$%', '$gsub', '$__last__match__1', '$__last__match__2', '$d66Type', '$isD9', '$<=', '$times', '$loop', '$>=', '$getJackUpValueOnAddRoll', '$rand', '$check_hit', '$push', '$sort_by', '$dice_num', '$randNomal', '$randFromRands', '$shift', '$raise', '$inspect', '$sub', '$marshalSignOfInequality', '$defaultSuccessTarget', '$&', '$getGrichText', '$d66dice', '$getD66', '$getD66Value', '$*', '$getSecretRollMembersHolderKey', '$getSecretDiceResultHolderKey', '$delete', '$addToSecretRollMembersHolder', '$saveSecretDiceResult', '$[]=', '$include?', '$length', '$is_a?', '$getSuccessText', '$check_nDx', '$check_1D100', '$check_1D20', '$check_nD10', '$check_2D6', '$check_nD6', '$rollDiceAddingUp', '$changeRangeTextToNumberText', '$paren_k', '$changeText', '$split_plus_minus', '$paren_k_loop', '$scan', '$last', '$paren_k_calculate_multiple_divide_text', '$paren_k_multi', '$paren_k_devide', '$calculate_multiple_divide', '$fractionType', '$loadDiceBot', '$loadUnknownGame', '$postSet', '$gameName', '$sleep']);
  
  self.$require("log");
  self.$require("configBcDice");
  self.$require("CountHolder");
  self.$require("kconv");
  
  Opal.def(self, '$decode', $decode$1 = function $$decode(code, str) {
    var self = this;

    return str.$kconv(code)
  }, $decode$1.$$arity = 2);
  
  Opal.def(self, '$encode', $encode$2 = function $$encode(code, str) {
    var self = this;

    return $$($nesting, 'Kconv').$kconv(str, code)
  }, $encode$2.$$arity = 2);
  $gvars.RUBY18_WIN = ($truthy($a = $rb_lt($$($nesting, 'RUBY_VERSION'), "1.9")) ? /mswin(?!ce)|mingw|cygwin|bccwin/i['$===']($$($nesting, 'RUBY_PLATFORM')) : $a);
  $gvars.secretRollMembersHolder = $hash2([], {});
  $gvars.secretDiceResultHolder = $hash2([], {});
  $gvars.plotPrintChannels = $hash2([], {});
  $gvars.point_counter = $hash2([], {});
  self.$require("CardTrader");
  self.$require("TableFileData");
  self.$require("diceBot/DiceBot");
  self.$require("diceBot/DiceBotLoader");
  self.$require("diceBot/DiceBotLoaderList");
  self.$require("dice/AddDice");
  self.$require("dice/UpperDice");
  self.$require("dice/RerollDice");
  (function($base, $super, $parent_nesting) {
    var self = $klass($base, $super, 'BCDiceMaker');

    var $nesting = [self].concat($parent_nesting), $BCDiceMaker_initialize$3, $BCDiceMaker_newBcDice$4;

    self.$$prototype.cardTrader = self.$$prototype.diceBot = self.$$prototype.counterInfos = self.$$prototype.tableFileData = nil;
    
    
    Opal.def(self, '$initialize', $BCDiceMaker_initialize$3 = function $$initialize() {
      var self = this;

      
      self.diceBot = $$($nesting, 'DiceBot').$new();
      self.cardTrader = $$($nesting, 'CardTrader').$new();
      self.cardTrader.$initValues();
      self.counterInfos = $hash2([], {});
      self.tableFileData = $$($nesting, 'TableFileData').$new();
      self.master = "";
      return (self.quitFunction = nil);
    }, $BCDiceMaker_initialize$3.$$arity = 0);
    self.$attr_accessor("master");
    self.$attr_accessor("quitFunction");
    self.$attr_accessor("diceBot");
    self.$attr_accessor("diceBotPath");
    return (Opal.def(self, '$newBcDice', $BCDiceMaker_newBcDice$4 = function $$newBcDice() {
      var self = this, bcdice = nil;

      
      bcdice = $$($nesting, 'BCDice').$new(self, self.cardTrader, self.diceBot, self.counterInfos, self.tableFileData);
      return bcdice;
    }, $BCDiceMaker_newBcDice$4.$$arity = 0), nil) && 'newBcDice';
  })($nesting[0], null, $nesting);
  return (function($base, $super, $parent_nesting) {
    var self = $klass($base, $super, 'BCDice');

    var $nesting = [self].concat($parent_nesting), $BCDice_initialize$5, $BCDice_setDir$6, $BCDice_isKeepSecretDice$7, $BCDice_getGameType$8, $BCDice_setDiceBot$9, $BCDice_readExtraCard$10, $BCDice_setIrcClient$11, $BCDice_setMessage$12, $BCDice_getOriginalMessage$13, $BCDice_changeMessageOriginal$14, $BCDice_recieveMessage$15, $BCDice_printErrorMessage$16, $BCDice_recieveMessageCatched$17, $BCDice_quit$18, $BCDice_setQuitFuction$19, $BCDice_setCommand$20, $BCDice_setMaster$21, $BCDice_setMasterWhenMasterAlreadySet$22, $BCDice_setMasterByCurrentMasterOwnself$23, $BCDice_setMasterWhenMasterYetSet$24, $BCDice_setGame$25, $BCDice_isMaster$26, $BCDice_setDisplayMode$27, $BCDice_setUpplerRollThreshold$28, $BCDice_setRerollLimit$29, $BCDice_setRatingTable$30, $BCDice_setSortMode$31, $BCDice_setCardMode$32, $BCDice_setSpellMode$33, $BCDice_setTapMode$34, $BCDice_readCardSet$35, $BCDice_executePointCounter$36, $BCDice_addPlot$37, $BCDice_getPrintPlotChannel$38, $BCDice_checkMode$39, $BCDice_printHelp$40, $BCDice_setChannel$43, $BCDice_recievePublicMessage$44, $BCDice_recievePublicMessageCatched$45, $BCDice_printPlot$46, $BCDice_setChannelForPlotOrSecretDice$48, $BCDice_isTalkChannel$49, $BCDice_printSecretRoll$50, $BCDice_executePointCounterPublic$52, $BCDice_executeDiceRoll$53, $BCDice_setTest$54, $BCDice_executeCard$55, $BCDice_dice_command$56, $BCDice_checkAddRoll$57, $BCDice_checkBDice$58, $BCDice_checkRnDice$59, $BCDice_checkUpperRoll$60, $BCDice_checkChoiceCommand$61, $BCDice_getTableDataResult$62, $BCDice_getTableIndexDiceValueAndDiceText$64, $BCDice_rollTableMessageDiceText$65, $BCDice_roll$67, $BCDice_setRandomValues$71, $BCDice_rand$72, $BCDice_setCollectRandResult$73, $BCDice_getRandResults$74, $BCDice_randNomal$75, $BCDice_randFromRands$76, $BCDice_dice_num$77, $BCDice_bdice$78, $BCDice_isReRollAgain$80, $BCDice_rollD66$81, $BCDice_d66dice$82, $BCDice_getD66Infos$84, $BCDice_getD66ValueByMarker$85, $BCDice_getD66Value$86, $BCDice_getD66$87, $BCDice_openSecretRoll$88, $BCDice_getNick$90, $BCDice_addToSecretDiceResult$91, $BCDice_addToSecretRollMembersHolder$92, $BCDice_getSecretRollMembersHolderKey$93, $BCDice_saveSecretDiceResult$94, $BCDice_getSecretDiceResultHolderKey$95, $BCDice_setPrintPlotChannel$96, $BCDice_choice_random$97, $BCDice_getMarshaledSignOfInequality$98, $BCDice_marshalSignOfInequality$99, $BCDice_check_hit$100, $BCDice_check_suc$101, $BCDice_getSuccessText$102, $BCDice_check_nDx$103, $BCDice_broadmsg$104, $BCDice_sendMessage$105, $BCDice_sendMessageToOnlySender$106, $BCDice_sendMessageToChannels$107, $BCDice_parren_killer$108, $BCDice_rollDiceAddingUp$110, $BCDice_changeRangeTextToNumberText$111, $BCDice_paren_k$112, $BCDice_split_plus_minus$114, $BCDice_paren_k_loop$116, $BCDice_paren_k_calculate_multiple_divide_text$117, $BCDice_paren_k_multi$118, $BCDice_paren_k_devide$119, $BCDice_calculate_multiple_divide$120, $BCDice_setGameByTitle$121, $BCDice_setIrcMode$122, $BCDice_sleepForIrc$123;

    self.$$prototype.cardTrader = self.$$prototype.tableFileData = self.$$prototype.diceBot = self.$$prototype.parent = self.$$prototype.messageOriginal = self.$$prototype.message = self.$$prototype.nick_e = self.$$prototype.tnick = self.$$prototype.ircClient = self.$$prototype.isShortSpell = self.$$prototype.canTapCard = self.$$prototype.messages = self.$$prototype.channel = self.$$prototype.isMessagePrinted = self.$$prototype.counterInfos = self.$$prototype.isTest = self.$$prototype.isKeepSecretDice = self.$$prototype.rands = self.$$prototype.randResults = self.$$prototype.isIrcMode = nil;
    
    Opal.const_set($nesting[0], 'SET_COMMAND_PATTERN', /^set\s+(.+)/i);
    self.$attr_reader("cardTrader");
    
    Opal.def(self, '$initialize', $BCDice_initialize$5 = function $$initialize(parent, cardTrader, diceBot, counterInfos, tableFileData) {
      var self = this;

      
      self.parent = parent;
      self.$setDiceBot(diceBot);
      self.cardTrader = cardTrader;
      self.cardTrader.$setBcDice(self);
      self.counterInfos = counterInfos;
      self.tableFileData = tableFileData;
      self.nick_e = "";
      self.tnick = "";
      self.isMessagePrinted = false;
      self.rands = nil;
      self.isKeepSecretDice = true;
      self.randResults = nil;
      return (self.isIrcMode = true);
    }, $BCDice_initialize$5.$$arity = 5);
    
    Opal.def(self, '$setDir', $BCDice_setDir$6 = function $$setDir(dir, prefix) {
      var self = this;

      return self.tableFileData.$setDir(dir, prefix)
    }, $BCDice_setDir$6.$$arity = 2);
    
    Opal.def(self, '$isKeepSecretDice', $BCDice_isKeepSecretDice$7 = function $$isKeepSecretDice(b) {
      var self = this;

      return (self.isKeepSecretDice = b)
    }, $BCDice_isKeepSecretDice$7.$$arity = 1);
    
    Opal.def(self, '$getGameType', $BCDice_getGameType$8 = function $$getGameType() {
      var self = this;

      return self.diceBot.$gameType()
    }, $BCDice_getGameType$8.$$arity = 0);
    
    Opal.def(self, '$setDiceBot', $BCDice_setDiceBot$9 = function $$setDiceBot(diceBot) {
      var self = this, $writer = nil;

      
      if ($truthy(diceBot['$nil?']())) {
        return nil};
      self.diceBot = diceBot;
      
      $writer = [self];
      $send(self.diceBot, 'bcdice=', Opal.to_a($writer));
      $writer[$rb_minus($writer["length"], 1)];;
      
      $writer = [self.diceBot];
      $send(self.parent, 'diceBot=', Opal.to_a($writer));
      return $writer[$rb_minus($writer["length"], 1)];;
    }, $BCDice_setDiceBot$9.$$arity = 1);
    self.$attr_reader("nick_e");
    
    Opal.def(self, '$readExtraCard', $BCDice_readExtraCard$10 = function $$readExtraCard(cardFileName) {
      var self = this;

      return self.cardTrader.$readExtraCard(cardFileName)
    }, $BCDice_readExtraCard$10.$$arity = 1);
    
    Opal.def(self, '$setIrcClient', $BCDice_setIrcClient$11 = function $$setIrcClient(client) {
      var self = this;

      return (self.ircClient = client)
    }, $BCDice_setIrcClient$11.$$arity = 1);
    
    Opal.def(self, '$setMessage', $BCDice_setMessage$12 = function $$setMessage(message) {
      var self = this, openPattern = nil, messageToSet = nil, $case = nil;
      if ($gvars.OPEN_DICE == null) $gvars.OPEN_DICE = nil;
      if ($gvars.OPEN_PLOT == null) $gvars.OPEN_PLOT = nil;

      
      openPattern = new RegExp("" + "\\A\\s*(?:" + ($gvars.OPEN_DICE) + "|" + ($gvars.OPEN_PLOT) + ")\\s*\\z", 'i');
      messageToSet = (function() {$case = message;
      if (openPattern['$===']($case) || $$($nesting, 'SET_COMMAND_PATTERN')['$===']($case)) {return message}
      else {return message.$split(/\s/, 2).$first()}})();
      self.$debug("setMessage messageToSet", messageToSet);
      self.messageOriginal = self.$parren_killer(messageToSet);
      self.message = self.messageOriginal.$upcase();
      return self.$debug("@message", self.message);
    }, $BCDice_setMessage$12.$$arity = 1);
    
    Opal.def(self, '$getOriginalMessage', $BCDice_getOriginalMessage$13 = function $$getOriginalMessage() {
      var self = this;

      return self.messageOriginal
    }, $BCDice_getOriginalMessage$13.$$arity = 0);
    
    Opal.def(self, '$changeMessageOriginal', $BCDice_changeMessageOriginal$14 = function $$changeMessageOriginal() {
      var self = this;

      return (self.message = self.messageOriginal)
    }, $BCDice_changeMessageOriginal$14.$$arity = 0);
    
    Opal.def(self, '$recieveMessage', $BCDice_recieveMessage$15 = function $$recieveMessage(nick_e, tnick) {
      var self = this, e = nil;

      try {
        return self.$recieveMessageCatched(nick_e, tnick)
      } catch ($err) {
        if (Opal.rescue($err, [$$($nesting, 'StandardError')])) {e = $err;
          try {
            return self.$printErrorMessage(e)
          } finally { Opal.pop_exception() }
        } else { throw $err; }
      }
    }, $BCDice_recieveMessage$15.$$arity = 2);
    
    Opal.def(self, '$printErrorMessage', $BCDice_printErrorMessage$16 = function $$printErrorMessage(e) {
      var self = this;

      return self.$sendMessageToOnlySender($rb_plus($rb_plus("error ", e.$to_s()), [].$join("\n")))
    }, $BCDice_printErrorMessage$16.$$arity = 1);
    
    Opal.def(self, '$recieveMessageCatched', $BCDice_recieveMessageCatched$17 = function $$recieveMessageCatched(nick_e, tnick) {
      var $a, self = this, setMatches = nil, $case = nil, __last__match__1 = nil, __last__match__2 = nil, __last__match__3 = nil, __last__match__4 = nil, __last__match__5 = nil, __last__match__6 = nil, __last__match__7 = nil, __last__match__8 = nil, __last__match__9 = nil, __last__match__10 = nil, __last__match__11 = nil, __last__match__12 = nil, __last__match__13 = nil, __last__match__14 = nil, __last__match__15 = nil, __last__match__16 = nil, __last__match__17 = nil, __last__match__18 = nil, __last__match__19 = nil, __last__match__20 = nil;
      if ($gvars.quitCommand == null) $gvars.quitCommand = nil;

      
      self.$debug("recieveMessage nick_e, tnick", nick_e, tnick);
      self.nick_e = nick_e;
      self.cardTrader.$setTnick(self.nick_e);
      self.tnick = tnick;
      self.cardTrader.$setTnick(self.tnick);
      self.$debug("@nick_e, @tnick", self.nick_e, self.tnick);
      setMatches = self.message.$match($$($nesting, 'SET_COMMAND_PATTERN'));
      if ($truthy(setMatches)) {
        
        self.$setCommand(setMatches['$[]'](1));
        return nil;};
      self.$executePointCounter();
      self.$addPlot(self.messageOriginal.$clone());
      return (function() {$case = self.message;
      if ($gvars.quitCommand['$===']($case)) {return self.$quit()}
      else if (/^mode$/i['$===']($case)) {
      __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
      __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
      __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
      __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
      __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
      __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
      __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
      __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
      __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
      __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
      __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
      __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
      __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
      __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
      __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
      __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
      __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
      __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
      __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
      __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
      return self.$checkMode();}
      else if (/^help$/i['$===']($case)) {
      __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
      __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
      __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
      __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
      __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
      __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
      __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
      __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
      __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
      __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
      __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
      __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
      __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
      __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
      __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
      __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
      __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
      __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
      __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
      __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
      return self.$printHelp();}
      else if (/^c-help$/i['$===']($case)) {
      __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
      __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
      __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
      __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
      __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
      __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
      __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
      __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
      __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
      __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
      __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
      __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
      __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
      __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
      __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
      __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
      __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
      __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
      __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
      __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
      return self.cardTrader.$printCardHelp();}
      else { return nil }})();
    }, $BCDice_recieveMessageCatched$17.$$arity = 2);
    
    Opal.def(self, '$quit', $BCDice_quit$18 = function $$quit() {
      var self = this;

      
      self.ircClient.$quit();
      if ($truthy(self.parent.$quitFunction()['$nil?']())) {
        
        self.$sleepForIrc(3);
        return self.$exit(0);
      } else {
        return self.parent.$quitFunction().$call()
      };
    }, $BCDice_quit$18.$$arity = 0);
    
    Opal.def(self, '$setQuitFuction', $BCDice_setQuitFuction$19 = function $$setQuitFuction(func) {
      var self = this, $writer = nil;

      
      $writer = [func];
      $send(self.parent, 'quitFunction=', Opal.to_a($writer));
      return $writer[$rb_minus($writer["length"], 1)];
    }, $BCDice_setQuitFuction$19.$$arity = 1);
    
    Opal.def(self, '$setCommand', $BCDice_setCommand$20 = function $$setCommand(arg) {
      var $a, self = this, $case = nil, __last__match__1 = nil, __last__match__2 = nil, __last__match__3 = nil, __last__match__4 = nil, __last__match__5 = nil, __last__match__6 = nil, __last__match__7 = nil, __last__match__8 = nil, __last__match__9 = nil, __last__match__10 = nil, __last__match__11 = nil, __last__match__12 = nil, __last__match__13 = nil, __last__match__14 = nil, __last__match__15 = nil, __last__match__16 = nil, __last__match__17 = nil, __last__match__18 = nil, __last__match__19 = nil, __last__match__20 = nil;

      
      self.$debug("setCommand arg", arg);
      return (function() {$case = arg.$downcase();
      if ("master"['$===']($case)) {return self.$setMaster()}
      else if ("game"['$===']($case)) {return self.$setGame()}
      else if (/^v(?:iew\s*)?mode$/['$===']($case)) {
      __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
      __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
      __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
      __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
      __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
      __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
      __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
      __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
      __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
      __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
      __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
      __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
      __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
      __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
      __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
      __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
      __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
      __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
      __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
      __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
      return self.$setDisplayMode();}
      else if ("upper"['$===']($case)) {return self.$setUpplerRollThreshold()}
      else if ("reroll"['$===']($case)) {return self.$setRerollLimit()}
      else if (/^r(?:ating\s*)?t(?:able)?$/['$===']($case)) {
      __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
      __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
      __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
      __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
      __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
      __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
      __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
      __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
      __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
      __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
      __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
      __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
      __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
      __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
      __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
      __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
      __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
      __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
      __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
      __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
      return self.$setRatingTable();}
      else if ("sort"['$===']($case)) {return self.$setSortMode()}
      else if ("cardplace"['$===']($case) || "cp"['$===']($case)) {return self.$setCardMode()}
      else if ("shortspell"['$===']($case) || "ss"['$===']($case)) {return self.$setSpellMode()}
      else if ("tap"['$===']($case)) {return self.$setTapMode()}
      else if ("cardset"['$===']($case) || "cs"['$===']($case)) {return self.$readCardSet()}
      else { return nil }})();
    }, $BCDice_setCommand$20.$$arity = 1);
    
    Opal.def(self, '$setMaster', $BCDice_setMaster$21 = function $$setMaster() {
      var self = this;

      if ($truthy(self.parent.$master()['$!='](""))) {
        return self.$setMasterWhenMasterAlreadySet()
      } else {
        return self.$setMasterWhenMasterYetSet()
      }
    }, $BCDice_setMaster$21.$$arity = 0);
    
    Opal.def(self, '$setMasterWhenMasterAlreadySet', $BCDice_setMasterWhenMasterAlreadySet$22 = function $$setMasterWhenMasterAlreadySet() {
      var self = this;

      if ($truthy(self.nick_e['$=='](self.parent.$master()))) {
        return self.$setMasterByCurrentMasterOwnself()
      } else {
        return self.$sendMessageToOnlySender("" + "Masterは" + (self.parent.$master()) + "さんになっています")
      }
    }, $BCDice_setMasterWhenMasterAlreadySet$22.$$arity = 0);
    
    Opal.def(self, '$setMasterByCurrentMasterOwnself', $BCDice_setMasterByCurrentMasterOwnself$23 = function $$setMasterByCurrentMasterOwnself() {
      var self = this, $writer = nil;

      if ($truthy(self.tnick['$!='](""))) {
        
        
        $writer = [self.tnick];
        $send(self.parent, 'master=', Opal.to_a($writer));
        $writer[$rb_minus($writer["length"], 1)];;
        return self.$sendMessageToChannels("" + (self.parent.$master()) + "さんをMasterに設定しました");
      } else {
        
        
        $writer = [""];
        $send(self.parent, 'master=', Opal.to_a($writer));
        $writer[$rb_minus($writer["length"], 1)];;
        return self.$sendMessageToChannels("Master設定を解除しました");
      }
    }, $BCDice_setMasterByCurrentMasterOwnself$23.$$arity = 0);
    
    Opal.def(self, '$setMasterWhenMasterYetSet', $BCDice_setMasterWhenMasterYetSet$24 = function $$setMasterWhenMasterYetSet() {
      var self = this, $writer = nil;

      
      if ($truthy(self.tnick['$!='](""))) {
        
        $writer = [self.tnick];
        $send(self.parent, 'master=', Opal.to_a($writer));
        $writer[$rb_minus($writer["length"], 1)];
      } else {
        
        $writer = [self.nick_e];
        $send(self.parent, 'master=', Opal.to_a($writer));
        $writer[$rb_minus($writer["length"], 1)];
      };
      return self.$sendMessageToChannels("" + (self.parent.$master()) + "さんをMasterに設定しました");
    }, $BCDice_setMasterWhenMasterYetSet$24.$$arity = 0);
    
    Opal.def(self, '$setGame', $BCDice_setGame$25 = function $$setGame() {
      var self = this, messages = nil;

      
      messages = self.$setGameByTitle(self.tnick);
      return self.$sendMessageToChannels(messages);
    }, $BCDice_setGame$25.$$arity = 0);
    
    Opal.def(self, '$isMaster', $BCDice_isMaster$26 = function $$isMaster() {
      var $a, self = this;

      return ($truthy($a = self.nick_e['$=='](self.parent.$master())) ? $a : self.parent.$master()['$=='](""))
    }, $BCDice_isMaster$26.$$arity = 0);
    
    Opal.def(self, '$setDisplayMode', $BCDice_setDisplayMode$27 = function $$setDisplayMode() {
      var $a, self = this, __last__match__1 = nil, __last__match__2 = nil, __last__match__3 = nil, __last__match__4 = nil, __last__match__5 = nil, __last__match__6 = nil, __last__match__7 = nil, __last__match__8 = nil, __last__match__9 = nil, __last__match__10 = nil, __last__match__11 = nil, __last__match__12 = nil, __last__match__13 = nil, __last__match__14 = nil, __last__match__15 = nil, __last__match__16 = nil, __last__match__17 = nil, __last__match__18 = nil, __last__match__19 = nil, __last__match__20 = nil, mode = nil;

      
      if ($truthy(self.$isMaster())) {
      } else {
        return nil
      };
      if ($truthy(/(\d+)/['$=~'](self.tnick))) {
      } else {
        return nil
      };
      __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
      __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
      __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
      __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
      __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
      __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
      __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
      __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
      __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
      __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
      __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
      __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
      __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
      __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
      __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
      __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
      __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
      __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
      __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
      __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
      mode = __last__match__1.$to_i();
      self.diceBot.$setSendMode(mode);
      return self.$sendMessageToChannels("" + "ViewMode" + (self.diceBot.$sendMode()) + "に変更しました");
    }, $BCDice_setDisplayMode$27.$$arity = 0);
    
    Opal.def(self, '$setUpplerRollThreshold', $BCDice_setUpplerRollThreshold$28 = function $$setUpplerRollThreshold() {
      var $a, self = this, __last__match__1 = nil, __last__match__2 = nil, __last__match__3 = nil, __last__match__4 = nil, __last__match__5 = nil, __last__match__6 = nil, __last__match__7 = nil, __last__match__8 = nil, __last__match__9 = nil, __last__match__10 = nil, __last__match__11 = nil, __last__match__12 = nil, __last__match__13 = nil, __last__match__14 = nil, __last__match__15 = nil, __last__match__16 = nil, __last__match__17 = nil, __last__match__18 = nil, __last__match__19 = nil, __last__match__20 = nil, $writer = nil;

      
      if ($truthy(self.$isMaster())) {
      } else {
        return nil
      };
      if ($truthy(/(\d+)/['$=~'](self.tnick))) {
      } else {
        return nil
      };
      __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
      __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
      __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
      __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
      __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
      __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
      __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
      __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
      __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
      __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
      __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
      __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
      __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
      __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
      __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
      __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
      __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
      __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
      __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
      __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
      
      $writer = [__last__match__1.$to_i()];
      $send(self.diceBot, 'upplerRollThreshold=', Opal.to_a($writer));
      $writer[$rb_minus($writer["length"], 1)];;
      if ($truthy($rb_gt(self.diceBot.$upplerRollThreshold(), 0))) {
        return self.$sendMessageToChannels("" + "上方無限ロールを" + (self.diceBot.$upplerRollThreshold()) + "以上に設定しました")
      } else {
        return self.$sendMessageToChannels("上方無限ロールの閾値設定を解除しました")
      };
    }, $BCDice_setUpplerRollThreshold$28.$$arity = 0);
    
    Opal.def(self, '$setRerollLimit', $BCDice_setRerollLimit$29 = function $$setRerollLimit() {
      var $a, self = this, __last__match__1 = nil, __last__match__2 = nil, __last__match__3 = nil, __last__match__4 = nil, __last__match__5 = nil, __last__match__6 = nil, __last__match__7 = nil, __last__match__8 = nil, __last__match__9 = nil, __last__match__10 = nil, __last__match__11 = nil, __last__match__12 = nil, __last__match__13 = nil, __last__match__14 = nil, __last__match__15 = nil, __last__match__16 = nil, __last__match__17 = nil, __last__match__18 = nil, __last__match__19 = nil, __last__match__20 = nil, $writer = nil;

      
      if ($truthy(self.$isMaster())) {
      } else {
        return nil
      };
      if ($truthy(/(\d+)/['$=~'](self.tnick))) {
      } else {
        return nil
      };
      __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
      __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
      __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
      __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
      __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
      __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
      __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
      __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
      __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
      __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
      __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
      __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
      __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
      __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
      __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
      __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
      __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
      __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
      __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
      __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
      
      $writer = [__last__match__1.$to_i()];
      $send(self.diceBot, 'rerollLimitCount=', Opal.to_a($writer));
      $writer[$rb_minus($writer["length"], 1)];;
      if ($truthy($rb_gt(self.diceBot.$rerollLimitCount(), 0))) {
        return self.$sendMessageToChannels("" + "個数振り足しロール回数を" + (self.diceBot.$rerollLimitCount()) + "以下に設定しました")
      } else {
        return self.$sendMessageToChannels("個数振り足しロールの回数を無限に設定しました")
      };
    }, $BCDice_setRerollLimit$29.$$arity = 0);
    
    Opal.def(self, '$setRatingTable', $BCDice_setRatingTable$30 = function $$setRatingTable() {
      var self = this, output = nil;

      
      if ($truthy(self.$isMaster())) {
      } else {
        return nil
      };
      output = self.diceBot.$setRatingTable(self.tnick);
      if ($truthy(output['$==']("1"))) {
        return nil};
      return self.$sendMessageToChannels(output);
    }, $BCDice_setRatingTable$30.$$arity = 0);
    
    Opal.def(self, '$setSortMode', $BCDice_setSortMode$31 = function $$setSortMode() {
      var $a, self = this, __last__match__1 = nil, __last__match__2 = nil, __last__match__3 = nil, __last__match__4 = nil, __last__match__5 = nil, __last__match__6 = nil, __last__match__7 = nil, __last__match__8 = nil, __last__match__9 = nil, __last__match__10 = nil, __last__match__11 = nil, __last__match__12 = nil, __last__match__13 = nil, __last__match__14 = nil, __last__match__15 = nil, __last__match__16 = nil, __last__match__17 = nil, __last__match__18 = nil, __last__match__19 = nil, __last__match__20 = nil, sortType = nil;

      
      if ($truthy(self.$isMaster())) {
      } else {
        return nil
      };
      if ($truthy(/(\d+)/['$=~'](self.tnick))) {
      } else {
        return nil
      };
      __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
      __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
      __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
      __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
      __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
      __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
      __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
      __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
      __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
      __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
      __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
      __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
      __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
      __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
      __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
      __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
      __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
      __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
      __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
      __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
      sortType = __last__match__1.$to_i();
      self.diceBot.$setSortType(sortType);
      if ($truthy(self.diceBot.$sortType()['$!='](0))) {
        return self.$sendMessageToChannels("ソート有りに変更しました")
      } else {
        return self.$sendMessageToChannels("ソート無しに変更しました")
      };
    }, $BCDice_setSortMode$31.$$arity = 0);
    
    Opal.def(self, '$setCardMode', $BCDice_setCardMode$32 = function $$setCardMode() {
      var self = this;

      
      if ($truthy(self.$isMaster())) {
      } else {
        return nil
      };
      return self.cardTrader.$setCardMode();
    }, $BCDice_setCardMode$32.$$arity = 0);
    
    Opal.def(self, '$setSpellMode', $BCDice_setSpellMode$33 = function $$setSpellMode() {
      var $a, self = this, __last__match__1 = nil, __last__match__2 = nil, __last__match__3 = nil, __last__match__4 = nil, __last__match__5 = nil, __last__match__6 = nil, __last__match__7 = nil, __last__match__8 = nil, __last__match__9 = nil, __last__match__10 = nil, __last__match__11 = nil, __last__match__12 = nil, __last__match__13 = nil, __last__match__14 = nil, __last__match__15 = nil, __last__match__16 = nil, __last__match__17 = nil, __last__match__18 = nil, __last__match__19 = nil, __last__match__20 = nil;

      
      if ($truthy(self.$isMaster())) {
      } else {
        return nil
      };
      if ($truthy(/(\d+)/['$=~'](self.tnick))) {
      } else {
        return nil
      };
      __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
      __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
      __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
      __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
      __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
      __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
      __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
      __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
      __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
      __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
      __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
      __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
      __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
      __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
      __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
      __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
      __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
      __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
      __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
      __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
      self.isShortSpell = __last__match__1.$to_i()['$!='](0);
      if ($truthy(self.isShortSpell)) {
        return self.$sendMessageToChannels("短い呪文モードに変更しました")
      } else {
        return self.$sendMessageToChannels("通常呪文モードに変更しました")
      };
    }, $BCDice_setSpellMode$33.$$arity = 0);
    
    Opal.def(self, '$setTapMode', $BCDice_setTapMode$34 = function $$setTapMode() {
      var $a, self = this, __last__match__1 = nil, __last__match__2 = nil, __last__match__3 = nil, __last__match__4 = nil, __last__match__5 = nil, __last__match__6 = nil, __last__match__7 = nil, __last__match__8 = nil, __last__match__9 = nil, __last__match__10 = nil, __last__match__11 = nil, __last__match__12 = nil, __last__match__13 = nil, __last__match__14 = nil, __last__match__15 = nil, __last__match__16 = nil, __last__match__17 = nil, __last__match__18 = nil, __last__match__19 = nil, __last__match__20 = nil;

      
      if ($truthy(self.$isMaster())) {
      } else {
        return nil
      };
      if ($truthy(/(\d+)/['$=~'](self.tnick))) {
      } else {
        return nil
      };
      __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
      __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
      __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
      __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
      __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
      __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
      __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
      __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
      __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
      __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
      __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
      __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
      __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
      __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
      __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
      __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
      __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
      __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
      __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
      __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
      self.canTapCard = __last__match__1.$to_i()['$!='](0);
      if ($truthy(self.canTapCard)) {
        return self.$sendMessageToChannels("タップ可能モードに変更しました")
      } else {
        return self.$sendMessageToChannels("タップ不可モードに変更しました")
      };
    }, $BCDice_setTapMode$34.$$arity = 0);
    
    Opal.def(self, '$readCardSet', $BCDice_readCardSet$35 = function $$readCardSet() {
      var self = this;

      
      if ($truthy(self.$isMaster())) {
      } else {
        return nil
      };
      return self.cardTrader.$readCardSet();
    }, $BCDice_readCardSet$35.$$arity = 0);
    
    Opal.def(self, '$executePointCounter', $BCDice_executePointCounter$36 = function $$executePointCounter() {
      var $a, $b, self = this, arg = nil, __last__match__1 = nil, __last__match__2 = nil, __last__match__3 = nil, __last__match__4 = nil, __last__match__5 = nil, __last__match__6 = nil, __last__match__7 = nil, __last__match__8 = nil, __last__match__9 = nil, __last__match__10 = nil, __last__match__11 = nil, __last__match__12 = nil, __last__match__13 = nil, __last__match__14 = nil, __last__match__15 = nil, __last__match__16 = nil, __last__match__17 = nil, __last__match__18 = nil, __last__match__19 = nil, __last__match__20 = nil, channel = nil, pointerMode = nil, output = nil, $case = nil;

      
      arg = self.messages;
      self.$debug("executePointCounter arg", arg);
      if ($truthy(arg['$=~'](/^#/))) {
      } else {
        
        __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
        __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
        __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
        __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
        __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
        __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
        __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
        __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
        __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
        __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
        __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
        __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
        __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
        __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
        __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
        __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
        __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
        __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
        __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
        __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
        __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
        __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
        __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
        __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
        __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
        __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
        __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
        __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
        __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
        __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
        __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
        __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
        __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
        __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
        __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
        __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
        __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
        __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
        __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
        __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
        self.$debug("executePointCounter is NOT matched");
        return nil;
      };
      __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
      __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
      __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
      __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
      __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
      __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
      __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
      __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
      __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
      __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
      __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
      __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
      __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
      __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
      __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
      __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
      __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
      __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
      __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
      __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
      channel = self.$getPrintPlotChannel(self.nick_e);
      self.$debug("getPrintPlotChannel get channel", channel);
      if ($truthy(channel['$==']("1"))) {
        
        self.$sendMessageToOnlySender("表示チャンネルが登録されていません");
        return nil;};
      if ($truthy(self.tnick['$empty?']())) {
      } else {
        arg = $rb_plus(arg, "" + "->" + (self.tnick))
      };
      pointerMode = "sameNick";
      $b = self.$countHolder().$executeCommand(arg, self.nick_e, channel, pointerMode), $a = Opal.to_ary($b), (output = ($a[0] == null ? nil : $a[0])), (pointerMode = ($a[1] == null ? nil : $a[1])), $b;
      self.$debug("point_counter_command called, line", 762);
      self.$debug("output", output);
      self.$debug("pointerMode", pointerMode);
      if ($truthy(output['$==']("1"))) {
        
        self.$debug("executePointCounter point_counter_command output is \"1\"");
        return nil;};
      $case = pointerMode;
      if ("sameNick"['$===']($case)) {
      self.$debug("executePointCounter:Talkで返事");
      self.$sendMessageToOnlySender(output);}
      else if ("sameChannel"['$===']($case)) {
      self.$debug("executePointCounter:publicで返事");
      self.$sendMessage(channel, output);};
      return self.$debug("executePointCounter end");
    }, $BCDice_executePointCounter$36.$$arity = 0);
    
    Opal.def(self, '$addPlot', $BCDice_addPlot$37 = function $$addPlot(arg) {
      var $a, self = this, __last__match__1 = nil, __last__match__2 = nil, __last__match__3 = nil, __last__match__4 = nil, __last__match__5 = nil, __last__match__6 = nil, __last__match__7 = nil, __last__match__8 = nil, __last__match__9 = nil, __last__match__10 = nil, __last__match__11 = nil, __last__match__12 = nil, __last__match__13 = nil, __last__match__14 = nil, __last__match__15 = nil, __last__match__16 = nil, __last__match__17 = nil, __last__match__18 = nil, __last__match__19 = nil, __last__match__20 = nil, plot = nil, channel = nil;
      if ($gvars.ADD_PLOT == null) $gvars.ADD_PLOT = nil;

      
      self.$debug("addPlot begin arg", arg);
      if ($truthy(new RegExp("" + ($gvars.ADD_PLOT) + "[:：](.+)", 'i')['$=~'](arg))) {
      } else {
        
        self.$debug("addPlot exit");
        return nil;
      };
      __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
      __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
      __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
      __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
      __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
      __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
      __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
      __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
      __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
      __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
      __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
      __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
      __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
      __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
      __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
      __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
      __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
      __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
      __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
      __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
      plot = __last__match__1;
      channel = self.$getPrintPlotChannel(self.nick_e);
      self.$debug("addPlot channel", channel);
      if ($truthy(channel['$nil?']())) {
        
        self.$debug("channel.nil?");
        return self.$sendMessageToOnlySender("プロット出力先が登録されていません");
      } else {
        
        self.$debug("addToSecretDiceResult calling...");
        self.$addToSecretDiceResult(plot, channel, 1);
        return self.$sendMessage(channel, "" + (self.nick_e) + " さんがプロットしました");
      };
    }, $BCDice_addPlot$37.$$arity = 1);
    
    Opal.def(self, '$getPrintPlotChannel', $BCDice_getPrintPlotChannel$38 = function $$getPrintPlotChannel(nick) {
      var self = this;
      if ($gvars.plotPrintChannels == null) $gvars.plotPrintChannels = nil;

      
      nick = self.$getNick(nick);
      return $gvars.plotPrintChannels['$[]'](nick);
    }, $BCDice_getPrintPlotChannel$38.$$arity = 1);
    
    Opal.def(self, '$checkMode', $BCDice_checkMode$39 = function $$checkMode() {
      var self = this, output = nil;

      
      if ($truthy(self.$isMaster())) {
      } else {
        return nil
      };
      output = $rb_plus($rb_plus($rb_plus($rb_plus($rb_plus("GameType = ", self.diceBot.$gameType()), ", ViewMode = "), self.diceBot.$sendMode()), ", Sort = "), self.diceBot.$sortType());
      return self.$sendMessageToOnlySender(output);
    }, $BCDice_checkMode$39.$$arity = 0);
    
    Opal.def(self, '$printHelp', $BCDice_printHelp$40 = function $$printHelp() {
      var $$41, $$42, self = this, send_to_sender = nil;
      if ($gvars.OPEN_DICE == null) $gvars.OPEN_DICE = nil;
      if ($gvars.OPEN_PLOT == null) $gvars.OPEN_PLOT = nil;
      if ($gvars.ADD_PLOT == null) $gvars.ADD_PLOT = nil;
      if ($gvars.READY_CMD == null) $gvars.READY_CMD = nil;

      
      send_to_sender = $send(self, 'lambda', [], ($$41 = function(message){var self = $$41.$$s || this;

      
        
        if (message == null) {
          message = nil;
        };
        return self.$sendMessageToOnlySender(message);}, $$41.$$s = self, $$41.$$arity = 1, $$41));
      $send(["・加算ロール　　　　　　　　(xDn) (n面体ダイスをx個)", "・バラバラロール　　　　　　(xBn)", "・個数振り足しロール　　　　(xRn[振り足し値])", "・上方無限ロール　　　　　　(xUn[境界値])", "・シークレットロール　　　　(Sダイスコマンド)", "" + "・シークレットをオープンする(" + ($gvars.OPEN_DICE) + ")", "・四則計算(端数切捨て)　　　(C(式))"], 'each', [], send_to_sender.$to_proc());
      self.$sleepForIrc(2);
      $send(self.diceBot.$getHelpMessage().$lines(), 'each_slice', [5], ($$42 = function(lines){var self = $$42.$$s || this;

      
        
        if (lines == null) {
          lines = nil;
        };
        $send(lines, 'each', [], send_to_sender.$to_proc());
        return self.$sleepForIrc(1);}, $$42.$$s = self, $$42.$$arity = 1, $$42));
      self.$sendMessageToOnlySender("  ---");
      self.$sleepForIrc(1);
      $send(["" + "・プロット表示　　　　　　　　(" + ($gvars.OPEN_PLOT) + ")", "" + "・プロット記録　　　　　　　　(Talkで " + ($gvars.ADD_PLOT) + ":プロット)", "  ---"], 'each', [], send_to_sender.$to_proc());
      self.$sleepForIrc(2);
      $send(["・ポイントカウンタ値登録　　　(#[名前:]タグn[/m]) (識別名、最大値省略可,Talk可)", "・カウンタ値操作　　　　　　　(#[名前:]タグ+n) (もちろん-nもOK,Talk可)", "・識別名変更　　　　　　　　　(#RENAME!名前1->名前2) (Talk可)"], 'each', [], send_to_sender.$to_proc());
      self.$sleepForIrc(1);
      $send(["・同一タグのカウンタ値一覧　　(#OPEN!タグ)", "・自キャラのカウンタ値一覧　　(Talkで#OPEN![タグ]) (全カウンタ表示時、タグ省略)", "・自キャラのカウンタ削除　　　(#[名前:]DIED!) (デフォルト時、識別名省略)", "・全自キャラのカウンタ削除　　(#ALL!:DIED!)", "" + "・カウンタ表示チャンネル登録　(" + ($gvars.READY_CMD) + ")", "  ---"], 'each', [], send_to_sender.$to_proc());
      self.$sleepForIrc(2);
      self.$sendMessageToOnlySender("・カード機能ヘルプ　　　　　　(c-help)");
      return self.$sendMessageToOnlySender("  -- END ---");
    }, $BCDice_printHelp$40.$$arity = 0);
    
    Opal.def(self, '$setChannel', $BCDice_setChannel$43 = function $$setChannel(channel) {
      var self = this;

      
      self.$debug("setChannel called channel", channel);
      return (self.channel = channel);
    }, $BCDice_setChannel$43.$$arity = 1);
    
    Opal.def(self, '$recievePublicMessage', $BCDice_recievePublicMessage$44 = function $$recievePublicMessage(nick_e) {
      var self = this, e = nil;

      try {
        return self.$recievePublicMessageCatched(nick_e)
      } catch ($err) {
        if (Opal.rescue($err, [$$($nesting, 'StandardError')])) {e = $err;
          try {
            return self.$printErrorMessage(e)
          } finally { Opal.pop_exception() }
        } else { throw $err; }
      }
    }, $BCDice_recievePublicMessage$44.$$arity = 1);
    
    Opal.def(self, '$recievePublicMessageCatched', $BCDice_recievePublicMessageCatched$45 = function $$recievePublicMessageCatched(nick_e) {
      var $a, self = this, mynick = nil, secret = nil, __last__match__1 = nil, __last__match__2 = nil, __last__match__3 = nil, __last__match__4 = nil, __last__match__5 = nil, __last__match__6 = nil, __last__match__7 = nil, __last__match__8 = nil, __last__match__9 = nil, __last__match__10 = nil, __last__match__11 = nil, __last__match__12 = nil, __last__match__13 = nil, __last__match__14 = nil, __last__match__15 = nil, __last__match__16 = nil, __last__match__17 = nil, __last__match__18 = nil, __last__match__19 = nil, __last__match__20 = nil, output = nil;
      if ($gvars.OPEN_PLOT == null) $gvars.OPEN_PLOT = nil;
      if ($gvars.OPEN_DICE == null) $gvars.OPEN_DICE = nil;

      
      self.$debug("recievePublicMessageCatched begin nick_e", nick_e);
      self.$debug("recievePublicMessageCatched @channel", self.channel);
      self.$debug("recievePublicMessageCatched @message", self.message);
      self.nick_e = nick_e;
      mynick = "";
      secret = false;
      self.$setChannelForPlotOrSecretDice();
      if ($truthy(new RegExp("" + "(^|\\s+)" + ($gvars.OPEN_PLOT) + "(\\s+|$)", 'i')['$=~'](self.message))) {
        
        __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
        __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
        __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
        __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
        __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
        __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
        __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
        __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
        __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
        __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
        __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
        __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
        __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
        __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
        __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
        __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
        __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
        __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
        __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
        __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
        self.$debug("print plot", self.message);
        self.$printPlot();};
      if ($truthy(new RegExp("" + "(^|\\s+)" + ($gvars.OPEN_DICE) + "(\\s+|$)", 'i')['$=~'](self.message))) {
        
        __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
        __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
        __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
        __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
        __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
        __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
        __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
        __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
        __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
        __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
        __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
        __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
        __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
        __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
        __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
        __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
        __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
        __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
        __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
        __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
        self.$debug("print secret roll", self.message);
        self.$printSecretRoll();};
      self.$executePointCounterPublic();
      self.$executeDiceRoll();
      if ($truthy(/(^|\s)C([-\d]+)\s*$/i['$=~'](self.message))) {
        
        __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
        __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
        __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
        __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
        __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
        __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
        __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
        __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
        __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
        __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
        __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
        __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
        __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
        __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
        __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
        __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
        __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
        __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
        __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
        __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
        output = __last__match__2;
        if ($truthy(output['$!='](""))) {
          self.$sendMessage(self.channel, "" + (self.nick_e) + ": 計算結果 ＞ " + (output))};};
      self.$changeMessageOriginal();
      self.$executeCard();
      if ($truthy(self.isMessagePrinted)) {};
      return self.$debug("\non_public end");
    }, $BCDice_recievePublicMessageCatched$45.$$arity = 1);
    
    Opal.def(self, '$printPlot', $BCDice_printPlot$46 = function $$printPlot() {
      var $$47, self = this, messageList = nil;

      
      self.$debug("printPlot begin");
      messageList = self.$openSecretRoll(self.channel, 1);
      self.$debug("messageList", messageList);
      return $send(messageList, 'each', [], ($$47 = function(message){var self = $$47.$$s || this;
        if (self.channel == null) self.channel = nil;

      
        
        if (message == null) {
          message = nil;
        };
        if ($truthy(message['$empty?']())) {
          
          self.$debug("message is empty");
          return self.$setPrintPlotChannel();
        } else {
          
          self.$debug("message", message);
          self.$sendMessage(self.channel, message);
          return self.$sleepForIrc(1);
        };}, $$47.$$s = self, $$47.$$arity = 1, $$47));
    }, $BCDice_printPlot$46.$$arity = 0);
    
    Opal.def(self, '$setChannelForPlotOrSecretDice', $BCDice_setChannelForPlotOrSecretDice$48 = function $$setChannelForPlotOrSecretDice() {
      var self = this, channel = nil;

      
      self.$debug("setChannelForPlotOrSecretDice Begin");
      if ($truthy(self.$isTalkChannel())) {
        return nil};
      channel = self.$getPrintPlotChannel(self.nick_e);
      if ($truthy(channel['$nil?']())) {
        return self.$setPrintPlotChannel()
      } else {
        return nil
      };
    }, $BCDice_setChannelForPlotOrSecretDice$48.$$arity = 0);
    
    Opal.def(self, '$isTalkChannel', $BCDice_isTalkChannel$49 = function $$isTalkChannel() {
      var self = this;

      return /^#/['$==='](self.channel)['$!']()
    }, $BCDice_isTalkChannel$49.$$arity = 0);
    
    Opal.def(self, '$printSecretRoll', $BCDice_printSecretRoll$50 = function $$printSecretRoll() {
      var $$51, self = this, outputs = nil;

      
      outputs = self.$openSecretRoll(self.channel, 0);
      return $send(outputs, 'each', [], ($$51 = function(diceResult){var self = $$51.$$s || this;
        if (self.channel == null) self.channel = nil;

      
        
        if (diceResult == null) {
          diceResult = nil;
        };
        if ($truthy(diceResult['$empty?']())) {
          return nil;};
        self.$sendMessage(self.channel, diceResult);
        return self.$sleepForIrc(1);}, $$51.$$s = self, $$51.$$arity = 1, $$51));
    }, $BCDice_printSecretRoll$50.$$arity = 0);
    
    Opal.def(self, '$executePointCounterPublic', $BCDice_executePointCounterPublic$52 = function $$executePointCounterPublic() {
      var $a, $b, self = this, __last__match__1 = nil, __last__match__2 = nil, __last__match__3 = nil, __last__match__4 = nil, __last__match__5 = nil, __last__match__6 = nil, __last__match__7 = nil, __last__match__8 = nil, __last__match__9 = nil, __last__match__10 = nil, __last__match__11 = nil, __last__match__12 = nil, __last__match__13 = nil, __last__match__14 = nil, __last__match__15 = nil, __last__match__16 = nil, __last__match__17 = nil, __last__match__18 = nil, __last__match__19 = nil, __last__match__20 = nil, pointerMode = nil, countHolder = nil, output = nil, secret = nil;
      if ($gvars.READY_CMD == null) $gvars.READY_CMD = nil;

      
      self.$debug("executePointCounterPublic begin");
      if ($truthy(new RegExp("" + "^" + ($gvars.READY_CMD) + "(\\s+|$)", 'i')['$=~'](self.message))) {
        
        __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
        __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
        __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
        __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
        __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
        __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
        __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
        __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
        __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
        __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
        __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
        __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
        __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
        __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
        __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
        __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
        __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
        __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
        __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
        __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
        self.$setPrintPlotChannel();
        self.$sendMessageToOnlySender("表示チャンネルを設定しました");
        return nil;};
      if ($truthy(/^#/['$=~'](self.message))) {
      } else {
        
        self.$debug("executePointCounterPublic NOT match");
        return nil;
      };
      __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
      __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
      __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
      __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
      __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
      __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
      __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
      __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
      __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
      __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
      __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
      __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
      __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
      __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
      __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
      __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
      __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
      __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
      __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
      __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
      pointerMode = "sameChannel";
      countHolder = $$($nesting, 'CountHolder').$new(self, self.counterInfos);
      $b = countHolder.$executeCommand(self.message, self.nick_e, self.channel, pointerMode), $a = Opal.to_ary($b), (output = ($a[0] == null ? nil : $a[0])), (secret = ($a[1] == null ? nil : $a[1])), $b;
      self.$debug("executePointCounterPublic output, secret", output, secret);
      if ($truthy(secret)) {
        
        self.$debug("is secret");
        if ($truthy(output['$!=']("1"))) {
          return self.$sendMessageToOnlySender(output)
        } else {
          return nil
        };
      } else {
        
        self.$debug("is NOT secret");
        if ($truthy(output['$!=']("1"))) {
          return self.$sendMessage(self.channel, output)
        } else {
          return nil
        };
      };
    }, $BCDice_executePointCounterPublic$52.$$arity = 0);
    
    Opal.def(self, '$executeDiceRoll', $BCDice_executeDiceRoll$53 = function $$executeDiceRoll() {
      var $a, $b, self = this, output = nil, secret = nil;

      
      self.$debug("executeDiceRoll begin");
      self.$debug("channel", self.channel);
      $b = self.$dice_command(), $a = Opal.to_ary($b), (output = ($a[0] == null ? nil : $a[0])), (secret = ($a[1] == null ? nil : $a[1])), $b;
      if ($truthy(secret)) {
      } else {
        
        self.$debug("executeDiceRoll @channel", self.channel);
        if ($truthy(output['$!=']("1"))) {
          self.$sendMessage(self.channel, output)};
        return nil;
      };
      if ($truthy(output['$==']("1"))) {
        return nil};
      if ($truthy(self.isTest)) {
        output = $rb_plus(output, "###secret dice###")};
      self.$broadmsg(output, self.nick_e);
      if ($truthy(self.isKeepSecretDice)) {
        return self.$addToSecretDiceResult(output, self.channel, 0)
      } else {
        return nil
      };
    }, $BCDice_executeDiceRoll$53.$$arity = 0);
    
    Opal.def(self, '$setTest', $BCDice_setTest$54 = function $$setTest(isTest) {
      var self = this;

      return (self.isTest = isTest)
    }, $BCDice_setTest$54.$$arity = 1);
    
    Opal.def(self, '$executeCard', $BCDice_executeCard$55 = function $$executeCard() {
      var self = this;

      
      self.$debug("executeCard begin");
      self.cardTrader.$setNick(self.nick_e);
      self.cardTrader.$setTnick(self.tnick);
      self.cardTrader.$executeCard(self.message, self.channel);
      return self.$debug("executeCard end");
    }, $BCDice_executeCard$55.$$arity = 0);
    
    Opal.def(self, '$dice_command', $BCDice_dice_command$56 = function $$dice_command() {
      var $a, $b, self = this, arg = nil, output = nil, secret = nil;

      
      arg = self.message.$upcase();
      self.$debug("dice_command arg", arg);
      $b = self.diceBot.$dice_command(self.message, self.nick_e), $a = Opal.to_ary($b), (output = ($a[0] == null ? nil : $a[0])), (secret = ($a[1] == null ? nil : $a[1])), $b;
      if ($truthy(output['$!=']("1"))) {
        return [output, secret]};
      $b = self.$rollD66(arg), $a = Opal.to_ary($b), (output = ($a[0] == null ? nil : $a[0])), (secret = ($a[1] == null ? nil : $a[1])), $b;
      if ($truthy(output['$nil?']())) {
      } else {
        return [output, secret]
      };
      $b = self.$checkAddRoll(arg), $a = Opal.to_ary($b), (output = ($a[0] == null ? nil : $a[0])), (secret = ($a[1] == null ? nil : $a[1])), $b;
      if ($truthy(output['$nil?']())) {
      } else {
        return [output, secret]
      };
      $b = self.$checkBDice(arg), $a = Opal.to_ary($b), (output = ($a[0] == null ? nil : $a[0])), (secret = ($a[1] == null ? nil : $a[1])), $b;
      if ($truthy(output['$nil?']())) {
      } else {
        return [output, secret]
      };
      $b = self.$checkRnDice(arg), $a = Opal.to_ary($b), (output = ($a[0] == null ? nil : $a[0])), (secret = ($a[1] == null ? nil : $a[1])), $b;
      if ($truthy(output['$nil?']())) {
      } else {
        return [output, secret]
      };
      $b = self.$checkUpperRoll(arg), $a = Opal.to_ary($b), (output = ($a[0] == null ? nil : $a[0])), (secret = ($a[1] == null ? nil : $a[1])), $b;
      if ($truthy(output['$nil?']())) {
      } else {
        return [output, secret]
      };
      $b = self.$checkChoiceCommand(arg), $a = Opal.to_ary($b), (output = ($a[0] == null ? nil : $a[0])), (secret = ($a[1] == null ? nil : $a[1])), $b;
      if ($truthy(output['$nil?']())) {
      } else {
        return [output, secret]
      };
      $b = self.$getTableDataResult(arg), $a = Opal.to_ary($b), (output = ($a[0] == null ? nil : $a[0])), (secret = ($a[1] == null ? nil : $a[1])), $b;
      if ($truthy(output['$nil?']())) {
      } else {
        return [output, secret]
      };
      output = "1";
      secret = false;
      return [output, secret];
    }, $BCDice_dice_command$56.$$arity = 0);
    
    Opal.def(self, '$checkAddRoll', $BCDice_checkAddRoll$57 = function $$checkAddRoll(arg) {
      var self = this, dice = nil, output = nil, secret = nil;

      
      self.$debug("check add roll");
      dice = $$($nesting, 'AddDice').$new(self, self.diceBot);
      output = dice.$rollDice(arg);
      if ($truthy(output['$==']("1"))) {
        return nil};
      secret = /S[-\d]+D[\d+-]+/['$==='](arg);
      return [output, secret];
    }, $BCDice_checkAddRoll$57.$$arity = 1);
    
    Opal.def(self, '$checkBDice', $BCDice_checkBDice$58 = function $$checkBDice(arg) {
      var self = this, output = nil, secret = nil;

      
      self.$debug("check barabara roll");
      output = self.$bdice(arg);
      if ($truthy(output['$==']("1"))) {
        return nil};
      secret = /S[\d]+B[\d]+/i['$==='](arg);
      return [output, secret];
    }, $BCDice_checkBDice$58.$$arity = 1);
    
    Opal.def(self, '$checkRnDice', $BCDice_checkRnDice$59 = function $$checkRnDice(arg) {
      var $a, self = this, __last__match__1 = nil, __last__match__2 = nil, __last__match__3 = nil, __last__match__4 = nil, __last__match__5 = nil, __last__match__6 = nil, __last__match__7 = nil, __last__match__8 = nil, __last__match__9 = nil, __last__match__10 = nil, __last__match__11 = nil, __last__match__12 = nil, __last__match__13 = nil, __last__match__14 = nil, __last__match__15 = nil, __last__match__16 = nil, __last__match__17 = nil, __last__match__18 = nil, __last__match__19 = nil, __last__match__20 = nil, secret = nil, output = nil, dice = nil;

      
      self.$debug("check xRn roll arg", arg);
      if ($truthy(/(S)?[\d]+R[\d]+/i['$==='](arg))) {
      } else {
        return nil
      };
      __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
      __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
      __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
      __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
      __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
      __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
      __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
      __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
      __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
      __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
      __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
      __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
      __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
      __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
      __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
      __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
      __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
      __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
      __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
      __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
      secret = __last__match__1['$nil?']()['$!']();
      output = self.diceBot.$dice_command_xRn(arg, self.nick_e);
      if ($truthy(($truthy($a = output['$nil?']()) ? $a : output['$==']("1")))) {
        return nil};
      if ($truthy(output['$empty?']())) {
        
        dice = $$($nesting, 'RerollDice').$new(self, self.diceBot);
        output = dice.$rollDice(arg);};
      if ($truthy(($truthy($a = output['$nil?']()) ? $a : output['$==']("1")))) {
        return nil};
      self.$debug("xRn output", output);
      return [output, secret];
    }, $BCDice_checkRnDice$59.$$arity = 1);
    
    Opal.def(self, '$checkUpperRoll', $BCDice_checkUpperRoll$60 = function $$checkUpperRoll(arg) {
      var $a, self = this, __last__match__1 = nil, __last__match__2 = nil, __last__match__3 = nil, __last__match__4 = nil, __last__match__5 = nil, __last__match__6 = nil, __last__match__7 = nil, __last__match__8 = nil, __last__match__9 = nil, __last__match__10 = nil, __last__match__11 = nil, __last__match__12 = nil, __last__match__13 = nil, __last__match__14 = nil, __last__match__15 = nil, __last__match__16 = nil, __last__match__17 = nil, __last__match__18 = nil, __last__match__19 = nil, __last__match__20 = nil, secret = nil, dice = nil, output = nil;

      
      self.$debug("check upper roll");
      if ($truthy(/(S)?[\d]+U[\d]+/i['$==='](arg))) {
      } else {
        return nil
      };
      __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
      __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
      __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
      __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
      __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
      __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
      __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
      __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
      __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
      __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
      __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
      __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
      __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
      __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
      __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
      __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
      __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
      __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
      __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
      __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
      secret = __last__match__1['$nil?']()['$!']();
      dice = $$($nesting, 'UpperDice').$new(self, self.diceBot);
      output = dice.$rollDice(arg);
      if ($truthy(output['$==']("1"))) {
        return nil};
      return [output, secret];
    }, $BCDice_checkUpperRoll$60.$$arity = 1);
    
    Opal.def(self, '$checkChoiceCommand', $BCDice_checkChoiceCommand$61 = function $$checkChoiceCommand(arg) {
      var $a, self = this, __last__match__1 = nil, __last__match__2 = nil, __last__match__3 = nil, __last__match__4 = nil, __last__match__5 = nil, __last__match__6 = nil, __last__match__7 = nil, __last__match__8 = nil, __last__match__9 = nil, __last__match__10 = nil, __last__match__11 = nil, __last__match__12 = nil, __last__match__13 = nil, __last__match__14 = nil, __last__match__15 = nil, __last__match__16 = nil, __last__match__17 = nil, __last__match__18 = nil, __last__match__19 = nil, __last__match__20 = nil, secret = nil, output = nil;

      
      self.$debug("check choice command");
      if ($truthy(/((^|\s)(S)?choice\[[^,]+(,[^,]+)+\]($|\s))/i['$==='](arg))) {
      } else {
        return nil
      };
      __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
      __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
      __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
      __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
      __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
      __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
      __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
      __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
      __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
      __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
      __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
      __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
      __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
      __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
      __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
      __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
      __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
      __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
      __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
      __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
      secret = __last__match__3['$nil?']()['$!']();
      output = self.$choice_random(__last__match__1);
      return [output, secret];
    }, $BCDice_checkChoiceCommand$61.$$arity = 1);
    
    Opal.def(self, '$getTableDataResult', $BCDice_getTableDataResult$62 = function $$getTableDataResult(arg) {
      var $a, $b, $$63, self = this, dice = nil, title = nil, table = nil, secret = nil, value = nil, diceText = nil, key = nil, message = nil, output = nil;

      
      self.$debug("getTableDataResult Begin");
      $b = self.tableFileData.$getTableData(arg, self.diceBot.$gameType()), $a = Opal.to_ary($b), (dice = ($a[0] == null ? nil : $a[0])), (title = ($a[1] == null ? nil : $a[1])), (table = ($a[2] == null ? nil : $a[2])), (secret = ($a[3] == null ? nil : $a[3])), $b;
      self.$debug("dice", dice);
      if ($truthy(table['$nil?']())) {
        
        self.$debug("table is null");
        return nil;};
      $b = self.$getTableIndexDiceValueAndDiceText(dice), $a = Opal.to_ary($b), (value = ($a[0] == null ? nil : $a[0])), (diceText = ($a[1] == null ? nil : $a[1])), $b;
      if ($truthy(value['$nil?']())) {
        return nil};
      self.$debug("value", value);
      $b = $send(table, 'find', [], ($$63 = function(i){var self = $$63.$$s || this;

      
        
        if (i == null) {
          i = nil;
        };
        return i.$first()['$==='](value);}, $$63.$$s = self, $$63.$$arity = 1, $$63)), $a = Opal.to_ary($b), (key = ($a[0] == null ? nil : $a[0])), (message = ($a[1] == null ? nil : $a[1])), $b;
      if ($truthy(message['$nil?']())) {
        return nil};
      message = self.$rollTableMessageDiceText(message);
      output = "" + (self.$nick_e()) + ":" + (title) + "(" + (value) + "[" + (diceText) + "]) ＞ " + (message);
      return [output, secret];
    }, $BCDice_getTableDataResult$62.$$arity = 1);
    
    Opal.def(self, '$getTableIndexDiceValueAndDiceText', $BCDice_getTableIndexDiceValueAndDiceText$64 = function $$getTableIndexDiceValueAndDiceText(dice) {
      var $a, $b, self = this, __last__match__1 = nil, __last__match__2 = nil, __last__match__3 = nil, __last__match__4 = nil, __last__match__5 = nil, __last__match__6 = nil, __last__match__7 = nil, __last__match__8 = nil, __last__match__9 = nil, __last__match__10 = nil, __last__match__11 = nil, __last__match__12 = nil, __last__match__13 = nil, __last__match__14 = nil, __last__match__15 = nil, __last__match__16 = nil, __last__match__17 = nil, __last__match__18 = nil, __last__match__19 = nil, __last__match__20 = nil, diceCount = nil, diceType = nil, value = nil, diceText = nil, string = nil, secret = nil, count = nil, swapMarker = nil;

      
      if ($truthy(/(\d+)D(\d+)/i['$==='](dice))) {
        
        __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
        __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
        __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
        __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
        __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
        __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
        __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
        __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
        __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
        __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
        __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
        __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
        __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
        __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
        __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
        __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
        __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
        __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
        __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
        __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
        diceCount = __last__match__1;
        diceType = __last__match__2;
        $b = self.$roll(diceCount, diceType), $a = Opal.to_ary($b), (value = ($a[0] == null ? nil : $a[0])), (diceText = ($a[1] == null ? nil : $a[1])), $b;
        return [value, diceText];};
      $b = self.$getD66Infos(dice), $a = Opal.to_ary($b), (string = ($a[0] == null ? nil : $a[0])), (secret = ($a[1] == null ? nil : $a[1])), (count = ($a[2] == null ? nil : $a[2])), (swapMarker = ($a[3] == null ? nil : $a[3])), $b;
      if ($truthy(string['$nil?']())) {
      } else {
        
        value = self.$getD66ValueByMarker(swapMarker);
        diceText = $rb_plus($rb_plus($rb_divide(value, 10).$to_s(), ","), value['$%'](10).$to_s());
        return [value, diceText];
      };
      return nil;
    }, $BCDice_getTableIndexDiceValueAndDiceText$64.$$arity = 1);
    
    Opal.def(self, '$rollTableMessageDiceText', $BCDice_rollTableMessageDiceText$65 = function $$rollTableMessageDiceText(text) {
      var $$66, self = this, message = nil;

      
      message = $send(text, 'gsub', [/(\d+)D(\d+)/], ($$66 = function(){var self = $$66.$$s || this, $a, $b, diceCount = nil, diceMax = nil, value = nil;

      
        diceCount = self.$__last__match__1();
        diceMax = self.$__last__match__2();
        $b = self.$roll(diceCount, diceMax), $a = Opal.to_ary($b), (value = ($a[0] == null ? nil : $a[0])), $b;
        return "" + (self.$__last__match__1()) + "D" + (self.$__last__match__2()) + "(=>" + (value) + ")";}, $$66.$$s = self, $$66.$$arity = 0, $$66));
      return message;
    }, $BCDice_rollTableMessageDiceText$65.$$arity = 1);
    
    Opal.def(self, '$roll', $BCDice_roll$67 = function $$roll(dice_cnt, dice_max, dice_sort, dice_add, dice_ul, dice_diff, dice_re) {
      var $a, $$68, $$70, self = this, total = nil, dice_str = nil, numberSpot1 = nil, cnt_max = nil, n_max = nil, cnt_suc = nil, d9_on = nil, rerollCount = nil, dice_result = nil;
      if ($gvars.DICE_MAXCNT == null) $gvars.DICE_MAXCNT = nil;
      if ($gvars.DICE_MAXNUM == null) $gvars.DICE_MAXNUM = nil;

      
      
      if (dice_sort == null) {
        dice_sort = 0;
      };
      
      if (dice_add == null) {
        dice_add = 0;
      };
      
      if (dice_ul == null) {
        dice_ul = "";
      };
      
      if (dice_diff == null) {
        dice_diff = 0;
      };
      
      if (dice_re == null) {
        dice_re = nil;
      };
      dice_cnt = dice_cnt.$to_i();
      dice_max = dice_max.$to_i();
      dice_re = dice_re.$to_i();
      total = 0;
      dice_str = "";
      numberSpot1 = 0;
      cnt_max = 0;
      n_max = 0;
      cnt_suc = 0;
      d9_on = false;
      rerollCount = 0;
      dice_result = [];
      if ($truthy(($truthy($a = self.diceBot.$d66Type()['$!='](0)) ? dice_max['$=='](66) : $a))) {
        
        dice_sort = 0;
        dice_cnt = 2;
        dice_max = 6;};
      if ($truthy(($truthy($a = self.diceBot.$isD9()) ? dice_max['$=='](9) : $a))) {
        
        d9_on = true;
        dice_max = $rb_plus(dice_max, 1);};
      if ($truthy(($truthy($a = $rb_le(dice_cnt, $gvars.DICE_MAXCNT)) ? $rb_le(dice_max, $gvars.DICE_MAXNUM) : $a))) {
      } else {
        return [total, dice_str, numberSpot1, cnt_max, n_max, cnt_suc, rerollCount]
      };
      (function(){var $brk = Opal.new_brk(); try {return $send(dice_cnt, 'times', [], ($$68 = function(i){var self = $$68.$$s || this, $$69, $b, dice_now = nil, dice_n = nil, dice_st_n = nil, round = nil, suc = nil;
        if (self.diceBot == null) self.diceBot = nil;

      
        
        if (i == null) {
          i = nil;
        };
        i = $rb_plus(i, 1);
        dice_now = 0;
        dice_n = 0;
        dice_st_n = "";
        round = 0;
        (function(){var $brk = Opal.new_brk(); try {return $send(self, 'loop', [], ($$69 = function(){var self = $$69.$$s || this, $b;
          if (self.diceBot == null) self.diceBot = nil;

        
          if ($truthy($rb_ge(round, 1))) {
            dice_now = $rb_plus(dice_now, self.diceBot.$getJackUpValueOnAddRoll(dice_n))};
          dice_n = $rb_plus(self.$rand(dice_max).$to_i(), 1);
          if ($truthy(d9_on)) {
            dice_n = $rb_minus(dice_n, 1)};
          dice_now = $rb_plus(dice_now, dice_n);
          self.$debug("@diceBot.sendMode", self.diceBot.$sendMode());
          if ($truthy($rb_ge(self.diceBot.$sendMode(), 2))) {
            
            if ($truthy(dice_st_n['$empty?']())) {
            } else {
              dice_st_n = $rb_plus(dice_st_n, ",")
            };
            dice_st_n = $rb_plus(dice_st_n, "" + (dice_n));};
          round = $rb_plus(round, 1);
          if ($truthy(($truthy($b = $rb_gt(dice_add, 1)) ? $rb_ge(dice_n, dice_add) : $b))) {
            return nil
          } else {
            
            Opal.brk(nil, $brk)
          };}, $$69.$$s = self, $$69.$$brk = $brk, $$69.$$arity = 0, $$69))
        } catch (err) { if (err === $brk) { return err.$v } else { throw err } }})();
        total = $rb_plus(total, dice_now);
        if ($truthy(dice_ul['$!='](""))) {
          
          suc = self.$check_hit(dice_now, dice_ul, dice_diff);
          cnt_suc = $rb_plus(cnt_suc, suc);};
        if ($truthy(dice_re)) {
          if ($truthy($rb_ge(dice_now, dice_re))) {
            rerollCount = $rb_plus(rerollCount, 1)}};
        if ($truthy(($truthy($b = $rb_ge(self.diceBot.$sendMode(), 2)) ? $rb_ge(round, 2) : $b))) {
          dice_result.$push("" + (dice_now) + "[" + (dice_st_n) + "]")
        } else {
          dice_result.$push(dice_now)
        };
        if ($truthy(dice_now['$=='](1))) {
          numberSpot1 = $rb_plus(numberSpot1, 1)};
        if ($truthy(dice_now['$=='](dice_max))) {
          cnt_max = $rb_plus(cnt_max, 1)};
        if ($truthy($rb_gt(dice_now, n_max))) {
          return (n_max = dice_now)
        } else {
          return nil
        };}, $$68.$$s = self, $$68.$$brk = $brk, $$68.$$arity = 1, $$68))
      } catch (err) { if (err === $brk) { return err.$v } else { throw err } }})();
      if ($truthy(dice_sort['$!='](0))) {
        dice_str = $send(dice_result, 'sort_by', [], ($$70 = function(a){var self = $$70.$$s || this;

        
          
          if (a == null) {
            a = nil;
          };
          return self.$dice_num(a);}, $$70.$$s = self, $$70.$$arity = 1, $$70)).$join(",")
      } else {
        dice_str = dice_result.$join(",")
      };
      return [total, dice_str, numberSpot1, cnt_max, n_max, cnt_suc, rerollCount];
    }, $BCDice_roll$67.$$arity = -3);
    
    Opal.def(self, '$setRandomValues', $BCDice_setRandomValues$71 = function $$setRandomValues(rands) {
      var self = this;

      return (self.rands = rands)
    }, $BCDice_setRandomValues$71.$$arity = 1);
    
    Opal.def(self, '$rand', $BCDice_rand$72 = function $$rand(max) {
      var self = this, value = nil;

      
      self.$debug("rand called @rands", self.rands);
      value = 0;
      if ($truthy(self.rands['$nil?']())) {
        value = self.$randNomal(max)
      } else {
        value = self.$randFromRands(max)
      };
      if ($truthy(self.randResults['$nil?']())) {
      } else {
        self.randResults.$push([$rb_plus(value, 1), max])
      };
      return value;
    }, $BCDice_rand$72.$$arity = 1);
    
    Opal.def(self, '$setCollectRandResult', $BCDice_setCollectRandResult$73 = function $$setCollectRandResult(b) {
      var self = this;

      if ($truthy(b)) {
        return (self.randResults = [])
      } else {
        return (self.randResults = nil)
      }
    }, $BCDice_setCollectRandResult$73.$$arity = 1);
    
    Opal.def(self, '$getRandResults', $BCDice_getRandResults$74 = function $$getRandResults() {
      var self = this;

      return self.randResults
    }, $BCDice_getRandResults$74.$$arity = 0);
    
    Opal.def(self, '$randNomal', $BCDice_randNomal$75 = function $$randNomal(max) {
      var self = this;

      return $$($nesting, 'Kernel').$rand(max)
    }, $BCDice_randNomal$75.$$arity = 1);
    
    Opal.def(self, '$randFromRands', $BCDice_randFromRands$76 = function $$randFromRands(targetMax) {
      var $a, $b, self = this, nextRand = nil, value = nil, max = nil;

      
      nextRand = self.rands.$shift();
      if ($truthy(nextRand['$nil?']())) {
        self.$raise("" + "nextRand is nil, so @rands is empty!! @rands:" + (self.rands.$inspect()))};
      $b = nextRand, $a = Opal.to_ary($b), (value = ($a[0] == null ? nil : $a[0])), (max = ($a[1] == null ? nil : $a[1])), $b;
      value = value.$to_i();
      max = max.$to_i();
      if ($truthy(max['$!='](targetMax))) {
        self.$raise("" + "invalid max value! [ " + (value) + " / " + (max) + " ] but NEED [ " + (targetMax) + " ] dice")};
      return $rb_minus(value, 1);
    }, $BCDice_randFromRands$76.$$arity = 1);
    
    Opal.def(self, '$dice_num', $BCDice_dice_num$77 = function $$dice_num(dice_str) {
      var self = this;

      
      dice_str = dice_str.$to_s();
      return dice_str.$sub(/\[[\d,]+\]/, "").$to_i();
    }, $BCDice_dice_num$77.$$arity = 1);
    
    Opal.def(self, '$bdice', $BCDice_bdice$78 = function $$bdice(string) {
      var $a, $$79, self = this, total_n = nil, suc = nil, signOfInequality = nil, diff = nil, output = nil, __last__match__1 = nil, __last__match__2 = nil, __last__match__3 = nil, __last__match__4 = nil, __last__match__5 = nil, __last__match__6 = nil, __last__match__7 = nil, __last__match__8 = nil, __last__match__9 = nil, __last__match__10 = nil, __last__match__11 = nil, __last__match__12 = nil, __last__match__13 = nil, __last__match__14 = nil, __last__match__15 = nil, __last__match__16 = nil, __last__match__17 = nil, __last__match__18 = nil, __last__match__19 = nil, __last__match__20 = nil, dice_a = nil, dice_cnt_total = nil, numberSpot1 = nil;

      
      total_n = 0;
      suc = 0;
      signOfInequality = "";
      diff = 0;
      output = "";
      string = string.$gsub(/-[\d]+B[\d]+/, "");
      if ($truthy(/(^|\s)S?(([\d]+B[\d]+(\+[\d]+B[\d]+)*)(([<>=]+)([\d]+))?)($|\s)/['$=~'](string))) {
      } else {
        
        output = "1";
        return output;
      };
      __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
      __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
      __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
      __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
      __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
      __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
      __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
      __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
      __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
      __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
      __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
      __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
      __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
      __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
      __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
      __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
      __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
      __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
      __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
      __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
      string = __last__match__2;
      if ($truthy(__last__match__5)) {
        
        signOfInequality = self.$marshalSignOfInequality(__last__match__6);
        diff = __last__match__7.$to_i();
        string = __last__match__3;
      } else if ($truthy(/([<>=]+)(\d+)/['$=~'](self.diceBot.$defaultSuccessTarget()))) {
        
        __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
        __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
        __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
        __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
        __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
        __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
        __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
        __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
        __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
        __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
        __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
        __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
        __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
        __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
        __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
        __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
        __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
        __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
        __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
        __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
        signOfInequality = self.$marshalSignOfInequality(__last__match__1);
        diff = __last__match__2.$to_i();};
      dice_a = string.$split(/\+/);
      dice_cnt_total = 0;
      numberSpot1 = 0;
      $send(dice_a, 'each', [], ($$79 = function(dice_o){var self = $$79.$$s || this, $b, $c, dice_cnt = nil, dice_max = nil, dice_dat = nil;
        if (self.diceBot == null) self.diceBot = nil;

      
        
        if (dice_o == null) {
          dice_o = nil;
        };
        $c = dice_o.$split(/[bB]/), $b = Opal.to_ary($c), (dice_cnt = ($b[0] == null ? nil : $b[0])), (dice_max = ($b[1] == null ? nil : $b[1])), $c;
        dice_cnt = dice_cnt.$to_i();
        dice_max = dice_max.$to_i();
        dice_dat = self.$roll(dice_cnt, dice_max, self.diceBot.$sortType()['$&'](2), 0, signOfInequality, diff);
        suc = $rb_plus(suc, dice_dat['$[]'](5));
        if ($truthy(output['$!='](""))) {
          output = $rb_plus(output, ",")};
        output = $rb_plus(output, dice_dat['$[]'](1));
        numberSpot1 = $rb_plus(numberSpot1, dice_dat['$[]'](2));
        return (dice_cnt_total = $rb_plus(dice_cnt_total, dice_cnt));}, $$79.$$s = self, $$79.$$arity = 1, $$79));
      if ($truthy(signOfInequality['$!='](""))) {
        
        string = $rb_plus(string, "" + (signOfInequality) + (diff));
        output = "" + (output) + " ＞ 成功数" + (suc);
        output = $rb_plus(output, self.diceBot.$getGrichText(numberSpot1, dice_cnt_total, suc));};
      output = "" + (self.nick_e) + ": (" + (string) + ") ＞ " + (output);
      return output;
    }, $BCDice_bdice$78.$$arity = 1);
    
    Opal.def(self, '$isReRollAgain', $BCDice_isReRollAgain$80 = function $$isReRollAgain(dice_cnt, round) {
      var $a, $b, self = this;

      
      self.$debug("isReRollAgain dice_cnt, round", dice_cnt, round);
      
      return ($truthy($a = $rb_gt(dice_cnt, 0)) ? ($truthy($b = $rb_lt(round, self.diceBot.$rerollLimitCount())) ? $b : self.diceBot.$rerollLimitCount()['$=='](0)) : $a);;
    }, $BCDice_isReRollAgain$80.$$arity = 2);
    
    Opal.def(self, '$rollD66', $BCDice_rollD66$81 = function $$rollD66(string) {
      var $a, $b, self = this, __last__match__1 = nil, __last__match__2 = nil, __last__match__3 = nil, __last__match__4 = nil, __last__match__5 = nil, __last__match__6 = nil, __last__match__7 = nil, __last__match__8 = nil, __last__match__9 = nil, __last__match__10 = nil, __last__match__11 = nil, __last__match__12 = nil, __last__match__13 = nil, __last__match__14 = nil, __last__match__15 = nil, __last__match__16 = nil, __last__match__17 = nil, __last__match__18 = nil, __last__match__19 = nil, __last__match__20 = nil, output = nil, secret = nil;

      
      if ($truthy(/^S?D66/i['$==='](string))) {
      } else {
        return nil
      };
      __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
      __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
      __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
      __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
      __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
      __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
      __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
      __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
      __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
      __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
      __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
      __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
      __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
      __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
      __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
      __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
      __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
      __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
      __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
      __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
      if ($truthy(self.diceBot.$d66Type()['$=='](0))) {
        return nil};
      self.$debug("match D66 roll");
      $b = self.$d66dice(string), $a = Opal.to_ary($b), (output = ($a[0] == null ? nil : $a[0])), (secret = ($a[1] == null ? nil : $a[1])), $b;
      return [output, secret];
    }, $BCDice_rollD66$81.$$arity = 1);
    
    Opal.def(self, '$d66dice', $BCDice_d66dice$82 = function $$d66dice(string) {
      var $a, $b, $$83, self = this, secret = nil, output = nil, count = nil, swapMarker = nil, d66List = nil, d66Text = nil;

      
      string = string.$upcase();
      secret = false;
      output = "1";
      $b = self.$getD66Infos(string), $a = Opal.to_ary($b), (string = ($a[0] == null ? nil : $a[0])), (secret = ($a[1] == null ? nil : $a[1])), (count = ($a[2] == null ? nil : $a[2])), (swapMarker = ($a[3] == null ? nil : $a[3])), $b;
      if ($truthy(string['$nil?']())) {
        return [output, secret]};
      self.$debug("d66dice count", count);
      d66List = [];
      $send(count, 'times', [], ($$83 = function(i){var self = $$83.$$s || this;

      
        
        if (i == null) {
          i = nil;
        };
        return d66List.$push(self.$getD66ValueByMarker(swapMarker));}, $$83.$$s = self, $$83.$$arity = 1, $$83));
      d66Text = d66List.$join(",");
      self.$debug("d66Text", d66Text);
      output = "" + (self.nick_e) + ": (" + (string) + ") ＞ " + (d66Text);
      return [output, secret];
    }, $BCDice_d66dice$82.$$arity = 1);
    
    Opal.def(self, '$getD66Infos', $BCDice_getD66Infos$84 = function $$getD66Infos(string) {
      var $a, self = this, __last__match__1 = nil, __last__match__2 = nil, __last__match__3 = nil, __last__match__4 = nil, __last__match__5 = nil, __last__match__6 = nil, __last__match__7 = nil, __last__match__8 = nil, __last__match__9 = nil, __last__match__10 = nil, __last__match__11 = nil, __last__match__12 = nil, __last__match__13 = nil, __last__match__14 = nil, __last__match__15 = nil, __last__match__16 = nil, __last__match__17 = nil, __last__match__18 = nil, __last__match__19 = nil, __last__match__20 = nil, secret = nil, count = nil, swapMarker = nil;

      
      self.$debug("getD66Infos, string", string);
      if ($truthy(/(^|\s)(S)?((\d+)?D66(N|S)?)(\s|$)/i['$==='](string))) {
      } else {
        return nil
      };
      __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
      __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
      __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
      __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
      __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
      __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
      __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
      __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
      __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
      __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
      __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
      __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
      __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
      __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
      __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
      __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
      __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
      __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
      __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
      __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
      secret = __last__match__2['$nil?']()['$!']();
      string = __last__match__3;
      count = ($truthy($a = __last__match__4) ? $a : 1).$to_i();
      swapMarker = ($truthy($a = __last__match__5) ? $a : "").$upcase();
      return [string, secret, count, swapMarker];
    }, $BCDice_getD66Infos$84.$$arity = 1);
    
    Opal.def(self, '$getD66ValueByMarker', $BCDice_getD66ValueByMarker$85 = function $$getD66ValueByMarker(swapMarker) {
      var self = this, $case = nil, isSwap = nil;

      return (function() {$case = swapMarker;
      if ("S"['$===']($case)) {
      isSwap = true;
      return self.$getD66(isSwap);}
      else if ("N"['$===']($case)) {
      isSwap = false;
      return self.$getD66(isSwap);}
      else {return self.$getD66Value()}})()
    }, $BCDice_getD66ValueByMarker$85.$$arity = 1);
    
    Opal.def(self, '$getD66Value', $BCDice_getD66Value$86 = function $$getD66Value(mode) {
      var $a, self = this, isSwap = nil;

      
      
      if (mode == null) {
        mode = nil;
      };
      mode = ($truthy($a = mode) ? $a : self.diceBot.$d66Type());
      isSwap = $rb_gt(mode, 1);
      return self.$getD66(isSwap);
    }, $BCDice_getD66Value$86.$$arity = -1);
    
    Opal.def(self, '$getD66', $BCDice_getD66$87 = function $$getD66(isSwap) {
      var $a, self = this, output = nil, dice_a = nil, dice_b = nil;

      
      output = 0;
      dice_a = $rb_plus(self.$rand(6), 1);
      dice_b = $rb_plus(self.$rand(6), 1);
      self.$debug("dice_a", dice_a);
      self.$debug("dice_b", dice_b);
      if ($truthy(($truthy($a = isSwap) ? $rb_gt(dice_a, dice_b) : $a))) {
        output = $rb_plus(dice_a, $rb_times(dice_b, 10))
      } else {
        output = $rb_plus($rb_times(dice_a, 10), dice_b)
      };
      self.$debug("output", output);
      return output;
    }, $BCDice_getD66$87.$$arity = 1);
    
    Opal.def(self, '$openSecretRoll', $BCDice_openSecretRoll$88 = function $$openSecretRoll(channel, mode) {
      var $$89, self = this, messages = nil, memberKey = nil, members = nil;
      if ($gvars.secretRollMembersHolder == null) $gvars.secretRollMembersHolder = nil;

      
      self.$debug("openSecretRoll begin");
      channel = channel.$upcase();
      messages = [];
      memberKey = self.$getSecretRollMembersHolderKey(channel, mode);
      members = $gvars.secretRollMembersHolder['$[]'](memberKey);
      if ($truthy(members['$nil?']())) {
        
        self.$debug("openSecretRoll members is nil. messages", messages);
        return messages;};
      $send(members, 'each', [], ($$89 = function(member){var self = $$89.$$s || this, diceResultKey = nil, diceResult = nil;
        if ($gvars.secretDiceResultHolder == null) $gvars.secretDiceResultHolder = nil;

      
        
        if (member == null) {
          member = nil;
        };
        diceResultKey = self.$getSecretDiceResultHolderKey(channel, mode, member);
        self.$debug("openSecretRoll diceResulyKey", diceResultKey);
        diceResult = $gvars.secretDiceResultHolder['$[]'](diceResultKey);
        self.$debug("openSecretRoll diceResult", diceResult);
        if ($truthy(diceResult)) {
          
          messages.$push(diceResult);
          return $gvars.secretDiceResultHolder.$delete(diceResultKey);
        } else {
          return nil
        };}, $$89.$$s = self, $$89.$$arity = 1, $$89));
      if ($truthy($rb_le(mode, 0))) {
        
        self.$debug("delete recorde data");
        $gvars.secretRollMembersHolder.$delete(channel);};
      self.$debug("openSecretRoll result messages", messages);
      return messages;
    }, $BCDice_openSecretRoll$88.$$arity = 2);
    
    Opal.def(self, '$getNick', $BCDice_getNick$90 = function $$getNick(nick) {
      var $a, self = this, __last__match__1 = nil, __last__match__2 = nil, __last__match__3 = nil, __last__match__4 = nil, __last__match__5 = nil, __last__match__6 = nil, __last__match__7 = nil, __last__match__8 = nil, __last__match__9 = nil, __last__match__10 = nil, __last__match__11 = nil, __last__match__12 = nil, __last__match__13 = nil, __last__match__14 = nil, __last__match__15 = nil, __last__match__16 = nil, __last__match__17 = nil, __last__match__18 = nil, __last__match__19 = nil, __last__match__20 = nil;

      
      
      if (nick == null) {
        nick = nil;
      };
      nick = ($truthy($a = nick) ? $a : self.nick_e);
      nick = nick.$upcase();
      /[_\d]*(.+)[_\d]*/['$=~'](nick);
      __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
      __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
      __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
      __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
      __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
      __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
      __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
      __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
      __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
      __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
      __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
      __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
      __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
      __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
      __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
      __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
      __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
      __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
      __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
      __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
      nick = __last__match__1;
      return nick;
    }, $BCDice_getNick$90.$$arity = -1);
    
    Opal.def(self, '$addToSecretDiceResult', $BCDice_addToSecretDiceResult$91 = function $$addToSecretDiceResult(diceResult, channel, mode) {
      var self = this, nick = nil;

      
      nick = self.$getNick();
      channel = channel.$upcase();
      self.$addToSecretRollMembersHolder(channel, mode);
      self.$saveSecretDiceResult(diceResult, channel, mode);
      return (self.isMessagePrinted = true);
    }, $BCDice_addToSecretDiceResult$91.$$arity = 3);
    
    Opal.def(self, '$addToSecretRollMembersHolder', $BCDice_addToSecretRollMembersHolder$92 = function $$addToSecretRollMembersHolder(channel, mode) {
      var $a, self = this, key = nil, $writer = nil, members = nil, nick = nil;
      if ($gvars.secretRollMembersHolder == null) $gvars.secretRollMembersHolder = nil;

      
      key = self.$getSecretRollMembersHolderKey(channel, mode);
      ($truthy($a = $gvars.secretRollMembersHolder['$[]'](key)) ? $a : (($writer = [key, []]), $send($gvars.secretRollMembersHolder, '[]=', Opal.to_a($writer)), $writer[$rb_minus($writer["length"], 1)]));
      members = $gvars.secretRollMembersHolder['$[]'](key);
      nick = self.$getNick();
      if ($truthy(members['$include?'](nick))) {
        return nil
      } else {
        return members.$push(nick)
      };
    }, $BCDice_addToSecretRollMembersHolder$92.$$arity = 2);
    
    Opal.def(self, '$getSecretRollMembersHolderKey', $BCDice_getSecretRollMembersHolderKey$93 = function $$getSecretRollMembersHolderKey(channel, mode) {
      var self = this;

      return "" + (mode) + "," + (channel)
    }, $BCDice_getSecretRollMembersHolderKey$93.$$arity = 2);
    
    Opal.def(self, '$saveSecretDiceResult', $BCDice_saveSecretDiceResult$94 = function $$saveSecretDiceResult(diceResult, channel, mode) {
      var self = this, nick = nil, key = nil, $writer = nil;
      if ($gvars.secretDiceResultHolder == null) $gvars.secretDiceResultHolder = nil;

      
      nick = self.$getNick();
      if ($truthy(mode['$!='](0))) {
        diceResult = "" + (nick) + ": " + (diceResult)};
      key = self.$getSecretDiceResultHolderKey(channel, mode, nick);
      
      $writer = [key, diceResult];
      $send($gvars.secretDiceResultHolder, '[]=', Opal.to_a($writer));
      $writer[$rb_minus($writer["length"], 1)];;
      self.$debug("key", key);
      return self.$debug("secretDiceResultHolder", $gvars.secretDiceResultHolder);
    }, $BCDice_saveSecretDiceResult$94.$$arity = 3);
    
    Opal.def(self, '$getSecretDiceResultHolderKey', $BCDice_getSecretDiceResultHolderKey$95 = function $$getSecretDiceResultHolderKey(channel, mode, nick) {
      var self = this, key = nil;

      
      key = "" + (mode) + "," + (channel) + "," + (nick);
      return key;
    }, $BCDice_getSecretDiceResultHolderKey$95.$$arity = 3);
    
    Opal.def(self, '$setPrintPlotChannel', $BCDice_setPrintPlotChannel$96 = function $$setPrintPlotChannel() {
      var self = this, nick = nil, $writer = nil;
      if ($gvars.plotPrintChannels == null) $gvars.plotPrintChannels = nil;

      
      nick = self.$getNick();
      
      $writer = [nick, self.channel];
      $send($gvars.plotPrintChannels, '[]=', Opal.to_a($writer));
      return $writer[$rb_minus($writer["length"], 1)];;
    }, $BCDice_setPrintPlotChannel$96.$$arity = 0);
    
    Opal.def(self, '$choice_random', $BCDice_choice_random$97 = function $$choice_random(string) {
      var $a, self = this, output = nil, __last__match__1 = nil, __last__match__2 = nil, __last__match__3 = nil, __last__match__4 = nil, __last__match__5 = nil, __last__match__6 = nil, __last__match__7 = nil, __last__match__8 = nil, __last__match__9 = nil, __last__match__10 = nil, __last__match__11 = nil, __last__match__12 = nil, __last__match__13 = nil, __last__match__14 = nil, __last__match__15 = nil, __last__match__16 = nil, __last__match__17 = nil, __last__match__18 = nil, __last__match__19 = nil, __last__match__20 = nil, targetList = nil, targets = nil, index = nil, target = nil;

      
      output = "1";
      if ($truthy(/(^|\s)((S)?choice\[([^,]+(,[^,]+)+)\])($|\s)/i['$=~'](string))) {
      } else {
        return output
      };
      __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
      __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
      __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
      __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
      __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
      __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
      __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
      __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
      __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
      __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
      __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
      __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
      __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
      __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
      __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
      __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
      __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
      __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
      __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
      __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
      string = __last__match__2;
      targetList = __last__match__4;
      if ($truthy(targetList)) {
      } else {
        return output
      };
      targets = targetList.$split(/,/);
      index = self.$rand(targets.$length());
      target = targets['$[]'](index);
      output = "" + (self.nick_e) + ": (" + (string) + ") ＞ " + (target);
      return output;
    }, $BCDice_choice_random$97.$$arity = 1);
    
    Opal.def(self, '$getMarshaledSignOfInequality', $BCDice_getMarshaledSignOfInequality$98 = function $$getMarshaledSignOfInequality(text) {
      var self = this;

      
      if ($truthy(text['$nil?']())) {
        return ""};
      return self.$marshalSignOfInequality(text);
    }, $BCDice_getMarshaledSignOfInequality$98.$$arity = 1);
    
    Opal.def(self, '$marshalSignOfInequality', $BCDice_marshalSignOfInequality$99 = function $$marshalSignOfInequality(signOfInequality) {
      var $a, self = this, $case = nil, __last__match__1 = nil, __last__match__2 = nil, __last__match__3 = nil, __last__match__4 = nil, __last__match__5 = nil, __last__match__6 = nil, __last__match__7 = nil, __last__match__8 = nil, __last__match__9 = nil, __last__match__10 = nil, __last__match__11 = nil, __last__match__12 = nil, __last__match__13 = nil, __last__match__14 = nil, __last__match__15 = nil, __last__match__16 = nil, __last__match__17 = nil, __last__match__18 = nil, __last__match__19 = nil, __last__match__20 = nil;

      
      $case = signOfInequality;
      if (/(<=|=<)/['$===']($case)) {
      __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
      __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
      __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
      __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
      __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
      __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
      __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
      __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
      __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
      __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
      __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
      __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
      __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
      __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
      __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
      __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
      __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
      __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
      __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
      __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
      return "<=";}
      else if (/(>=|=>)/['$===']($case)) {
      __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
      __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
      __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
      __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
      __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
      __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
      __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
      __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
      __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
      __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
      __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
      __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
      __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
      __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
      __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
      __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
      __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
      __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
      __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
      __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
      return ">=";}
      else if (/(<>)/['$===']($case)) {
      __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
      __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
      __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
      __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
      __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
      __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
      __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
      __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
      __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
      __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
      __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
      __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
      __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
      __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
      __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
      __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
      __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
      __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
      __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
      __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
      return "<>";}
      else if (/[<]+/['$===']($case)) {
      __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
      __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
      __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
      __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
      __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
      __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
      __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
      __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
      __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
      __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
      __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
      __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
      __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
      __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
      __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
      __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
      __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
      __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
      __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
      __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
      return "<";}
      else if (/[>]+/['$===']($case)) {
      __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
      __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
      __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
      __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
      __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
      __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
      __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
      __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
      __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
      __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
      __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
      __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
      __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
      __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
      __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
      __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
      __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
      __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
      __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
      __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
      return ">";}
      else if (/[=]+/['$===']($case)) {
      __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
      __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
      __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
      __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
      __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
      __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
      __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
      __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
      __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
      __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
      __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
      __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
      __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
      __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
      __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
      __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
      __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
      __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
      __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
      __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
      return "=";};
      return signOfInequality;
    }, $BCDice_marshalSignOfInequality$99.$$arity = 1);
    
    Opal.def(self, '$check_hit', $BCDice_check_hit$100 = function $$check_hit(dice_now, signOfInequality, diff) {
      var $a, self = this, suc = nil, __last__match__1 = nil, __last__match__2 = nil, __last__match__3 = nil, __last__match__4 = nil, __last__match__5 = nil, __last__match__6 = nil, __last__match__7 = nil, __last__match__8 = nil, __last__match__9 = nil, __last__match__10 = nil, __last__match__11 = nil, __last__match__12 = nil, __last__match__13 = nil, __last__match__14 = nil, __last__match__15 = nil, __last__match__16 = nil, __last__match__17 = nil, __last__match__18 = nil, __last__match__19 = nil, __last__match__20 = nil, $case = nil;

      
      suc = 0;
      if ($truthy(diff['$is_a?']($$($nesting, 'String')))) {
        
        if ($truthy(/\d/['$=~'](diff))) {
        } else {
          return suc
        };
        __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
        __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
        __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
        __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
        __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
        __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
        __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
        __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
        __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
        __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
        __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
        __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
        __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
        __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
        __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
        __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
        __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
        __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
        __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
        __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
        diff = diff.$to_i();};
      $case = signOfInequality;
      if (/(<=|=<)/['$===']($case)) {
      __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
      __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
      __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
      __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
      __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
      __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
      __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
      __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
      __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
      __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
      __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
      __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
      __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
      __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
      __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
      __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
      __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
      __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
      __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
      __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
      if ($truthy($rb_le(dice_now, diff))) {
        suc = $rb_plus(suc, 1)};}
      else if (/(>=|=>)/['$===']($case)) {
      __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
      __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
      __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
      __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
      __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
      __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
      __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
      __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
      __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
      __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
      __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
      __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
      __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
      __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
      __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
      __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
      __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
      __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
      __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
      __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
      if ($truthy($rb_ge(dice_now, diff))) {
        suc = $rb_plus(suc, 1)};}
      else if (/(<>)/['$===']($case)) {
      __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
      __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
      __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
      __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
      __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
      __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
      __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
      __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
      __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
      __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
      __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
      __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
      __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
      __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
      __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
      __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
      __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
      __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
      __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
      __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
      if ($truthy(dice_now['$!='](diff))) {
        suc = $rb_plus(suc, 1)};}
      else if (/[<]+/['$===']($case)) {
      __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
      __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
      __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
      __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
      __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
      __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
      __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
      __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
      __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
      __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
      __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
      __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
      __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
      __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
      __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
      __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
      __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
      __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
      __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
      __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
      if ($truthy($rb_lt(dice_now, diff))) {
        suc = $rb_plus(suc, 1)};}
      else if (/[>]+/['$===']($case)) {
      __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
      __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
      __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
      __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
      __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
      __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
      __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
      __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
      __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
      __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
      __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
      __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
      __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
      __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
      __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
      __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
      __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
      __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
      __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
      __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
      if ($truthy($rb_gt(dice_now, diff))) {
        suc = $rb_plus(suc, 1)};}
      else if (/[=]+/['$===']($case)) {
      __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
      __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
      __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
      __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
      __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
      __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
      __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
      __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
      __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
      __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
      __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
      __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
      __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
      __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
      __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
      __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
      __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
      __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
      __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
      __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
      if ($truthy(dice_now['$=='](diff))) {
        suc = $rb_plus(suc, 1)};};
      return suc;
    }, $BCDice_check_hit$100.$$arity = 3);
    
    Opal.def(self, '$check_suc', $BCDice_check_suc$101 = function $$check_suc($a) {
      var $post_args, check_param, $b, self = this, total_n = nil, dice_n = nil, signOfInequality = nil, diff = nil, dice_cnt = nil, dice_max = nil, n1 = nil, n_max = nil, __last__match__1 = nil, __last__match__2 = nil, __last__match__3 = nil, __last__match__4 = nil, __last__match__5 = nil, __last__match__6 = nil, __last__match__7 = nil, __last__match__8 = nil, __last__match__9 = nil, __last__match__10 = nil, __last__match__11 = nil, __last__match__12 = nil, __last__match__13 = nil, __last__match__14 = nil, __last__match__15 = nil, __last__match__16 = nil, __last__match__17 = nil, __last__match__18 = nil, __last__match__19 = nil, __last__match__20 = nil, check_paramNew = nil, text = nil;

      
      
      $post_args = Opal.slice.call(arguments, 0, arguments.length);
      
      check_param = $post_args;;
      $b = [].concat(Opal.to_a(check_param)), (total_n = ($b[0] == null ? nil : $b[0])), (dice_n = ($b[1] == null ? nil : $b[1])), (signOfInequality = ($b[2] == null ? nil : $b[2])), (diff = ($b[3] == null ? nil : $b[3])), (dice_cnt = ($b[4] == null ? nil : $b[4])), (dice_max = ($b[5] == null ? nil : $b[5])), (n1 = ($b[6] == null ? nil : $b[6])), (n_max = ($b[7] == null ? nil : $b[7])), $b;
      self.$debug("check params : total_n, dice_n, signOfInequality, diff, dice_cnt, dice_max, n1, n_max", total_n, dice_n, signOfInequality, diff, dice_cnt, dice_max, n1, n_max);
      if ($truthy(/((\+|\-)?[\d]+)[)]?$/['$=~'](total_n.$to_s()))) {
      } else {
        return ""
      };
      __last__match__1 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](1));
      __last__match__2 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](2));
      __last__match__3 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](3));
      __last__match__4 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](4));
      __last__match__5 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](5));
      __last__match__6 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](6));
      __last__match__7 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](7));
      __last__match__8 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](8));
      __last__match__9 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](9));
      __last__match__10 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](10));
      __last__match__11 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](11));
      __last__match__12 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](12));
      __last__match__13 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](13));
      __last__match__14 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](14));
      __last__match__15 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](15));
      __last__match__16 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](16));
      __last__match__17 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](17));
      __last__match__18 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](18));
      __last__match__19 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](19));
      __last__match__20 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](20));
      total_n = __last__match__1.$to_i();
      diff = diff.$to_i();
      check_paramNew = [total_n, dice_n, signOfInequality, diff, dice_cnt, dice_max, n1, n_max];
      text = $send(self, 'getSuccessText', Opal.to_a(check_paramNew));
      text = ($truthy($b = text) ? $b : "");
      if ($truthy(text['$empty?']())) {
        if ($truthy(signOfInequality['$!='](""))) {
          
          self.$debug("どれでもないけど判定するとき");
          return $send(self, 'check_nDx', Opal.to_a(check_param));}};
      return text;
    }, $BCDice_check_suc$101.$$arity = -1);
    
    Opal.def(self, '$getSuccessText', $BCDice_getSuccessText$102 = function $$getSuccessText($a) {
      var $post_args, check_param, $b, self = this, total_n = nil, dice_n = nil, signOfInequality = nil, diff = nil, dice_cnt = nil, dice_max = nil, n1 = nil, n_max = nil, result = nil;

      
      
      $post_args = Opal.slice.call(arguments, 0, arguments.length);
      
      check_param = $post_args;;
      self.$debug("getSuccessText begin");
      $b = [].concat(Opal.to_a(check_param)), (total_n = ($b[0] == null ? nil : $b[0])), (dice_n = ($b[1] == null ? nil : $b[1])), (signOfInequality = ($b[2] == null ? nil : $b[2])), (diff = ($b[3] == null ? nil : $b[3])), (dice_cnt = ($b[4] == null ? nil : $b[4])), (dice_max = ($b[5] == null ? nil : $b[5])), (n1 = ($b[6] == null ? nil : $b[6])), (n_max = ($b[7] == null ? nil : $b[7])), $b;
      self.$debug("dice_max, dice_cnt", dice_max, dice_cnt);
      if ($truthy(($truthy($b = dice_max['$=='](100)) ? dice_cnt['$=='](1) : $b))) {
        
        self.$debug("1D100判定");
        return $send(self.diceBot, 'check_1D100', Opal.to_a(check_param));};
      if ($truthy(($truthy($b = dice_max['$=='](20)) ? dice_cnt['$=='](1) : $b))) {
        
        self.$debug("1d20判定");
        return $send(self.diceBot, 'check_1D20', Opal.to_a(check_param));};
      if ($truthy(dice_max['$=='](10))) {
        
        self.$debug("d10ベース判定");
        return $send(self.diceBot, 'check_nD10', Opal.to_a(check_param));};
      if ($truthy(dice_max['$=='](6))) {
        
        if ($truthy(dice_cnt['$=='](2))) {
          
          self.$debug("2d6判定");
          result = $send(self.diceBot, 'check_2D6', Opal.to_a(check_param));
          if ($truthy(result['$empty?']())) {
          } else {
            return result
          };};
        self.$debug("xD6判定");
        return $send(self.diceBot, 'check_nD6', Opal.to_a(check_param));};
      return "";
    }, $BCDice_getSuccessText$102.$$arity = -1);
    
    Opal.def(self, '$check_nDx', $BCDice_check_nDx$103 = function $$check_nDx(total_n, dice_n, signOfInequality, diff, dice_cnt, dice_max, n1, n_max) {
      var self = this, success = nil;

      
      self.$debug("check_nDx begin diff", diff);
      success = self.$check_hit(total_n, signOfInequality, diff);
      self.$debug("check_nDx success", success);
      if ($truthy($rb_ge(success, 1))) {
        return " ＞ 成功"};
      return " ＞ 失敗";
    }, $BCDice_check_nDx$103.$$arity = 8);
    
    Opal.def(self, '$broadmsg', $BCDice_broadmsg$104 = function $$broadmsg(output, nick) {
      var self = this;

      
      self.$debug("broadmsg output, nick", output, nick);
      self.$debug("@nick_e", self.nick_e);
      if ($truthy(output['$==']("1"))) {
        return nil};
      if ($truthy(nick['$=='](self.nick_e))) {
        return self.$sendMessageToOnlySender(output)
      } else {
        return self.$sendMessage(nick, output)
      };
    }, $BCDice_broadmsg$104.$$arity = 2);
    
    Opal.def(self, '$sendMessage', $BCDice_sendMessage$105 = function $$sendMessage(to, message) {
      var self = this;

      
      self.$debug("sendMessage to, message", to, message);
      self.ircClient.$sendMessage(to, message);
      return (self.isMessagePrinted = true);
    }, $BCDice_sendMessage$105.$$arity = 2);
    
    Opal.def(self, '$sendMessageToOnlySender', $BCDice_sendMessageToOnlySender$106 = function $$sendMessageToOnlySender(message) {
      var self = this;

      
      self.$debug("sendMessageToOnlySender message", message);
      self.$debug("@nick_e", self.nick_e);
      self.ircClient.$sendMessageToOnlySender(self.nick_e, message);
      return (self.isMessagePrinted = true);
    }, $BCDice_sendMessageToOnlySender$106.$$arity = 1);
    
    Opal.def(self, '$sendMessageToChannels', $BCDice_sendMessageToChannels$107 = function $$sendMessageToChannels(message) {
      var self = this;

      
      self.ircClient.$sendMessageToChannels(message);
      return (self.isMessagePrinted = true);
    }, $BCDice_sendMessageToChannels$107.$$arity = 1);
    
    Opal.def(self, '$parren_killer', $BCDice_parren_killer$108 = function $$parren_killer(string) {
      var $a, $b, $c, $$109, self = this, __last__match__1 = nil, __last__match__2 = nil, __last__match__3 = nil, __last__match__4 = nil, __last__match__5 = nil, __last__match__6 = nil, __last__match__7 = nil, __last__match__8 = nil, __last__match__9 = nil, __last__match__10 = nil, __last__match__11 = nil, __last__match__12 = nil, __last__match__13 = nil, __last__match__14 = nil, __last__match__15 = nil, __last__match__16 = nil, __last__match__17 = nil, __last__match__18 = nil, __last__match__19 = nil, __last__match__20 = nil, str_before = nil, str_after = nil, dice_cmd = nil, rolled = nil, dmy = nil, str_a = nil, str_b = nil, par_i = nil, par_o = nil;
      if ($gvars.str_a == null) $gvars.str_a = nil;

      
      self.$debug("parren_killer input", string);
      while ($truthy(/^(.*?)\[(\d+[Dd]\d+)\](.*)/['$=~'](string))) {
        
        __last__match__1 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](1));
        __last__match__2 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](2));
        __last__match__3 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](3));
        __last__match__4 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](4));
        __last__match__5 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](5));
        __last__match__6 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](6));
        __last__match__7 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](7));
        __last__match__8 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](8));
        __last__match__9 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](9));
        __last__match__10 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](10));
        __last__match__11 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](11));
        __last__match__12 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](12));
        __last__match__13 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](13));
        __last__match__14 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](14));
        __last__match__15 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](15));
        __last__match__16 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](16));
        __last__match__17 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](17));
        __last__match__18 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](18));
        __last__match__19 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](19));
        __last__match__20 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](20));
        str_before = "";
        str_after = "";
        dice_cmd = __last__match__2;
        if ($truthy(__last__match__1)) {
          str_before = __last__match__1};
        if ($truthy(__last__match__3)) {
          str_after = __last__match__3};
        $c = self.$rollDiceAddingUp(dice_cmd), $b = Opal.to_ary($c), (rolled = ($b[0] == null ? nil : $b[0])), (dmy = ($b[1] == null ? nil : $b[1])), $c;
        string = "" + (str_before) + (rolled) + (str_after);
      };
      string = self.$changeRangeTextToNumberText(string);
      while ($truthy(/^(.*?)(\([\d\/*+-]+?\))(.*)/['$=~'](string))) {
        
        __last__match__1 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](1));
        __last__match__2 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](2));
        __last__match__3 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](3));
        __last__match__4 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](4));
        __last__match__5 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](5));
        __last__match__6 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](6));
        __last__match__7 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](7));
        __last__match__8 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](8));
        __last__match__9 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](9));
        __last__match__10 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](10));
        __last__match__11 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](11));
        __last__match__12 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](12));
        __last__match__13 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](13));
        __last__match__14 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](14));
        __last__match__15 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](15));
        __last__match__16 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](16));
        __last__match__17 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](17));
        __last__match__18 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](18));
        __last__match__19 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](19));
        __last__match__20 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](20));
        self.$debug("while string", string);
        str_a = __last__match__3;
        str_a = ($truthy($b = str_a) ? $b : "");
        str_b = __last__match__1;
        str_b = ($truthy($b = str_b) ? $b : "");
        self.$debug("str_b", str_b);
        par_i = __last__match__2;
        self.$debug("par_i", par_i);
        par_o = self.$paren_k(par_i);
        self.$debug("par_o", par_o);
        if ($truthy(par_o['$!='](0))) {
          
          if ($truthy($rb_lt(par_o, 0))) {
            if ($truthy(/(.+?)(\+)$/['$=~'](str_b))) {
              
              __last__match__1 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](1));
              __last__match__2 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](2));
              __last__match__3 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](3));
              __last__match__4 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](4));
              __last__match__5 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](5));
              __last__match__6 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](6));
              __last__match__7 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](7));
              __last__match__8 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](8));
              __last__match__9 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](9));
              __last__match__10 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](10));
              __last__match__11 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](11));
              __last__match__12 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](12));
              __last__match__13 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](13));
              __last__match__14 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](14));
              __last__match__15 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](15));
              __last__match__16 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](16));
              __last__match__17 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](17));
              __last__match__18 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](18));
              __last__match__19 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](19));
              __last__match__20 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](20));
              str_b = __last__match__1;
            } else if ($truthy(/(.+?)(-)$/['$=~'](str_b))) {
              
              __last__match__1 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](1));
              __last__match__2 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](2));
              __last__match__3 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](3));
              __last__match__4 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](4));
              __last__match__5 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](5));
              __last__match__6 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](6));
              __last__match__7 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](7));
              __last__match__8 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](8));
              __last__match__9 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](9));
              __last__match__10 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](10));
              __last__match__11 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](11));
              __last__match__12 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](12));
              __last__match__13 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](13));
              __last__match__14 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](14));
              __last__match__15 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](15));
              __last__match__16 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](16));
              __last__match__17 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](17));
              __last__match__18 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](18));
              __last__match__19 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](19));
              __last__match__20 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](20));
              str_b = "" + (__last__match__1) + "+";
              par_o = $rb_times(par_o, -1);}};
          string = "" + (str_b) + (par_o) + (str_a);
        } else {
          
          if ($truthy(/^([DBRUdbru][\d]+)(.*)/['$=~']($gvars.str_a))) {
            
            __last__match__1 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](1));
            __last__match__2 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](2));
            __last__match__3 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](3));
            __last__match__4 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](4));
            __last__match__5 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](5));
            __last__match__6 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](6));
            __last__match__7 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](7));
            __last__match__8 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](8));
            __last__match__9 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](9));
            __last__match__10 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](10));
            __last__match__11 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](11));
            __last__match__12 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](12));
            __last__match__13 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](13));
            __last__match__14 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](14));
            __last__match__15 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](15));
            __last__match__16 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](16));
            __last__match__17 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](17));
            __last__match__18 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](18));
            __last__match__19 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](19));
            __last__match__20 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](20));
            str_a = __last__match__2;};
          string = "" + (str_b) + "0" + (str_a);
        };
      };
      self.$debug("diceBot.changeText(string) begin", string);
      string = self.diceBot.$changeText(string);
      self.$debug("diceBot.changeText(string) end", string);
      string = $send(string, 'gsub', [/([\d]+[dD])([^\d\w]|$)/], ($$109 = function(){var self = $$109.$$s || this, $d;

      
        __last__match__1 = (($d = $gvars['~']) === nil ? nil : $d['$[]'](1));
        __last__match__2 = (($d = $gvars['~']) === nil ? nil : $d['$[]'](2));
        __last__match__3 = (($d = $gvars['~']) === nil ? nil : $d['$[]'](3));
        __last__match__4 = (($d = $gvars['~']) === nil ? nil : $d['$[]'](4));
        __last__match__5 = (($d = $gvars['~']) === nil ? nil : $d['$[]'](5));
        __last__match__6 = (($d = $gvars['~']) === nil ? nil : $d['$[]'](6));
        __last__match__7 = (($d = $gvars['~']) === nil ? nil : $d['$[]'](7));
        __last__match__8 = (($d = $gvars['~']) === nil ? nil : $d['$[]'](8));
        __last__match__9 = (($d = $gvars['~']) === nil ? nil : $d['$[]'](9));
        __last__match__10 = (($d = $gvars['~']) === nil ? nil : $d['$[]'](10));
        __last__match__11 = (($d = $gvars['~']) === nil ? nil : $d['$[]'](11));
        __last__match__12 = (($d = $gvars['~']) === nil ? nil : $d['$[]'](12));
        __last__match__13 = (($d = $gvars['~']) === nil ? nil : $d['$[]'](13));
        __last__match__14 = (($d = $gvars['~']) === nil ? nil : $d['$[]'](14));
        __last__match__15 = (($d = $gvars['~']) === nil ? nil : $d['$[]'](15));
        __last__match__16 = (($d = $gvars['~']) === nil ? nil : $d['$[]'](16));
        __last__match__17 = (($d = $gvars['~']) === nil ? nil : $d['$[]'](17));
        __last__match__18 = (($d = $gvars['~']) === nil ? nil : $d['$[]'](18));
        __last__match__19 = (($d = $gvars['~']) === nil ? nil : $d['$[]'](19));
        __last__match__20 = (($d = $gvars['~']) === nil ? nil : $d['$[]'](20));
        return "" + (__last__match__1) + "6" + (__last__match__2);}, $$109.$$s = self, $$109.$$arity = 0, $$109));
      self.$debug("parren_killer output", string);
      return string;
    }, $BCDice_parren_killer$108.$$arity = 1);
    
    Opal.def(self, '$rollDiceAddingUp', $BCDice_rollDiceAddingUp$110 = function $$rollDiceAddingUp($a) {
      var $post_args, arg, self = this, dice = nil;

      
      
      $post_args = Opal.slice.call(arguments, 0, arguments.length);
      
      arg = $post_args;;
      dice = $$($nesting, 'AddDice').$new(self, self.diceBot);
      return $send(dice, 'rollDiceAddingUp', Opal.to_a(arg));
    }, $BCDice_rollDiceAddingUp$110.$$arity = -1);
    
    Opal.def(self, '$changeRangeTextToNumberText', $BCDice_changeRangeTextToNumberText$111 = function $$changeRangeTextToNumberText(string) {
      var $a, $b, $c, self = this, __last__match__1 = nil, __last__match__2 = nil, __last__match__3 = nil, __last__match__4 = nil, __last__match__5 = nil, __last__match__6 = nil, __last__match__7 = nil, __last__match__8 = nil, __last__match__9 = nil, __last__match__10 = nil, __last__match__11 = nil, __last__match__12 = nil, __last__match__13 = nil, __last__match__14 = nil, __last__match__15 = nil, __last__match__16 = nil, __last__match__17 = nil, __last__match__18 = nil, __last__match__19 = nil, __last__match__20 = nil, beforeText = nil, rangeBegin = nil, rangeEnd = nil, afterText = nil, range = nil, rolledNumber = nil, resultNumber = nil;

      
      self.$debug("[st...ed] before string", string);
      while ($truthy(/^(.*?)\[(\d+)[.]{3}(\d+)\](.*)/['$=~'](string))) {
        
        __last__match__1 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](1));
        __last__match__2 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](2));
        __last__match__3 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](3));
        __last__match__4 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](4));
        __last__match__5 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](5));
        __last__match__6 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](6));
        __last__match__7 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](7));
        __last__match__8 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](8));
        __last__match__9 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](9));
        __last__match__10 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](10));
        __last__match__11 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](11));
        __last__match__12 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](12));
        __last__match__13 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](13));
        __last__match__14 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](14));
        __last__match__15 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](15));
        __last__match__16 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](16));
        __last__match__17 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](17));
        __last__match__18 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](18));
        __last__match__19 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](19));
        __last__match__20 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](20));
        beforeText = __last__match__1;
        beforeText = ($truthy($b = beforeText) ? $b : "");
        rangeBegin = __last__match__2.$to_i();
        rangeEnd = __last__match__3.$to_i();
        afterText = __last__match__4;
        afterText = ($truthy($b = afterText) ? $b : "");
        if ($truthy($rb_lt(rangeBegin, rangeEnd))) {
          
          range = $rb_plus($rb_minus(rangeEnd, rangeBegin), 1);
          self.$debug("range", range);
          $c = self.$roll(1, range), $b = Opal.to_ary($c), (rolledNumber = ($b[0] == null ? nil : $b[0])), $c;
          resultNumber = $rb_plus($rb_minus(rangeBegin, 1), rolledNumber);
          string = "" + (beforeText) + (resultNumber) + (afterText);};
      };
      self.$debug("[st...ed] after string", string);
      return string;
    }, $BCDice_changeRangeTextToNumberText$111.$$arity = 1);
    
    Opal.def(self, '$paren_k', $BCDice_paren_k$112 = function $$paren_k(string) {
      var $a, $$113, self = this, result = nil, __last__match__1 = nil, __last__match__2 = nil, __last__match__3 = nil, __last__match__4 = nil, __last__match__5 = nil, __last__match__6 = nil, __last__match__7 = nil, __last__match__8 = nil, __last__match__9 = nil, __last__match__10 = nil, __last__match__11 = nil, __last__match__12 = nil, __last__match__13 = nil, __last__match__14 = nil, __last__match__15 = nil, __last__match__16 = nil, __last__match__17 = nil, __last__match__18 = nil, __last__match__19 = nil, __last__match__20 = nil, list = nil;

      
      result = 0;
      if ($truthy(/([\d\/*+-]+)/['$=~'](string))) {
      } else {
        return result
      };
      __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
      __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
      __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
      __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
      __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
      __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
      __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
      __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
      __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
      __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
      __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
      __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
      __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
      __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
      __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
      __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
      __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
      __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
      __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
      __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
      string = __last__match__1;
      string = string.$gsub(/\-\-/, "+");
      self.$debug("paren_k string", string);
      list = self.$split_plus_minus(string);
      self.$debug("paren_k list", list);
      result = 0;
      $send(list, 'each', [], ($$113 = function(text){var self = $$113.$$s || this;

      
        
        if (text == null) {
          text = nil;
        };
        return (result = $rb_plus(result, self.$paren_k_loop(text)));}, $$113.$$s = self, $$113.$$arity = 1, $$113));
      return result;
    }, $BCDice_paren_k$112.$$arity = 1);
    
    Opal.def(self, '$split_plus_minus', $BCDice_split_plus_minus$114 = function $$split_plus_minus(string) {
      var $$115, self = this, list = nil, result = nil;

      
      list = string.$scan(/[\+\-]?[^\+\-]+/);
      self.$debug("split_plus_minus list", list);
      result = [];
      $send(list.$length(), 'times', [], ($$115 = function(i){var self = $$115.$$s || this, $a, __last__match__1 = nil, __last__match__2 = nil, __last__match__3 = nil, __last__match__4 = nil, __last__match__5 = nil, __last__match__6 = nil, __last__match__7 = nil, __last__match__8 = nil, __last__match__9 = nil, __last__match__10 = nil, __last__match__11 = nil, __last__match__12 = nil, __last__match__13 = nil, __last__match__14 = nil, __last__match__15 = nil, __last__match__16 = nil, __last__match__17 = nil, __last__match__18 = nil, __last__match__19 = nil, __last__match__20 = nil, $writer = nil;

      
        
        if (i == null) {
          i = nil;
        };
        if ($truthy(result['$empty?']())) {
        } else if ($truthy(/(\*|\/)$/['$==='](result.$last()))) {
          
          __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
          __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
          __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
          __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
          __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
          __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
          __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
          __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
          __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
          __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
          __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
          __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
          __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
          __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
          __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
          __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
          __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
          __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
          __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
          __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
          
          $writer = [$rb_minus(result.$length(), 1), $rb_plus(result['$[]']($rb_minus(result.$length(), 1)), list['$[]'](i))];
          $send(result, '[]=', Opal.to_a($writer));
          $writer[$rb_minus($writer["length"], 1)];;
          return nil;;};
        return result.$push(list['$[]'](i));}, $$115.$$s = self, $$115.$$arity = 1, $$115));
      self.$debug("split_plus_minus result", result);
      return result;
    }, $BCDice_split_plus_minus$114.$$arity = 1);
    
    Opal.def(self, '$paren_k_loop', $BCDice_paren_k_loop$116 = function $$paren_k_loop(string) {
      var self = this, result = nil;

      
      self.$debug("paren_k_plus Begin", string);
      result = self.$paren_k_calculate_multiple_divide_text(string);
      self.$debug("paren_k_plus End result", result);
      return result;
    }, $BCDice_paren_k_loop$116.$$arity = 1);
    
    Opal.def(self, '$paren_k_calculate_multiple_divide_text', $BCDice_paren_k_calculate_multiple_divide_text$117 = function $$paren_k_calculate_multiple_divide_text(string) {
      var $a, $b, self = this, multi = nil, divide = nil, result = nil;

      
      multi = 1;
      divide = 1;
      $b = self.$paren_k_multi(string), $a = Opal.to_ary($b), (string = ($a[0] == null ? nil : $a[0])), (multi = ($a[1] == null ? nil : $a[1])), $b;
      $b = self.$paren_k_devide(string), $a = Opal.to_ary($b), (string = ($a[0] == null ? nil : $a[0])), (divide = ($a[1] == null ? nil : $a[1])), $b;
      result = self.$calculate_multiple_divide(string, multi, divide);
      return result;
    }, $BCDice_paren_k_calculate_multiple_divide_text$117.$$arity = 1);
    
    Opal.def(self, '$paren_k_multi', $BCDice_paren_k_multi$118 = function $$paren_k_multi(string) {
      var $a, $b, self = this, multi = nil, __last__match__1 = nil, __last__match__2 = nil, __last__match__3 = nil, __last__match__4 = nil, __last__match__5 = nil, __last__match__6 = nil, __last__match__7 = nil, __last__match__8 = nil, __last__match__9 = nil, __last__match__10 = nil, __last__match__11 = nil, __last__match__12 = nil, __last__match__13 = nil, __last__match__14 = nil, __last__match__15 = nil, __last__match__16 = nil, __last__match__17 = nil, __last__match__18 = nil, __last__match__19 = nil, __last__match__20 = nil, before = nil, after = nil, calculate_text = nil;

      
      self.$debug("paren_k_multi Begin string", string);
      multi = 1;
      while ($truthy(/(.*?)(\*[-\d]+)(.*)/['$=~'](string))) {
        
        __last__match__1 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](1));
        __last__match__2 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](2));
        __last__match__3 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](3));
        __last__match__4 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](4));
        __last__match__5 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](5));
        __last__match__6 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](6));
        __last__match__7 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](7));
        __last__match__8 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](8));
        __last__match__9 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](9));
        __last__match__10 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](10));
        __last__match__11 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](11));
        __last__match__12 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](12));
        __last__match__13 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](13));
        __last__match__14 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](14));
        __last__match__15 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](15));
        __last__match__16 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](16));
        __last__match__17 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](17));
        __last__match__18 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](18));
        __last__match__19 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](19));
        __last__match__20 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](20));
        before = __last__match__1;
        after = __last__match__3;
        calculate_text = __last__match__2;
        string = "" + (before) + (after);
        if ($truthy(/([-\d]+)/['$=~'](calculate_text))) {
          
          __last__match__1 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](1));
          __last__match__2 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](2));
          __last__match__3 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](3));
          __last__match__4 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](4));
          __last__match__5 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](5));
          __last__match__6 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](6));
          __last__match__7 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](7));
          __last__match__8 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](8));
          __last__match__9 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](9));
          __last__match__10 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](10));
          __last__match__11 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](11));
          __last__match__12 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](12));
          __last__match__13 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](13));
          __last__match__14 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](14));
          __last__match__15 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](15));
          __last__match__16 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](16));
          __last__match__17 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](17));
          __last__match__18 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](18));
          __last__match__19 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](19));
          __last__match__20 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](20));
          multi = $rb_times(multi, __last__match__1.$to_i());};
      };
      self.$debug("paren_k_multi End multi", multi);
      self.$debug("paren_k_multi End", string);
      return [string, multi];
    }, $BCDice_paren_k_multi$118.$$arity = 1);
    
    Opal.def(self, '$paren_k_devide', $BCDice_paren_k_devide$119 = function $$paren_k_devide(string) {
      var $a, $b, self = this, divide = nil, __last__match__1 = nil, __last__match__2 = nil, __last__match__3 = nil, __last__match__4 = nil, __last__match__5 = nil, __last__match__6 = nil, __last__match__7 = nil, __last__match__8 = nil, __last__match__9 = nil, __last__match__10 = nil, __last__match__11 = nil, __last__match__12 = nil, __last__match__13 = nil, __last__match__14 = nil, __last__match__15 = nil, __last__match__16 = nil, __last__match__17 = nil, __last__match__18 = nil, __last__match__19 = nil, __last__match__20 = nil, before = nil, after = nil, calculate_text = nil;

      
      divide = 1;
      while ($truthy(/(.*?)(\/[-\d]+)(.*)/['$=~'](string))) {
        
        __last__match__1 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](1));
        __last__match__2 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](2));
        __last__match__3 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](3));
        __last__match__4 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](4));
        __last__match__5 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](5));
        __last__match__6 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](6));
        __last__match__7 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](7));
        __last__match__8 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](8));
        __last__match__9 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](9));
        __last__match__10 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](10));
        __last__match__11 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](11));
        __last__match__12 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](12));
        __last__match__13 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](13));
        __last__match__14 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](14));
        __last__match__15 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](15));
        __last__match__16 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](16));
        __last__match__17 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](17));
        __last__match__18 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](18));
        __last__match__19 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](19));
        __last__match__20 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](20));
        before = __last__match__1;
        after = __last__match__3;
        calculate_text = __last__match__2;
        string = "" + (before) + (after);
        if ($truthy(/([-\d]+)/['$=~'](calculate_text))) {
          
          __last__match__1 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](1));
          __last__match__2 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](2));
          __last__match__3 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](3));
          __last__match__4 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](4));
          __last__match__5 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](5));
          __last__match__6 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](6));
          __last__match__7 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](7));
          __last__match__8 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](8));
          __last__match__9 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](9));
          __last__match__10 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](10));
          __last__match__11 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](11));
          __last__match__12 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](12));
          __last__match__13 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](13));
          __last__match__14 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](14));
          __last__match__15 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](15));
          __last__match__16 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](16));
          __last__match__17 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](17));
          __last__match__18 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](18));
          __last__match__19 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](19));
          __last__match__20 = (($b = $gvars['~']) === nil ? nil : $b['$[]'](20));
          divide = $rb_times(divide, __last__match__1.$to_i());};
      };
      return [string, divide];
    }, $BCDice_paren_k_devide$119.$$arity = 1);
    
    Opal.def(self, '$calculate_multiple_divide', $BCDice_calculate_multiple_divide$120 = function $$calculate_multiple_divide(string, multi, divide) {
      var $a, self = this, result = nil, __last__match__1 = nil, __last__match__2 = nil, __last__match__3 = nil, __last__match__4 = nil, __last__match__5 = nil, __last__match__6 = nil, __last__match__7 = nil, __last__match__8 = nil, __last__match__9 = nil, __last__match__10 = nil, __last__match__11 = nil, __last__match__12 = nil, __last__match__13 = nil, __last__match__14 = nil, __last__match__15 = nil, __last__match__16 = nil, __last__match__17 = nil, __last__match__18 = nil, __last__match__19 = nil, __last__match__20 = nil, work = nil, $case = nil;

      
      result = 0;
      if ($truthy(divide['$=='](0))) {
        return result};
      if ($truthy(/([-\d]+)/['$=~'](string))) {
      } else {
        return result
      };
      __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
      __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
      __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
      __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
      __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
      __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
      __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
      __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
      __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
      __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
      __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
      __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
      __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
      __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
      __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
      __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
      __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
      __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
      __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
      __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
      work = $rb_times(__last__match__1.$to_i(), multi);
      $case = self.diceBot.$fractionType();
      if ("roundUp"['$===']($case)) {result = $rb_plus($rb_divide(work, divide), 0.999).$to_i()}
      else if ("roundOff"['$===']($case)) {result = $rb_plus($rb_divide(work, divide), 0.5).$to_i()}
      else {result = $rb_divide(work, divide).$to_i()};
      return result;
    }, $BCDice_calculate_multiple_divide$120.$$arity = 3);
    
    Opal.def(self, '$setGameByTitle', $BCDice_setGameByTitle$121 = function $$setGameByTitle(gameTitle) {
      var $a, self = this, loader = nil, diceBot = nil, message = nil;

      
      self.$debug("setGameByTitle gameTitle", gameTitle);
      self.cardTrader.$initValues();
      loader = $$($nesting, 'DiceBotLoaderList').$find(gameTitle);
      diceBot = (function() {if ($truthy(loader)) {
        return loader.$loadDiceBot()
      } else {
        return ($truthy($a = $$($nesting, 'DiceBotLoader').$loadUnknownGame(gameTitle)) ? $a : $$($nesting, 'DiceBot').$new())
      }; return nil; })();
      self.$setDiceBot(diceBot);
      diceBot.$postSet();
      message = "" + "Game設定を" + (diceBot.$gameName()) + "に設定しました";
      self.$debug("setGameByTitle message", message);
      return message;
    }, $BCDice_setGameByTitle$121.$$arity = 1);
    
    Opal.def(self, '$setIrcMode', $BCDice_setIrcMode$122 = function $$setIrcMode(mode) {
      var self = this;

      return (self.isIrcMode = mode)
    }, $BCDice_setIrcMode$122.$$arity = 1);
    return (Opal.def(self, '$sleepForIrc', $BCDice_sleepForIrc$123 = function $$sleepForIrc(second) {
      var self = this;

      if ($truthy(self.isIrcMode)) {
        return self.$sleep(second)
      } else {
        return nil
      }
    }, $BCDice_sleepForIrc$123.$$arity = 1), nil) && 'sleepForIrc';
  })($nesting[0], null, $nesting);
};

/* Generated by Opal 0.11.99.dev */
Opal.modules["native"] = function(Opal) {
  function $rb_minus(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs - rhs : lhs['$-'](rhs);
  }
  function $rb_ge(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs >= rhs : lhs['$>='](rhs);
  }
  var self = Opal.top, $nesting = [], nil = Opal.nil, $$$ = Opal.const_get_qualified, $$ = Opal.const_get_relative, $breaker = Opal.breaker, $slice = Opal.slice, $module = Opal.module, $truthy = Opal.truthy, $send = Opal.send, $hash2 = Opal.hash2, $range = Opal.range, $klass = Opal.klass, $gvars = Opal.gvars;

  Opal.add_stubs(['$try_convert', '$native?', '$respond_to?', '$to_n', '$raise', '$inspect', '$Native', '$proc', '$map!', '$end_with?', '$define_method', '$[]', '$convert', '$call', '$to_proc', '$new', '$each', '$native_reader', '$native_writer', '$extend', '$warn', '$include', '$is_a?', '$map', '$to_a', '$_Array', '$method_missing', '$bind', '$instance_method', '$slice', '$-', '$length', '$[]=', '$enum_for', '$===', '$>=', '$<<', '$each_pair', '$_initialize', '$name', '$exiting_mid', '$native_module']);
  
  (function($base, $parent_nesting) {
    var self = $module($base, 'Native');

    var $nesting = [self].concat($parent_nesting), $Native_is_a$ques$1, $Native_try_convert$2, $Native_convert$3, $Native_call$4, $Native_proc$5, $Native_included$22;

    
    Opal.defs(self, '$is_a?', $Native_is_a$ques$1 = function(object, klass) {
      var self = this;

      
      try {
        return object instanceof self.$try_convert(klass);
      }
      catch (e) {
        return false;
      }
    
    }, $Native_is_a$ques$1.$$arity = 2);
    Opal.defs(self, '$try_convert', $Native_try_convert$2 = function $$try_convert(value, default$) {
      var self = this;

      
      
      if (default$ == null) {
        default$ = nil;
      };
      
      if (self['$native?'](value)) {
        return value;
      }
      else if (value['$respond_to?']("to_n")) {
        return value.$to_n();
      }
      else {
        return default$;
      }
    ;
    }, $Native_try_convert$2.$$arity = -2);
    Opal.defs(self, '$convert', $Native_convert$3 = function $$convert(value) {
      var self = this;

      
      if (self['$native?'](value)) {
        return value;
      }
      else if (value['$respond_to?']("to_n")) {
        return value.$to_n();
      }
      else {
        self.$raise($$($nesting, 'ArgumentError'), "" + (value.$inspect()) + " isn't native");
      }
    
    }, $Native_convert$3.$$arity = 1);
    Opal.defs(self, '$call', $Native_call$4 = function $$call(obj, key, $a) {
      var $iter = $Native_call$4.$$p, block = $iter || nil, $post_args, args, self = this;

      if ($iter) $Native_call$4.$$p = null;
      
      
      if ($iter) $Native_call$4.$$p = null;;
      
      $post_args = Opal.slice.call(arguments, 2, arguments.length);
      
      args = $post_args;;
      
      var prop = obj[key];

      if (prop instanceof Function) {
        var converted = new Array(args.length);

        for (var i = 0, l = args.length; i < l; i++) {
          var item = args[i],
              conv = self.$try_convert(item);

          converted[i] = conv === nil ? item : conv;
        }

        if (block !== nil) {
          converted.push(block);
        }

        return self.$Native(prop.apply(obj, converted));
      }
      else {
        return self.$Native(prop);
      }
    ;
    }, $Native_call$4.$$arity = -3);
    Opal.defs(self, '$proc', $Native_proc$5 = function $$proc() {
      var $iter = $Native_proc$5.$$p, block = $iter || nil, $$6, self = this;

      if ($iter) $Native_proc$5.$$p = null;
      
      
      if ($iter) $Native_proc$5.$$p = null;;
      if ($truthy(block)) {
      } else {
        self.$raise($$($nesting, 'LocalJumpError'), "no block given")
      };
      return $send($$$('::', 'Kernel'), 'proc', [], ($$6 = function($a){var self = $$6.$$s || this, $post_args, args, $$7, instance = nil;

      
        
        $post_args = Opal.slice.call(arguments, 0, arguments.length);
        
        args = $post_args;;
        $send(args, 'map!', [], ($$7 = function(arg){var self = $$7.$$s || this;

        
          
          if (arg == null) {
            arg = nil;
          };
          return self.$Native(arg);}, $$7.$$s = self, $$7.$$arity = 1, $$7));
        instance = self.$Native(this);
        
        // if global is current scope, run the block in the scope it was defined
        if (this === Opal.global) {
          return block.apply(self, args);
        }

        var self_ = block.$$s;
        block.$$s = null;

        try {
          return block.apply(instance, args);
        }
        finally {
          block.$$s = self_;
        }
      ;}, $$6.$$s = self, $$6.$$arity = -1, $$6));
    }, $Native_proc$5.$$arity = 0);
    (function($base, $parent_nesting) {
      var self = $module($base, 'Helpers');

      var $nesting = [self].concat($parent_nesting), $Helpers_alias_native$8, $Helpers_native_reader$12, $Helpers_native_writer$15, $Helpers_native_accessor$18;

      
      
      Opal.def(self, '$alias_native', $Helpers_alias_native$8 = function $$alias_native(new$, $a, $b) {
        var $post_args, $kwargs, old, as, $$9, $$10, $$11, $iter = $Helpers_alias_native$8.$$p, $yield = $iter || nil, self = this;

        if ($iter) $Helpers_alias_native$8.$$p = null;
        
        
        $post_args = Opal.slice.call(arguments, 1, arguments.length);
        
        $kwargs = Opal.extract_kwargs($post_args);
        
        if ($kwargs == null) {
          $kwargs = $hash2([], {});
        } else if (!$kwargs.$$is_hash) {
          throw Opal.ArgumentError.$new('expected kwargs');
        };
        
        if ($post_args.length > 0) {
          old = $post_args[0];
          $post_args.splice(0, 1);
        }
        if (old == null) {
          old = new$;
        };
        
        as = $kwargs.$$smap["as"];
        if (as == null) {
          as = nil
        };
        if ($truthy(old['$end_with?']("="))) {
          return $send(self, 'define_method', [new$], ($$9 = function(value){var self = $$9.$$s || this;
            if (self["native"] == null) self["native"] = nil;

          
            
            if (value == null) {
              value = nil;
            };
            self["native"][old['$[]']($range(0, -2, false))] = $$($nesting, 'Native').$convert(value);
            return value;}, $$9.$$s = self, $$9.$$arity = 1, $$9))
        } else if ($truthy(as)) {
          return $send(self, 'define_method', [new$], ($$10 = function($c){var self = $$10.$$s || this, $iter = $$10.$$p, block = $iter || nil, $post_args, args, value = nil;
            if (self["native"] == null) self["native"] = nil;

          
            
            if ($iter) $$10.$$p = null;;
            
            $post_args = Opal.slice.call(arguments, 0, arguments.length);
            
            args = $post_args;;
            value = $send($$($nesting, 'Native'), 'call', [self["native"], old].concat(Opal.to_a(args)), block.$to_proc());
            if ($truthy(value)) {
              return as.$new(value.$to_n())
            } else {
              return nil
            };}, $$10.$$s = self, $$10.$$arity = -1, $$10))
        } else {
          return $send(self, 'define_method', [new$], ($$11 = function($c){var self = $$11.$$s || this, $iter = $$11.$$p, block = $iter || nil, $post_args, args;
            if (self["native"] == null) self["native"] = nil;

          
            
            if ($iter) $$11.$$p = null;;
            
            $post_args = Opal.slice.call(arguments, 0, arguments.length);
            
            args = $post_args;;
            return $send($$($nesting, 'Native'), 'call', [self["native"], old].concat(Opal.to_a(args)), block.$to_proc());}, $$11.$$s = self, $$11.$$arity = -1, $$11))
        };
      }, $Helpers_alias_native$8.$$arity = -2);
      
      Opal.def(self, '$native_reader', $Helpers_native_reader$12 = function $$native_reader($a) {
        var $post_args, names, $$13, self = this;

        
        
        $post_args = Opal.slice.call(arguments, 0, arguments.length);
        
        names = $post_args;;
        return $send(names, 'each', [], ($$13 = function(name){var self = $$13.$$s || this, $$14;

        
          
          if (name == null) {
            name = nil;
          };
          return $send(self, 'define_method', [name], ($$14 = function(){var self = $$14.$$s || this;
            if (self["native"] == null) self["native"] = nil;

          return self.$Native(self["native"][name])}, $$14.$$s = self, $$14.$$arity = 0, $$14));}, $$13.$$s = self, $$13.$$arity = 1, $$13));
      }, $Helpers_native_reader$12.$$arity = -1);
      
      Opal.def(self, '$native_writer', $Helpers_native_writer$15 = function $$native_writer($a) {
        var $post_args, names, $$16, self = this;

        
        
        $post_args = Opal.slice.call(arguments, 0, arguments.length);
        
        names = $post_args;;
        return $send(names, 'each', [], ($$16 = function(name){var self = $$16.$$s || this, $$17;

        
          
          if (name == null) {
            name = nil;
          };
          return $send(self, 'define_method', ["" + (name) + "="], ($$17 = function(value){var self = $$17.$$s || this;
            if (self["native"] == null) self["native"] = nil;

          
            
            if (value == null) {
              value = nil;
            };
            return self.$Native(self["native"][name] = value);}, $$17.$$s = self, $$17.$$arity = 1, $$17));}, $$16.$$s = self, $$16.$$arity = 1, $$16));
      }, $Helpers_native_writer$15.$$arity = -1);
      
      Opal.def(self, '$native_accessor', $Helpers_native_accessor$18 = function $$native_accessor($a) {
        var $post_args, names, self = this;

        
        
        $post_args = Opal.slice.call(arguments, 0, arguments.length);
        
        names = $post_args;;
        $send(self, 'native_reader', Opal.to_a(names));
        return $send(self, 'native_writer', Opal.to_a(names));
      }, $Helpers_native_accessor$18.$$arity = -1);
    })($nesting[0], $nesting);
    (function($base, $parent_nesting) {
      var self = $module($base, 'Wrapper');

      var $nesting = [self].concat($parent_nesting), $Wrapper_initialize$19, $Wrapper_to_n$20, $Wrapper_included$21;

      
      
      Opal.def(self, '$initialize', $Wrapper_initialize$19 = function $$initialize(native$) {
        var self = this;

        
        if ($truthy($$$('::', 'Kernel')['$native?'](native$))) {
        } else {
          $$$('::', 'Kernel').$raise($$($nesting, 'ArgumentError'), "" + (native$.$inspect()) + " isn't native")
        };
        return (self["native"] = native$);
      }, $Wrapper_initialize$19.$$arity = 1);
      
      Opal.def(self, '$to_n', $Wrapper_to_n$20 = function $$to_n() {
        var self = this;
        if (self["native"] == null) self["native"] = nil;

        return self["native"]
      }, $Wrapper_to_n$20.$$arity = 0);
      Opal.defs(self, '$included', $Wrapper_included$21 = function $$included(klass) {
        var self = this;

        return klass.$extend($$($nesting, 'Helpers'))
      }, $Wrapper_included$21.$$arity = 1);
    })($nesting[0], $nesting);
    Opal.defs(self, '$included', $Native_included$22 = function $$included(base) {
      var self = this;

      
      self.$warn("Including ::Native is deprecated. Please include Native::Wrapper instead.");
      base.$include($$($nesting, 'Wrapper'));
      return base.$extend($$($nesting, 'Helpers'));
    }, $Native_included$22.$$arity = 1);
  })($nesting[0], $nesting);
  (function($base, $parent_nesting) {
    var self = $module($base, 'Kernel');

    var $nesting = [self].concat($parent_nesting), $Kernel_native$ques$23, $Kernel_Native$24, $Kernel_Array$27;

    
    
    Opal.def(self, '$native?', $Kernel_native$ques$23 = function(value) {
      var self = this;

      return value == null || !value.$$class;
    }, $Kernel_native$ques$23.$$arity = 1);
    
    Opal.def(self, '$Native', $Kernel_Native$24 = function $$Native(obj) {
      var $$25, $$26, $iter = $Kernel_Native$24.$$p, $yield = $iter || nil, self = this;

      if ($iter) $Kernel_Native$24.$$p = null;
      if ($truthy(obj == null)) {
        return nil
      } else if ($truthy(self['$native?'](obj))) {
        return $$$($$($nesting, 'Native'), 'Object').$new(obj)
      } else if ($truthy(obj['$is_a?']($$($nesting, 'Array')))) {
        return $send(obj, 'map', [], ($$25 = function(o){var self = $$25.$$s || this;

        
          
          if (o == null) {
            o = nil;
          };
          return self.$Native(o);}, $$25.$$s = self, $$25.$$arity = 1, $$25))
      } else if ($truthy(obj['$is_a?']($$($nesting, 'Proc')))) {
        return $send(self, 'proc', [], ($$26 = function($a){var self = $$26.$$s || this, $iter = $$26.$$p, block = $iter || nil, $post_args, args;

        
          
          if ($iter) $$26.$$p = null;;
          
          $post_args = Opal.slice.call(arguments, 0, arguments.length);
          
          args = $post_args;;
          return self.$Native($send(obj, 'call', Opal.to_a(args), block.$to_proc()));}, $$26.$$s = self, $$26.$$arity = -1, $$26))
      } else {
        return obj
      }
    }, $Kernel_Native$24.$$arity = 1);
    Opal.alias(self, "_Array", "Array");
    
    Opal.def(self, '$Array', $Kernel_Array$27 = function $$Array(object, $a) {
      var $iter = $Kernel_Array$27.$$p, block = $iter || nil, $post_args, args, self = this;

      if ($iter) $Kernel_Array$27.$$p = null;
      
      
      if ($iter) $Kernel_Array$27.$$p = null;;
      
      $post_args = Opal.slice.call(arguments, 1, arguments.length);
      
      args = $post_args;;
      if ($truthy(self['$native?'](object))) {
        return $send($$$($$($nesting, 'Native'), 'Array'), 'new', [object].concat(Opal.to_a(args)), block.$to_proc()).$to_a()};
      return self.$_Array(object);
    }, $Kernel_Array$27.$$arity = -2);
  })($nesting[0], $nesting);
  (function($base, $super, $parent_nesting) {
    var self = $klass($base, $super, 'Object');

    var $nesting = [self].concat($parent_nesting), $Object_$eq_eq$28, $Object_has_key$ques$29, $Object_each$30, $Object_$$$31, $Object_$$$eq$32, $Object_merge$excl$33, $Object_respond_to$ques$34, $Object_respond_to_missing$ques$35, $Object_method_missing$36, $Object_nil$ques$37, $Object_is_a$ques$38, $Object_instance_of$ques$39, $Object_class$40, $Object_to_a$41, $Object_inspect$42;

    self.$$prototype["native"] = nil;
    
    self.$include($$$($$$('::', 'Native'), 'Wrapper'));
    
    Opal.def(self, '$==', $Object_$eq_eq$28 = function(other) {
      var self = this;

      return self["native"] === $$$('::', 'Native').$try_convert(other)
    }, $Object_$eq_eq$28.$$arity = 1);
    
    Opal.def(self, '$has_key?', $Object_has_key$ques$29 = function(name) {
      var self = this;

      return Opal.hasOwnProperty.call(self["native"], name)
    }, $Object_has_key$ques$29.$$arity = 1);
    Opal.alias(self, "key?", "has_key?");
    Opal.alias(self, "include?", "has_key?");
    Opal.alias(self, "member?", "has_key?");
    
    Opal.def(self, '$each', $Object_each$30 = function $$each($a) {
      var $post_args, args, $iter = $Object_each$30.$$p, $yield = $iter || nil, self = this;

      if ($iter) $Object_each$30.$$p = null;
      
      
      $post_args = Opal.slice.call(arguments, 0, arguments.length);
      
      args = $post_args;;
      if (($yield !== nil)) {
        
        
        for (var key in self["native"]) {
          Opal.yieldX($yield, [key, self["native"][key]])
        }
      ;
        return self;
      } else {
        return $send(self, 'method_missing', ["each"].concat(Opal.to_a(args)))
      };
    }, $Object_each$30.$$arity = -1);
    
    Opal.def(self, '$[]', $Object_$$$31 = function(key) {
      var self = this;

      
      var prop = self["native"][key];

      if (prop instanceof Function) {
        return prop;
      }
      else {
        return $$$('::', 'Native').$call(self["native"], key)
      }
    
    }, $Object_$$$31.$$arity = 1);
    
    Opal.def(self, '$[]=', $Object_$$$eq$32 = function(key, value) {
      var self = this, native$ = nil;

      
      native$ = $$$('::', 'Native').$try_convert(value);
      if ($truthy(native$ === nil)) {
        return self["native"][key] = value
      } else {
        return self["native"][key] = native$
      };
    }, $Object_$$$eq$32.$$arity = 2);
    
    Opal.def(self, '$merge!', $Object_merge$excl$33 = function(other) {
      var self = this;

      
      
      other = $$$('::', 'Native').$convert(other);

      for (var prop in other) {
        self["native"][prop] = other[prop];
      }
    ;
      return self;
    }, $Object_merge$excl$33.$$arity = 1);
    
    Opal.def(self, '$respond_to?', $Object_respond_to$ques$34 = function(name, include_all) {
      var self = this;

      
      
      if (include_all == null) {
        include_all = false;
      };
      return $$$('::', 'Kernel').$instance_method("respond_to?").$bind(self).$call(name, include_all);
    }, $Object_respond_to$ques$34.$$arity = -2);
    
    Opal.def(self, '$respond_to_missing?', $Object_respond_to_missing$ques$35 = function(name, include_all) {
      var self = this;

      
      
      if (include_all == null) {
        include_all = false;
      };
      return Opal.hasOwnProperty.call(self["native"], name);
    }, $Object_respond_to_missing$ques$35.$$arity = -2);
    
    Opal.def(self, '$method_missing', $Object_method_missing$36 = function $$method_missing(mid, $a) {
      var $iter = $Object_method_missing$36.$$p, block = $iter || nil, $post_args, args, self = this, $writer = nil;

      if ($iter) $Object_method_missing$36.$$p = null;
      
      
      if ($iter) $Object_method_missing$36.$$p = null;;
      
      $post_args = Opal.slice.call(arguments, 1, arguments.length);
      
      args = $post_args;;
      
      if (mid.charAt(mid.length - 1) === '=') {
        return (($writer = [mid.$slice(0, $rb_minus(mid.$length(), 1)), args['$[]'](0)]), $send(self, '[]=', Opal.to_a($writer)), $writer[$rb_minus($writer["length"], 1)]);
      }
      else {
        return $send($$$('::', 'Native'), 'call', [self["native"], mid].concat(Opal.to_a(args)), block.$to_proc());
      }
    ;
    }, $Object_method_missing$36.$$arity = -2);
    
    Opal.def(self, '$nil?', $Object_nil$ques$37 = function() {
      var self = this;

      return false
    }, $Object_nil$ques$37.$$arity = 0);
    
    Opal.def(self, '$is_a?', $Object_is_a$ques$38 = function(klass) {
      var self = this;

      return Opal.is_a(self, klass);
    }, $Object_is_a$ques$38.$$arity = 1);
    Opal.alias(self, "kind_of?", "is_a?");
    
    Opal.def(self, '$instance_of?', $Object_instance_of$ques$39 = function(klass) {
      var self = this;

      return self.$$class === klass;
    }, $Object_instance_of$ques$39.$$arity = 1);
    
    Opal.def(self, '$class', $Object_class$40 = function() {
      var self = this;

      return self.$$class;
    }, $Object_class$40.$$arity = 0);
    
    Opal.def(self, '$to_a', $Object_to_a$41 = function $$to_a(options) {
      var $iter = $Object_to_a$41.$$p, block = $iter || nil, self = this;

      if ($iter) $Object_to_a$41.$$p = null;
      
      
      if ($iter) $Object_to_a$41.$$p = null;;
      
      if (options == null) {
        options = $hash2([], {});
      };
      return $send($$$($$$('::', 'Native'), 'Array'), 'new', [self["native"], options], block.$to_proc()).$to_a();
    }, $Object_to_a$41.$$arity = -1);
    return (Opal.def(self, '$inspect', $Object_inspect$42 = function $$inspect() {
      var self = this;

      return "" + "#<Native:" + (String(self["native"])) + ">"
    }, $Object_inspect$42.$$arity = 0), nil) && 'inspect';
  })($$($nesting, 'Native'), $$($nesting, 'BasicObject'), $nesting);
  (function($base, $super, $parent_nesting) {
    var self = $klass($base, $super, 'Array');

    var $nesting = [self].concat($parent_nesting), $Array_initialize$43, $Array_each$44, $Array_$$$45, $Array_$$$eq$46, $Array_last$47, $Array_length$48, $Array_inspect$49;

    self.$$prototype.named = self.$$prototype["native"] = self.$$prototype.get = self.$$prototype.block = self.$$prototype.set = self.$$prototype.length = nil;
    
    self.$include($$$($$($nesting, 'Native'), 'Wrapper'));
    self.$include($$($nesting, 'Enumerable'));
    
    Opal.def(self, '$initialize', $Array_initialize$43 = function $$initialize(native$, options) {
      var $iter = $Array_initialize$43.$$p, block = $iter || nil, $a, self = this;

      if ($iter) $Array_initialize$43.$$p = null;
      
      
      if ($iter) $Array_initialize$43.$$p = null;;
      
      if (options == null) {
        options = $hash2([], {});
      };
      $send(self, Opal.find_super_dispatcher(self, 'initialize', $Array_initialize$43, false), [native$], null);
      self.get = ($truthy($a = options['$[]']("get")) ? $a : options['$[]']("access"));
      self.named = options['$[]']("named");
      self.set = ($truthy($a = options['$[]']("set")) ? $a : options['$[]']("access"));
      self.length = ($truthy($a = options['$[]']("length")) ? $a : "length");
      self.block = block;
      if ($truthy(self.$length() == null)) {
        return self.$raise($$($nesting, 'ArgumentError'), "no length found on the array-like object")
      } else {
        return nil
      };
    }, $Array_initialize$43.$$arity = -2);
    
    Opal.def(self, '$each', $Array_each$44 = function $$each() {
      var $iter = $Array_each$44.$$p, block = $iter || nil, self = this;

      if ($iter) $Array_each$44.$$p = null;
      
      
      if ($iter) $Array_each$44.$$p = null;;
      if ($truthy(block)) {
      } else {
        return self.$enum_for("each")
      };
      
      for (var i = 0, length = self.$length(); i < length; i++) {
        Opal.yield1(block, self['$[]'](i));
      }
    ;
      return self;
    }, $Array_each$44.$$arity = 0);
    
    Opal.def(self, '$[]', $Array_$$$45 = function(index) {
      var self = this, result = nil, $case = nil;

      
      result = (function() {$case = index;
      if ($$($nesting, 'String')['$===']($case) || $$($nesting, 'Symbol')['$===']($case)) {if ($truthy(self.named)) {
        return self["native"][self.named](index)
      } else {
        return self["native"][index]
      }}
      else if ($$($nesting, 'Integer')['$===']($case)) {if ($truthy(self.get)) {
        return self["native"][self.get](index)
      } else {
        return self["native"][index]
      }}
      else { return nil }})();
      if ($truthy(result)) {
        if ($truthy(self.block)) {
          return self.block.$call(result)
        } else {
          return self.$Native(result)
        }
      } else {
        return nil
      };
    }, $Array_$$$45.$$arity = 1);
    
    Opal.def(self, '$[]=', $Array_$$$eq$46 = function(index, value) {
      var self = this;

      if ($truthy(self.set)) {
        return self["native"][self.set](index, $$($nesting, 'Native').$convert(value))
      } else {
        return self["native"][index] = $$($nesting, 'Native').$convert(value)
      }
    }, $Array_$$$eq$46.$$arity = 2);
    
    Opal.def(self, '$last', $Array_last$47 = function $$last(count) {
      var $a, self = this, index = nil, result = nil;

      
      
      if (count == null) {
        count = nil;
      };
      if ($truthy(count)) {
        
        index = $rb_minus(self.$length(), 1);
        result = [];
        while ($truthy($rb_ge(index, 0))) {
          
          result['$<<'](self['$[]'](index));
          index = $rb_minus(index, 1);
        };
        return result;
      } else {
        return self['$[]']($rb_minus(self.$length(), 1))
      };
    }, $Array_last$47.$$arity = -1);
    
    Opal.def(self, '$length', $Array_length$48 = function $$length() {
      var self = this;

      return self["native"][self.length]
    }, $Array_length$48.$$arity = 0);
    Opal.alias(self, "to_ary", "to_a");
    return (Opal.def(self, '$inspect', $Array_inspect$49 = function $$inspect() {
      var self = this;

      return self.$to_a().$inspect()
    }, $Array_inspect$49.$$arity = 0), nil) && 'inspect';
  })($$($nesting, 'Native'), null, $nesting);
  (function($base, $super, $parent_nesting) {
    var self = $klass($base, $super, 'Numeric');

    var $nesting = [self].concat($parent_nesting), $Numeric_to_n$50;

    return (Opal.def(self, '$to_n', $Numeric_to_n$50 = function $$to_n() {
      var self = this;

      return self.valueOf();
    }, $Numeric_to_n$50.$$arity = 0), nil) && 'to_n'
  })($nesting[0], null, $nesting);
  (function($base, $super, $parent_nesting) {
    var self = $klass($base, $super, 'Proc');

    var $nesting = [self].concat($parent_nesting), $Proc_to_n$51;

    return (Opal.def(self, '$to_n', $Proc_to_n$51 = function $$to_n() {
      var self = this;

      return self
    }, $Proc_to_n$51.$$arity = 0), nil) && 'to_n'
  })($nesting[0], null, $nesting);
  (function($base, $super, $parent_nesting) {
    var self = $klass($base, $super, 'String');

    var $nesting = [self].concat($parent_nesting), $String_to_n$52;

    return (Opal.def(self, '$to_n', $String_to_n$52 = function $$to_n() {
      var self = this;

      return self.valueOf();
    }, $String_to_n$52.$$arity = 0), nil) && 'to_n'
  })($nesting[0], null, $nesting);
  (function($base, $super, $parent_nesting) {
    var self = $klass($base, $super, 'Regexp');

    var $nesting = [self].concat($parent_nesting), $Regexp_to_n$53;

    return (Opal.def(self, '$to_n', $Regexp_to_n$53 = function $$to_n() {
      var self = this;

      return self.valueOf();
    }, $Regexp_to_n$53.$$arity = 0), nil) && 'to_n'
  })($nesting[0], null, $nesting);
  (function($base, $super, $parent_nesting) {
    var self = $klass($base, $super, 'MatchData');

    var $nesting = [self].concat($parent_nesting), $MatchData_to_n$54;

    self.$$prototype.matches = nil;
    return (Opal.def(self, '$to_n', $MatchData_to_n$54 = function $$to_n() {
      var self = this;

      return self.matches
    }, $MatchData_to_n$54.$$arity = 0), nil) && 'to_n'
  })($nesting[0], null, $nesting);
  (function($base, $super, $parent_nesting) {
    var self = $klass($base, $super, 'Struct');

    var $nesting = [self].concat($parent_nesting), $Struct_to_n$55;

    return (Opal.def(self, '$to_n', $Struct_to_n$55 = function $$to_n() {
      var $$56, self = this, result = nil;

      
      result = {};
      $send(self, 'each_pair', [], ($$56 = function(name, value){var self = $$56.$$s || this;

      
        
        if (name == null) {
          name = nil;
        };
        
        if (value == null) {
          value = nil;
        };
        return result[name] = $$($nesting, 'Native').$try_convert(value, value);}, $$56.$$s = self, $$56.$$arity = 2, $$56));
      return result;
    }, $Struct_to_n$55.$$arity = 0), nil) && 'to_n'
  })($nesting[0], null, $nesting);
  (function($base, $super, $parent_nesting) {
    var self = $klass($base, $super, 'Array');

    var $nesting = [self].concat($parent_nesting), $Array_to_n$57;

    return (Opal.def(self, '$to_n', $Array_to_n$57 = function $$to_n() {
      var self = this;

      
      var result = [];

      for (var i = 0, length = self.length; i < length; i++) {
        var obj = self[i];

        result.push($$($nesting, 'Native').$try_convert(obj, obj));
      }

      return result;
    
    }, $Array_to_n$57.$$arity = 0), nil) && 'to_n'
  })($nesting[0], null, $nesting);
  (function($base, $super, $parent_nesting) {
    var self = $klass($base, $super, 'Boolean');

    var $nesting = [self].concat($parent_nesting), $Boolean_to_n$58;

    return (Opal.def(self, '$to_n', $Boolean_to_n$58 = function $$to_n() {
      var self = this;

      return self.valueOf();
    }, $Boolean_to_n$58.$$arity = 0), nil) && 'to_n'
  })($nesting[0], null, $nesting);
  (function($base, $super, $parent_nesting) {
    var self = $klass($base, $super, 'Time');

    var $nesting = [self].concat($parent_nesting), $Time_to_n$59;

    return (Opal.def(self, '$to_n', $Time_to_n$59 = function $$to_n() {
      var self = this;

      return self
    }, $Time_to_n$59.$$arity = 0), nil) && 'to_n'
  })($nesting[0], null, $nesting);
  (function($base, $super, $parent_nesting) {
    var self = $klass($base, $super, 'NilClass');

    var $nesting = [self].concat($parent_nesting), $NilClass_to_n$60;

    return (Opal.def(self, '$to_n', $NilClass_to_n$60 = function $$to_n() {
      var self = this;

      return null;
    }, $NilClass_to_n$60.$$arity = 0), nil) && 'to_n'
  })($nesting[0], null, $nesting);
  (function($base, $super, $parent_nesting) {
    var self = $klass($base, $super, 'Hash');

    var $nesting = [self].concat($parent_nesting), $Hash_initialize$61, $Hash_to_n$62;

    
    Opal.alias(self, "_initialize", "initialize");
    
    Opal.def(self, '$initialize', $Hash_initialize$61 = function $$initialize(defaults) {
      var $iter = $Hash_initialize$61.$$p, block = $iter || nil, self = this;

      if ($iter) $Hash_initialize$61.$$p = null;
      
      
      if ($iter) $Hash_initialize$61.$$p = null;;
      ;
      
      if (defaults != null &&
           (defaults.constructor === undefined ||
             defaults.constructor === Object)) {
        var smap = self.$$smap,
            keys = self.$$keys,
            key, value;

        for (key in defaults) {
          value = defaults[key];

          if (value &&
               (value.constructor === undefined ||
                 value.constructor === Object)) {
            smap[key] = $$($nesting, 'Hash').$new(value);
          } else if (value && value.$$is_array) {
            value = value.map(function(item) {
              if (item &&
                   (item.constructor === undefined ||
                     item.constructor === Object)) {
                return $$($nesting, 'Hash').$new(item);
              }

              return self.$Native(item);
            });
            smap[key] = value
          } else {
            smap[key] = self.$Native(value);
          }

          keys.push(key);
        }

        return self;
      }

      return $send(self, '_initialize', [defaults], block.$to_proc());
    ;
    }, $Hash_initialize$61.$$arity = -1);
    return (Opal.def(self, '$to_n', $Hash_to_n$62 = function $$to_n() {
      var self = this;

      
      var result = {},
          keys = self.$$keys,
          smap = self.$$smap,
          key, value;

      for (var i = 0, length = keys.length; i < length; i++) {
        key = keys[i];

        if (key.$$is_string) {
          value = smap[key];
        } else {
          key = key.key;
          value = key.value;
        }

        result[key] = $$($nesting, 'Native').$try_convert(value, value);
      }

      return result;
    
    }, $Hash_to_n$62.$$arity = 0), nil) && 'to_n';
  })($nesting[0], null, $nesting);
  (function($base, $super, $parent_nesting) {
    var self = $klass($base, $super, 'Module');

    var $nesting = [self].concat($parent_nesting), $Module_native_module$63;

    return (Opal.def(self, '$native_module', $Module_native_module$63 = function $$native_module() {
      var self = this;

      return Opal.global[self.$name()] = self
    }, $Module_native_module$63.$$arity = 0), nil) && 'native_module'
  })($nesting[0], null, $nesting);
  (function($base, $super, $parent_nesting) {
    var self = $klass($base, $super, 'Class');

    var $nesting = [self].concat($parent_nesting), $Class_native_alias$64, $Class_native_class$65;

    
    
    Opal.def(self, '$native_alias', $Class_native_alias$64 = function $$native_alias(new_jsid, existing_mid) {
      var self = this;

      
      var aliased = self.prototype['$' + existing_mid];
      if (!aliased) {
        self.$raise($$($nesting, 'NameError').$new("" + "undefined method `" + (existing_mid) + "' for class `" + (self.$inspect()) + "'", self.$exiting_mid()));
      }
      self.prototype[new_jsid] = aliased;
    
    }, $Class_native_alias$64.$$arity = 2);
    return (Opal.def(self, '$native_class', $Class_native_class$65 = function $$native_class() {
      var self = this;

      
      self.$native_module();
      return self["new"] = self.$new;;
    }, $Class_native_class$65.$$arity = 0), nil) && 'native_class';
  })($nesting[0], null, $nesting);
  return ($gvars.$ = ($gvars.global = self.$Native(Opal.global)));
};

/* Generated by Opal 0.11.99.dev */
(function(Opal) {
  function $rb_minus(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs - rhs : lhs['$-'](rhs);
  }
  var self = Opal.top, $nesting = [], nil = Opal.nil, $$$ = Opal.const_get_qualified, $$ = Opal.const_get_relative, $breaker = Opal.breaker, $slice = Opal.slice, $klass = Opal.klass, $send = Opal.send, $truthy = Opal.truthy, $gvars = Opal.gvars;

  Opal.add_stubs(['$require', '$getFileData', '$getTableData', '$debug', '$map', '$lines', '$toutf8', '$[]', '$to_proc', '$shift', '$getDiceAndTitle', '$each', '$getLineKeyValue', '$empty?', '$to_i', '$<<', '$nil?', '$getTableDataFromFile', '$[]=', '$-', '$gsub', '$resolve', '$to_s', '$getBotNames', '$collectDiceBotDescriptions', '$resolveAll', '$==', '$new', '$const_get', '$loadAsync', '$createInstance', '$load']);
  
  self.$require("diceBot/DiceBot");
  self.$require("StaticDiceBotLoaderList");
  self.$require("StaticTableFileData");
  self.$require("bcdiceCore");
  self.$require("native");
  (function($base, $super, $parent_nesting) {
    var self = $klass($base, $super, 'TableFileData');

    var $nesting = [self].concat($parent_nesting), $TableFileData_setDir$1, $TableFileData_searchTableFileDefine$2, $TableFileData_getTableDataFromFile$3, $TableFileData_readOneTableData$5;

    self.$$prototype.tableData = self.$$prototype.fileData = nil;
    
    
    Opal.def(self, '$setDir', $TableFileData_setDir$1 = function $$setDir(dir, prefix) {
      var self = this;

      
      
      if (prefix == null) {
        prefix = "";
      };
      return self.tableData;
    }, $TableFileData_setDir$1.$$arity = -2);
    
    Opal.def(self, '$searchTableFileDefine', $TableFileData_searchTableFileDefine$2 = function $$searchTableFileDefine() {
      var self = this;

      
      self.fileData = $$($nesting, 'StaticTableFileData').$getFileData();
      return $$($nesting, 'StaticTableFileData').$getTableData();
    }, $TableFileData_searchTableFileDefine$2.$$arity = 0);
    
    Opal.def(self, '$getTableDataFromFile', $TableFileData_getTableDataFromFile$3 = function $$getTableDataFromFile(fileName) {
      var $a, $b, $$4, self = this, table = nil, lines = nil, defineLine = nil, dice = nil, title = nil;

      
      self.$debug("getTableDataFromFile", fileName);
      table = [];
      lines = $send(self.fileData['$[]'](fileName).$toutf8().$lines(), 'map', [], "chomp".$to_proc());
      defineLine = lines.$shift();
      $b = self.$getDiceAndTitle(defineLine), $a = Opal.to_ary($b), (dice = ($a[0] == null ? nil : $a[0])), (title = ($a[1] == null ? nil : $a[1])), $b;
      $send(lines, 'each', [], ($$4 = function(line){var self = $$4.$$s || this, $c, $d, key = nil, value = nil;

      
        
        if (line == null) {
          line = nil;
        };
        $d = self.$getLineKeyValue(line), $c = Opal.to_ary($d), (key = ($c[0] == null ? nil : $c[0])), (value = ($c[1] == null ? nil : $c[1])), $d;
        if ($truthy(key['$empty?']())) {
          return nil;};
        key = key.$to_i();
        return table['$<<']([key, value]);}, $$4.$$s = self, $$4.$$arity = 1, $$4));
      return [dice, title, table];
    }, $TableFileData_getTableDataFromFile$3.$$arity = 1);
    return (Opal.def(self, '$readOneTableData', $TableFileData_readOneTableData$5 = function $$readOneTableData(oneTableData) {
      var $a, $b, self = this, command = nil, gameType = nil, fileName = nil, dice = nil, title = nil, table = nil, $writer = nil;

      
      if ($truthy(oneTableData['$nil?']())) {
        return nil};
      if ($truthy(oneTableData['$[]']("table")['$nil?']())) {
      } else {
        return nil
      };
      command = oneTableData['$[]']("command");
      gameType = oneTableData['$[]']("gameType");
      fileName = oneTableData['$[]']("fileName");
      if ($truthy(command['$nil?']())) {
        return nil};
      $b = self.$getTableDataFromFile(fileName), $a = Opal.to_ary($b), (dice = ($a[0] == null ? nil : $a[0])), (title = ($a[1] == null ? nil : $a[1])), (table = ($a[2] == null ? nil : $a[2])), $b;
      
      $writer = ["dice", dice];
      $send(oneTableData, '[]=', Opal.to_a($writer));
      $writer[$rb_minus($writer["length"], 1)];;
      
      $writer = ["title", title];
      $send(oneTableData, '[]=', Opal.to_a($writer));
      $writer[$rb_minus($writer["length"], 1)];;
      
      $writer = ["table", table];
      $send(oneTableData, '[]=', Opal.to_a($writer));
      $writer[$rb_minus($writer["length"], 1)];;
      return oneTableData;
    }, $TableFileData_readOneTableData$5.$$arity = 1), nil) && 'readOneTableData';
  })($nesting[0], null, $nesting);
  (function($base, $super, $parent_nesting) {
    var self = $klass($base, $super, 'DiceBotLoader');

    var $nesting = [self].concat($parent_nesting), $DiceBotLoader_loadUnknownGame$6, $DiceBotLoader_collectDiceBotDescriptions$7, $DiceBotLoader_collectDiceBots$8, $DiceBotLoader_loadDiceBot$10;

    self.$$prototype.filenames = self.$$prototype.diceBotClass = nil;
    
    Opal.defs(self, '$loadUnknownGame', $DiceBotLoader_loadUnknownGame$6 = function $$loadUnknownGame(gameTitle) {
      var self = this, escapedGameTitle = nil, e = nil;

      
      self.$debug("loadUnknownGame", gameTitle);
      escapedGameTitle = gameTitle.$gsub(/(\.\.|\/|:|-)/, "_");
      
      try {
        return $$($nesting, 'DiceBotResolver').$resolve(escapedGameTitle)
      } catch ($err) {
        if (Opal.rescue($err, [$$($nesting, 'LoadError'), $$($nesting, 'StandardError')])) {e = $err;
          try {
            
            self.$debug("DiceBot load ERROR!!!", e.$to_s());
            return nil;
          } finally { Opal.pop_exception() }
        } else { throw $err; }
      };;
    }, $DiceBotLoader_loadUnknownGame$6.$$arity = 1);
    Opal.defs(self, '$collectDiceBotDescriptions', $DiceBotLoader_collectDiceBotDescriptions$7 = function $$collectDiceBotDescriptions() {
      var self = this;

      return $$($nesting, 'StaticDiceBotLoaderList').$getBotNames()
    }, $DiceBotLoader_collectDiceBotDescriptions$7.$$arity = 0);
    Opal.defs(self, '$collectDiceBots', $DiceBotLoader_collectDiceBots$8 = function $$collectDiceBots() {
      var $$9, self = this;

      return $send($$($nesting, 'DiceBotLoader').$collectDiceBotDescriptions(), 'map', [], ($$9 = function(botName){var self = $$9.$$s || this;

      
        
        if (botName == null) {
          botName = nil;
        };
        self.$debug("collectDiceBots", botName);
        return $$($nesting, 'DiceBotResolver').$resolve(botName['$[]'](0));}, $$9.$$s = self, $$9.$$arity = 1, $$9))
    }, $DiceBotLoader_collectDiceBots$8.$$arity = 0);
    return (Opal.def(self, '$loadDiceBot', $DiceBotLoader_loadDiceBot$10 = function $$loadDiceBot() {
      var self = this;

      return $$($nesting, 'DiceBotResolver').$resolveAll(self.filenames, self.diceBotClass)
    }, $DiceBotLoader_loadDiceBot$10.$$arity = 0), nil) && 'loadDiceBot';
  })($nesting[0], null, $nesting);
  (function($base, $super, $parent_nesting) {
    var self = $klass($base, $super, 'DiceBotResolver');

    var $nesting = [self].concat($parent_nesting), $DiceBotResolver_getMode$11, $DiceBotResolver_setMode$12, $DiceBotResolver_load$13, $DiceBotResolver_loadAsync$14, $DiceBotResolver_createInstance$15, $DiceBotResolver_resolve$16, $DiceBotResolver_resolveAll$17, $DiceBotResolver_setCustomLoader$20, $DiceBotResolver_async$ques$21;

    
    (Opal.class_variable_set($nesting[0], '@@mode', "dynamic-require"));
    (Opal.class_variable_set($nesting[0], '@@loader', nil));
    (Opal.class_variable_set($nesting[0], '@@async', false));
    (Opal.class_variable_set($nesting[0], '@@cache', {}));
    Opal.defs(self, '$getMode', $DiceBotResolver_getMode$11 = function $$getMode() {
      var $a, self = this;

      return (($a = $nesting[0].$$cvars['@@mode']) == null ? nil : $a)
    }, $DiceBotResolver_getMode$11.$$arity = 0);
    Opal.defs(self, '$setMode', $DiceBotResolver_setMode$12 = function $$setMode(mode) {
      var self = this;

      return (Opal.class_variable_set($nesting[0], '@@mode', mode))
    }, $DiceBotResolver_setMode$12.$$arity = 1);
    Opal.defs(self, '$load', $DiceBotResolver_load$13 = function $$load(filename) {
      var $a, self = this;

      
      self.$debug("nodeRequire", (($a = $nesting[0].$$cvars['@@mode']) == null ? nil : $a), filename);
      if ($truthy((($a = $nesting[0].$$cvars['@@mode']) == null ? nil : $a)['$==']("dynamic-require"))) {
        
        self.$debug("require", filename);
        var result = null;
        try { result = require('./diceBot/' + filename); } catch (e) { result = null; };
        self.$debug("require", result ? 'done' : 'fail');
        return result;;
      } else if ($truthy((($a = $nesting[0].$$cvars['@@mode']) == null ? nil : $a)['$==']("custom"))) {
        return (($a = $nesting[0].$$cvars['@@loader']) == null ? nil : $a)(filename)
      } else if ($truthy((($a = $nesting[0].$$cvars['@@mode']) == null ? nil : $a)['$==']("static"))) {
        return true
      } else {
        return nil
      };
    }, $DiceBotResolver_load$13.$$arity = 1);
    Opal.defs(self, '$loadAsync', $DiceBotResolver_loadAsync$14 = function $$loadAsync(filename) {
      var $a, self = this;

      
      self.$debug("loadAsync", filename);
      return (filename in (($a = $nesting[0].$$cvars['@@cache']) == null ? nil : $a)) ? Promise.resolve((($a = $nesting[0].$$cvars['@@cache']) == null ? nil : $a)[filename]) : (($a = $nesting[0].$$cvars['@@loader']) == null ? nil : $a)(filename);
    }, $DiceBotResolver_loadAsync$14.$$arity = 1);
    Opal.defs(self, '$createInstance', $DiceBotResolver_createInstance$15 = function $$createInstance(className) {
      var self = this;

      
      self.$debug("createInstance", className);
      return $$($nesting, 'Object').$const_get(className).$new();
    }, $DiceBotResolver_createInstance$15.$$arity = 1);
    Opal.defs(self, '$resolve', $DiceBotResolver_resolve$16 = function $$resolve(className) {
      var $a, self = this;

      if ($truthy((($a = $nesting[0].$$cvars['@@async']) == null ? nil : $a))) {
        return $$($nesting, 'DiceBotResolver').$loadAsync(className).then(function() { return $$($nesting, 'DiceBotResolver').$createInstance(className); })
      } else {
        
        $$($nesting, 'DiceBotResolver').$load(className);
        return $$($nesting, 'DiceBotResolver').$createInstance(className);
      }
    }, $DiceBotResolver_resolve$16.$$arity = 1);
    Opal.defs(self, '$resolveAll', $DiceBotResolver_resolveAll$17 = function $$resolveAll(filenames, className) {
      var $a, $$18, $$19, self = this;

      
      self.$debug("resolveAll", filenames, className);
      if ($truthy((($a = $nesting[0].$$cvars['@@async']) == null ? nil : $a))) {
        
        var results = [];
        $send(filenames, 'each', [], ($$18 = function(filename){var self = $$18.$$s || this;

        
          
          if (filename == null) {
            filename = nil;
          };
          return results.push($$($nesting, 'DiceBotResolver').$loadAsync(filename));}, $$18.$$s = self, $$18.$$arity = 1, $$18));
        
                var result = Promise.all(results).then(function() {
                    return $$($nesting, 'DiceBotResolver').$createInstance(className)
                });
            ;
        return result;;
      } else {
        
        $send(filenames, 'each', [], ($$19 = function(filename){var self = $$19.$$s || this;

        
          
          if (filename == null) {
            filename = nil;
          };
          return $$($nesting, 'DiceBotResolver').$load(filename);}, $$19.$$s = self, $$19.$$arity = 1, $$19));
        return $$($nesting, 'DiceBotResolver').$createInstance(className);
      };
    }, $DiceBotResolver_resolveAll$17.$$arity = 2);
    Opal.defs(self, '$setCustomLoader', $DiceBotResolver_setCustomLoader$20 = function $$setCustomLoader(loader, async) {
      var self = this;

      
      (Opal.class_variable_set($nesting[0], '@@mode', "custom"));
      (Opal.class_variable_set($nesting[0], '@@async', async));
      return (Opal.class_variable_set($nesting[0], '@@loader', loader));
    }, $DiceBotResolver_setCustomLoader$20.$$arity = 2);
    return (Opal.defs(self, '$async?', $DiceBotResolver_async$ques$21 = function() {
      var $a, self = this;

      return (($a = $nesting[0].$$cvars['@@async']) == null ? nil : $a)
    }, $DiceBotResolver_async$ques$21.$$arity = 0), nil) && 'async?';
  })($nesting[0], null, $nesting);
  return ($gvars.SEND_STR_MAX = 99999);
})(Opal);
